// ── PnL PDF Export: Moved to bo-produccion.js (Executive version) ──

// ── Costos por Lote ────────────────────────────────────────────
async function loadLotesCostos() {
    const tbody = document.getElementById('lotesBody');
    if (!tbody) return;
    const _rolCostos = (CURRENT_USER?.rol || '').toLowerCase().trim();
    const _verCostos = _rolCostos !== 'almacen';
    const _colSpan = _verCostos ? 11 : 5;
    // Hide/show cost header columns based on role
    document.querySelectorAll('.th-costo-lote').forEach(th => th.style.display = _verCostos ? '' : 'none');
    tbody.innerHTML = `<tr><td colspan="${_colSpan}" style="text-align:center;padding:2rem;"><div class="spinner"></div> Cargando...</td></tr>`;
    const mes = document.getElementById('costosMesFiltro')?.value;
    if (!mes) return;
    const [anio, mesNum] = mes.split('-');
    try {
        const sql = `
            SELECT fecha, lote, producto_id, cantidad,
                   COALESCE(costo_materia_prima,0) AS costo_materia_prima,
                   COALESCE(kg_merma,0) AS kg_merma,
                   COALESCE(costo_merma,0) AS costo_merma,
                   COALESCE(costo_prorrateo,0) AS costo_prorrateo,
                   COALESCE(costo_mod,0) AS costo_mod,
                   COALESCE(costo_depreciacion,0) AS costo_depreciacion,
                   id, planta, COALESCE(etiquetado_pais, 'MEX') AS etiquetado_pais
            FROM produccion_diaria
            WHERE EXTRACT(YEAR FROM fecha) = ${anio} AND EXTRACT(MONTH FROM fecha) = ${mesNum}
            ORDER BY fecha DESC`;
        const res  = await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql });
        const rows = res?.rows || [];
        const prodNombre = { fresa:'Dulet Fresa', vainilla:'Dulet Vainilla', choco:'Dulet Choco', natural:'Dulet Natural', eucament:'Eucament' };
        if (!rows.length) {
            tbody.innerHTML = `<tr><td colspan="${_colSpan}" style="text-align:center;color:var(--text-dim);padding:3rem;">Sin lotes en este mes.</td></tr>`; return;
        }
        let totCosto = 0, totUds = 0, totMerma = 0, totProrrateo = 0, totMod = 0, totDeprec = 0;
        tbody.innerHTML = rows.map(r => {
            const costo      = parseFloat(r.costo_materia_prima || 0);
            const cMerma     = parseFloat(r.costo_merma || 0);
            const cProrrateo = parseFloat(r.costo_prorrateo || 0);
            const cMod       = parseFloat(r.costo_mod || 0);
            const cDeprec    = parseFloat(r.costo_depreciacion || 0);
            const costoTotal = costo + cMerma + cProrrateo + cMod + cDeprec;
            const uds        = parseInt(r.cantidad || 0);
            const costUd     = uds > 0 ? (costoTotal / uds).toFixed(4) : '—';
            totCosto += costo; totMerma += cMerma; totProrrateo += cProrrateo; 
            totMod += cMod; totDeprec += cDeprec; totUds += uds;
            const _esSupervisorOMaster = ['supervisor','master','admin'].includes((CURRENT_USER?.rol||'').toLowerCase());
            return `<tr>
                <td>${(r.fecha||'').substring(0,10)}</td>
                <td style="font-size:.8rem;font-family:monospace;">${r.lote || '—'}</td>
                <td style="font-weight:600;">${prodNombre[r.producto_id] || r.producto_id}</td>
                <td style="font-size:.78rem;"><span style="padding:1px 6px;border:1px solid rgba(255,255,255,.15);border-radius:3px;">${r.etiquetado_pais || 'MEX'}</span></td>
                <td style="text-align:right;">${uds.toLocaleString()}</td>
                ${_verCostos ? `<td style="text-align:right;color:var(--warning);font-weight:600;">$${costo.toLocaleString('es-MX',{minimumFractionDigits:2})}</td>
                <td style="text-align:right;font-size:.78rem;color:#fbbf24;">${cMerma > 0 ? '$'+cMerma.toLocaleString('es-MX',{minimumFractionDigits:2}) : '—'}</td>
                <td style="text-align:right;font-size:.78rem;color:#a5b4fc;">${cProrrateo > 0 ? '$'+cProrrateo.toLocaleString('es-MX',{minimumFractionDigits:2}) : '—'}</td>
                <td style="text-align:right;font-size:.78rem;color:#4ade80;">${cMod > 0 ? '$'+cMod.toLocaleString('es-MX',{minimumFractionDigits:2}) : '—'}</td>
                <td style="text-align:right;font-size:.78rem;color:#94a3b8;">${cDeprec > 0 ? '$'+cDeprec.toLocaleString('es-MX',{minimumFractionDigits:2}) : '—'}</td>
                <td style="text-align:right;font-size:.8rem;color:var(--text-dim);">$${costUd}</td>` : ''}
            </tr>`;
        }).join('') + `
        <tr style="background:rgba(99,102,241,.08);font-weight:700;border-top:2px solid rgba(99,102,241,.3);">
            <td colspan="4">TOTAL MES</td>
            <td style="text-align:right;">${totUds.toLocaleString()}</td>
            ${_verCostos ? `<td style="text-align:right;color:var(--warning);">$${totCosto.toLocaleString('es-MX',{minimumFractionDigits:2})}</td>
            <td style="text-align:right;color:#fbbf24;">$${totMerma.toLocaleString('es-MX',{minimumFractionDigits:2})}</td>
            <td style="text-align:right;color:#a5b4fc;">$${totProrrateo.toLocaleString('es-MX',{minimumFractionDigits:2})}</td>
            <td style="text-align:right;color:#4ade80;">$${totMod.toLocaleString('es-MX',{minimumFractionDigits:2})}</td>
            <td style="text-align:right;color:#94a3b8;">$${totDeprec.toLocaleString('es-MX',{minimumFractionDigits:2})}</td>
            <td style="text-align:right;color:var(--text);">$${(totUds>0?(totCosto+totMerma+totProrrateo+totMod+totDeprec)/totUds:0).toFixed(4)}</td>` : ''}
        </tr>`;

        // ── Disparar panel de costo estándar ───────────────────────────────
        if (typeof loadCostoEstandarPanel === 'function') loadCostoEstandarPanel(mes).catch(_=>_);
    } catch(e) {
        tbody.innerHTML = `<tr><td colspan="${_colSpan}" style="text-align:center;color:var(--danger);padding:2rem;">Error: ${e.message}</td></tr>`;
    }
}

async function ejecutarCierreCostos() {
    const mes = document.getElementById('costosMesFiltro')?.value;
    if (!mes) {
        BO_AUTH.showAlert('Selecciona un mes primero.', 'warning');
        return;
    }
    const [anio, mesNum] = mes.split('-');
    
    if (!confirm(`¿Deseas ejecutar el cierre de costos prorrateados (MOD, Depreciación y Bodega) para el mes ${mes}? \n\nEsto calculará las tasas unitarias y actualizará todos los lotes de ese mes.`)) return;

    const btn = document.querySelector('button[onclick="ejecutarCierreCostos()"]');
    if (btn) { btn.disabled = true; btn.textContent = 'Procesando cierre...'; }

    try {
        // Asegurar columnas requeridas
        await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql: `
            ALTER TABLE produccion_diaria ADD COLUMN IF NOT EXISTS costo_mod NUMERIC(14,2) DEFAULT 0;
            ALTER TABLE produccion_diaria ADD COLUMN IF NOT EXISTS costo_depreciacion NUMERIC(14,2) DEFAULT 0;
            ALTER TABLE produccion_diaria ADD COLUMN IF NOT EXISTS costo_prorrateo NUMERIC(14,2) DEFAULT 0;
            ALTER TABLE produccion_diaria ADD COLUMN IF NOT EXISTS costo_merma NUMERIC(14,2) DEFAULT 0;
            ALTER TABLE produccion_diaria ADD COLUMN IF NOT EXISTS planta TEXT DEFAULT 'planta_1';
        ` }).catch(_=>_);

        // 1. Obtener gastos del mes por subcategoría (sin requerir planta_id estricto)
        const sqlGastos = `
            SELECT COALESCE(NULLIF(planta_id,''), 'planta_1') as planta_id, subcategoria, SUM(monto_mxn) as total_mxn
            FROM gastos_mensuales
            WHERE mes = '${mes}' 
              AND subcategoria IN ('nomina_directa', 'depreciacion', 'renta', 'luz')
              AND (empresa = 'DI' OR empresa IS NULL OR empresa = '')
            GROUP BY 1, 2`;
        const resGastos = await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql: sqlGastos });
        const gastos = resGastos?.rows || [];

        // 2. Fallbacks automáticos si faltan registros en gastos_mensuales
        // A) MOD fallback: Nómina de operarios de producción DI con cargas sociales (32.5% a 44.7%)
        const resNomTeorica = await BO_API.post('/bo/sql-relay', {
            secret: 'duletia_relay_2026',
            sql: `SELECT COALESCE(SUM(
                    CASE WHEN sbc > 0 THEN (sbc * 30.416 * 1.325)
                         ELSE (sueldo_mensual * 1.447)
                    END
                  ), 0) AS total_mod
                  FROM operarios_produccion
                  WHERE es_mod = true AND activo = true AND (empresa = 'DI' OR empresa IS NULL)`
        }).catch(() => ({ rows: [] }));
        const modTeorica = parseFloat(resNomTeorica?.rows?.[0]?.total_mod || 0);

        // B) Depreciación fallback: Maquinaria activa de DI
        const resDeprecTeorica = await BO_API.post('/bo/sql-relay', {
            secret: 'duletia_relay_2026',
            sql: `SELECT COALESCE(SUM(
                    (valor_compra - COALESCE(valor_rescate,0)) / NULLIF(vida_util_anos * 12, 0)
                  ), 0) AS dep_mensual
                  FROM activos_fijos
                  WHERE activo = true AND categoria = 'maquinaria' AND (empresa = 'DI' OR empresa IS NULL)`
        }).catch(() => ({ rows: [] }));
        const deprecTeorica = parseFloat(resDeprecTeorica?.rows?.[0]?.dep_mensual || 0);

        // C) Bodega fallback: Renta y Luz configuradas en sistema_config
        let bodegaTeorica = 0;
        try {
            const resBodegaCfg = await BO_API.post('/bo/sql-relay', {
                secret: 'duletia_relay_2026',
                sql: `SELECT valor FROM sistema_config WHERE clave = 'bodega_config'`
            });
            const bVal = resBodegaCfg?.rows?.[0]?.valor;
            if (bVal) {
                const p1 = bVal.planta_1 || bVal;
                bodegaTeorica = (parseFloat(p1.renta_mensual) || 0) + (parseFloat(p1.luz_mensual) || 0);
            }
        } catch(_) {}

        // 3. Obtener total de unidades producidas en el mes
        const sqlUds = `
            SELECT COALESCE(NULLIF(planta,''), 'planta_1') as planta, SUM(cantidad) as total_uds
            FROM produccion_diaria
            WHERE EXTRACT(YEAR FROM fecha) = ${anio} AND EXTRACT(MONTH FROM fecha) = ${mesNum}
            GROUP BY 1`;
        const resUds = await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql: sqlUds });
        const udsPorPlanta = resUds?.rows || [];

        if (udsPorPlanta.length === 0) {
            BO_AUTH.showAlert(`No hay unidades producidas en ${mes} para prorratear.`, 'warning');
            return;
        }

        let actualizados = 0;

        // 4. Por cada planta, calcular tasas y actualizar lotes
        for (const up of udsPorPlanta) {
            const planta = up.planta || 'planta_1';
            const totalUds = parseInt(up.total_uds || 0);
            if (totalUds <= 0) continue;

            let mod = parseFloat(gastos.find(g => g.planta_id === planta && g.subcategoria === 'nomina_directa')?.total_mxn || 0);
            if (mod <= 0) mod = modTeorica;

            let deprec = parseFloat(gastos.find(g => g.planta_id === planta && g.subcategoria === 'depreciacion')?.total_mxn || 0);
            if (deprec <= 0) deprec = deprecTeorica;

            let bodega = parseFloat(gastos.filter(g => g.planta_id === planta && ['renta','luz'].includes(g.subcategoria)).reduce((s,x)=>s+parseFloat(x.total_mxn||0),0));
            if (bodega <= 0) bodega = bodegaTeorica;

            const rateMod = totalUds > 0 ? (mod / totalUds) : 0;
            const rateDeprec = totalUds > 0 ? (deprec / totalUds) : 0;
            const rateBodega = totalUds > 0 ? (bodega / totalUds) : 0;

            const sqlUpdate = `
                UPDATE produccion_diaria
                SET costo_mod = ROUND(cantidad * ${rateMod}, 2),
                    costo_depreciacion = ROUND(cantidad * ${rateDeprec}, 2),
                    costo_prorrateo = ROUND(cantidad * ${rateBodega}, 2)
                WHERE EXTRACT(YEAR FROM fecha) = ${anio} AND EXTRACT(MONTH FROM fecha) = ${mesNum}
                  AND COALESCE(NULLIF(planta,''), 'planta_1') = '${planta}';
            `;
            const resUpdate = await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql: sqlUpdate });
            if (resUpdate?.rowCount > 0) actualizados += resUpdate.rowCount;
        }

        // 5. Corregir cualquier anomalía extrema de escala (ej. Eucament lote con botella/atomizador a precio de millar)
        try {
            await BO_API.post('/bo/sql-relay', {
                secret: 'duletia_relay_2026',
                sql: `UPDATE produccion_diaria
                      SET costo_materia_prima = ROUND(cantidad * 4.04, 2)
                      WHERE producto_id = 'eucament'
                        AND cantidad > 0
                        AND (costo_materia_prima / cantidad) > 100
                        AND EXTRACT(YEAR FROM fecha) = ${anio} AND EXTRACT(MONTH FROM fecha) = ${mesNum};`
            });
        } catch(_) {}

        BO_AUTH.showAlert(`✅ Cierre de costos ejecutado. Se actualizaron ${actualizados} lotes con MOD, Depreciación y Bodega.`, 'success', 4000);
        loadLotesCostos(); // Recargar tabla
    } catch(e) {
        BO_AUTH.showAlert('Error en cierre de costos: ' + e.message, 'danger');
    } finally {
        if (btn) { btn.disabled = false; btn.innerHTML = '🔄 Ejecutar Cierre (Prorratear MOD/Depreciación)'; }
    }
}

function switchProdTab(tabId) {
    // Hide all tabs
    document.querySelectorAll('[id^="prodContent-"]').forEach(el => el.style.display = 'none');
    document.querySelectorAll('.bo-tab-btn').forEach(el => {
        el.classList.remove('active');
        el.style.color = 'var(--text-muted)';
        el.style.fontWeight = 'normal';
        el.style.borderBottom = 'none';
    });

    // Show target tab
    const content = document.getElementById('prodContent-' + tabId);
    if (content) content.style.display = 'block';

    const btn = document.getElementById('btn-prodTab-' + tabId);
    if (btn) {
        btn.classList.add('active');
        btn.style.color = 'var(--text)';
        btn.style.fontWeight = '600';
        btn.style.borderBottom = '2px solid var(--primary)';
    }

    if (tabId === 'inventario-mp') {
        if (typeof _setInvMpVista === 'function') _setInvMpVista(window._invMpVista || 'balance');
        loadInventarioMP();
    }
    if (tabId === 'lotes') loadProduccion();
    if (tabId === 'auditoria') {
        if (typeof loadAuditoriaProduccion === 'function') loadAuditoriaProduccion();
    }
}

// ── Estado global del módulo Inventario y Kardex MP ──────────────────────────
window._invMpVista = 'balance';      // 'balance' | 'kardex' | 'stock'
window._invMpCatFiltro = '';        // '' | 'lacteo' | 'sabor' | 'envase' | 'empaque' | 'quimico'
window._invMpKardexRows = [];
window._invMpStockRows = [];
window._invMpKardexFiltered = [];
window._invMpStockFiltered = [];
window._invMpKardexPage = 0;
window._invMpStockPage = 0;

// ── Clasificador de Categoría de Insumos ──────────────────────────────────────
function _getMpCategoria(nombre) {
    const s = (nombre || '').toLowerCase();
    if (s.includes('suero') || s.includes('leche') || s.includes('lacto') || s.includes('proteina')) return 'lacteo';
    if (s.includes('fresa') || s.includes('vainilla') || s.includes('choco') || s.includes('cacao') || s.includes('cocoa') || s.includes('sabor') || s.includes('azucar') || s.includes('stevia')) return 'sabor';
    if (s.includes('botella') || s.includes('frasco') || s.includes('tapa') || s.includes('atomizador') || s.includes('liner') || s.includes('envase')) return 'envase';
    if (s.includes('etiqueta') || s.includes('caja') || s.includes('sello') || s.includes('empaque') || s.includes('funda') || s.includes('cinta')) return 'empaque';
    if (s.includes('alcohol') || s.includes('quimico') || s.includes('eucalipto') || s.includes('mentol') || s.includes('esencia') || s.includes('sanitiz')) return 'quimico';
    return 'otros';
}

function _getMpCatBadge(nombre) {
    const cat = _getMpCategoria(nombre);
    const badges = {
        lacteo:  `<span style="font-size:.68rem;padding:2px 6px;border-radius:4px;background:rgba(59,130,246,.15);color:#93c5fd;border:1px solid rgba(59,130,246,.3);">🥛 Lácteo</span>`,
        sabor:   `<span style="font-size:.68rem;padding:2px 6px;border-radius:4px;background:rgba(236,72,153,.15);color:#f472b6;border:1px solid rgba(236,72,153,.3);">🍓 Sabor</span>`,
        envase:  `<span style="font-size:.68rem;padding:2px 6px;border-radius:4px;background:rgba(16,185,129,.15);color:#6ee7b7;border:1px solid rgba(16,185,129,.3);">🧴 Envase</span>`,
        empaque: `<span style="font-size:.68rem;padding:2px 6px;border-radius:4px;background:rgba(245,158,11,.15);color:#fcd34d;border:1px solid rgba(245,158,11,.3);">🏷️ Empaque</span>`,
        quimico: `<span style="font-size:.68rem;padding:2px 6px;border-radius:4px;background:rgba(168,85,247,.15);color:#c084fc;border:1px solid rgba(168,85,247,.3);">🧪 Químico</span>`,
        otros:   `<span style="font-size:.68rem;padding:2px 6px;border-radius:4px;background:rgba(148,163,184,.15);color:#cbd5e1;border:1px solid rgba(148,163,184,.3);">📦 Insumo</span>`
    };
    return badges[cat] || badges.otros;
}

// ── Switch de Sub-vista: Balance vs Kardex vs Stock ──────────────────────────
function _setInvMpVista(vista) {
    window._invMpVista = vista || 'balance';
    const btnBalance = document.getElementById('btn-invMpVista-balance');
    const btnKardex  = document.getElementById('btn-invMpVista-kardex');
    const btnStock   = document.getElementById('btn-invMpVista-stock');
    const cBalance   = document.getElementById('invMpContenedor-balance');
    const cKardex    = document.getElementById('invMpContenedor-kardex');
    const cStock     = document.getElementById('invMpContenedor-stock');
    const gTipoMov   = document.getElementById('group-invMpTipoMov');

    // Reset styles
    [btnBalance, btnKardex, btnStock].forEach(b => {
        if (b) { b.style.background = 'transparent'; b.style.color = 'var(--text-dim)'; b.style.fontWeight = '500'; }
    });
    if (cBalance) cBalance.style.display = 'none';
    if (cKardex)  cKardex.style.display  = 'none';
    if (cStock)   cStock.style.display   = 'none';
    if (gTipoMov) gTipoMov.style.display = 'none';

    if (window._invMpVista === 'kardex') {
        if (btnKardex) { btnKardex.style.background = 'var(--primary)'; btnKardex.style.color = '#fff'; btnKardex.style.fontWeight = '600'; }
        if (cKardex) cKardex.style.display = 'block';
        if (gTipoMov) gTipoMov.style.display = '';
    } else if (window._invMpVista === 'stock') {
        if (btnStock) { btnStock.style.background = 'var(--primary)'; btnStock.style.color = '#fff'; btnStock.style.fontWeight = '600'; }
        if (cStock) cStock.style.display = 'block';
    } else {
        window._invMpVista = 'balance';
        if (btnBalance) { btnBalance.style.background = 'var(--primary)'; btnBalance.style.color = '#fff'; btnBalance.style.fontWeight = '600'; }
        if (cBalance) cBalance.style.display = 'block';
    }
    _aplicarFiltrosYRenderInvMp();
}

// ── Chips de Categoría de Insumos ─────────────────────────────────────────────
function _setInvMpCategoria(cat) {
    window._invMpCatFiltro = cat;
    document.querySelectorAll('#invMpChipsCat .prod-chip').forEach(btn => {
        if ((btn.dataset.cat || '') === (cat || '')) btn.classList.add('active');
        else btn.classList.remove('active');
    });
    _aplicarFiltrosYRenderInvMp();
}

// ── Selector de Mes y Rangos Rápidos ──────────────────────────────────────────
function _onInvMpMesChange(mesStr) {
    if (!mesStr) return;
    const [y, m] = mesStr.split('-').map(Number);
    const primerDia = `${mesStr}-01`;
    const ultimoDiaNum = new Date(y, m, 0).getDate();
    const ultimoDia = `${mesStr}-${String(ultimoDiaNum).padStart(2, '0')}`;
    const dEl = document.getElementById('invMpDesde');
    const hEl = document.getElementById('invMpHasta');
    if (dEl) dEl.value = primerDia;
    if (hEl) hEl.value = ultimoDia;
    loadInventarioMP();
}

function _cambiarMesInvMp(delta) {
    const mesEl = document.getElementById('invMpMesSelector');
    let base = mesEl?.value;
    if (!base) {
        const dEl = document.getElementById('invMpDesde');
        if (dEl?.value) base = dEl.value.substring(0, 7);
        else {
            const hoy = new Date();
            base = `${hoy.getFullYear()}-${String(hoy.getMonth() + 1).padStart(2, '0')}`;
        }
    }
    const [y, m] = base.split('-').map(Number);
    const nuevaFecha = new Date(y, m - 1 + delta, 1);
    const nuevoMesStr = `${nuevaFecha.getFullYear()}-${String(nuevaFecha.getMonth() + 1).padStart(2, '0')}`;
    if (mesEl) mesEl.value = nuevoMesStr;
    _onInvMpMesChange(nuevoMesStr);
}

function _setInvMpRango(tipo) {
    const hoy = new Date();
    const desdeEl = document.getElementById('invMpDesde');
    const hastaEl = document.getElementById('invMpHasta');
    const mesEl = document.getElementById('invMpMesSelector');
    if (!desdeEl || !hastaEl) return;

    if (tipo === 'todo') {
        desdeEl.value = '2026-01-01';
        hastaEl.value = hoy.toISOString().slice(0, 10);
    } else {
        hastaEl.value = hoy.toISOString().slice(0, 10);
        let d = new Date(hoy);
        if (tipo === 'hoy') { /* hoy */ }
        else if (tipo === '3dias') d.setDate(d.getDate() - 2);
        else if (tipo === 'semana') d.setDate(d.getDate() - 6);
        else if (tipo === 'mes') d = new Date(hoy.getFullYear(), hoy.getMonth(), 1);
        desdeEl.value = d.toISOString().slice(0, 10);
    }
    if (mesEl && desdeEl.value) mesEl.value = desdeEl.value.substring(0, 7);
    loadInventarioMP();
}

function _filtrarInvMp(q) {
    _aplicarFiltrosYRenderInvMp();
}

// ── Carga de Inventario y Kardex MP ──────────────────────────────────────────
async function loadInventarioMP() {
    const bBody = document.getElementById('invMpBalanceBody');
    const kBody = document.getElementById('invMpKardexBody');
    const sBody = document.getElementById('inventarioMpBody');
    if (bBody) bBody.innerHTML = '<tr><td colspan="9" style="text-align:center;padding:2rem;"><div class="spinner" style="display:inline-block;width:18px;height:18px;border:2px solid rgba(255,255,255,.2);border-top-color:var(--primary);border-radius:50%;animation:spin .8s linear infinite;margin-right:8px;vertical-align:middle;"></div> Cargando balance de insumos...</td></tr>';
    if (kBody) kBody.innerHTML = '<tr><td colspan="10" style="text-align:center;padding:2rem;"><div class="spinner" style="display:inline-block;width:18px;height:18px;border:2px solid rgba(255,255,255,.2);border-top-color:var(--primary);border-radius:50%;animation:spin .8s linear infinite;margin-right:8px;vertical-align:middle;"></div> Cargando movimientos de materias primas...</td></tr>';
    if (sBody) sBody.innerHTML = '<tr><td colspan="10" style="text-align:center;padding:2rem;"><div class="spinner" style="display:inline-block;width:18px;height:18px;border:2px solid rgba(255,255,255,.2);border-top-color:var(--primary);border-radius:50%;animation:spin .8s linear infinite;margin-right:8px;vertical-align:middle;"></div> Cargando inventario de materias primas...</td></tr>';

    const desde = document.getElementById('invMpDesde')?.value || '';
    const hasta = document.getElementById('invMpHasta')?.value || '';
    const planta = document.getElementById('invMpPlantaFiltro')?.value || '';

    const hoy = new Date();
    const _desde = desde || `${hoy.getFullYear()}-${String(hoy.getMonth()+1).padStart(2,'0')}-01`;
    const _hasta = hasta || hoy.toISOString().slice(0,10);

    const dEl = document.getElementById('invMpDesde');
    const hEl = document.getElementById('invMpHasta');
    const mEl = document.getElementById('invMpMesSelector');
    if (dEl && !dEl.value) dEl.value = _desde;
    if (hEl && !hEl.value) hEl.value = _hasta;
    if (mEl && !mEl.value && _desde) mEl.value = _desde.substring(0, 7);

    // Asegurar columnas requeridas en inventario_mp de forma idempotente
    try {
        await BO_API.post('/bo/sql-relay', {
            secret: 'duletia_relay_2026',
            sql: `ALTER TABLE inventario_mp ADD COLUMN IF NOT EXISTS planta TEXT DEFAULT 'planta_1', ADD COLUMN IF NOT EXISTS creado_por TEXT DEFAULT 'sistema'`
        }).catch(() => {});
    } catch (_) {}

    try {
        const plantaKardexWhere = planta ? `AND (COALESCE(planta, 'planta_1') = '${planta}')` : '';
        const plantaStockWhere  = planta ? `AND (COALESCE(planta, 'planta_1') = '${planta}')` : '';

        // 1. Query Kardex: Movimientos del periodo (ingresos, consumos, salidas)
        const sqlKardex = `
            SELECT id, ingrediente, tipo_movimiento,
                   COALESCE(TO_CHAR(fecha, 'YYYY-MM-DD'), '') as fecha,
                   COALESCE(cantidad_kg, 0) as cantidad,
                   COALESCE(saldo_restante_kg, 0) as saldo_restante,
                   COALESCE(costo_unitario_kg, 0) as cpk,
                   COALESCE(costo_total, 0) as costo_total,
                   COALESCE(lote_peps, '') as lote_peps,
                   COALESCE(unidad, 'kg') as unidad,
                   COALESCE(planta, 'planta_1') as planta,
                   referencia_tipo, referencia_id, proveedor_rfc, notas, creado_por
            FROM inventario_mp
            WHERE fecha::date BETWEEN '${_desde}' AND '${_hasta}'
              ${plantaKardexWhere}
            ORDER BY fecha DESC, id DESC
            LIMIT 1200`;

        // 2. Query Stock: Lotes activos con saldo disponible actual (PEPS)
        const sqlStock = `
            SELECT id, ingrediente,
                   COALESCE(TO_CHAR(fecha, 'YYYY-MM-DD'), '') as fecha,
                   COALESCE(cantidad_kg, 0) as cantidad,
                   COALESCE(saldo_restante_kg, 0) as stock_restante,
                   (COALESCE(cantidad_kg, 0) - COALESCE(saldo_restante_kg, 0)) as consumido,
                   COALESCE(costo_unitario_kg, 0) as cpk,
                   COALESCE(costo_total, 0) as costo_total,
                   COALESCE(lote_peps, '') as lote_peps,
                   COALESCE(unidad, 'kg') as unidad,
                   COALESCE(planta, 'planta_1') as planta,
                   notas
            FROM inventario_mp
            WHERE tipo_movimiento = 'ingreso' AND COALESCE(saldo_restante_kg, 0) > 0
              ${plantaStockWhere}
            ORDER BY ingrediente ASC, fecha ASC`;

        // 3. Query Balance Consolidado: Remanente anterior + Compras periodo − Usado producción = Stock Final
        const sqlBalance = `
            SELECT 
                UPPER(TRIM(ingrediente)) as ingrediente,
                COALESCE(unidad, 'kg') as unidad,
                COALESCE(SUM(CASE WHEN fecha::date < '${_desde}' AND tipo_movimiento = 'ingreso' THEN cantidad_kg 
                                  WHEN fecha::date < '${_desde}' AND tipo_movimiento IN ('consumo','salida','merma') THEN -cantidad_kg 
                                  ELSE 0 END), 0) AS remanente_anterior,
                COALESCE(SUM(CASE WHEN fecha::date BETWEEN '${_desde}' AND '${_hasta}' AND tipo_movimiento = 'ingreso' THEN cantidad_kg ELSE 0 END), 0) AS compras_periodo,
                COALESCE(SUM(CASE WHEN fecha::date BETWEEN '${_desde}' AND '${_hasta}' AND tipo_movimiento IN ('consumo','salida','merma') THEN cantidad_kg ELSE 0 END), 0) AS usado_produccion,
                COALESCE(SUM(CASE WHEN tipo_movimiento = 'ingreso' THEN cantidad_kg 
                                  WHEN tipo_movimiento IN ('consumo','salida','merma') THEN -cantidad_kg 
                                  ELSE 0 END), 0) AS stock_final,
                COALESCE(AVG(NULLIF(costo_unitario_kg, 0)), 0) AS cpk_promedio,
                MAX(planta) as planta
            FROM inventario_mp
            WHERE 1=1 ${plantaStockWhere}
            GROUP BY UPPER(TRIM(ingrediente)), COALESCE(unidad, 'kg')
            ORDER BY 1 ASC`;

        const [resKardex, resStock, resBalance] = await Promise.all([
            BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql: sqlKardex }),
            BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql: sqlStock }),
            BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql: sqlBalance }).catch(() => ({ rows: [] }))
        ]);

        window._invMpKardexRows  = resKardex?.rows || [];
        window._invMpStockRows   = resStock?.rows || [];
        
        // Deduplicación e integración defensiva para asegurar 1 sola fila por materia prima
        const mergedBalanceMap = {};
        (resBalance?.rows || []).forEach(r => {
            const key = (r.ingrediente || '').toUpperCase().trim();
            if (!mergedBalanceMap[key]) {
                mergedBalanceMap[key] = { ...r, ingrediente: key };
            } else {
                mergedBalanceMap[key].remanente_anterior = parseFloat(mergedBalanceMap[key].remanente_anterior || 0) + parseFloat(r.remanente_anterior || 0);
                mergedBalanceMap[key].compras_periodo = parseFloat(mergedBalanceMap[key].compras_periodo || 0) + parseFloat(r.compras_periodo || 0);
                mergedBalanceMap[key].usado_produccion = parseFloat(mergedBalanceMap[key].usado_produccion || 0) + parseFloat(r.usado_produccion || 0);
                mergedBalanceMap[key].stock_final = parseFloat(mergedBalanceMap[key].stock_final || 0) + parseFloat(r.stock_final || 0);
                if (!mergedBalanceMap[key].cpk_promedio && r.cpk_promedio) {
                    mergedBalanceMap[key].cpk_promedio = r.cpk_promedio;
                }
            }
        });
        window._invMpBalanceRows = Object.values(mergedBalanceMap);

        // Poblar datalist de ingredientes en modal
        _poblarDatalistIngredientesMP(window._invMpStockRows.concat(window._invMpKardexRows).concat(window._invMpBalanceRows));

        _aplicarFiltrosYRenderInvMp();

    } catch (e) {
        const bBody = document.getElementById('invMpBalanceBody');
        if (bBody) bBody.innerHTML = `<tr><td colspan="9" style="text-align:center;color:var(--danger);padding:2rem;">Error: ${e.message}</td></tr>`;
        if (kBody) kBody.innerHTML = `<tr><td colspan="10" style="text-align:center;color:var(--danger);padding:2rem;">Error: ${e.message}</td></tr>`;
        if (sBody) sBody.innerHTML = `<tr><td colspan="10" style="text-align:center;color:var(--danger);padding:2rem;">Error: ${e.message}</td></tr>`;
    }
}

// ── Filtro Inteligente y Cálculo de KPIs ──────────────────────────────────────
function _aplicarFiltrosYRenderInvMp() {
    const rawKardex  = window._invMpKardexRows  || [];
    const rawStock   = window._invMpStockRows   || [];
    const rawBalance = window._invMpBalanceRows || [];

    const q = document.getElementById('invMpBuscador')?.value || '';
    const catChip = window._invMpCatFiltro || '';
    const tipoMov = document.getElementById('invMpTipoMovFiltro')?.value || '';
    const cleanQ = (typeof _normSearch === 'function') ? _normSearch(q) : q.toLowerCase().trim();

    // 1. Filtrar Balance
    let filteredBalance = rawBalance;
    if (catChip) {
        filteredBalance = filteredBalance.filter(r => _getMpCategoria(r.ingrediente) === catChip);
    }
    if (cleanQ) {
        const terms = cleanQ.split(' ').filter(Boolean);
        filteredBalance = filteredBalance.filter(r => {
            const blob = [r.ingrediente, r.unidad, (r.planta || '').replace('_',' ')].join(' ');
            const nBlob = (typeof _normSearch === 'function') ? _normSearch(blob) : blob.toLowerCase();
            return terms.every(t => nBlob.includes(t));
        });
    }

    // 2. Filtrar Kardex
    let filteredKardex = rawKardex;
    if (tipoMov) {
        filteredKardex = filteredKardex.filter(r => (r.tipo_movimiento || '').toLowerCase() === tipoMov.toLowerCase());
    }
    if (catChip) {
        filteredKardex = filteredKardex.filter(r => _getMpCategoria(r.ingrediente) === catChip);
    }
    if (cleanQ) {
        const terms = cleanQ.split(' ').filter(Boolean);
        filteredKardex = filteredKardex.filter(r => {
            const blob = [
                r.fecha, r.ingrediente, r.tipo_movimiento, r.lote_peps,
                r.cantidad, r.unidad, r.notas, r.referencia_tipo,
                r.proveedor_rfc, r.creado_por, (r.planta || '').replace('_',' ')
            ].join(' ');
            const nBlob = (typeof _normSearch === 'function') ? _normSearch(blob) : blob.toLowerCase();
            return terms.every(t => nBlob.includes(t));
        });
    }

    // 3. Filtrar Stock
    let filteredStock = rawStock;
    if (catChip) {
        filteredStock = filteredStock.filter(r => _getMpCategoria(r.ingrediente) === catChip);
    }
    if (cleanQ) {
        const terms = cleanQ.split(' ').filter(Boolean);
        filteredStock = filteredStock.filter(r => {
            const blob = [
                r.fecha, r.ingrediente, r.lote_peps,
                r.cantidad, r.stock_restante, r.consumido, r.unidad,
                r.notas, (r.planta || '').replace('_',' ')
            ].join(' ');
            const nBlob = (typeof _normSearch === 'function') ? _normSearch(blob) : blob.toLowerCase();
            return terms.every(t => nBlob.includes(t));
        });
    }

    window._invMpBalanceFiltered = filteredBalance;
    window._invMpKardexFiltered  = filteredKardex;
    window._invMpStockFiltered   = filteredStock;
    window._invMpBalancePage = 0;
    window._invMpKardexPage  = 0;
    window._invMpStockPage   = 0;

    // Actualizar KPIs superiores
    _actualizarInvMpKpis(filteredKardex, filteredStock, filteredBalance);

    // Actualizar badge del buscador
    const infoEl = document.getElementById('invMpBuscadorInfo');
    if (infoEl) {
        let currentCount = filteredBalance.length;
        let totalCount   = rawBalance.length;
        if (window._invMpVista === 'kardex') {
            currentCount = filteredKardex.length;
            totalCount   = rawKardex.length;
        } else if (window._invMpVista === 'stock') {
            currentCount = filteredStock.length;
            totalCount   = rawStock.length;
        }
        if (cleanQ || catChip || (window._invMpVista === 'kardex' && tipoMov)) {
            infoEl.innerHTML = `<span style="color:#a5b4fc;font-weight:600;">${currentCount}</span> de ${totalCount} registros`;
        } else {
            infoEl.textContent = `${totalCount} registro(s)`;
        }
    }

    // Renderizar tabla según vista activa
    if (window._invMpVista === 'kardex') {
        _renderInvMpKardex(filteredKardex);
    } else if (window._invMpVista === 'stock') {
        _renderInvMpStock(filteredStock);
    } else {
        _renderInvMpBalance(filteredBalance);
    }
}

// ── Actualización de KPIs Reactivos ──────────────────────────────────────────
function _actualizarInvMpKpis(kardex, stock, balance) {
    const kpisEl = document.getElementById('invMpKpis');
    if (!kpisEl) return;

    // 1. Stock Valuado Total Activo
    const valorStockTotal = (stock && stock.length ? stock : balance || []).reduce((acc, r) => {
        const cant = parseFloat(r.stock_restante || r.stock_final || 0);
        const cpk  = parseFloat(r.cpk || r.cpk_promedio || 0);
        return acc + (cant * cpk);
    }, 0);
    const ingredientesUnicos = new Set((balance && balance.length ? balance : stock || []).map(r => r.ingrediente)).size;

    // 2. Remanente Mes Pasado (Valorizado)
    const valorRemanenteAnterior = (balance || []).reduce((acc, r) => {
        const rem = parseFloat(r.remanente_anterior || 0);
        const cpk = parseFloat(r.cpk_promedio || 0);
        return acc + (rem * cpk);
    }, 0);

    // 3. Ingresos del Periodo (Compras)
    const ingresos = (kardex || []).filter(r => (r.tipo_movimiento || '').toLowerCase() === 'ingreso');
    let valorIngresos = ingresos.reduce((acc, r) => acc + (parseFloat(r.costo_total || 0) || (parseFloat(r.cantidad || 0) * parseFloat(r.cpk || 0))), 0);
    if (valorIngresos <= 0 && balance && balance.length) {
        valorIngresos = balance.reduce((acc, r) => acc + (parseFloat(r.compras_periodo || 0) * parseFloat(r.cpk_promedio || 0)), 0);
    }

    // 4. Salidas / Consumo a Producción (Usado)
    const salidas = (kardex || []).filter(r => ['consumo', 'salida', 'merma'].includes((r.tipo_movimiento || '').toLowerCase()));
    let valorSalidas = salidas.reduce((acc, r) => acc + (parseFloat(r.costo_total || 0) || (parseFloat(r.cantidad || 0) * parseFloat(r.cpk || 0))), 0);
    if (valorSalidas <= 0 && balance && balance.length) {
        valorSalidas = balance.reduce((acc, r) => acc + (parseFloat(r.usado_produccion || 0) * parseFloat(r.cpk_promedio || 0)), 0);
    }

    kpisEl.innerHTML = `
        <div class="stat-card" style="min-width:130px;padding:.45rem .8rem;" title="Remanente que venía en bodega antes de la fecha inicial">
            <div class="stat-label" style="font-size:.68rem;">📦 Remanente Anterior</div>
            <div class="stat-value" style="font-size:1.05rem;color:#cbd5e1;">$${valorRemanenteAnterior.toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</div>
        </div>
        <div class="stat-card" style="min-width:130px;padding:.45rem .8rem;" title="Compras y recepciones ingresadas en el periodo">
            <div class="stat-label" style="font-size:.68rem;">📥 + Compras Periodo</div>
            <div class="stat-value" style="font-size:1.05rem;color:#38bdf8;">$${valorIngresos.toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</div>
        </div>
        <div class="stat-card" style="min-width:130px;padding:.45rem .8rem;" title="Materia prima consumida/absorbida por lotes de producción">
            <div class="stat-label" style="font-size:.68rem;">📤 − Usado en Prod.</div>
            <div class="stat-value" style="font-size:1.05rem;color:#fb7185;">$${valorSalidas.toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</div>
        </div>
        <div class="stat-card" style="min-width:130px;padding:.45rem .8rem;" title="Valor comercial del stock final disponible en bodega">
            <div class="stat-label" style="font-size:.68rem;">🎯 = Stock Valuado MP</div>
            <div class="stat-value" style="font-size:1.05rem;color:#10b981;">$${valorStockTotal.toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</div>
        </div>
        <div class="stat-card" style="min-width:100px;padding:.45rem .8rem;" title="Insumos distintos en existencia">
            <div class="stat-label" style="font-size:.68rem;">Insumos</div>
            <div class="stat-value" style="font-size:1.05rem;color:#c084fc;">${ingredientesUnicos}</div>
        </div>
    `;
}

// ── Renderizado de Kardex (Movimientos Ingreso vs Salida) ─────────────────────
function _renderInvMpKardex(rows) {
    const tbody = document.getElementById('invMpKardexBody');
    const pagDiv = document.getElementById('invMpKardexPagination');
    if (!tbody || !pagDiv) return;

    if (!rows.length) {
        tbody.innerHTML = '<tr><td colspan="10" style="text-align:center;color:var(--text-dim);padding:3rem;">🔍 No se encontraron movimientos para el periodo o filtro seleccionado.</td></tr>';
        pagDiv.innerHTML = '';
        return;
    }

    const ITEMS_PER_PAGE = 30;
    const totalPages = Math.ceil(rows.length / ITEMS_PER_PAGE);
    const p = window._invMpKardexPage || 0;
    const pageRows = rows.slice(p * ITEMS_PER_PAGE, (p + 1) * ITEMS_PER_PAGE);

    tbody.innerHTML = pageRows.map(r => {
        const esIngreso = (r.tipo_movimiento || '').toLowerCase() === 'ingreso';
        const esConsumo = ['consumo', 'salida'].includes((r.tipo_movimiento || '').toLowerCase());
        const u = r.unidad || 'kg';
        const cant = parseFloat(r.cantidad || 0);
        const cpk = parseFloat(r.cpk || 0);
        const cTotal = parseFloat(r.costo_total || 0) || (cant * cpk);
        const saldoRest = parseFloat(r.saldo_restante || 0);

        const badgeTipo = esIngreso
            ? `<span style="background:rgba(16,185,129,.15);color:#34d399;border:1px solid rgba(16,185,129,.3);padding:2px 8px;border-radius:4px;font-weight:700;font-size:.72rem;">📥 INGRESO</span>`
            : (esConsumo
                ? `<span style="background:rgba(239,68,68,.15);color:#f87171;border:1px solid rgba(239,68,68,.3);padding:2px 8px;border-radius:4px;font-weight:700;font-size:.72rem;">📤 SALIDA PROD</span>`
                : `<span style="background:rgba(245,158,11,.15);color:#fbbf24;border:1px solid rgba(245,158,11,.3);padding:2px 8px;border-radius:4px;font-weight:700;font-size:.72rem;">⚖️ ${(r.tipo_movimiento || '').toUpperCase()}</span>`);

        const cantColor = esIngreso ? 'color:#34d399;font-weight:700;' : 'color:#f87171;font-weight:700;';
        const cantPrefijo = esIngreso ? '+' : '-';

        let destinoTxt = '—';
        if (esConsumo) {
            destinoTxt = `<span style="color:#a5b4fc;font-weight:600;">🏭 ${r.notas || ('Orden PD-' + (r.referencia_id || ''))}</span>`;
        } else if (esIngreso) {
            destinoTxt = `<span style="color:var(--text-dim);font-size:.78rem;">${r.proveedor_rfc || r.notas || 'Compra / Ingreso'}</span>`;
        }

        return `<tr>
            <td style="font-size:.82rem;white-space:nowrap;">${r.fecha || '—'}</td>
            <td style="text-align:center;">${badgeTipo}</td>
            <td>
                <div style="display:flex;align-items:center;gap:6px;">
                    <span style="font-weight:600;color:#fff;">${r.ingrediente}</span>
                    ${_getMpCatBadge(r.ingrediente)}
                </div>
            </td>
            <td style="font-size:.78rem;font-family:monospace;color:var(--primary);">${r.lote_peps || '—'}</td>
            <td style="font-size:.82rem;">${destinoTxt}</td>
            <td style="text-align:right;${cantColor}">${cantPrefijo}${cant.toLocaleString('es-MX', { maximumFractionDigits: 2 })} ${u}</td>
            <td style="text-align:right;color:#10b981;font-size:.82rem;">${esIngreso ? saldoRest.toLocaleString('es-MX', { maximumFractionDigits: 2 }) + ' ' + u : '—'}</td>
            <td style="text-align:right;font-size:.8rem;color:var(--text-dim);">$${cpk.toLocaleString('es-MX', { minimumFractionDigits: 2 })}/${u}</td>
            <td style="text-align:right;font-weight:600;color:var(--warning);">$${cTotal.toLocaleString('es-MX', { minimumFractionDigits: 2 })}</td>
            <td style="font-size:.78rem;color:var(--text-dim);">${r.creado_por || 'sistema'}</td>
        </tr>`;
    }).join('');

    if (totalPages <= 1) { pagDiv.innerHTML = ''; return; }
    let btns = '';
    const from = Math.max(0, p - 2);
    const to   = Math.min(totalPages - 1, p + 2);
    if (from > 0) btns += `<button class="btn btn-outline btn-sm" onclick="window._invMpKardexPage=0;_renderInvMpKardex(window._invMpKardexFiltered)">1</button><span style="color:var(--text-dim);">…</span>`;
    for (let i = from; i <= to; i++) {
        const active = i === p ? 'style="background:var(--accent-purple);color:#fff;border-color:var(--accent-purple);"' : '';
        btns += `<button class="btn btn-outline btn-sm" ${active} onclick="window._invMpKardexPage=${i};_renderInvMpKardex(window._invMpKardexFiltered)">${i+1}</button>`;
    }
    if (to < totalPages - 1) btns += `<span style="color:var(--text-dim);">…</span><button class="btn btn-outline btn-sm" onclick="window._invMpKardexPage=${totalPages-1};_renderInvMpKardex(window._invMpKardexFiltered)">${totalPages}</button>`;
    pagDiv.innerHTML = btns;
}

// ── Renderizado de Balance de Insumos (Remanente + Compras − Usado = Stock Final) ──
function _renderInvMpBalance(rows) {
    const tbody = document.getElementById('invMpBalanceBody');
    const pagDiv = document.getElementById('invMpBalancePagination');
    if (!tbody) return;

    if (!rows.length) {
        tbody.innerHTML = '<tr><td colspan="9" style="text-align:center;color:var(--text-dim);padding:3rem;">No hay insumos registrados para este periodo o filtro.</td></tr>';
        if (pagDiv) pagDiv.innerHTML = '';
        return;
    }

    const ITEMS_PER_PAGE = 30;
    const totalPages = Math.ceil(rows.length / ITEMS_PER_PAGE);
    const p = window._invMpBalancePage || 0;
    const pageRows = rows.slice(p * ITEMS_PER_PAGE, (p + 1) * ITEMS_PER_PAGE);

    tbody.innerHTML = pageRows.map(r => {
        const u = r.unidad || 'kg';
        const remanente = parseFloat(r.remanente_anterior || 0);
        const compras = parseFloat(r.compras_periodo || 0);
        const usado = parseFloat(r.usado_produccion || 0);
        const stockFinal = parseFloat(r.stock_final || (remanente + compras - usado));
        const cpk = parseFloat(r.cpk_promedio || 0);
        const valorFinal = stockFinal * cpk;

        const baseDisponible = (remanente > 0 ? remanente : 0) + compras;
        const pctUsado = baseDisponible > 0 ? Math.min(100, Math.round((usado / baseDisponible) * 100)) : (usado > 0 ? 100 : 0);
        const barColor = pctUsado > 75 ? '#ef4444' : (pctUsado > 35 ? '#f59e0b' : (pctUsado > 0 ? '#38bdf8' : 'rgba(255,255,255,.2)'));

        return `<tr>
            <td style="font-weight:600;color:#fff;">
                <div style="display:flex;align-items:center;gap:6px;">
                    <span style="font-size:.88rem;">${r.ingrediente}</span>
                </div>
            </td>
            <td>${_getMpCatBadge(r.ingrediente)}</td>
            <td style="text-align:right;color:#cbd5e1;font-family:monospace;font-size:.85rem;">
                ${remanente.toLocaleString('es-MX', {maximumFractionDigits:2})} ${u}
            </td>
            <td style="text-align:right;color:#38bdf8;font-weight:600;font-family:monospace;font-size:.85rem;">
                ${compras > 0 ? '+' + compras.toLocaleString('es-MX', {maximumFractionDigits:2}) + ' ' + u : '—'}
            </td>
            <td style="text-align:right;color:#fb7185;font-weight:600;font-family:monospace;font-size:.85rem;">
                ${usado > 0 ? '−' + usado.toLocaleString('es-MX', {maximumFractionDigits:2}) + ' ' + u : '—'}
            </td>
            <td style="text-align:right;color:#10b981;font-weight:700;font-family:monospace;font-size:.9rem;">
                ${stockFinal.toLocaleString('es-MX', {maximumFractionDigits:2})} ${u}
            </td>
            <td style="text-align:center;">
                <div style="display:flex;flex-direction:column;align-items:center;gap:3px;">
                    <div style="width:100%;max-width:110px;height:6px;background:rgba(255,255,255,.1);border-radius:3px;overflow:hidden;">
                        <div style="width:${pctUsado}%;height:100%;background:${barColor};border-radius:3px;"></div>
                    </div>
                    <span style="font-size:.68rem;color:${pctUsado > 0 ? '#38bdf8' : 'var(--text-dim)'};font-weight:${pctUsado > 0 ? '600' : '400'};">
                        ${pctUsado}% usado ${usado > 0 ? '(' + usado.toLocaleString('es-MX',{maximumFractionDigits:1}) + ' ' + u + ')' : ''}
                    </span>
                </div>
            </td>
            <td style="text-align:right;font-size:.8rem;color:var(--text-dim);">$${cpk.toLocaleString('es-MX',{minimumFractionDigits:2, maximumFractionDigits:2})}/${u}</td>
            <td style="text-align:right;color:var(--warning);font-weight:600;font-size:.85rem;">$${valorFinal.toLocaleString('es-MX',{minimumFractionDigits:2, maximumFractionDigits:2})}</td>
        </tr>`;
    }).join('');

    if (pagDiv) {
        if (totalPages <= 1) { pagDiv.innerHTML = ''; return; }
        let btns = '';
        const from = Math.max(0, p - 2);
        const to   = Math.min(totalPages - 1, p + 2);
        if (from > 0) btns += `<button class="btn btn-outline btn-sm" onclick="window._invMpBalancePage=0;_renderInvMpBalance(window._invMpBalanceFiltered)">1</button><span style="color:var(--text-dim);">…</span>`;
        for (let i = from; i <= to; i++) {
            const active = i === p ? 'style="background:var(--accent-purple);color:#fff;border-color:var(--accent-purple);"' : '';
            btns += `<button class="btn btn-outline btn-sm" ${active} onclick="window._invMpBalancePage=${i};_renderInvMpBalance(window._invMpBalanceFiltered)">${i+1}</button>`;
        }
        if (to < totalPages - 1) btns += `<span style="color:var(--text-dim);">…</span><button class="btn btn-outline btn-sm" onclick="window._invMpBalancePage=${totalPages-1};_renderInvMpBalance(window._invMpBalanceFiltered)">${totalPages}</button>`;
        pagDiv.innerHTML = btns;
    }
}

// ── Renderizado de Stock Disponible por Lote (PEPS) ──────────────────────────
function _renderInvMpStock(rows) {
    const tbody = document.getElementById('inventarioMpBody');
    const pagDiv = document.getElementById('invMpStockPagination');
    if (!tbody || !pagDiv) return;

    if (!rows.length) {
        tbody.innerHTML = '<tr><td colspan="10" style="text-align:center;color:var(--text-dim);padding:3rem;">No hay materias primas con saldo disponible registrado para este filtro.</td></tr>';
        pagDiv.innerHTML = '';
        return;
    }

    const ITEMS_PER_PAGE = 30;
    const totalPages = Math.ceil(rows.length / ITEMS_PER_PAGE);
    const p = window._invMpStockPage || 0;
    const pageRows = rows.slice(p * ITEMS_PER_PAGE, (p + 1) * ITEMS_PER_PAGE);

    tbody.innerHTML = pageRows.map(r => {
        const stockRestante = parseFloat(r.stock_restante || 0);
        const cantidad = parseFloat(r.cantidad || 0);
        const consumido = parseFloat(r.consumido || 0);
        const cpk = parseFloat(r.cpk || 0);
        const valorRestante = stockRestante * cpk;
        const u = r.unidad || 'kg';
        const pctConsumido = cantidad > 0 ? Math.min(100, Math.round((consumido / cantidad) * 100)) : 0;
        const pctDisponible = 100 - pctConsumido;

        return `<tr>
            <td style="font-size:.8rem;font-family:monospace;color:var(--primary);">${r.lote_peps || 'MP-'+r.id}</td>
            <td>
                <div style="display:flex;align-items:center;gap:6px;">
                    <span style="font-weight:600;color:#fff;">${r.ingrediente}</span>
                    ${_getMpCatBadge(r.ingrediente)}
                </div>
            </td>
            <td style="font-size:.82rem;color:var(--text-dim);">${r.fecha || '—'}</td>
            <td style="font-size:.8rem;"><span style="background:rgba(99,102,241,.12);color:#a5b4fc;padding:2px 6px;border-radius:4px;">🏭 ${(r.planta || 'planta_1').replace('_',' ').toUpperCase()}</span></td>
            <td style="text-align:right;">${cantidad.toLocaleString('es-MX', {maximumFractionDigits:2})} ${u}</td>
            <td style="text-align:right;color:var(--text-dim);">${consumido > 0 ? consumido.toLocaleString('es-MX', {maximumFractionDigits:2}) + ' ' + u : '—'}</td>
            <td style="text-align:center;">
                <div style="display:flex;flex-direction:column;align-items:center;gap:3px;">
                    <div style="width:100%;max-width:100px;height:6px;background:rgba(255,255,255,.1);border-radius:3px;overflow:hidden;">
                        <div style="width:${pctConsumido}%;height:100%;background:${pctConsumido > 80 ? '#ef4444' : (pctConsumido > 40 ? '#f59e0b' : '#10b981')};border-radius:3px;"></div>
                    </div>
                    <span style="font-size:.68rem;color:var(--text-dim);">${pctConsumido}% consumido (${pctDisponible}% libre)</span>
                </div>
            </td>
            <td style="text-align:right;color:#10b981;font-weight:700;">${stockRestante.toLocaleString('es-MX', {maximumFractionDigits:2})} ${u}</td>
            <td style="text-align:right;font-size:.8rem;color:var(--text-dim);">$${cpk.toLocaleString('es-MX',{minimumFractionDigits:2})}/${u}</td>
            <td style="text-align:right;color:var(--warning);font-weight:600;">$${valorRestante.toLocaleString('es-MX',{minimumFractionDigits:2})}</td>
        </tr>`;
    }).join('');

    if (totalPages <= 1) { pagDiv.innerHTML = ''; return; }
    let btns = '';
    const from = Math.max(0, p - 2);
    const to   = Math.min(totalPages - 1, p + 2);
    if (from > 0) btns += `<button class="btn btn-outline btn-sm" onclick="window._invMpStockPage=0;_renderInvMpStock(window._invMpStockFiltered)">1</button><span style="color:var(--text-dim);">…</span>`;
    for (let i = from; i <= to; i++) {
        const active = i === p ? 'style="background:var(--accent-purple);color:#fff;border-color:var(--accent-purple);"' : '';
        btns += `<button class="btn btn-outline btn-sm" ${active} onclick="window._invMpStockPage=${i};_renderInvMpStock(window._invMpStockFiltered)">${i+1}</button>`;
    }
    if (to < totalPages - 1) btns += `<span style="color:var(--text-dim);">…</span><button class="btn btn-outline btn-sm" onclick="window._invMpStockPage=${totalPages-1};_renderInvMpStock(window._invMpStockFiltered)">${totalPages}</button>`;
    pagDiv.innerHTML = btns;
}

// ── Gestión del Modal de Nuevo Ingreso de Materia Prima ───────────────────────
function _poblarDatalistIngredientesMP(rows) {
    const dl = document.getElementById('lista-ingredientes-mp');
    if (!dl) return;
    const setIngs = new Set();
    (rows || []).forEach(r => {
        if (r.ingrediente) setIngs.add(r.ingrediente.trim());
    });
    ['ALCOHOL ISOPROPILICO', 'ATOMIZADOR', 'BOTELLA OVAL', 'CACAO', 'CAJA DULET CHICA', 'CAJAS INDIVIDUAL EUCAMENT', 'COCOA', 'ETIQUETA NATURAL MEXICO', 'SUERO DE LECHE', 'FRAGANCIA EUCALIPTO', 'MENTOL'].forEach(i => setIngs.add(i));
    dl.innerHTML = Array.from(setIngs).sort().map(ing => `<option value="${ing}">`).join('');
}

function abrirModalNuevoIngresoMP() {
    const m = document.getElementById('modalNuevoIngresoMP');
    if (!m) return;
    const fechaEl = document.getElementById('nmp-fecha');
    if (fechaEl && !fechaEl.value) fechaEl.value = new Date().toISOString().slice(0, 10);
    _calcularTotalIngresoMP();
    m.style.display = 'flex';
}

function cerrarModalNuevoIngresoMP() {
    const m = document.getElementById('modalNuevoIngresoMP');
    if (m) m.style.display = 'none';
}

function _calcularTotalIngresoMP() {
    const cant = parseFloat(document.getElementById('nmp-cantidad')?.value || 0);
    const unit = parseFloat(document.getElementById('nmp-costo-unit')?.value || 0);
    const totalEl = document.getElementById('nmp-costo-total');
    if (totalEl) {
        const total = (cant > 0 && unit > 0) ? (cant * unit) : 0;
        totalEl.value = `$${total.toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
    }
}

async function guardarNuevoIngresoMP(event) {
    if (event) event.preventDefault();
    const btn = document.getElementById('btnGuardarIngresoMP');
    if (btn) btn.disabled = true;

    try {
        const fecha = document.getElementById('nmp-fecha')?.value;
        const ingrediente = document.getElementById('nmp-ingrediente')?.value?.trim().toUpperCase();
        const cantidad = parseFloat(document.getElementById('nmp-cantidad')?.value || 0);
        const unidad = document.getElementById('nmp-unidad')?.value || 'kg';
        const costoUnit = parseFloat(document.getElementById('nmp-costo-unit')?.value || 0);
        const planta = document.getElementById('nmp-planta')?.value || 'planta_1';
        const proveedor = document.getElementById('nmp-proveedor')?.value?.trim() || '';
        const loteProv = document.getElementById('nmp-lote-prov')?.value?.trim() || '';
        const notas = document.getElementById('nmp-notas')?.value?.trim() || '';

        if (!fecha || !ingrediente || cantidad <= 0 || costoUnit <= 0) {
            BO_AUTH.showAlert('Por favor completa todos los campos requeridos (*).', 'warning');
            if (btn) btn.disabled = false;
            return;
        }

        const costoTotal = Math.round(cantidad * costoUnit * 100) / 100;
        const fStr = fecha.replace(/-/g, '');
        const hex = Math.random().toString(16).substring(2, 8).toUpperCase();
        const lotePeps = `PEPS-${fStr}-${hex}`;
        const creadoPor = CURRENT_USER?.nombre || CURRENT_USER?.email || 'admin';
        const notasFinal = [loteProv, notas].filter(Boolean).join(' | ');

        const sql = `
            INSERT INTO inventario_mp (
                ingrediente, tipo_movimiento, cantidad_kg, costo_unitario_kg, costo_total,
                lote_peps, referencia_tipo, proveedor_rfc, fecha, saldo_restante_kg, unidad, notas, creado_por, planta
            ) VALUES (
                '${ingrediente.replace(/'/g, "''")}', 'ingreso', ${cantidad}, ${costoUnit}, ${costoTotal},
                '${lotePeps}', 'compra', '${proveedor.replace(/'/g, "''")}', '${fecha}', ${cantidad}, '${unidad}',
                '${notasFinal.replace(/'/g, "''")}', '${creadoPor.replace(/'/g, "''")}', '${planta}'
            );
        `;

        const res = await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql });
        if (res?.error) {
            BO_AUTH.showAlert('Error registrando ingreso: ' + res.error, 'danger');
            if (btn) btn.disabled = false;
            return;
        }

        BO_AUTH.showAlert(`✅ Ingreso registrado exitosamente (Lote: ${lotePeps}).`, 'success');
        cerrarModalNuevoIngresoMP();
        document.getElementById('formNuevoIngresoMP')?.reset();
        loadInventarioMP();

    } catch (e) {
        BO_AUTH.showAlert('Error al registrar ingreso: ' + e.message, 'danger');
    } finally {
        if (btn) btn.disabled = false;
    }
}

// ── Exportación a Excel y CSV con SheetJS ─────────────────────────────────────
function _obtenerDatosExportacionInventarioMp() {
    if (window._invMpVista === 'balance') {
        const rows = window._invMpBalanceFiltered || [];
        if (!rows.length) {
            BO_AUTH.showAlert('No hay datos en el Balance de Insumos para exportar.', 'warning');
            return null;
        }
        const headers = ['Componente / Insumo', 'Categoría', 'Remanente Anterior', 'Compras Periodo', 'Usado en Producción', 'Stock Final', 'Unidad', '% Usado Periodo', 'Costo Promedio (CPK $)', 'Valor Total Stock ($)'];
        const data = [headers];
        let totRemanente = 0, totCompras = 0, totUsado = 0, totFinal = 0, totValor = 0;

        rows.forEach(r => {
            const remanente = parseFloat(r.remanente_anterior || 0);
            const compras = parseFloat(r.compras_periodo || 0);
            const usado = parseFloat(r.usado_produccion || 0);
            const stockFinal = parseFloat(r.stock_final || (remanente + compras - usado));
            const cpk = parseFloat(r.cpk_promedio || 0);
            const valor = stockFinal * cpk;
            const base = remanente + compras;
            const pct = base > 0 ? (usado / base * 100) : 0;

            totRemanente += remanente;
            totCompras += compras;
            totUsado += usado;
            totFinal += stockFinal;
            totValor += valor;

            data.push([
                r.ingrediente,
                _getMpCategoria(r.ingrediente).toUpperCase(),
                remanente,
                compras,
                usado,
                stockFinal,
                r.unidad || 'kg',
                `${pct.toFixed(1)}%`,
                cpk,
                Math.round(valor * 100) / 100
            ]);
        });

        data.push(['TOTALES', `${rows.length} insumos`, totRemanente, totCompras, totUsado, totFinal, '', '', '', Math.round(totValor * 100) / 100]);
        return { data, nombre: 'Balance_Insumos_Materia_Prima' };

    } else if (window._invMpVista === 'kardex') {
        const rows = window._invMpKardexFiltered || [];
        if (!rows.length) {
            BO_AUTH.showAlert('No hay movimientos en el filtro actual para exportar.', 'warning');
            return null;
        }
        const headers = ['ID', 'Fecha', 'Tipo Movimiento', 'Componente / Insumo', 'Categoría', 'Lote MP', 'Destino / Origen', 'Cantidad', 'Unidad', 'Saldo Lote', 'Costo Unitario ($)', 'Costo Total ($)', 'Planta', 'Registrado Por'];
        const data = [headers];
        let totIngresos = 0, totSalidas = 0;

        rows.forEach(r => {
            const esIngreso = (r.tipo_movimiento || '').toLowerCase() === 'ingreso';
            const cant = parseFloat(r.cantidad || 0);
            const cTotal = parseFloat(r.costo_total || 0) || (cant * parseFloat(r.cpk || 0));
            if (esIngreso) totIngresos += cTotal;
            else totSalidas += cTotal;

            data.push([
                r.id,
                r.fecha,
                (r.tipo_movimiento || '').toUpperCase(),
                r.ingrediente,
                _getMpCategoria(r.ingrediente).toUpperCase(),
                r.lote_peps || '—',
                r.notas || r.referencia_tipo || '—',
                esIngreso ? cant : -cant,
                r.unidad || 'kg',
                parseFloat(r.saldo_restante || 0),
                parseFloat(r.cpk || 0),
                cTotal,
                (r.planta || 'planta_1').toUpperCase(),
                r.creado_por || 'sistema'
            ]);
        });

        data.push(['TOTALES', '', '', `${rows.length} movimientos`, '', '', '', '', '', '', '', `Ingresos: $${totIngresos.toFixed(2)} | Salidas: $${totSalidas.toFixed(2)}`, '', '']);
        return { data, nombre: 'Kardex_Materias_Primas' };

    } else {
        const rows = window._invMpStockFiltered || [];
        if (!rows.length) {
            BO_AUTH.showAlert('No hay lotes con stock en el filtro actual para exportar.', 'warning');
            return null;
        }
        const headers = ['ID Lote MP', 'Componente / Insumo', 'Categoría', 'Fecha Ingreso', 'Planta', 'Ingreso Inicial', 'Consumido', 'Stock Restante', 'Unidad', 'Costo Unitario (CPK)', 'Valor Inv. Restante ($)'];
        const data = [headers];
        let valorTotal = 0;

        rows.forEach(r => {
            const stock = parseFloat(r.stock_restante || 0);
            const cpk = parseFloat(r.cpk || 0);
            const vRest = stock * cpk;
            valorTotal += vRest;

            data.push([
                r.lote_peps || 'MP-' + r.id,
                r.ingrediente,
                _getMpCategoria(r.ingrediente).toUpperCase(),
                r.fecha,
                (r.planta || 'planta_1').toUpperCase(),
                parseFloat(r.cantidad || 0),
                parseFloat(r.consumido || 0),
                stock,
                r.unidad || 'kg',
                cpk,
                Math.round(vRest * 100) / 100
            ]);
        });

        data.push(['TOTALES', `${rows.length} lotes`, '', '', '', '', '', '', '', 'Valor Total:', Math.round(valorTotal * 100) / 100]);
        return { data, nombre: 'Stock_Disponible_Materias_Primas' };
    }
}

function exportarInventarioMpXLSX() {
    if (typeof XLSX === 'undefined') {
        BO_AUTH.showAlert('Librería SheetJS no encontrada para exportar Excel.', 'danger');
        return;
    }
    const info = _obtenerDatosExportacionInventarioMp();
    if (!info) return;

    const ws = XLSX.utils.aoa_to_sheet(info.data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, info.nombre.substring(0, 31));
    const desde = document.getElementById('invMpDesde')?.value || 'periodo';
    const hasta = document.getElementById('invMpHasta')?.value || 'periodo';
    XLSX.writeFile(wb, `${info.nombre}_${desde}_a_${hasta}.xlsx`);
    BO_AUTH.showAlert(`✅ Excel generado exitosamente.`, 'success');
}

function exportarInventarioMpCSV() {
    if (typeof XLSX === 'undefined') {
        BO_AUTH.showAlert('Librería SheetJS no encontrada para exportar CSV.', 'danger');
        return;
    }
    const info = _obtenerDatosExportacionInventarioMp();
    if (!info) return;

    const ws = XLSX.utils.aoa_to_sheet(info.data);
    const csv = XLSX.utils.sheet_to_csv(ws);
    const blob = new Blob(["\uFEFF" + csv], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    const desde = document.getElementById('invMpDesde')?.value || 'periodo';
    const hasta = document.getElementById('invMpHasta')?.value || 'periodo';
    a.download = `${info.nombre}_${desde}_a_${hasta}.csv`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    setTimeout(() => URL.revokeObjectURL(url), 60000);
    BO_AUTH.showAlert(`✅ Archivo CSV generado exitosamente.`, 'success');
}

window.loadInventarioMP = loadInventarioMP;
window._setInvMpVista = _setInvMpVista;
window._setInvMpCategoria = _setInvMpCategoria;
window._onInvMpMesChange = _onInvMpMesChange;
window._cambiarMesInvMp = _cambiarMesInvMp;
window._setInvMpRango = _setInvMpRango;
window._filtrarInvMp = _filtrarInvMp;
window._aplicarFiltrosYRenderInvMp = _aplicarFiltrosYRenderInvMp;
window.abrirModalNuevoIngresoMP = abrirModalNuevoIngresoMP;
window.cerrarModalNuevoIngresoMP = cerrarModalNuevoIngresoMP;
window._calcularTotalIngresoMP = _calcularTotalIngresoMP;
window.guardarNuevoIngresoMP = guardarNuevoIngresoMP;
window.exportarInventarioMpXLSX = exportarInventarioMpXLSX;
window.exportarInventarioMpCSV = exportarInventarioMpCSV;


let _prodChartMes = null;
let _prodChartPie = null;

function initProduccionView() {
    // Establecer rango por defecto: mes actual
    const desdeEl = document.getElementById('prodDesde');
    const hastaEl = document.getElementById('prodHasta');
    const hoy = new Date();
    if (desdeEl && !desdeEl.value) desdeEl.value = `${hoy.getFullYear()}-${String(hoy.getMonth()+1).padStart(2,'0')}-01`;
    if (hastaEl && !hastaEl.value) hastaEl.value = hoy.toISOString().slice(0,10);
    
    if (typeof switchProdTab === 'function') switchProdTab('lotes');
    else loadProduccion();
    
    // Cargar automáticamente los bloques secundarios
    if (typeof loadLotesSinVincular === 'function') loadLotesSinVincular();
    if (typeof loadTrazabilidadPEPS === 'function') loadTrazabilidadPEPS();
}

// Quick range buttons for production filter
function _setProdRango(tipo) {
    const hoy = new Date();
    const desdeEl = document.getElementById('prodDesde');
    const hastaEl = document.getElementById('prodHasta');
    if (!desdeEl || !hastaEl) return;
    hastaEl.value = hoy.toISOString().slice(0,10);
    let d = new Date(hoy);
    if (tipo === 'hoy') { /* d stays today */ }
    else if (tipo === '3dias') d.setDate(d.getDate() - 2);
    else if (tipo === 'semana') d.setDate(d.getDate() - 6);
    else if (tipo === 'mes') d = new Date(hoy.getFullYear(), hoy.getMonth(), 1);
    desdeEl.value = d.toISOString().slice(0,10);
    loadProduccion();
}


// ── SUB-REPORTE: Lotes sin vincular a inventario ──
async function loadLotesSinVincular(desde, hasta) {
    const body = document.getElementById('lotesNoVinculadosBody');
    if (!body) return;
    body.innerHTML = '<tr><td colspan="5" style="text-align:center;padding:1rem;color:var(--text-dim);"><div class="spinner" style="display:inline-block;width:14px;height:14px;vertical-align:middle;margin-right:6px;"></div> Cargando...</td></tr>';
    
    const _desde = desde || document.getElementById('prodDesde')?.value || '';
    const _hasta = hasta || document.getElementById('prodHasta')?.value || '';
    const dateWhere = (_desde && _hasta) ? `AND (p.fecha::date BETWEEN '${_desde}' AND '${_hasta}')` : '';

    try {
        const sql = `
            SELECT p.id, p.fecha, p.producto_id, p.lote, p.cantidad, p.liberado
            FROM produccion_diaria p
            LEFT JOIN inventario_transacciones t 
              ON (t.tipo_movimiento = 'produccion' AND (t.notas LIKE '%' || p.lote || '%' OR t.notas = p.lote))
            WHERE t.id IS NULL ${dateWhere}
            ORDER BY p.fecha DESC, p.id DESC
            LIMIT 100`;
        const res = await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql });
        const noVinculados = res?.rows || [];

        if (!noVinculados.length) {
            body.innerHTML = '<tr><td colspan="5" style="text-align:center;padding:1.5rem;color:#86efac;font-weight:600;">✅ Todos los lotes del periodo están vinculados al inventario</td></tr>';
            return;
        }

        body.innerHTML = noVinculados.map(l => {
            const fechaStr = l.fecha ? String(l.fecha).substring(0, 10) : '—';
            const estadoHtml = (l.liberado === true || l.liberado === 't' || l.liberado === 1)
                ? '<span style="color:#86efac;">✅ Liberado</span>'
                : '<span style="color:#fbbf24;">⏳ Pendiente</span>';
            const pNombre = typeof window._nombreSaborLegible === 'function' ? window._nombreSaborLegible(l.producto_id) : (l.producto_id || '—');
            return `<tr>
                <td>${fechaStr}</td>
                <td style="font-family:monospace;font-size:.78rem;font-weight:600;">${l.lote || '—'}</td>
                <td style="font-weight:600;">${pNombre}</td>
                <td style="text-align:right;font-weight:600;">${Number(l.cantidad || 0).toLocaleString()}</td>
                <td style="text-align:center;">${estadoHtml}</td>
            </tr>`;
        }).join('');
    } catch (e) {
        console.error('loadLotesSinVincular', e);
        body.innerHTML = '<tr><td colspan="5" style="text-align:center;color:#f87171;padding:1rem;">Error: ' + e.message + '</td></tr>';
    }
}

// ── SUB-REPORTE: Trazabilidad PEPS (fuente de lotes) ──
async function loadTrazabilidadPEPS(desde, hasta) {
    const body = document.getElementById('trazabilidadPepsBody');
    if (!body) return;
    body.innerHTML = '<tr><td colspan="6" style="text-align:center;padding:1rem;color:var(--text-dim);"><div class="spinner" style="display:inline-block;width:14px;height:14px;vertical-align:middle;margin-right:6px;"></div> Cargando...</td></tr>';
    
    const _desde = desde || document.getElementById('prodDesde')?.value || '';
    const _hasta = hasta || document.getElementById('prodHasta')?.value || '';
    const dateWhere = (_desde && _hasta) ? `WHERE (p.fecha::date BETWEEN '${_desde}' AND '${_hasta}')` : '';

    try {
        const sql = `
            SELECT p.id, p.fecha, p.producto_id, p.lote, p.cantidad,
                   COALESCE(SUM(t.cantidad), 0) AS al_inventario
            FROM produccion_diaria p
            LEFT JOIN inventario_transacciones t 
              ON (t.tipo_movimiento = 'produccion' AND (t.notas LIKE '%' || p.lote || '%' OR t.notas = p.lote))
            ${dateWhere}
            GROUP BY p.id, p.fecha, p.producto_id, p.lote, p.cantidad
            ORDER BY p.fecha DESC, p.id DESC
            LIMIT 100`;
        const res = await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql });
        const lotes = res?.rows || [];

        if (!lotes.length) {
            body.innerHTML = '<tr><td colspan="6" style="text-align:center;padding:1.5rem;color:var(--text-dim);">Sin registros de lotes en el periodo seleccionado</td></tr>';
            return;
        }

        body.innerHTML = lotes.map(l => {
            const producido = Number(l.cantidad || 0);
            const alInv = Number(l.al_inventario || 0);
            const remanente = producido - alInv;
            const rColor = remanente > 0 ? '#fbbf24' : (remanente === 0 ? '#86efac' : '#38bdf8');
            const fuente = alInv > 0 ? '<span style="color:#86efac;">📦 Inventario</span>' : '<span style="color:#f87171;">❌ Sin ingreso</span>';
            const pNombre = typeof window._nombreSaborLegible === 'function' ? window._nombreSaborLegible(l.producto_id) : (l.producto_id || '—');
            return `<tr>
                <td style="font-family:monospace;font-size:.78rem;font-weight:600;">PD-${l.id} (${l.lote || '—'})</td>
                <td style="font-weight:600;">${pNombre}</td>
                <td style="text-align:right;">${producido.toLocaleString()}</td>
                <td style="text-align:right;">${alInv.toLocaleString()}</td>
                <td style="text-align:right;font-weight:700;color:${rColor};">${remanente.toLocaleString()}</td>
                <td>${fuente}</td>
            </tr>`;
        }).join('');
    } catch (e) {
        console.error('loadTrazabilidadPEPS', e);
        body.innerHTML = '<tr><td colspan="6" style="text-align:center;color:#f87171;padding:1rem;">Error: ' + e.message + '</td></tr>';
    }
}

// ══════════════════════════════════════════════════════════════════
// 📦 VARIANTES DE PRODUCTO OFICIALES (SABORES Y PRESENTACIONES)
// ══════════════════════════════════════════════════════════════════
const PROD_VARIANTES = [
    { key: 'natural_bote',   label: 'Nat. Bote (500g)',   color: '#2563eb' },
    { key: 'natural_sachet', label: 'Nat. Sach. (500g)', color: '#60a5fa' },
    { key: 'fresa_bote',     label: 'Fresa Bote (450g)',   color: '#e11d48' },
    { key: 'fresa_sachet',   label: 'Fresa Sach. (450g)', color: '#fb7185' },
    { key: 'vainilla_bote',  label: 'Vain. Bote (450g)',   color: '#d97706' },
    { key: 'vainilla_sachet',label: 'Vain. Sach. (450g)', color: '#fcd34d' },
    { key: 'choco_bote',     label: 'Choco Bote (450g)',   color: '#7c3aed' },
    { key: 'choco_sachet',   label: 'Choco Sach. (450g)', color: '#c084fc' },
    { key: 'eucament',       label: 'Eucament (60ml)',     color: '#10b981' }
];

const PROD_SABORES_UNIFICADOS = [
    { key: 'natural',   label: 'Dulet Natural',   color: '#2563eb' },
    { key: 'fresa',     label: 'Dulet Fresa',     color: '#e11d48' },
    { key: 'vainilla',  label: 'Dulet Vainilla',  color: '#d97706' },
    { key: 'choco',     label: 'Dulet Chocolate', color: '#7c3aed' },
    { key: 'eucament',  label: 'Eucament',        color: '#10b981' }
];
window.PROD_SABORES_UNIFICADOS = PROD_SABORES_UNIFICADOS;

function _clasificarVarianteProduccion(r) {
    if (!r) return 'natural_bote';
    const prod = String(r.producto_id || '').toLowerCase().trim();
    const pres = String(r.presentacion || '').toLowerCase().trim();
    const pais = String(r.etiquetado_pais || '').toUpperCase().trim();

    if (prod.includes('eucament')) return 'eucament';

    // Regla de Oro 2026: USA y GTQ son Bote; MEX es Sachet
    let esSachet = false;
    if (pres === 'sachet' || pres === 'bolsa' || prod.includes('sachet') || prod.includes('bolsa')) {
        esSachet = true;
    } else if (pres === 'bote' || prod.includes('bote')) {
        esSachet = false;
    } else {
        esSachet = !(pais === 'USA' || pais === 'GTQ' || pais === 'GTM');
    }

    if (prod.includes('fresa')) return esSachet ? 'fresa_sachet' : 'fresa_bote';
    if (prod.includes('vainilla')) return esSachet ? 'vainilla_sachet' : 'vainilla_bote';
    if (prod.includes('choco') || prod.includes('cacao') || prod.includes('chocolate')) return esSachet ? 'choco_sachet' : 'choco_bote';
    return esSachet ? 'natural_sachet' : 'natural_bote';
}
window.PROD_VARIANTES = PROD_VARIANTES;
window._clasificarVarianteProduccion = _clasificarVarianteProduccion;

function _renderGraficasProduccion(rows, rangoLabel) {
    try {
        const canvasMes = document.getElementById('chartProduccionMes');
        const canvasPie = document.getElementById('chartProduccionPie');
        if (!canvasMes || !canvasPie || typeof Chart === 'undefined') return;

        const prodKeys   = PROD_VARIANTES.map(v => v.key);
        const prodLabels = PROD_VARIANTES.map(v => v.label);
        const colors     = PROD_VARIANTES.map(v => v.color);

        // Totales por producto y presentación
        const totProd = {};
        prodKeys.forEach(k => totProd[k] = 0);
        rows.forEach(r => {
            const k = _clasificarVarianteProduccion(r);
            if (totProd[k] !== undefined) totProd[k] += (+r.cantidad || 0);
        });

        const totalUds = Object.values(totProd).reduce((a, b) => a + b, 0);

        // Comparativa por planta
        const plantas = [...new Set(rows.map(r => r.planta).filter(Boolean))].sort();
        const hasPlantas = plantas.length > 1;

        // ── Agrupación unificada en sabores y productos para gráfico de dona ──
        const totSabor = { natural: 0, fresa: 0, vainilla: 0, choco: 0, eucament: 0 };
        rows.forEach(r => {
            const k = _clasificarVarianteProduccion(r);
            const cant = (+r.cantidad || 0);
            if (k.startsWith('natural')) totSabor.natural += cant;
            else if (k.startsWith('fresa')) totSabor.fresa += cant;
            else if (k.startsWith('vainilla')) totSabor.vainilla += cant;
            else if (k.startsWith('choco')) totSabor.choco += cant;
            else if (k === 'eucament') totSabor.eucament += cant;
        });

        const activeSabores = PROD_SABORES_UNIFICADOS.filter(s => totSabor[s.key] > 0);
        const finalPieVars   = activeSabores.length > 0 ? activeSabores : PROD_SABORES_UNIFICADOS;

        const pieLabels = finalPieVars.map(s => {
            const q = totSabor[s.key] || 0;
            const pct = totalUds > 0 ? ((q / totalUds) * 100).toFixed(1) : '0';
            return `${s.label}: ${q.toLocaleString()} (${pct}%)`;
        });
        const pieData   = finalPieVars.map(s => totSabor[s.key] || 0);
        const pieColors = finalPieVars.map(s => s.color);

        if (_prodChartPie) _prodChartPie.destroy();
        _prodChartPie = new Chart(canvasPie, {
            type: 'doughnut',
            data: {
                labels: pieLabels,
                datasets: [{
                    data: pieData,
                    backgroundColor: pieColors,
                    borderWidth: 1.5,
                    borderColor: '#1e293b'
                }]
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    legend: {
                        position: 'bottom',
                        labels: { boxWidth: 10, font: { size: 10, weight: '600' }, color: '#cbd5e1' }
                    }
                }
            },
            plugins: [{
                id: 'centerTotalDoughnut',
                afterDraw(chart) {
                    const { ctx, chartArea: { left, right, top, bottom } } = chart;
                    if (!left && !right) return;
                    const cx = (left + right) / 2;
                    const cy = (top + bottom) / 2;
                    ctx.save();
                    ctx.textAlign = 'center';
                    ctx.textBaseline = 'middle';
                    ctx.font = '9px system-ui, sans-serif';
                    ctx.fillStyle = '#94a3b8';
                    ctx.fillText('TOTAL', cx, cy - 7);
                    ctx.font = 'bold 12px system-ui, sans-serif';
                    ctx.fillStyle = '#f8fafc';
                    ctx.fillText(totalUds.toLocaleString() + ' uds', cx, cy + 7);
                    ctx.restore();
                }
            }]
        });

        // Plugin para pintar las cifras exactas encima de cada barra
        const barLabelPlugin = {
            id: 'barValueLabels',
            afterDatasetsDraw(chart) {
                const { ctx } = chart;
                ctx.save();
                ctx.font = 'bold 10px system-ui, sans-serif';
                ctx.fillStyle = '#f1f5f9';
                ctx.textAlign = 'center';
                ctx.textBaseline = 'bottom';
                chart.data.datasets.forEach((dataset, i) => {
                    const meta = chart.getDatasetMeta(i);
                    if (!meta.hidden) {
                        meta.data.forEach((element, index) => {
                            const val = dataset.data[index];
                            if (val && val > 0) {
                                ctx.fillText(Number(val).toLocaleString(), element.x, element.y - 3);
                            }
                        });
                    }
                });
                ctx.restore();
            }
        };

        if (_prodChartMes) _prodChartMes.destroy();

        if (hasPlantas) {
            // Modo comparativa: un dataset por planta, X = variantes fijas
            const plantaColors = ['#6366f1','#f59e0b','#ef4444','#10b981','#3b82f6'];
            const datasets = plantas.map((planta, pi) => {
                const data = prodKeys.map(prod => {
                    return rows.filter(r => r.planta === planta && _clasificarVarianteProduccion(r) === prod)
                               .reduce((s, r) => s + (+r.cantidad||0), 0);
                });
                const col = plantaColors[pi % plantaColors.length];
                return {
                    label: planta === 'planta_1' ? 'Planta 1' : (planta === 'planta_2' ? 'Planta 2' : planta.replace('_',' ')),
                    data,
                    backgroundColor: col + 'cc',
                    borderColor: col,
                    borderWidth: 2,
                    borderRadius: 4
                };
            });
            _prodChartMes = new Chart(canvasMes, {
                type: 'bar',
                data: { labels: prodLabels, datasets },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    layout: { padding: { top: 18 } },
                    plugins: {
                        legend: { position: 'top', labels: { boxWidth: 12, font: { size: 10 }, color: '#cbd5e1' } }
                    },
                    scales: {
                        x: { stacked: false, grid: { display: false }, ticks: { color: '#94a3b8', font: { size: 9 } } },
                        y: { beginAtZero: true, grid: { color: 'rgba(63,63,70,.2)' }, ticks: { color: '#94a3b8', precision: 0 } }
                    }
                },
                plugins: [barLabelPlugin]
            });
        } else {
            // Sin comparativa: barras fijas para cada variante con su color asignado
            _prodChartMes = new Chart(canvasMes, {
                type: 'bar',
                data: {
                    labels: prodLabels,
                    datasets: [{
                        label: `Uds producidas (${rangoLabel})`,
                        data: prodKeys.map(k => totProd[k]),
                        backgroundColor: colors.map(c => c + 'cc'),
                        borderColor: colors,
                        borderWidth: 2,
                        borderRadius: 4
                    }]
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    layout: { padding: { top: 18 } },
                    plugins: { legend: { display: false } },
                    scales: {
                        y: { beginAtZero: true, grid: { color: 'rgba(63,63,70,.2)' }, ticks: { color: '#94a3b8', precision: 0 } },
                        x: { grid: { display: false }, ticks: { color: '#94a3b8', font: { size: 9 } } }
                    }
                },
                plugins: [barLabelPlugin]
            });
        }
    } catch(e) { console.warn('Error renderizando gráficas producción:', e); }
}

// ══════════════════════════════════════════════════════════════════
// 📅 BALANCE DE PRODUCCIÓN ANUAL (GRÁFICO GRANDE + MIX ANUAL)
// ══════════════════════════════════════════════════════════════════

let _prodChartAnual = null;
let _prodChartAnualPie = null;
window._prodGraficasModo = 'anual';
window._prodBalanceAnualCache = null;

function _setProdGraficasModo(modo) {
    window._prodGraficasModo = modo || 'anual';
    const btnAnual = document.getElementById('btn-prodGraficas-anual');
    const btnMes   = document.getElementById('btn-prodGraficas-mes');
    const cAnual   = document.getElementById('contenedorGraficasProdAnual');
    const cMes     = document.getElementById('contenedorGraficasProdMes');

    if (modo === 'mes') {
        if (btnMes)   { btnMes.style.background = 'var(--primary)'; btnMes.style.color = '#fff'; btnMes.style.fontWeight = '600'; }
        if (btnAnual) { btnAnual.style.background = 'transparent'; btnAnual.style.color = 'var(--text-dim)'; btnAnual.style.fontWeight = '500'; }
        if (cMes)   cMes.style.display = 'block';
        if (cAnual) cAnual.style.display = 'none';
        if (_prodChartMes) _prodChartMes.resize();
        if (_prodChartPie) _prodChartPie.resize();
    } else {
        window._prodGraficasModo = 'anual';
        if (btnAnual) { btnAnual.style.background = 'var(--primary)'; btnAnual.style.color = '#fff'; btnAnual.style.fontWeight = '600'; }
        if (btnMes)   { btnMes.style.background = 'transparent'; btnMes.style.color = 'var(--text-dim)'; btnMes.style.fontWeight = '500'; }
        if (cAnual) cAnual.style.display = 'block';
        if (cMes)   cMes.style.display = 'none';
        if (!window._prodBalanceAnualCache) {
            cargarBalanceProduccionAnual();
        } else {
            if (_prodChartAnual) _prodChartAnual.resize();
            if (_prodChartAnualPie) _prodChartAnualPie.resize();
        }
    }
}

async function cargarBalanceProduccionAnual(anioParam) {
    const selAnio = document.getElementById('prodBalanceAnualAnio');
    const anio = parseInt(anioParam || selAnio?.value || (new Date()).getFullYear(), 10);

    const subEl = document.getElementById('prodBalanceAnualSubtitulo');
    if (subEl) subEl.textContent = `Consolidado de unidades producidas mes a mes por producto — Año ${anio}`;

    try {
        // 1. Cargar años disponibles si aún no están poblados
        if (selAnio && selAnio.options.length <= 3) {
            try {
                const resAños = await BO_API.post('/bo/sql-relay', {
                    secret: 'duletia_relay_2026',
                    sql: `SELECT DISTINCT EXTRACT(YEAR FROM fecha)::int AS anio 
                          FROM produccion_diaria 
                          WHERE fecha IS NOT NULL AND EXTRACT(YEAR FROM fecha) >= 2020 
                          ORDER BY anio DESC`
                });
                const years = resAños?.rows?.map(r => r.anio).filter(Boolean) || [];
                if (years.length > 0) {
                    const currentVal = anio;
                    selAnio.innerHTML = years.map(y => `<option value="${y}" ${y === currentVal ? 'selected' : ''}>${y}</option>`).join('');
                }
            } catch(eYears) {
                console.warn('[Balance Anual] No se pudieron cargar años dinámicos:', eYears);
            }
        }

        // 2. Query de producción agrupada por mes, producto, presentación y país para el año
        const sql = `
            SELECT 
                EXTRACT(MONTH FROM fecha)::int AS mes,
                producto_id,
                COALESCE(presentacion, 'bote') AS presentacion,
                COALESCE(etiquetado_pais, 'MEX') AS etiquetado_pais,
                COALESCE(SUM(cantidad), 0)::int AS total_uds,
                COUNT(id)::int AS total_lotes
            FROM produccion_diaria
            WHERE EXTRACT(YEAR FROM fecha)::int = ${anio}
            GROUP BY 1, 2, 3, 4
            ORDER BY 1 ASC;
        `;
        const res = await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql });
        const rows = res?.rows || [];

        // 3. Procesar datos para 12 meses y 9 variantes fijas
        const prodKeys   = PROD_VARIANTES.map(v => v.key);
        const prodLabels = PROD_VARIANTES.map(v => v.label);
        const colors     = PROD_VARIANTES.map(v => v.color);

        // Matriz: matriz[varianteKey][mesIndex(0..11)] = uds
        const matriz = {};
        prodKeys.forEach(k => { matriz[k] = new Array(12).fill(0); });
        const totalesPorMes = new Array(12).fill(0);
        const lotesPorMes   = new Array(12).fill(0);
        const totalesPorSabor = {};
        prodKeys.forEach(k => { totalesPorSabor[k] = 0; });
        let granTotalAnual = 0;
        let granTotalLotes = 0;

        rows.forEach(r => {
            const k = _clasificarVarianteProduccion(r);
            const m = (parseInt(r.mes, 10) || 1) - 1; // 0..11
            const cant = parseInt(r.total_uds, 10) || 0;
            const lotes = parseInt(r.total_lotes, 10) || 0;

            if (matriz[k] && m >= 0 && m < 12) {
                matriz[k][m] += cant;
                totalesPorMes[m] += cant;
                totalesPorSabor[k] += cant;
                lotesPorMes[m] += lotes;
                granTotalAnual += cant;
                granTotalLotes += lotes;
            }
        });

        window._prodBalanceAnualCache = {
            anio,
            prodKeys,
            prodLabels,
            colors,
            matriz,
            totalesPorMes,
            lotesPorMes,
            totalesPorSabor,
            granTotalAnual,
            granTotalLotes
        };

        // 4. Renderizar KPIs, Gráficos y Tabla
        _renderKpisBalanceAnual(window._prodBalanceAnualCache);
        _renderGraficaAnual();
        _renderDonaAnual();
        _renderTablaBalanceMensual(window._prodBalanceAnualCache);

    } catch (e) {
        console.error('Error cargando balance de producción anual:', e);
        const kpisEl = document.getElementById('prodBalanceAnualKpis');
        if (kpisEl) kpisEl.innerHTML = `<div style="grid-column:1/-1;color:var(--danger);padding:1rem;text-align:center;">Error al cargar datos anuales: ${e.message}</div>`;
    }
}

function _renderKpisBalanceAnual(d) {
    const kpisEl = document.getElementById('prodBalanceAnualKpis');
    if (!kpisEl) return;

    const mesesNombres = ['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'];

    // Mes pico
    let maxMesIdx = 0;
    let maxMesVal = 0;
    d.totalesPorMes.forEach((val, idx) => {
        if (val > maxMesVal) {
            maxMesVal = val;
            maxMesIdx = idx;
        }
    });

    // Variante más producida
    let maxSaborKey = 'natural_bote';
    let maxSaborVal = 0;
    d.prodKeys.forEach(k => {
        if (d.totalesPorSabor[k] > maxSaborVal) {
            maxSaborVal = d.totalesPorSabor[k];
            maxSaborKey = k;
        }
    });
    const maxSaborLbl = d.prodLabels[d.prodKeys.indexOf(maxSaborKey)] || maxSaborKey;
    const maxSaborPct = d.granTotalAnual > 0 ? ((maxSaborVal / d.granTotalAnual) * 100).toFixed(1) : '0';

    // Promedio mensual
    const mesesConProd = d.totalesPorMes.filter(v => v > 0).length || 1;
    const promedioMes = Math.round(d.granTotalAnual / mesesConProd);

    kpisEl.innerHTML = `
        <div class="stat-card" style="padding:.6rem 1rem;">
            <div class="stat-label" style="font-size:.7rem;">🏭 Total Producido en ${d.anio}</div>
            <div class="stat-value" style="font-size:1.35rem;color:#10b981;font-weight:700;">
                ${d.granTotalAnual.toLocaleString()} <span style="font-size:.8rem;font-weight:400;color:var(--text-dim);">uds</span>
            </div>
        </div>
        <div class="stat-card" style="padding:.6rem 1rem;">
            <div class="stat-label" style="font-size:.7rem;">📈 Promedio Mensual Activo</div>
            <div class="stat-value" style="font-size:1.35rem;color:#38bdf8;font-weight:700;">
                ${promedioMes.toLocaleString()} <span style="font-size:.8rem;font-weight:400;color:var(--text-dim);">uds/mes</span>
            </div>
        </div>
        <div class="stat-card" style="padding:.6rem 1rem;">
            <div class="stat-label" style="font-size:.7rem;">🏆 Variante Más Producida</div>
            <div class="stat-value" style="font-size:1.2rem;color:#c084fc;font-weight:700;">
                ${maxSaborLbl} <span style="font-size:.8rem;font-weight:600;color:#e9d5ff;">(${maxSaborPct}%)</span>
            </div>
        </div>
        <div class="stat-card" style="padding:.6rem 1rem;">
            <div class="stat-label" style="font-size:.7rem;">⚡ Mes Récord de Producción</div>
            <div class="stat-value" style="font-size:1.2rem;color:#fbbf24;font-weight:700;">
                ${maxMesVal > 0 ? mesesNombres[maxMesIdx] : '—'} <span style="font-size:.8rem;font-weight:500;color:var(--text-dim);">${maxMesVal > 0 ? '(' + maxMesVal.toLocaleString() + ' uds)' : ''}</span>
            </div>
        </div>
        <div class="stat-card" style="padding:.6rem 1rem;">
            <div class="stat-label" style="font-size:.7rem;">🏷️ Lotes Fabricados en el Año</div>
            <div class="stat-value" style="font-size:1.35rem;color:#f43f5e;font-weight:700;">
                ${d.granTotalLotes.toLocaleString()} <span style="font-size:.8rem;font-weight:400;color:var(--text-dim);">lotes</span>
            </div>
        </div>
    `;
}

function cambiarTipoGraficaAnual(tipo) {
    _renderGraficaAnual(tipo);
}

function _renderGraficaAnual(tipoParam) {
    const canvas = document.getElementById('chartProduccionAnual');
    if (!canvas || typeof Chart === 'undefined' || !window._prodBalanceAnualCache) return;

    const d = window._prodBalanceAnualCache;
    const tipoSel = tipoParam || document.getElementById('prodBalanceAnualTipo')?.value || 'stacked';
    const mesesLabels = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];

    if (_prodChartAnual) {
        _prodChartAnual.destroy();
        _prodChartAnual = null;
    }

    const esLine = tipoSel === 'line';
    const esApilado = tipoSel === 'stacked';

    const datasets = d.prodKeys.map((k, i) => {
        const col = d.colors[i];
        return {
            label: d.prodLabels[i],
            data: d.matriz[k],
            backgroundColor: esLine ? col + '33' : col + (esApilado ? 'ee' : 'cc'),
            borderColor: col,
            borderWidth: esLine ? 2.5 : 1.5,
            borderRadius: esLine ? 0 : 4,
            tension: esLine ? 0.3 : 0,
            fill: esLine ? false : false,
            stack: esApilado ? 'balance' : undefined,
            pointRadius: esLine ? 4 : 0,
            pointHoverRadius: esLine ? 6 : 0
        };
    });

    // Plugin para pintar el total mensual encima de la barra apilada
    const totalAnualMesPlugin = {
        id: 'totalAnualMesLabels',
        afterDatasetsDraw(chart) {
            if (!esApilado) return;
            const { ctx } = chart;
            ctx.save();
            ctx.font = 'bold 10px system-ui, sans-serif';
            ctx.fillStyle = '#f8fafc';
            ctx.textAlign = 'center';
            ctx.textBaseline = 'bottom';

            const metaLast = chart.getDatasetMeta(chart.data.datasets.length - 1);
            if (metaLast && metaLast.data) {
                metaLast.data.forEach((element, index) => {
                    const totalMes = d.totalesPorMes[index];
                    if (totalMes && totalMes > 0) {
                        ctx.fillText(Number(totalMes).toLocaleString(), element.x, element.y - 4);
                    }
                });
            }
            ctx.restore();
        }
    };

    _prodChartAnual = new Chart(canvas, {
        type: esLine ? 'line' : 'bar',
        data: {
            labels: mesesLabels,
            datasets
        },
        options: {
            responsive: true,
            maintainAspectRatio: false,
            layout: { padding: { top: 22 } },
            interaction: { mode: 'index', intersect: false },
            plugins: {
                legend: {
                    position: 'top',
                    labels: { boxWidth: 12, font: { size: 10, weight: '600' }, color: '#cbd5e1' }
                },
                tooltip: {
                    callbacks: {
                        footer(items) {
                            const mesIdx = items[0]?.dataIndex;
                            const total = d.totalesPorMes[mesIdx] || 0;
                            return `TOTAL MES: ${total.toLocaleString()} uds`;
                        }
                    }
                }
            },
            scales: {
                x: {
                    stacked: esApilado,
                    grid: { display: false },
                    ticks: { color: '#94a3b8', font: { size: 11, weight: '600' } }
                },
                y: {
                    stacked: esApilado,
                    beginAtZero: true,
                    grid: { color: 'rgba(63,63,70,.25)' },
                    ticks: {
                        color: '#94a3b8',
                        callback(val) { return Number(val).toLocaleString(); }
                    }
                }
            }
        },
        plugins: [totalAnualMesPlugin]
    });
}

function _renderDonaAnual() {
    const canvas = document.getElementById('chartProduccionAnualPie');
    if (!canvas || typeof Chart === 'undefined' || !window._prodBalanceAnualCache) return;

    const d = window._prodBalanceAnualCache;

    if (_prodChartAnualPie) {
        _prodChartAnualPie.destroy();
        _prodChartAnualPie = null;
    }

    // ── Unificar sabores y productos para la dona anual ──
    const totSaborAnual = {
        natural: (d.totalesPorSabor['natural_bote'] || 0) + (d.totalesPorSabor['natural_sachet'] || 0),
        fresa: (d.totalesPorSabor['fresa_bote'] || 0) + (d.totalesPorSabor['fresa_sachet'] || 0),
        vainilla: (d.totalesPorSabor['vainilla_bote'] || 0) + (d.totalesPorSabor['vainilla_sachet'] || 0),
        choco: (d.totalesPorSabor['choco_bote'] || 0) + (d.totalesPorSabor['choco_sachet'] || 0),
        eucament: (d.totalesPorSabor['eucament'] || 0)
    };

    const activeSaboresAnual = PROD_SABORES_UNIFICADOS.filter(s => (totSaborAnual[s.key] || 0) > 0);
    const finalSabores = activeSaboresAnual.length > 0 ? activeSaboresAnual : PROD_SABORES_UNIFICADOS;

    const pieLabels = finalSabores.map(s => {
        const q = totSaborAnual[s.key] || 0;
        const pct = d.granTotalAnual > 0 ? ((q / d.granTotalAnual) * 100).toFixed(1) : '0';
        return `${s.label}: ${q.toLocaleString()} (${pct}%)`;
    });
    const pieData = finalSabores.map(s => totSaborAnual[s.key] || 0);
    const pieColors = finalSabores.map(s => s.color);

    _prodChartAnualPie = new Chart(canvas, {
        type: 'doughnut',
        data: {
            labels: pieLabels,
            datasets: [{
                data: pieData,
                backgroundColor: pieColors,
                borderWidth: 2,
                borderColor: '#18181b'
            }]
        },
        options: {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
                legend: {
                    position: 'bottom',
                    labels: { boxWidth: 10, font: { size: 10, weight: '600' }, color: '#cbd5e1', padding: 12 }
                }
            },
            cutout: '68%'
        },
        plugins: [{
            id: 'centerTotalAnualDoughnut',
            afterDraw(chart) {
                const { ctx, chartArea: { left, right, top, bottom } } = chart;
                if (!left && !right) return;
                const cx = (left + right) / 2;
                const cy = (top + bottom) / 2;
                ctx.save();
                ctx.textAlign = 'center';
                ctx.textBaseline = 'middle';
                ctx.font = '600 10px system-ui, sans-serif';
                ctx.fillStyle = '#94a3b8';
                ctx.fillText(`TOTAL ${d.anio}`, cx, cy - 9);
                ctx.font = 'bold 15px system-ui, sans-serif';
                ctx.fillStyle = '#f8fafc';
                ctx.fillText(d.granTotalAnual.toLocaleString() + ' uds', cx, cy + 9);
                ctx.restore();
            }
        }]
    });
}

function _renderTablaBalanceMensual(d) {
    const tbody = document.getElementById('tablaBalanceAnualMensualBody');
    if (!tbody) return;

    const mesesNombres = ['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'];

    let html = '';
    for (let m = 0; m < 12; m++) {
        const totalMes = d.totalesPorMes[m];
        const pctMes = d.granTotalAnual > 0 ? ((totalMes / d.granTotalAnual) * 100).toFixed(1) : '0';
        const mesNumStr = String(m + 1).padStart(2, '0');

        html += `<tr style="cursor:pointer;transition:background .15s ease;" onclick="_filtrarMesDesdeBalanceAnual('${d.anio}-${mesNumStr}')" title="Clic para filtrar lotes de ${mesesNombres[m]} ${d.anio}">
            <td style="font-weight:600;color:#fff;">
                <span style="display:inline-flex;align-items:center;gap:6px;">
                    <span style="color:var(--primary);font-size:.75rem;">📅</span> ${mesesNombres[m]}
                </span>
            </td>
            <td style="text-align:right;font-family:monospace;color:#60a5fa;">
                ${d.matriz.natural_bote[m] > 0 ? d.matriz.natural_bote[m].toLocaleString() : '<span style="color:var(--text-dim);">—</span>'}
            </td>
            <td style="text-align:right;font-family:monospace;color:#93c5fd;">
                ${d.matriz.natural_sachet[m] > 0 ? d.matriz.natural_sachet[m].toLocaleString() : '<span style="color:var(--text-dim);">—</span>'}
            </td>
            <td style="text-align:right;font-family:monospace;color:#f87171;">
                ${d.matriz.fresa_bote[m] > 0 ? d.matriz.fresa_bote[m].toLocaleString() : '<span style="color:var(--text-dim);">—</span>'}
            </td>
            <td style="text-align:right;font-family:monospace;color:#fca5a5;">
                ${d.matriz.fresa_sachet[m] > 0 ? d.matriz.fresa_sachet[m].toLocaleString() : '<span style="color:var(--text-dim);">—</span>'}
            </td>
            <td style="text-align:right;font-family:monospace;color:#fbbf24;">
                ${d.matriz.vainilla_bote[m] > 0 ? d.matriz.vainilla_bote[m].toLocaleString() : '<span style="color:var(--text-dim);">—</span>'}
            </td>
            <td style="text-align:right;font-family:monospace;color:#fde68a;">
                ${d.matriz.vainilla_sachet[m] > 0 ? d.matriz.vainilla_sachet[m].toLocaleString() : '<span style="color:var(--text-dim);">—</span>'}
            </td>
            <td style="text-align:right;font-family:monospace;color:#c084fc;">
                ${d.matriz.choco_bote[m] > 0 ? d.matriz.choco_bote[m].toLocaleString() : '<span style="color:var(--text-dim);">—</span>'}
            </td>
            <td style="text-align:right;font-family:monospace;color:#e9d5ff;">
                ${d.matriz.choco_sachet[m] > 0 ? d.matriz.choco_sachet[m].toLocaleString() : '<span style="color:var(--text-dim);">—</span>'}
            </td>
            <td style="text-align:right;font-family:monospace;color:#34d399;">
                ${d.matriz.eucament[m] > 0 ? d.matriz.eucament[m].toLocaleString() : '<span style="color:var(--text-dim);">—</span>'}
            </td>
            <td style="text-align:right;font-family:monospace;font-weight:700;color:#10b981;font-size:.85rem;">
                ${totalMes > 0 ? totalMes.toLocaleString() : '<span style="color:var(--text-dim);">0</span>'}
            </td>
            <td style="text-align:right;font-size:.75rem;color:${parseFloat(pctMes) > 10 ? '#38bdf8' : 'var(--text-dim)'};font-weight:${parseFloat(pctMes) > 10 ? '600' : '400'};">
                ${totalMes > 0 ? pctMes + '%' : '0%'}
            </td>
        </tr>`;
    }

    // Fila de Totales Generales Anuales
    html += `<tr style="background:rgba(255,255,255,0.05);font-weight:700;border-top:2px solid var(--border);">
        <td style="color:#fff;">🎯 TOTAL ANUAL ${d.anio}</td>
        <td style="text-align:right;color:#60a5fa;font-family:monospace;">${(d.totalesPorSabor.natural_bote||0).toLocaleString()}</td>
        <td style="text-align:right;color:#93c5fd;font-family:monospace;">${(d.totalesPorSabor.natural_sachet||0).toLocaleString()}</td>
        <td style="text-align:right;color:#f87171;font-family:monospace;">${(d.totalesPorSabor.fresa_bote||0).toLocaleString()}</td>
        <td style="text-align:right;color:#fca5a5;font-family:monospace;">${(d.totalesPorSabor.fresa_sachet||0).toLocaleString()}</td>
        <td style="text-align:right;color:#fbbf24;font-family:monospace;">${(d.totalesPorSabor.vainilla_bote||0).toLocaleString()}</td>
        <td style="text-align:right;color:#fde68a;font-family:monospace;">${(d.totalesPorSabor.vainilla_sachet||0).toLocaleString()}</td>
        <td style="text-align:right;color:#c084fc;font-family:monospace;">${(d.totalesPorSabor.choco_bote||0).toLocaleString()}</td>
        <td style="text-align:right;color:#e9d5ff;font-family:monospace;">${(d.totalesPorSabor.choco_sachet||0).toLocaleString()}</td>
        <td style="text-align:right;color:#34d399;font-family:monospace;">${(d.totalesPorSabor.eucament||0).toLocaleString()}</td>
        <td style="text-align:right;color:#10b981;font-size:.9rem;font-family:monospace;">${d.granTotalAnual.toLocaleString()}</td>
        <td style="text-align:right;color:#fff;">100%</td>
    </tr>`;

    tbody.innerHTML = html;
}

function _filtrarMesDesdeBalanceAnual(anioMes) {
    if (!anioMes) return;
    const mesSel = document.getElementById('prodMesSelector');
    if (mesSel) {
        mesSel.value = anioMes;
        if (typeof _onProdMesSelectorChange === 'function') {
            _onProdMesSelectorChange(anioMes);
        }
    }
    // Scroll suave hacia la tabla de lotes
    const tablaLotes = document.getElementById('tablaProduccion');
    if (tablaLotes) {
        tablaLotes.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    BO_AUTH.showAlert(`Filtrando lotes de producción para ${anioMes}`, 'info', 2500);
}

// Exponer globalmente
window._setProdGraficasModo = _setProdGraficasModo;
window.cargarBalanceProduccionAnual = cargarBalanceProduccionAnual;
window.cambiarTipoGraficaAnual = cambiarTipoGraficaAnual;
window._filtrarMesDesdeBalanceAnual = _filtrarMesDesdeBalanceAnual;

async function generarPDFTrazabilidad(id) {
    const { jsPDF } = window.jspdf;
    if (!jsPDF) { BO_AUTH.showAlert('jsPDF no disponible.', 'danger'); return; }

    // Logo en base64 (PNG de Dulet)
    const LOGO_B64 = 'data:image/png;base64,' + await fetch('../images/dulet_logo.png')
        .then(r => r.blob())
        .then(b => new Promise(res => { const fr = new FileReader(); fr.onload = () => res(fr.result.split(',')[1]); fr.readAsDataURL(b); }))
        .catch(() => '');

    const PAISES = { MEX:'México', USA:'EE. UU.', SLV:'El Salvador', GTQ:'Guatemala', CAN:'Canadá', ARG:'Argentina' };
    const PLANTAS = { planta_1:'Planta 1', planta_2:'Planta 2', planta_3:'Planta 3' };

    function fmtFecha(f) {
        if (!f) return '—';
        const d = new Date(f);
        if (isNaN(d)) return String(f).substring(0,10);
        return d.toLocaleDateString('es-MX', { day:'2-digit', month:'long', year:'numeric' });
    }

    try {
        const res  = await BO_API.post('/bo/sql-relay', {
            secret: 'duletia_relay_2026',
            sql: `SELECT p.*, s.cantidad_total AS exist_actual,
                         COALESCE(SUM(CASE WHEN t.tipo_movimiento IN ('produccion','traslado_entrada') THEN ABS(t.cantidad) ELSE 0 END), 0) AS total_entradas,
                         COALESCE(SUM(CASE WHEN t.tipo_movimiento IN ('venta','traslado_salida','merma') THEN ABS(t.cantidad) ELSE 0 END), 0) AS total_salidas
                  FROM produccion_diaria p
                  LEFT JOIN inventario_stock s ON s.producto_id = p.producto_id AND s.cedis_id = 'master'
                  LEFT JOIN inventario_transacciones t ON t.producto_id = p.producto_id AND t.notas = p.lote
                  WHERE p.id = ${id}
                  GROUP BY p.id, s.cantidad_total`
        });
        const r = res?.rows?.[0];
        if (!r) { BO_AUTH.showAlert('Registro no encontrado.', 'warning'); return; }

        const doc = new jsPDF();
        const prodLabel = { fresa:'Dulet Fresa', vainilla:'Dulet Vainilla', choco:'Dulet Chocolate', natural:'Dulet Natural', eucament:'Eucament' };
        const EMPRESA   = 'Dulet Internacional S de RL de CV';

        // ── Encabezado ───────────────────────────────────────────────
        doc.setFillColor(30,41,59);
        doc.rect(0, 0, 210, 32, 'F');

        // Logo (si cargó)
        if (LOGO_B64) {
            try { doc.addImage(LOGO_B64, 'PNG', 8, 4, 28, 24); } catch(e) {}
        }

        doc.setTextColor(255,255,255);
        doc.setFontSize(15); doc.setFont('helvetica','bold');
        doc.text(EMPRESA, 105, 13, { align:'center' });
        doc.setFontSize(9); doc.setFont('helvetica','normal');
        doc.text('Hoja de Trazabilidad de Producción', 105, 21, { align:'center' });
        doc.setFontSize(8); doc.setTextColor(160,170,200);
        doc.text(`Folio: ${r.lote || ('PD-'+id)} | Generado: ${new Date().toLocaleString('es-MX')}`, 105, 28, { align:'center' });

        // ── Información del lote ──────────────────────────────────────
        doc.setTextColor(0,0,0);
        doc.setFontSize(11); doc.setFont('helvetica','bold');
        doc.text('INFORMACIÓN DEL LOTE', 14, 44);
        doc.setLineWidth(0.3); doc.setDrawColor(99,102,241);
        doc.line(14, 46, 196, 46);
        doc.setFont('helvetica','normal'); doc.setFontSize(10);

        const datos = [
            ['Nombre del Producto', prodLabel[r.producto_id] || (r.producto_id || '?').replace(/_/g,' ')],
            ['Número de Lote',      r.lote || 'Sin número de lote'],
            ['Fecha de Producción', fmtFecha(r.fecha)],
            ['Planta',              PLANTAS[r.planta] || (r.planta || '—').replace(/_/g,' ')],
            ['Etiquetado País',     PAISES[r.etiquetado_pais] || r.etiquetado_pais || 'México'],
            ['Operador',            r.operador || '—'],
        ];
        // Solo mostrar costo si el rol NO es almacen (supervisor_almacen, master, admin, contabilidad sí lo ven)
        const _trazRol = (CURRENT_USER?.rol || '').toLowerCase().trim();
        if (_trazRol !== 'almacen') {
            datos.push(['Costo MP ($)',        r.costo_materia_prima ? '$' + Number(r.costo_materia_prima).toLocaleString('es-MX') : '—']);
        }
        let yy = 54;
        datos.forEach(([k,v]) => {
            doc.setFont('helvetica','bold'); doc.text(k + ':', 14, yy);
            doc.setFont('helvetica','normal'); doc.text(String(v), 78, yy);
            yy += 8;
        });

        // ── Tabla de movimientos ──────────────────────────────────────
        yy += 4;
        doc.setFillColor(99,102,241); doc.rect(14, yy-5, 182, 9, 'F');
        doc.setTextColor(255,255,255); doc.setFont('helvetica','bold'); doc.setFontSize(10);
        doc.text('Entradas', 55, yy, {align:'center'});
        doc.text('Salidas', 115, yy, {align:'center'});
        doc.text('Existencia Actual', 165, yy, {align:'center'});
        doc.setTextColor(0,0,0); doc.setFont('helvetica','normal'); yy += 12;
        doc.text(String(+r.total_entradas || r.cantidad || 0), 55, yy, { align:'center' });
        doc.text(String(+r.total_salidas || 0), 115, yy, { align:'center' });
        doc.text(String(+r.exist_actual || 0), 165, yy, { align:'center' });

        if (r.notas) {
            yy += 15;
            doc.setFontSize(9); doc.setTextColor(80,80,80);
            doc.setFont('helvetica','italic');
            doc.text('Notas: ' + r.notas, 14, yy);
        }

        // ── Línea de firma ────────────────────────────────────────────
        yy = Math.max(yy + 20, 220);
        doc.setDrawColor(120,120,120); doc.line(14, yy, 95, yy);
        doc.setFontSize(8); doc.setTextColor(100,100,100); doc.setFont('helvetica','normal');
        doc.text('Firma del Operador / Responsable', 14, yy+5);
        doc.line(120, yy, 196, yy);
        doc.text('Firma de Supervisión', 120, yy+5);

        // ── Footer ────────────────────────────────────────────────────
        doc.setFillColor(30,41,59); doc.rect(0,278,210,19,'F');
        doc.setTextColor(160,170,200); doc.setFontSize(7.5);
        doc.text(`${EMPRESA}  |  Documento de uso interno y confidencial`, 105, 284, { align:'center' });
        const nombrePdf = `Trazabilidad_${r.lote || ('ID'+id)}_${(r.fecha||'').substring(0,10)}.pdf`;
        const blob = doc.output('blob');
        const blobUrl = URL.createObjectURL(blob);
        const win = window.open(blobUrl, '_blank');
        if (!win) {
            doc.save(nombrePdf);
            BO_AUTH.showAlert('✅ PDF de trazabilidad descargado.', 'info');
        } else {
            BO_AUTH.showAlert('✅ PDF de trazabilidad abierto en nueva pestaña.', 'success');
            setTimeout(() => URL.revokeObjectURL(blobUrl), 120000);
        }

    } catch(e) {
        BO_AUTH.showAlert('Error generando PDF: ' + e.message, 'danger');
        console.error(e);
    }
}


async function eliminarLoteProduccion(id) {
    if (!BO_AUTH.hasRole('admin') && !BO_AUTH.hasRole('supervisor_almacen')) { BO_AUTH.showAlert('Sin permisos.','warning'); return; }
    if (!confirm('¿Eliminar este registro de producción? El inventario NO se revertirá automáticamente.')) return;
    try {
        await BO_API.post('/bo/sql-relay', {
            secret: 'duletia_relay_2026',
            sql: `DELETE FROM produccion_diaria WHERE id = ${id}`
        });
        BO_AUTH.showAlert('Registro eliminado.', 'success');
        loadProduccion();
    } catch(e) { BO_AUTH.showAlert('Error: ' + e.message, 'danger'); }
}

async function toggleLiberarLote(id, liberar) {
    const _uid = String(CURRENT_USER?.id || '');
    if (!BO_AUTH.hasRole('admin') && !BO_AUTH.hasRole('supervisor_almacen') && _uid !== '101010') {
        BO_AUTH.showAlert('Sin permisos para liberar lotes.','warning'); return;
    }
    const accion = liberar ? 'liberar' : 'revertir a pendiente';
    if (!confirm(`¿Confirmas ${accion} este lote?`)) return;
    try {
        const sql = liberar
            ? `UPDATE produccion_diaria SET liberado = true, fecha_liberacion = NOW() WHERE id = ${id}`
            : `UPDATE produccion_diaria SET liberado = false, fecha_liberacion = NULL WHERE id = ${id}`;
        await BO_API.post('/bo/sql-relay', { secret: 'fixdb_2026', sql });

        if (liberar) {
            // 1. Obtener datos del lote incluyendo etiquetado_pais
            const resLote = await BO_API.post('/bo/sql-relay', { secret: 'fixdb_2026',
                sql: `SELECT id, lote, producto_id, cantidad, etiquetado_pais, costo_materia_prima, costo_merma, costo_prorrateo, costo_mod, costo_depreciacion, notas FROM produccion_diaria WHERE id = ${id}` });
            const lote = resLote?.rows?.[0];
            if (lote) {
                const prodNom = (() => {
                    const p = String(lote.producto_id || '');
                    const cat = typeof PRODUCTOS_CAT !== 'undefined' && PRODUCTOS_CAT.find(x => String(x.id) === p);
                    return cat ? cat.nombre : (lote.producto_id || 'Producto');
                })();
                const qty = parseFloat(lote.cantidad || 0);
                
                // 2. Determinar destino (MEX -> DG, USA -> LLC)
                const pais = String(lote.etiquetado_pais || 'MEX').toUpperCase().trim();
                const esUSA = pais === 'USA' || pais === 'US';
                const empDestino = esUSA ? 'LLC' : 'DG';
                const moneda = esUSA ? 'USD' : 'MXN';
                const simbolo = esUSA ? 'US$' : '$';

                // 3. Consultar precio oficial intercompañía configurado
                let precioIntercia = 0;
                try {
                    const resPrecio = await BO_API.post('/bo/sql-relay', {
                        secret: 'duletia_relay_2026',
                        sql: `SELECT precio_unitario, iva_pct FROM config_precios_intercia WHERE empresa_destino = '${empDestino}' AND (producto_id = '${lote.producto_id}' OR '${lote.producto_id}' LIKE '%' || producto_id || '%') LIMIT 1`
                    });
                    precioIntercia = parseFloat(resPrecio?.rows?.[0]?.precio_unitario || 0);
                } catch(ePrice) {
                    console.warn('[Intercia] Error al consultar tarifa:', ePrice);
                }

                // Fallbacks seguros según producto y destino si no existe en BD
                if (precioIntercia <= 0) {
                    if (esUSA) {
                        precioIntercia = String(lote.producto_id).toLowerCase().includes('eucament') ? 1.50 : 2.00;
                    } else {
                        precioIntercia = String(lote.producto_id).toLowerCase().includes('eucament') ? 22.92 : 32.08;
                    }
                }

                // 4. Calcular costo de materia prima vía deducción PEPS o formulación
                let cMP = parseFloat(lote.costo_materia_prima || 0);
                if (cMP <= 0 && qty > 0) {
                    try {
                        const mrpRes = await descontarMaterialesLotePEPS(id, lote.producto_id, qty, lote.lote, libPor, lote.fecha, lote.presentacion, lote.etiquetado_pais);
                        if (mrpRes?.ok && mrpRes?.costoReal > 0) {
                            cMP = +mrpRes.costoReal.toFixed(2);
                        } else {
                            const pSlug = typeof _resolverFormulacionSlug === 'function' 
                                ? _resolverFormulacionSlug(lote.producto_id, lote.presentacion, lote.etiquetado_pais) 
                                : String(lote.producto_id||'').toLowerCase();
                            const resForm = await BO_API.post('/bo/sql-relay', {
                                secret: 'duletia_relay_2026',
                                sql: `SELECT COALESCE(SUM(
                                        CASE WHEN LOWER(COALESCE(unidad,'g')) IN ('piezas','pz')
                                             THEN costo_por_kg * gramos_unidad
                                             ELSE (gramos_unidad * costo_por_kg) / 1000
                                        END
                                      ), 0) AS costo_unitario_mp
                                      FROM formulacion_componentes
                                      WHERE producto_slug = '${pSlug}'`
                            });
                            const cUnitMP = parseFloat(resForm?.rows?.[0]?.costo_unitario_mp || 0);
                            if (cUnitMP > 0) {
                                cMP = +(cUnitMP * qty).toFixed(2);
                                await BO_API.post('/bo/sql-relay', {
                                    secret: 'duletia_relay_2026',
                                    sql: `UPDATE produccion_diaria SET costo_materia_prima = ${cMP} WHERE id = ${id}`
                                }).catch(() => {});
                            }
                        }
                    } catch(eForm) {
                        console.warn('[Intercia] Error calculando BOM:', eForm);
                    }
                }

                const cMerma = parseFloat(lote.costo_merma || 0);
                const cProrrateo = parseFloat(lote.costo_prorrateo || 0);
                const cMod  = parseFloat(lote.costo_mod || 0);
                const cDep  = parseFloat(lote.costo_depreciacion || 0);
                
                const costoFabricacionTotal = +(cMP + cMerma + cProrrateo + cMod + cDep).toFixed(2);
                const costoU = qty > 0 ? +(costoFabricacionTotal / qty).toFixed(4) : 0;
                
                // Total facturable intercompañía
                const totalFacturable = +(qty * precioIntercia).toFixed(2);
                const totalFinal = totalFacturable > 0 ? totalFacturable : costoFabricacionTotal;

                const fecha  = new Date().toISOString().slice(0,10).replace(/-/g,'');
                const folio  = `IC-${fecha}-${String(id).padStart(4,'0')}`;
                const libPor = CURRENT_USER?.nombre || CURRENT_USER?.registro || _uid;
                const notasSeguras = (lote.notas || '').replace(/'/g, "''");
                
                await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql:
                    `INSERT INTO ventas_intercompania
                        (folio, lote_id, lote_clave, producto_id, producto_nombre, cantidad, costo_unitario, total, liberado_por, empresa_origen, empresa_destino, notas, precio_intercompania, moneda, total_facturable, costo_fabricacion_total)
                     VALUES
                        ('${folio}', ${id}, '${(lote.lote||'').replace(/'/g,"''")}',
                         '${lote.producto_id}', '${prodNom.replace(/'/g,"''")}',
                         ${qty}, ${costoU}, ${totalFinal},
                         '${libPor.replace(/'/g,"''")}', 'DI', '${empDestino}', '${notasSeguras}',
                         ${precioIntercia}, '${moneda}', ${totalFacturable}, ${costoFabricacionTotal})
                     ON CONFLICT (folio) DO UPDATE SET 
                        cantidad = EXCLUDED.cantidad,
                        costo_unitario = EXCLUDED.costo_unitario,
                        total = EXCLUDED.total,
                        precio_intercompania = EXCLUDED.precio_intercompania,
                        total_facturable = EXCLUDED.total_facturable,
                        costo_fabricacion_total = EXCLUDED.costo_fabricacion_total,
                        empresa_destino = EXCLUDED.empresa_destino,
                        moneda = EXCLUDED.moneda,
                        notas = EXCLUDED.notas` });

                const msgTarifa = precioIntercia > 0 
                    ? `Tarifa: ${simbolo}${precioIntercia.toFixed(2)} ${moneda}` 
                    : `Tarifa: Pendiente`;
                BO_AUTH.showAlert(`Lote liberado ✅ — Folio ${folio} (${empDestino}, ${msgTarifa})`, 'success');
            } else {
                BO_AUTH.showAlert('Lote liberado ✅', 'success');
            }
        } else {
            BO_AUTH.showAlert('Lote regresado a pendiente ⏳', 'success');
        }
        loadProduccion();
    } catch(e) { BO_AUTH.showAlert('Error: ' + e.message, 'danger'); }
}

// ── Intercompañía: Periodos Rápidos ──────────────────────────────────────────
function setIntercompaniaPeriodo(tipo) {
    document.querySelectorAll('.ic-periodo-btn').forEach(b => {
        b.classList.toggle('active', b.dataset.per === tipo);
    });
    const hoy = new Date();
    let desde, hasta = new Date(hoy);
    switch(tipo) {
        case 'dia':
            desde = new Date(hoy); break;
        case 'semana':
            desde = new Date(hoy);
            desde.setDate(hoy.getDate() - 6); break;
        case 'quincena':
            desde = new Date(hoy);
            desde.setDate(hoy.getDate() - 14); break;
        case 'mes':
            desde = new Date(hoy.getFullYear(), hoy.getMonth(), 1); break;
        case 'anio':
            desde = new Date(hoy.getFullYear(), 0, 1); break;
        case 'todo':
            desde = new Date(2025, 0, 1); break;
        default:
            desde = new Date(hoy.getFullYear(), hoy.getMonth(), 1);
    }
    const dEl = document.getElementById('ic-desde');
    const hEl = document.getElementById('ic-hasta');
    if (dEl) dEl.value = desde.toISOString().slice(0,10);
    if (hEl) hEl.value = hasta.toISOString().slice(0,10);
    loadIntercompania();
}

// ── Intercompañía: Carga y Consulta Principal ────────────────────────────────
async function loadIntercompania() {
    const tbody = document.getElementById('icBody');
    if (!tbody) return;
    const hoy = new Date().toISOString().slice(0,10);
    const dEl = document.getElementById('ic-desde');
    const hEl = document.getElementById('ic-hasta');
    if (dEl && !dEl.value) dEl.value = hoy.slice(0,7) + '-01';
    if (hEl && !hEl.value) hEl.value = hoy;
    
    const desde = dEl?.value || hoy.slice(0,7) + '-01';
    const hasta = hEl?.value || hoy;
    const rutaFiltro = document.getElementById('ic-ruta')?.value || 'todas';

    tbody.innerHTML = '<tr><td colspan="12" style="text-align:center;padding:2.5rem;"><div class="spinner"></div> Cargando registros intercompañía...</td></tr>';
    
    try {
        let sqlWhere = `WHERE fecha_liberacion::date BETWEEN '${desde}' AND '${hasta}'`;
        if (rutaFiltro === 'DI_DG') {
            sqlWhere += ` AND empresa_origen = 'DI' AND empresa_destino = 'DG'`;
        } else if (rutaFiltro === 'DG_LLC') {
            sqlWhere += ` AND (empresa_origen = 'DG' AND empresa_destino = 'LLC')`;
        } else if (rutaFiltro === 'DI_LLC') {
            sqlWhere += ` AND (empresa_origen = 'DI' AND empresa_destino = 'LLC')`;
        } else if (rutaFiltro === 'DG_DC') {
            sqlWhere += ` AND (empresa_destino = 'DC' OR empresa_origen = 'DC')`;
        } else if (rutaFiltro === 'DS_DG') {
            sqlWhere += ` AND (empresa_origen = 'DS' OR empresa_destino = 'DS')`;
        }

        const sql = `SELECT * FROM ventas_intercompania
                     ${sqlWhere}
                     ORDER BY fecha_liberacion DESC, id DESC`;
        
        const res = await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql });
        const rows = res?.rows || [];
        
        // Guardar copia completa para filtrado local y exportaciones
        window._icAllRows = rows;
        window._icLastRows = rows;
        window._icPage = 0;

        _recalcularMetricasIntercompania(rows);

        const pdfBtn = document.getElementById('ic-btn-pdf');
        if (pdfBtn) pdfBtn.style.display = rows.length ? '' : 'none';

        _renderIntercompania();
    } catch(e) {
        tbody.innerHTML = `<tr><td colspan="12" style="text-align:center;color:var(--danger);padding:2rem;">Error al cargar datos: ${e.message}</td></tr>`;
        console.error('loadIntercompania error:', e);
    }
}

function _recalcularMetricasIntercompania(rows) {
    const totalUds = rows.reduce((s,r) => s + (+r.cantidad||0), 0);
    const totalValMXN = rows.filter(r => (r.moneda || 'MXN').toUpperCase() !== 'USD')
                            .reduce((s,r) => s + (parseFloat(r.total_facturable || r.total) || 0), 0);
    const totalValUSD = rows.filter(r => (r.moneda || '').toUpperCase() === 'USD')
                            .reduce((s,r) => s + (parseFloat(r.total_facturable || r.total) || 0), 0);
    
    const el = id => document.getElementById(id);
    if (el('ic-total-lotes')) el('ic-total-lotes').textContent = rows.length.toLocaleString('es-MX');
    if (el('ic-total-uds'))   el('ic-total-uds').textContent   = totalUds.toLocaleString('es-MX');
    if (el('ic-total-cajas')) el('ic-total-cajas').textContent = Math.round(totalUds / 24).toLocaleString('es-MX') + ' cajas aprox. (24 uds)';
    if (el('ic-total-valor')) el('ic-total-valor').textContent = '$' + totalValMXN.toLocaleString('es-MX',{minimumFractionDigits:2}) + ' MXN';
    if (el('ic-total-valor-usd')) el('ic-total-valor-usd').textContent = '$' + totalValUSD.toLocaleString('es-MX',{minimumFractionDigits:2}) + ' USD';
}

// ── Búsqueda Instantánea en Tiempo Real ──────────────────────────────────────
function _filtrarIntercompaniaLocal() {
    const q = (document.getElementById('icSearch')?.value || '').toLowerCase().trim();
    const all = window._icAllRows || [];
    if (!q) {
        window._icLastRows = all;
    } else {
        window._icLastRows = all.filter(r => {
            const fol = (r.folio || '').toLowerCase();
            const lot = (r.lote_clave || '').toLowerCase();
            const pro = (r.producto_nombre || r.producto_id || '').toLowerCase();
            const lib = (r.liberado_por || '').toLowerCase();
            const not = (r.notas || '').toLowerCase();
            return fol.includes(q) || lot.includes(q) || pro.includes(q) || lib.includes(q) || not.includes(q);
        });
    }
    window._icPage = 0;
    _renderIntercompania();
}

// ── Render de Tabla con Paginación y Emojis ─────────────────────────────────
function _renderIntercompania() {
    const tbody = document.getElementById('icBody');
    const pagDiv = document.getElementById('ic-pagination');
    if (!tbody || !pagDiv) return;
    
    const rows = window._icLastRows || [];
    if (!rows.length) {
        tbody.innerHTML = '<tr><td colspan="12" style="text-align:center;color:var(--text-dim);padding:3rem;">Sin registros en el periodo o búsqueda seleccionada.</td></tr>';
        pagDiv.innerHTML = '';
        return;
    }
    
    const ITEMS_PER_PAGE = 25;
    const totalPages = Math.ceil(rows.length / ITEMS_PER_PAGE);
    const p = window._icPage || 0;
    const pageRows = rows.slice(p * ITEMS_PER_PAGE, (p + 1) * ITEMS_PER_PAGE);

    const _getEmoji = (nombre) => {
        const s = (nombre || '').toLowerCase();
        if (s.includes('fresa')) return '🍓';
        if (s.includes('vainilla')) return '🍦';
        if (s.includes('choco')) return '🍫';
        if (s.includes('natural')) return '🥛';
        if (s.includes('eucament')) return '🌿';
        return '📦';
    };
    
    tbody.innerHTML = pageRows.map(r => {
        const costoU = parseFloat(r.costo_unitario || 0);
        const precioIntercia = parseFloat(r.precio_intercompania || 0);
        const totalFact = parseFloat(r.total_facturable || r.total || 0);
        const moneda = (r.moneda || 'MXN').toUpperCase();
        const empOri = r.empresa_origen || 'DI';
        const empDes = r.empresa_destino || 'DG';
        
        const badgeRuta = (typeof window.renderEmpresaBadge === 'function')
            ? `${window.renderEmpresaBadge(empOri)} <span style="color:#94a3b8;font-size:.7rem;margin:0 2px;">➔</span> ${window.renderEmpresaBadge(empDes)}`
            : `<span style="font-size:.72rem;background:rgba(99,102,241,.15);color:#a5b4fc;border:1px solid rgba(99,102,241,.35);padding:2px 8px;border-radius:4px;font-weight:700;white-space:nowrap;">${empOri} ➔ ${empDes}</span>`;
        
        const tarifaTxt = precioIntercia > 0 
            ? `<span style="color:#fcd34d;font-weight:700;">$${precioIntercia.toFixed(2)}</span> <span style="font-size:.7rem;color:var(--text-dim);">${moneda}</span>`
            : `<span style="background:rgba(239,68,68,.15);color:#f87171;padding:2px 6px;border-radius:3px;font-size:.72rem;font-weight:600;">$0.00 (Pendiente)</span>`;
            
        const prodDisplay = r.producto_nombre || r.producto_id || '—';
        const emoji = _getEmoji(prodDisplay);

        return `<tr>
            <td style="font-family:monospace;font-size:.8rem;color:#60a5fa;font-weight:700;white-space:nowrap;">
                <span title="Click para copiar folio" style="cursor:pointer;" onclick="navigator.clipboard.writeText('${r.folio}');if(typeof BO_AUTH!=='undefined')BO_AUTH.showAlert('Folio copiado al portapapeles','info');">${r.folio||'—'}</span>
            </td>
            <td style="white-space:nowrap;font-size:.82rem;">${(r.fecha_liberacion||'').substring(0,10)}</td>
            <td style="font-size:.8rem;font-family:monospace;white-space:nowrap;">${r.lote_clave||'—'}</td>
            <td style="font-weight:600;white-space:nowrap;">
                <span style="margin-right:4px;">${emoji}</span>${prodDisplay}
            </td>
            <td style="text-align:right;font-weight:700;">${(+r.cantidad||0).toLocaleString('es-MX')}</td>
            <td style="text-align:right;color:var(--warning);font-size:.82rem;">$${costoU.toLocaleString('es-MX',{minimumFractionDigits:4})}</td>
            <td style="text-align:right;font-size:.82rem;">${tarifaTxt}</td>
            <td style="text-align:right;color:#4ade80;font-weight:700;font-size:.86rem;white-space:nowrap;">
                $${totalFact.toLocaleString('es-MX',{minimumFractionDigits:2})} ${moneda}
            </td>
            <td style="white-space:nowrap;">${badgeRuta}</td>
            <td style="font-size:.8rem;white-space:nowrap;">${r.liberado_por||'—'}</td>
            <td style="font-size:.76rem;color:var(--text-dim);max-width:160px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;" title="${r.notas||''}">${r.notas||'—'}</td>
            <td style="text-align:center;white-space:nowrap;">
                <button onclick="_pdfNotaRemisionIC('${(r.folio||'').replace(/'/g,"\\'")}')" style="background:#ef4444;border:none;color:#fff;border-radius:5px;padding:.2rem .55rem;cursor:pointer;font-size:.72rem;font-weight:700;display:inline-flex;align-items:center;gap:3px;" title="Descargar PDF Nota de Remisión">
                    📄 PDF
                </button>
            </td>
        </tr>`;
    }).join('') + (totalPages === 1 || p === totalPages - 1 ? `<tr style="background:rgba(99,102,241,.08);font-weight:700;border-top:2px solid rgba(99,102,241,.3);">
        <td colspan="4">TOTAL EN VISTA (${rows.length} lotes)</td>
        <td style="text-align:right;color:#4ade80;">${rows.reduce((s,r) => s + (+r.cantidad||0), 0).toLocaleString()}</td>
        <td></td>
        <td></td>
        <td style="text-align:right;color:#4ade80;">
            ${(() => {
                const mxn = rows.filter(r => (r.moneda||'MXN').toUpperCase()!=='USD').reduce((s,r) => s + (parseFloat(r.total_facturable||r.total)||0), 0);
                const usd = rows.filter(r => (r.moneda||'').toUpperCase()==='USD').reduce((s,r) => s + (parseFloat(r.total_facturable||r.total)||0), 0);
                let txt = '';
                if (mxn > 0) txt += `$${mxn.toLocaleString('es-MX',{minimumFractionDigits:2})} MXN`;
                if (usd > 0) txt += `${txt ? ' + ' : ''}$${usd.toLocaleString('es-MX',{minimumFractionDigits:2})} USD`;
                return txt || '$0.00';
            })()}
        </td>
        <td colspan="4"></td>
    </tr>` : '');

    // Controles de Paginación
    if (totalPages <= 1) { pagDiv.innerHTML = ''; return; }
    let btns = '';
    const from = Math.max(0, p - 2);
    const to   = Math.min(totalPages - 1, p + 2);
    if (from > 0) btns += `<button class="btn btn-outline btn-sm" onclick="window._icPage=0;_renderIntercompania()">1</button><span style="color:var(--text-dim);">…</span>`;
    for (let i = from; i <= to; i++) {
        const active = i === p ? 'style="background:var(--accent-purple);color:#fff;border-color:var(--accent-purple);"' : '';
        btns += `<button class="btn btn-outline btn-sm" ${active} onclick="window._icPage=${i};_renderIntercompania()">${i+1}</button>`;
    }
    if (to < totalPages - 1) btns += `<span style="color:var(--text-dim);">…</span><button class="btn btn-outline btn-sm" onclick="window._icPage=${totalPages-1};_renderIntercompania()">${totalPages}</button>`;
    pagDiv.innerHTML = btns;
}

// ── 1-Click: Recalcular Lotes Pendientes con Tarifas Oficiales Vigentes ─────────
async function _recalcularTarifasIntercompania() {
    if (!confirm('¿Deseas recalcular los lotes con tarifa pendiente ($0.00) aplicando las tarifas oficiales configuradas en el sistema?')) return;
    try {
        const sql = `
            UPDATE ventas_intercompania vi
            SET 
                precio_intercompania = cp.precio_unitario,
                total_facturable = ROUND(vi.cantidad * cp.precio_unitario, 2),
                total = ROUND(vi.cantidad * cp.precio_unitario, 2),
                moneda = COALESCE(vi.moneda, cp.moneda, 'MXN')
            FROM config_precios_intercia cp
            WHERE cp.empresa_destino = vi.empresa_destino
              AND (cp.producto_id = vi.producto_id OR LOWER(vi.producto_nombre) LIKE CONCAT('%', cp.producto_id, '%'))
              AND (vi.precio_intercompania = 0 OR vi.precio_intercompania IS NULL OR vi.total_facturable = 0 OR vi.total_facturable IS NULL)
            RETURNING vi.id;
        `;
        const res = await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql });
        const cant = res?.count || res?.rows?.length || 0;
        if (typeof BO_AUTH !== 'undefined') {
            BO_AUTH.showAlert(`⚡ Se recalcularon exitosamente ${cant} transferencias con sus tarifas oficiales.`, 'success');
        }
        await loadIntercompania();
    } catch(e) {
        if (typeof BO_AUTH !== 'undefined') BO_AUTH.showAlert('Error al recalcular tarifas: ' + e.message, 'danger');
    }
}

// ── Exportar Excel con Formato Ejecutivo ────────────────────────────────────
function _exportIntercompaniaExcel() {
    const rows = window._icLastRows || [];
    if (!rows.length) {
        if (typeof BO_AUTH !== 'undefined') BO_AUTH.showAlert('No hay registros para exportar en este periodo.', 'warning');
        return;
    }
    if (typeof XLSX === 'undefined') {
        if (typeof BO_AUTH !== 'undefined') BO_AUTH.showAlert('SheetJS (XLSX) no disponible.', 'danger');
        return;
    }

    const data = [
        ['DULETIA — REPORTE DE VENTAS Y TRANSFERENCIAS INTERCOMPAÑÍA (DI → DG / LLC)'],
        [`Generado: ${new Date().toLocaleString('es-MX')}`, `Total Registros: ${rows.length}`],
        [],
        ['Folio', 'Fecha Liberación', 'Lote Clave', 'Producto', 'Cantidad (Uds)', 'Costo BOM ($)', 'Tarifa Intercia ($)', 'Total Facturable ($)', 'Moneda', 'Origen', 'Destino', 'Liberado Por', 'Notas']
    ];

    rows.forEach(r => {
        data.push([
            r.folio || '',
            (r.fecha_liberacion || '').substring(0,10),
            r.lote_clave || '',
            r.producto_nombre || r.producto_id || '',
            +r.cantidad || 0,
            +r.costo_unitario || 0,
            +r.precio_intercompania || 0,
            +r.total_facturable || +r.total || 0,
            (r.moneda || 'MXN').toUpperCase(),
            r.empresa_origen || 'DI',
            r.empresa_destino || 'DG',
            r.liberado_por || '',
            r.notas || ''
        ]);
    });

    const ws = XLSX.utils.aoa_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Intercompañía');

    const desde = document.getElementById('ic-desde')?.value || 'inicio';
    const hasta = document.getElementById('ic-hasta')?.value || 'fin';
    XLSX.writeFile(wb, `Duletia_Intercompania_${desde}_${hasta}.xlsx`);
    if (typeof BO_AUTH !== 'undefined') BO_AUTH.showAlert('✅ Archivo Excel descargado exitosamente.', 'success');
}

function _exportIntercompaniaPDF() {
    const rows = window._icLastRows || [];
    if (!rows.length) return;
    const desde = document.getElementById('ic-desde')?.value || '';
    const hasta  = document.getElementById('ic-hasta')?.value  || '';
    const totalUds = rows.reduce((s,r) => s + (+r.cantidad||0), 0);
    const totalMXN = rows.filter(r => (r.moneda||'MXN').toUpperCase()!=='USD').reduce((s,r) => s + (parseFloat(r.total_facturable||r.total)||0), 0);
    const totalUSD = rows.filter(r => (r.moneda||'').toUpperCase()==='USD').reduce((s,r) => s + (parseFloat(r.total_facturable||r.total)||0), 0);

    const head = `<html><head><meta charset="UTF-8"><title>Ventas Intercompañía</title>
    <style>body{font-family:Arial,sans-serif;font-size:11px;}
    table{width:100%;border-collapse:collapse;margin-top:10px;}th,td{border:1px solid #ccc;padding:5px 7px;}
    th{background:#1e3a5f;color:#fff;}tr:nth-child(even){background:#f9fafb;}
    .total{font-weight:bold;background:#e8f0fe;}</style></head><body>
    <h2 style="color:#1e3a5f;margin-bottom:4px;">🔄 Reporte de Ventas Intercompañía (DI ➔ DG / LLC)</h2>
    <p style="margin:2px 0;color:#555;">Periodo: <strong>${desde}</strong> al <strong>${hasta}</strong> | Total Lotes: <strong>${rows.length}</strong> | Unidades: <strong>${totalUds.toLocaleString('es-MX')}</strong></p>
    <p style="margin:2px 0;font-weight:bold;color:#1e3a5f;">Total Facturable: $${totalMXN.toLocaleString('es-MX',{minimumFractionDigits:2})} MXN ${totalUSD > 0 ? ` + $${totalUSD.toLocaleString('es-MX',{minimumFractionDigits:2})} USD` : ''}</p>`;
    
    const tableRows = rows.map(r => `<tr>
        <td>${r.folio||''}</td>
        <td>${(r.fecha_liberacion||'').substring(0,10)}</td>
        <td>${r.lote_clave||''}</td>
        <td>${r.producto_nombre||''}</td>
        <td style="text-align:right;">${(+r.cantidad||0).toLocaleString()}</td>
        <td style="text-align:right;">$${(+r.costo_unitario||0).toLocaleString('es-MX',{minimumFractionDigits:4})}</td>
        <td style="text-align:right;">$${parseFloat(r.precio_intercompania||0).toFixed(2)} ${r.moneda||'MXN'}</td>
        <td style="text-align:right;font-weight:bold;">$${parseFloat(r.total_facturable||r.total||0).toLocaleString('es-MX',{minimumFractionDigits:2})} ${r.moneda||'MXN'}</td>
        <td>${r.empresa_origen||'DI'} ➔ ${r.empresa_destino||'DG'}</td>
        <td>${r.liberado_por||''}</td>
    </tr>`).join('');
    
    const html = head + `<table><thead><tr>
        <th>Folio</th><th>Fecha</th><th>Lote</th><th>Producto</th>
        <th>Cantidad</th><th>Costo BOM</th><th>Tarifa Intercia</th>
        <th>Total Facturable</th><th>Ruta</th><th>Liberado por</th>
    </tr></thead><tbody>${tableRows}</tbody></table></body></html>`;
    
    const w = window.open('','_blank');
    w.document.write(html);
    w.document.close();
    setTimeout(() => w.print(), 400);
}

function _pdfNotaRemisionIC(folio) {
    const rows = window._icLastRows || [];
    const r = rows.find(x => x.folio === folio);
    if (!r) return;
    
    const esUSA = (r.empresa_destino || '').toUpperCase() === 'LLC' || (r.moneda || '').toUpperCase() === 'USD';
    const moneda = (r.moneda || (esUSA ? 'USD' : 'MXN')).toUpperCase();
    const precioTarifa = parseFloat(r.precio_intercompania || 0);
    const totalFact = parseFloat(r.total_facturable || r.total || 0);
    
    const tituloDoc = esUSA 
        ? "Nota de Remisión y Transferencia Internacional (USA)" 
        : "Nota de Remisión Intercompañía México";
    const empresaReceptora = esUSA 
        ? "Dulet Group LLC<br>United States of America · Delaware / California" 
        : "Dulet International Group SA de CV<br>Centro de Distribución México";
    
    const head = `<html><head><meta charset="UTF-8"><title>Remisión - ${folio}</title>
    <style>
        body { font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; font-size: 13px; color: #333; padding: 25px; }
        .header { display: flex; justify-content: space-between; border-bottom: 2px solid #1e3a5f; padding-bottom: 12px; margin-bottom: 20px; }
        .header h1 { margin: 0; color: #1e3a5f; font-size: 22px; }
        .header p { margin: 4px 0 0; color: #666; font-size: 13px; }
        .details { margin-bottom: 25px; display: flex; justify-content: space-between; }
        .details div { width: 48%; }
        table { width: 100%; border-collapse: collapse; margin-bottom: 20px; }
        th, td { border: 1px solid #ddd; padding: 10px; text-align: left; }
        th { background-color: #1e3a5f; color: #fff; }
        .totales { text-align: right; margin-top: 15px; font-size: 16px; }
        .firmas { margin-top: 60px; display: flex; justify-content: space-between; text-align: center; }
        .firma-box { width: 42%; border-top: 1px solid #333; padding-top: 6px; }
    </style></head><body>
    
    <div class="header">
        <div>
            <h1>${tituloDoc}</h1>
            <p><strong>Emisor:</strong> Dulet Internacional S de RL de CV (Planta)</p>
        </div>
        <div style="text-align:right;">
            <p><strong>Folio:</strong> ${r.folio}</p>
            <p><strong>Fecha Liberación:</strong> ${(r.fecha_liberacion||'').substring(0,10)}</p>
            <p><strong>Moneda:</strong> ${moneda}</p>
        </div>
    </div>
    
    <div class="details">
        <div>
            <strong>De (Origen):</strong><br>
            Planta Dulet Internacional (DI)<br>
            Almacén de Producto Terminado
        </div>
        <div>
            <strong>Para (Destinatario):</strong><br>
            ${empresaReceptora}
        </div>
    </div>
    
    <table>
        <thead>
            <tr>
                <th>Lote</th>
                <th>Producto</th>
                <th style="text-align:right;">Cantidad (Uds)</th>
                <th style="text-align:right;">Costo BOM Fab.</th>
                <th style="text-align:right;">Tarifa Intercia</th>
                <th style="text-align:right;">Total Facturable</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td><strong>${r.lote_clave || '—'}</strong></td>
                <td>${r.producto_nombre || '—'}</td>
                <td style="text-align:right;font-weight:bold;">${(+r.cantidad||0).toLocaleString()}</td>
                <td style="text-align:right;">$${(+r.costo_unitario||0).toLocaleString('es-MX',{minimumFractionDigits:4})}</td>
                <td style="text-align:right;color:#1e3a5f;font-weight:bold;">$${precioTarifa.toFixed(2)} ${moneda}</td>
                <td style="text-align:right;color:#047857;font-weight:bold;font-size:14px;">$${totalFact.toLocaleString('es-MX',{minimumFractionDigits:2})} ${moneda}</td>
            </tr>
        </tbody>
    </table>
    
    <div class="totales">
        <strong>Total a Facturar / Transferir: $${totalFact.toLocaleString('es-MX',{minimumFractionDigits:2})} ${moneda}</strong>
    </div>
    
    <div style="margin-top: 20px; padding: 12px; background: #f9fafb; border-left: 4px solid #f59e0b; font-size: 12px; color: #555;">
        <strong>Notas / Desglose de Operación:</strong><br>
        ${r.notas || 'Sin observaciones.'}
    </div>
    
    <div class="firmas">
        <div class="firma-box">
            Entregado por (Planta DI)<br>
            <span style="font-size:11px;color:#666;">${r.liberado_por || 'Almacén DI'}</span>
        </div>
        <div class="firma-box">
            Recibido por (${r.empresa_destino || 'Receptor'})<br>
            <span style="font-size:11px;color:#666;">Almacén / Contabilidad Central</span>
        </div>
    </div>
    
    </body></html>`;
    
    const w = window.open('','_blank');
    w.document.write(head);
    w.document.close();
    setTimeout(() => w.print(), 500);
}



async function _cargarProductosFormulacionModal() {
    const prodSel = document.getElementById('mpd-producto');
    if (!prodSel) return;
    if (window._productosFormulacionCargados) return;
    try {
        const res = await BO_API.post('/bo/sql-relay', {
            secret: 'duletia_relay_2026',
            sql: `SELECT slug, nombre, activo FROM formulacion_productos WHERE activo = true ORDER BY slug`
        });
        if (res?.rows && res.rows.length > 0) {
            const sachets = [];
            const botes = [];
            const otros = [];
            res.rows.forEach(p => {
                const s = p.slug.toLowerCase();
                if (s.includes('sachet')) sachets.push(p);
                else if (s.includes('bote')) botes.push(p);
                else otros.push(p);
            });
            let html = '';
            if (sachets.length) {
                html += `<optgroup label="Dulet Sachet (Predeterminado México)">`;
                sachets.forEach(p => {
                    html += `<option value="${p.slug}">${p.nombre}</option>`;
                });
                html += `</optgroup>`;
            }
            if (botes.length) {
                html += `<optgroup label="Dulet Bote (USA / Guatemala / Especial)">`;
                botes.forEach(p => {
                    html += `<option value="${p.slug}">${p.nombre}</option>`;
                });
                html += `</optgroup>`;
            }
            if (otros.length) {
                html += `<optgroup label="Líquidos / Tópicos / Otros">`;
                otros.forEach(p => {
                    html += `<option value="${p.slug}">${p.nombre}</option>`;
                });
                html += `</optgroup>`;
            }
            const curVal = prodSel.value;
            prodSel.innerHTML = html;
            if (curVal && prodSel.querySelector(`option[value="${curVal}"]`)) {
                prodSel.value = curVal;
            } else if (prodSel.options.length > 0) {
                prodSel.selectedIndex = 0;
            }
            window._productosFormulacionCargados = true;
        }
    } catch(e) {
        console.warn('[ModalProd] Error cargando formulacion_productos:', e.message);
    }
}
window._cargarProductosFormulacionModal = _cargarProductosFormulacionModal;

async function abrirModalNuevaProduccion() {
    const m = document.getElementById('modalProdDiaria');
    if (!m) { BO_AUTH.showAlert('Modal no encontrado.', 'danger'); return; }
    // Fecha default: hoy
    const fechaEl = document.getElementById('mpd-fecha');
    if (fechaEl && !fechaEl.value) fechaEl.value = new Date().toISOString().slice(0,10);
    // Auto-lote sugerido
    const loteEl = document.getElementById('mpd-lote');
    if (loteEl && !loteEl.value) {
        const d = new Date();
        loteEl.value = `LOT-${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-001`;
    }
    // Ocultar campos de costo y notas para rol almacen (sin supervisor)
    const costoGroup = document.getElementById('mpd-costo')?.closest('.form-group');
    const notasGroup = document.getElementById('mpd-notas')?.closest('.form-group');
    const rolActual = (CURRENT_USER?.rol || '').toLowerCase().trim();
    const esAlmacenPuro = (rolActual === 'almacen');
    if (costoGroup) costoGroup.style.display = esAlmacenPuro ? 'none' : '';
    if (notasGroup) notasGroup.style.display = esAlmacenPuro ? 'none' : '';

    // Cargar dinámicamente formulaciones si aún no se han poblado
    await _cargarProductosFormulacionModal();

    // ── Wiring: auto-precalcular costo desde formulacion al cambiar producto o cantidad ──
    const prodSel   = document.getElementById('mpd-producto');
    const cantInput = document.getElementById('mpd-cantidad');
    if (prodSel  && !prodSel._costoWired)  { prodSel.addEventListener('change', _precalcularCostoFormulacion);  prodSel._costoWired  = true; }
    if (cantInput && !cantInput._costoWired) {
        let _costoDebounce;
        cantInput.addEventListener('input', () => { clearTimeout(_costoDebounce); _costoDebounce = setTimeout(_precalcularCostoFormulacion, 350); });
        cantInput._costoWired = true;
    }
    // Recalcular al abrir (por si ya hay un producto seleccionado)
    _precalcularCostoFormulacion();

    m.style.display = 'block';
    document.body.style.overflow = 'hidden';
}

// ── Auto-calcular Costo MP desde Formulación ───────────────────────────────
async function _precalcularCostoFormulacion() {
    const productoRaw = document.getElementById('mpd-producto')?.value;
    const presRaw     = document.getElementById('mpd-presentacion')?.value;
    const paisRaw     = document.getElementById('mpd-etiquetado')?.value;
    const cantidad    = parseInt(document.getElementById('mpd-cantidad')?.value) || 0;
    const costoEl     = document.getElementById('mpd-costo');
    const costoLabel  = costoEl?.closest('.form-group')?.querySelector('.form-label');
    if (!productoRaw || !costoEl || !costoLabel) return;

    const producto = typeof _resolverFormulacionSlug === 'function'
        ? _resolverFormulacionSlug(productoRaw, presRaw, paisRaw)
        : productoRaw;

    try {
        const res = await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026',
            sql: `SELECT COALESCE(SUM(
                    CASE WHEN LOWER(COALESCE(unidad,'g')) IN ('piezas','pz')
                         THEN costo_por_kg * gramos_unidad
                         ELSE (gramos_unidad * costo_por_kg) / 1000
                    END
                  ), 0) AS costo_unitario
                  FROM formulacion_componentes
                  WHERE producto_slug = '${producto}'` });
        const costoUd = parseFloat(res?.rows?.[0]?.costo_unitario || 0);

        if (costoUd > 0) {
            // Costo encontrado: auto-rellenar
            if (cantidad > 0) {
                costoEl.value = (costoUd * cantidad).toFixed(2);
                costoLabel.innerHTML = `💰 Costo materia prima ($) <span style="font-size:.65rem;color:#4ade80;font-weight:400;margin-left:4px;">&#9888; Auto: $${costoUd.toFixed(4)}/ud &times; ${cantidad.toLocaleString('es-MX')} = $${(costoUd * cantidad).toLocaleString('es-MX', {minimumFractionDigits:2})}</span>`;
            } else {
                costoLabel.innerHTML = `💰 Costo materia prima ($) <span style="font-size:.65rem;color:#94a3b8;font-weight:400;margin-left:4px;">Costo/ud: $${costoUd.toFixed(4)} &mdash; ingresa cantidad para calcular total</span>`;
            }
        } else {
            // Sin precios en formulación
            costoLabel.innerHTML = `💰 Costo materia prima ($) <span style="font-size:.65rem;color:#fbbf24;font-weight:400;margin-left:4px;">⚠️ Formulación sin costos &mdash; actualiza precios en la pestaña Formulación</span>`;
        }
    } catch(e) {
        console.warn('[FormulaCosto] Error:', e.message);
    }
}

function _sincronizarPresentacionModal(prodVal) {
    const presEl = document.getElementById('mpd-presentacion');
    if (!presEl) return;
    if (prodVal.includes('sachet')) {
        presEl.value = 'sachet';
    } else {
        presEl.value = 'bote';
    }
    if (typeof _precalcularCostoFormulacion === 'function') _precalcularCostoFormulacion();
    if (typeof _mostrarProrrateoModal === 'function') _mostrarProrrateoModal();
}

function _sincronizarProductoModal(presVal) {
    const prodEl = document.getElementById('mpd-producto');
    if (!prodEl) return;
    const curVal = prodEl.value;
    if (curVal === 'eucament' || curVal.includes('eucament')) return;

    let baseFlavor = 'natural';
    if (curVal.includes('fresa')) baseFlavor = 'fresa';
    else if (curVal.includes('vainilla')) baseFlavor = 'vainilla';
    else if (curVal.includes('choco')) baseFlavor = 'choco';

    const targetVal = `${baseFlavor}_${presVal}`;
    if (prodEl.querySelector(`option[value="${targetVal}"]`)) {
        prodEl.value = targetVal;
    } else {
        for (let i = 0; i < prodEl.options.length; i++) {
            const v = prodEl.options[i].value;
            if (v.includes(baseFlavor) && v.includes(presVal)) {
                prodEl.value = v;
                break;
            }
        }
    }
    if (typeof _precalcularCostoFormulacion === 'function') _precalcularCostoFormulacion();
    if (typeof _mostrarProrrateoModal === 'function') _mostrarProrrateoModal();
}
function _sincronizarPaisModal(paisVal) {
    const presEl = document.getElementById('mpd-presentacion');
    if (!presEl) return;
    const p = String(paisVal || 'MEX').toUpperCase().trim();
    if (p === 'USA' || p === 'GTQ' || p === 'GTM') {
        presEl.value = 'bote';
        _sincronizarProductoModal('bote');
    } else if (p === 'MEX') {
        presEl.value = 'sachet';
        _sincronizarProductoModal('sachet');
    }
}
window._sincronizarPresentacionModal = _sincronizarPresentacionModal;
window._sincronizarProductoModal = _sincronizarProductoModal;
window._sincronizarPaisModal = _sincronizarPaisModal;

function cerrarModalProdDiaria() {
    const m = document.getElementById('modalProdDiaria');
    if (m) { m.style.display = 'none'; document.body.style.overflow = ''; }
    ['mpd-lote','mpd-cantidad','mpd-operador','mpd-costo','mpd-notas'].forEach(id => {
        const el = document.getElementById(id);
        if (el) el.value = '';
    });
}

async function guardarProdDiaria() {
    const fecha     = document.getElementById('mpd-fecha')?.value?.trim();
    const planta    = document.getElementById('mpd-planta')?.value;
    const producto  = document.getElementById('mpd-producto')?.value;
    const presentacion = document.getElementById('mpd-presentacion')?.value || (producto.includes('sachet') ? 'sachet' : 'bote');
    const etiqueta  = document.getElementById('mpd-etiquetado')?.value || 'MEX';
    const lote      = document.getElementById('mpd-lote')?.value?.trim() || '';
    const cantidad  = parseInt(document.getElementById('mpd-cantidad')?.value) || 0;
    const operador  = (document.getElementById('mpd-operador')?.value || '').trim().replace(/'/g,"''");
    let costo       = parseFloat(document.getElementById('mpd-costo')?.value) || 0;
    const notas     = (document.getElementById('mpd-notas')?.value || '').trim().replace(/'/g,"''");
    const kgMerma   = parseFloat(document.getElementById('mpd-merma-kg')?.value) || 0;
    const costoMerma= parseFloat(document.getElementById('mpd-merma-costo')?.value) || 0;

    if (!fecha)    { BO_AUTH.showAlert('Selecciona una fecha de producción.', 'warning'); return; }
    if (cantidad < 1) { BO_AUTH.showAlert('La cantidad mínima es 1 unidad.', 'warning'); return; }

    const btn = document.getElementById('btnGuardarProdDiaria');
    if (btn) { btn.disabled = true; btn.textContent = 'Guardando...'; }

    try {
        const creadoPor = CURRENT_USER?.registro || CURRENT_USER?.id || 'sistema';
        const loteSafe  = lote.replace(/'/g,"''");
        const loteVal   = loteSafe || `LOT-${fecha.replace(/-/g,'')}-${Math.floor(Math.random()*900+100)}`;

        // Calcular prorrateo de bodega para este producto/mes/planta
        let costoProrrateo = 0;
        try {
            const bodegaCfg = (typeof _getBodegaCfg === 'function') ? await _getBodegaCfg() : null;
            if (bodegaCfg) {
                // Compatible con versión anterior o nueva
                const pCfg = bodegaCfg[planta] || (planta === 'planta_1' ? bodegaCfg.planta_1 : (planta === 'planta_2' ? bodegaCfg.planta_2 : bodegaCfg));
                if (pCfg && pCfg.m2_total) {
                    const cTotal = (pCfg.renta_mensual || 0) + (pCfg.luz_mensual || 0);
                    const m2Sku  = pCfg.m2_por_sku?.[producto] || 0;
                    costoProrrateo = (cTotal / pCfg.m2_total) * m2Sku;
                }
            }
        } catch(_) {}

        // Migrar columnas nuevas de produccion_diaria
        await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026',
            sql: `ALTER TABLE produccion_diaria
                  ADD COLUMN IF NOT EXISTS presentacion VARCHAR(50) DEFAULT 'bote',
                  ADD COLUMN IF NOT EXISTS kg_merma NUMERIC(10,4) DEFAULT 0,
                  ADD COLUMN IF NOT EXISTS costo_merma NUMERIC(14,2) DEFAULT 0,
                  ADD COLUMN IF NOT EXISTS costo_prorrateo NUMERIC(14,2) DEFAULT 0`
        }).catch(_=>_);

        const sql = `
            INSERT INTO produccion_diaria 
                (fecha, planta, producto_id, presentacion, etiquetado_pais, lote, cantidad, operador, costo_materia_prima, notas, creado_por, created_at,
                 kg_merma, costo_merma, costo_prorrateo)
            VALUES
                ('${fecha}', '${planta}', '${producto}', '${presentacion}', '${etiqueta}', '${loteVal}', ${cantidad}, '${operador}', ${costo}, '${notas}', '${creadoPor}', NOW(),
                 ${kgMerma}, ${costoMerma}, ${costoProrrateo.toFixed(2)})
            RETURNING id`;

        const res = await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql });

        if (res?.rows?.length || res?.rowCount > 0) {
            BO_AUTH.showAlert(`✅ Lote "${loteVal}" registrado con ${cantidad} unidades.`, 'success');

            // ── Fase 3: MRP Explosión de Materiales y Costo Real PEPS ──
            try {
                const mrpRes = await descontarMaterialesLotePEPS(res.rows[0].id, producto, cantidad, loteVal, creadoPor, fecha, presentacion, etiqueta);
                if (mrpRes?.ok && mrpRes?.costoReal > 0) {
                    costo = mrpRes.costoReal;
                    console.log(`[MRP] Descontados materiales para ${cantidad} de ${producto}. Costo real PEPS: $${costo}`);
                }
            } catch(e) {
                console.warn('[MRP] No se descontaron materias primas:', e.message);
            }

            // ── Fase 4: Actualizar Inventario CEDIS (master = almacén general) ──
            // El trigger trg_inventario_transacciones en PostgreSQL actualiza inventario_stock automáticamente
            try {
                await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql:
                    `INSERT INTO inventario_transacciones (cedis_id, producto_id, cantidad, tipo_movimiento, destino_id, notas, created_at)
                     VALUES ('master', '${producto}', ${cantidad}, 'produccion', 'master', 'Lote ${loteVal.replace(/'/g,"''")} — ${planta}', NOW())` });
                console.log('[INV] Inventario actualizado: +' + cantidad + ' de ' + producto + ' en master');
            } catch(e) {
                console.warn('[INV] No se pudo actualizar inventario_transacciones:', e.message);
            }

            // ── Fase 5: Registrar costo en Costos y Finanzas (gastos_mensuales) ──
            if (costo > 0) {
                try {
                    const mesCosto = fecha.slice(0, 7); // YYYY-MM
                    const creadoPorGasto = (CURRENT_USER?.nombre || String(creadoPor)).replace(/'/g,"''");
                    await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql:
                        `INSERT INTO gastos_mensuales (mes, concepto, categoria, subcategoria, producto_id, monto, notas, creado_por, empresa, origen)
                         VALUES ('${mesCosto}', 'Costo MP — Lote ${loteVal.replace(/'/g,"''")}', 'produccion', 'costo_produccion', '${producto}', ${costo}, 'Lote ${loteVal.replace(/'/g,"''")} | ${planta} | ${cantidad} uds', '${creadoPorGasto}', 'DI', 'auto_lote')` });
                    // Merma
                    if (costoMerma > 0) {
                        await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql:
                            `INSERT INTO gastos_mensuales (mes, concepto, categoria, subcategoria, producto_id, monto, notas, creado_por, empresa, origen)
                             VALUES ('${mesCosto}', 'Merma — Lote ${loteVal.replace(/'/g,"''")}', 'variable', 'merma_produccion', '${producto}', ${costoMerma}, '${kgMerma} kg | Lote ${loteVal.replace(/'/g,"''")}', '${creadoPorGasto}', 'DI', 'auto_lote')` });
                    }
                    // Prorrateo bodega
                    if (costoProrrateo > 0) {
                        await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql:
                            `INSERT INTO gastos_mensuales (mes, concepto, categoria, subcategoria, producto_id, monto, notas, creado_por, empresa, origen)
                             VALUES ('${mesCosto}', 'Prorrateo Bodega — Lote ${loteVal.replace(/'/g,"''")}', 'fijo', 'renta', '${producto}', ${costoProrrateo.toFixed(2)}, 'Bodega m² | ${producto} | Lote ${loteVal.replace(/'/g,"''")}', '${creadoPorGasto}', 'DI', 'auto_lote')` });
                    }
                    console.log('[COSTOS] Gasto de producción registrado: $' + costo + ' en ' + mesCosto);
                } catch(e) {
                    console.warn('[COSTOS] No se pudo registrar en gastos_mensuales:', e.message);
                }
            }

            cerrarModalProdDiaria();
            loadProduccion(); // refrescar tabla
        } else {
            throw new Error('La BD no confirmó el insert.');
        }
    } catch(e) {
        BO_AUTH.showAlert('Error al guardar: ' + e.message, 'danger');
        console.error('[guardarProdDiaria]', e);
    } finally {
        if (btn) { btn.disabled = false; btn.textContent = '🏭 Guardar Lote'; }
    }
}

// ── Editar Costo/Notas de un lote (supervisor/master) ────────
function abrirEditarCostoLote(prodId, costoActual, notasActuales) {
    // Remove existing modal if present
    let m = document.getElementById('modalEditCostoLote');
    if (m) m.remove();

    m = document.createElement('div');
    m.id = 'modalEditCostoLote';
    m.style.cssText = 'position:fixed;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,.6);backdrop-filter:blur(4px);z-index:10010;display:flex;align-items:center;justify-content:center;';
    m.innerHTML = `
        <div style="background:var(--card-bg,#1e1e2e);border:1px solid rgba(99,102,241,.25);border-radius:12px;padding:1.5rem 2rem;min-width:340px;max-width:420px;box-shadow:0 8px 32px rgba(0,0,0,.5);">
            <h3 style="margin:0 0 .8rem;font-size:1rem;color:var(--primary-color,#a5b4fc);">💰 Editar Costo — Lote #${prodId}</h3>
            <div style="margin-bottom:.8rem;">
                <label style="display:block;font-size:.75rem;color:var(--text-dim,#94a3b8);margin-bottom:3px;">Costo Materia Prima ($)</label>
                <input id="ecl-costo" type="number" step="0.01" min="0" value="${costoActual}" style="width:100%;padding:.45rem .6rem;background:rgba(255,255,255,.06);border:1px solid rgba(255,255,255,.15);border-radius:6px;color:#fff;font-size:.9rem;">
            </div>
            <div style="margin-bottom:1rem;">
                <label style="display:block;font-size:.75rem;color:var(--text-dim,#94a3b8);margin-bottom:3px;">Notas (alerta al productor)</label>
                <textarea id="ecl-notas" rows="3" style="width:100%;padding:.45rem .6rem;background:rgba(255,255,255,.06);border:1px solid rgba(255,255,255,.15);border-radius:6px;color:#fff;font-size:.82rem;resize:vertical;">${notasActuales || ''}</textarea>
            </div>
            <div style="display:flex;gap:.6rem;justify-content:flex-end;">
                <button onclick="document.getElementById('modalEditCostoLote')?.remove()" style="background:rgba(255,255,255,.08);border:1px solid rgba(255,255,255,.15);color:#ccc;border-radius:6px;padding:.4rem 1rem;cursor:pointer;font-size:.82rem;">Cancelar</button>
                <button id="btnGuardarCostoLote" onclick="guardarCostoLote(${prodId})" style="background:linear-gradient(135deg,#f59e0b,#d97706);border:none;color:#000;border-radius:6px;padding:.4rem 1.2rem;cursor:pointer;font-size:.82rem;font-weight:700;">💾 Guardar</button>
            </div>
        </div>`;
    document.body.appendChild(m);
}

async function guardarCostoLote(prodId) {
    const costo = parseFloat(document.getElementById('ecl-costo')?.value) || 0;
    const notas = (document.getElementById('ecl-notas')?.value || '').trim().replace(/'/g,"''");
    const btn = document.getElementById('btnGuardarCostoLote');
    if (btn) { btn.disabled = true; btn.textContent = 'Guardando...'; }

    try {
        const sql = `
            UPDATE produccion_diaria SET costo_materia_prima = ${costo}, notas = '${notas}' WHERE id = ${prodId};
            UPDATE ventas_intercompania SET notas = '${notas}' WHERE lote_id = ${prodId};
        `;
        await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql });
        BO_AUTH.showAlert(`✅ Costo y notas actualizados para lote #${prodId}.`, 'success');
        document.getElementById('modalEditCostoLote')?.remove();
        loadProduccion(); // refrescar tabla
    } catch(e) {
        BO_AUTH.showAlert('Error: ' + e.message, 'danger');
        if (btn) { btn.disabled = false; btn.textContent = '💾 Guardar'; }
    }
}

// ============================================================

function exportarRescateExcel() {
    if (!BO_AUTH.hasRole('master')) return;
    const rows = [...document.querySelectorAll('#rescateBody tr')].map(tr =>
        [...tr.querySelectorAll('td')].map(td => td.innerText).join(',')
    );
    const csv = `ID,Nombre,Estatus,País,Sin Compra\n${rows.join('\n')}`;
    const blob = new Blob(['﻿'+csv], {type:'text/csv;charset=utf-8;'});
    const a = document.createElement('a'); a.href = URL.createObjectURL(blob);
    a.download = `cartera_vencida_${new Date().toISOString().slice(0,10)}.csv`; a.click();
}

function exportarRescatePDF() {
    const { jsPDF } = window.jspdf;
    const doc = new jsPDF();
    doc.setFillColor(29,78,216); doc.rect(0,0,210,20,'F');
    doc.setTextColor(255,255,255); doc.setFontSize(14); doc.setFont('helvetica','bold');
    doc.text('PANEL RESCATE EMPRESARIAL', 105, 13, { align:'center' });
    doc.setTextColor(0,0,0); doc.setFontSize(10); doc.setFont('helvetica','normal');
    doc.text(`Generado: ${new Date().toLocaleDateString('es-MX')} — IDs en baja definitiva`, 15, 30);
    doc.setFillColor(29,78,216); doc.rect(0,275,210,22,'F');
    doc.setTextColor(255,255,255); doc.setFontSize(8);
    doc.text('Dulet International Group — Confidencial', 105, 285, { align:'center' });
    doc.save('Rescate_Empresarial.pdf');
}

// ============================================================
// FACTURACIÓN — cuenta regresiva cierre de mes
// ============================================================
function iniciarCuentaRegresiva() {
    const el = document.getElementById('cuentaRegresiva');
    if (!el) return;
    const cierre = new Date(new Date().getFullYear(), new Date().getMonth()+1, 0, 23, 59, 0);
    // Update the banner text dynamically
    const meses = ['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'];
    const txtEl = document.getElementById('alertaCierreTexto');
    if (txtEl) txtEl.textContent = `Periodo Abierto — Cierra el ${cierre.getDate()} de ${meses[cierre.getMonth()]} ${cierre.getFullYear()} a las 23:59`;
    function update() {
        const diff = cierre - new Date();
        if (diff <= 0) { el.textContent = '🔒 CERRADO'; return; }
        const d = Math.floor(diff/86400000);
        const h = Math.floor((diff%86400000)/3600000);
        const m = Math.floor((diff%3600000)/60000);
        el.textContent = `${d}d ${h}h ${m}m`;
    }
    update();
    setInterval(update, 60000);

    // Load the global billing draft automatically if Master/Admin
    if (BO_AUTH.hasRole('master') || BO_AUTH.hasRole('admin')) {
        document.getElementById('panelFacturaGlobal').style.display = 'block';
        loadFacturaGlobal();
    } else {
        document.getElementById('panelFacturaGlobal').style.display = 'none';
    }
}

// ── Borrador Global: estado de paginación y datos ───────────────────────────
let _borradorData  = [];   // todos los registros cargados
let _borradorPage  = 0;    // página actual (base 0)
const _BORRADOR_PER_PAGE = 30;

// ── Ver detalle de nota desde el borrador global ────────────────────────────
async function verNotaBorrador(ventaId) {
    try {
        // 1) Intentar encontrar en _borradorData ya cargado (evita query extra y RBAC)
        let row = (_borradorData || []).find(r => r.id === ventaId);
        let clienteNombre = row?.cliente_nombre || 'Publico General';

        // 2) Si no está en cache local, hacer query SIN join a cliente (evita RBAC anti-scraping)
        if (!row) {
            const sql = `SELECT id, fecha_venta, total, cantidad, comentario, approved, piezas, registro_id, cliente_id, cedis_id
                         FROM venta WHERE id::text = '${ventaId}'`;
            const res = await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql });
            const rows = Array.isArray(res) ? res : (res?.rows || []);
            row = rows[0];
            if (!row || row.success === false) {
                console.error('[verNotaBorrador] No row found. Full response:', res);
                BO_AUTH.showAlert('No se encontró la nota ' + ventaId, 'error');
                return;
            }
            clienteNombre = 'ID: ' + (row.cliente_id || 'N/A');
        }

        // Parsear piezas
        let piezas = row.piezas || [];
        if (typeof piezas === 'string') { try { piezas = JSON.parse(piezas); } catch(e) { piezas = []; } }
        if (!Array.isArray(piezas)) piezas = [];

        let total = parseFloat(row.total || 0);
        let activosAmount = 0;
        const allActivosMatches = [...((row.comentario || '').matchAll(/(?:^|[^A-Z_])(?:ACTIVOS(?:_[A-Z_]+)?(?:\/[^\s$]+)?[^$]*\$([0-9.,]+))/gi))];
        if (allActivosMatches.length > 0) {
            activosAmount = allActivosMatches.reduce((s, m) => s + parseFloat(m[1].replace(/,/g, '')), 0);
        }
        let totalPagadoCheck = 0;
        const pagosCheck = (row.comentario || '').match(/\$[\d,]+(?:\.\d+)?/g) || [];
        pagosCheck.forEach(m => { const val = parseFloat(m.replace(/[\$,]/g, '')); if (!isNaN(val)) totalPagadoCheck += val; });
        const envioMCheck = (row.comentario || '').match(/ENVIO_EXTRA\s*\$([\d,]+(?:\.\d+)?)/i);
        if (envioMCheck) totalPagadoCheck -= parseFloat(envioMCheck[1].replace(/,/g,''));
        if (totalPagadoCheck > total) total = totalPagadoCheck;

        const fechaD = row.fecha_venta ? new Date(row.fecha_venta) : null;
        const v = {
            nota:          row.id ? String(row.id).split('-')[0].toUpperCase() : '???',
            notaFull:      row.id || '',
            cliente:       clienteNombre.trim(),
            clienteReg:    row.cliente_registro ?? 'N/A',
            fechaD,
            fechaStr:      fechaD ? fechaD.toLocaleDateString('es-MX', {day:'2-digit',month:'2-digit',year:'numeric'}) : '—',
            total:         '$' + total.toLocaleString('es-MX', {minimumFractionDigits:2}),
            totalNum:      total,
            activosAmount: activosAmount,
            tipoPago:      typeof parseVentasPago === 'function' ? parseVentasPago(row.comentario) : (row.comentario || '—'),
            comentarioRaw: row.comentario || '',
            estado:        parseInt(row.approved) === 1 ? 'aprobada' : 'pendiente',
            subioPor:      row.registro_id || '',
            subioPorNombre:'',
            cedis_id:      row.cedis_id || null,
            cajas:         parseInt(row.cantidad) || 1,
            piezas:        piezas
        };
        verNotaDetalle(v);
    } catch(e) {
        console.error('[verNotaBorrador] Error:', e);
        BO_AUTH.showAlert('Error al cargar nota: ' + e.message, 'error');
    }
}

async function _facAutoResolveByClienteId(clienteId, clienteNombre) {
    const infoEl    = document.getElementById('fac-lider-info');
    const searchInp = document.getElementById('fac-lider-search');
    if (!clienteId || clienteId === 'null' || clienteId === '') return;
    try {
        const res = await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026',
            sql: `SELECT id, registro, nombre, COALESCE(ape_p,'') AS ape_p, COALESCE(rfc,'') AS rfc, COALESCE(cp,'') AS cp FROM cliente WHERE id = '${clienteId}' LIMIT 1` });
        const cli = res.rows?.[0];
        if (cli) {
            _facClienteIdFilter = cli.id;
            _facRegistroFilter  = null;
            const nombre = (cli.nombre + ' ' + cli.ape_p).trim();
            if (searchInp) searchInp.value = nombre + '  #' + cli.registro;
            const rfc = (cli.rfc || '').trim().toUpperCase();
            if (rfc && rfc.length >= 12) {
                _setFieldVal('fac-rfc', rfc);
                _setFieldVal('fac-razon', nombre);
                _setFieldVal('fac-cp', cli.cp || '45050');
                validarRFC(rfc);
                if (infoEl) { infoEl.style.display='block'; infoEl.innerHTML=`✅ Comprador: <b>${nombre}</b> (Reg. #${cli.registro}) — RFC: <b style="color:var(--success)">${rfc}</b>`; infoEl.style.color='var(--success)'; }
            } else {
                _aplicarRFCGenerico();
                if (searchInp) searchInp.value = nombre + '  #' + cli.registro;
                if (infoEl) { infoEl.style.display='block'; infoEl.innerHTML=`✅ Comprador: <b>${nombre}</b> (Reg. #${cli.registro}) — <span style="color:var(--accent-gold)">Sin RFC → genérico</span>`; infoEl.style.color='var(--success)'; }
            }
        } else {
            _facClienteIdFilter = clienteId;
            _facRegistroFilter  = null;
            if (searchInp) searchInp.value = clienteNombre;
            _aplicarRFCGenerico();
            if (infoEl) { infoEl.style.display='block'; infoEl.innerHTML=`✅ Comprador: <b>${clienteNombre}</b> — <span style="color:var(--accent-gold)">Sin RFC → genérico</span>`; infoEl.style.color='var(--success)'; }
        }
    } catch(e) {
        console.error('_facAutoResolveByClienteId:', e);
    }
}

// ── Botón "Solicitar" en fila del borrador ────────────────────────────────────────────
function facturarNotaBorrador(notaId, clienteNombre, total, clienteId) {
    if (typeof showView === 'function') showView('facturacion');
    setTimeout(async () => {
        // 1. Auto-resolver el COMPRADOR por cliente_id (UUID directo en tabla cliente)
        if (clienteId && clienteId !== 'null' && clienteId !== '') {
            await _facAutoResolveByClienteId(clienteId, clienteNombre);
        }
        // 2. Cargar notas filtradas por este comprador
        try { await cargarNotasSinFacturar(_facClienteIdFilter); } catch(_) {}
        // 3. Pre-seleccionar la nota en el dropdown
        const sel = document.getElementById('fac-nota');
        if (sel) {
            if (!Array.from(sel.options).some(o => o.value === notaId)) {
                const lbl = `#${notaId.substring(0,12)}… — ${clienteNombre} — $${Number(total).toLocaleString('es-MX',{minimumFractionDigits:2})}`;
                sel.add(new Option(lbl, notaId), 1);
            }
            if (!(_notasSinFacturar||[]).some(n => n.id === notaId)) {
                const bNote = (_borradorData||[]).find(r => r.id === notaId);
                if (bNote) {
                    if (!_notasSinFacturar) _notasSinFacturar = [];
                    if (!bNote.monto_real) bNote.monto_real = typeof _parseMontoRealFactura === 'function' ? _parseMontoRealFactura(bNote) : Number(bNote.total||0);
                    _notasSinFacturar.push(bNote);
                }
            }
            sel.value = notaId;
            const infoNota = _notasSinFacturar?.find(n => n.id === notaId);
            if (infoNota && typeof mostrarInfoNota === 'function') mostrarInfoNota(infoNota);
            sel.dispatchEvent(new Event('change'));
        }
        // 4. Scroll al formulario
        const form = document.getElementById('fac-rfc');
        if (form) form.scrollIntoView({behavior:'smooth', block:'center'});
    }, 400);
}

async function loadFacturaGlobal() {
    // Inicializar fechas si están vacías
    const startInput = document.getElementById('fg-date-start');
    const endInput = document.getElementById('fg-date-end');
    if (startInput && !startInput.value) {
        const now = new Date();
        startInput.value = `${now.getFullYear()}-${String(now.getMonth()+1).padStart(2,'0')}-01`;
    }
    if (endInput && !endInput.value) {
        const now = new Date();
        endInput.value = `${now.getFullYear()}-${String(now.getMonth()+1).padStart(2,'0')}-${String(now.getDate()).padStart(2,'0')}`;
    }

    const mesInicio = startInput?.value ? `${startInput.value} 00:00:00` : `${new Date().toISOString().substring(0,7)}-01 00:00:00`;
    const mesFin = endInput?.value ? `${endInput.value} 23:59:59` : `${new Date().toISOString().substring(0,10)} 23:59:59`;

    const tbody = document.getElementById('bodyFacturaGlobal');
    tbody.innerHTML = '<tr><td colspan="8" style="text-align:center;color:var(--text-dim);padding:1.5rem;">Cargando...</td></tr>';
    document.getElementById('fg-pagination').innerHTML = '';
    const srch = document.getElementById('fg-search');
    if (srch) srch.value = '';

    try {
        // 1) Borrador con piezas incluidas
        let res;
        try {
            const sqlBorrador = `SELECT v.id, v.fecha_venta, v.total, COALESCE(v.monto_facturable::float, v.total) AS monto_facturable, v.comentario, v.piezas, v.registro_id, v.cliente_id, v.cedis_id, v.centro_apoyo_id,
                CASE
                  WHEN v.moneda IS NOT NULL AND v.moneda <> '' THEN v.moneda
                  WHEN v.cedis_id::text = '4'              THEN 'USD'
                  WHEN EXISTS (
                    SELECT 1 FROM pais p
                    WHERE p.id = c.pais_id AND p.codigo IN ('USA','SLV')
                  )                                        THEN 'USD'
                  WHEN EXISTS (
                    SELECT 1 FROM pais p
                    WHERE p.id = c.pais_id AND p.codigo IN ('GTM','GUA')
                  )                                        THEN 'GTQ'
                  WHEN EXISTS (
                    SELECT 1 FROM pais p
                    WHERE p.id = c.pais_id AND p.codigo = 'CAN'
                  )                                        THEN 'CAD'
                  ELSE 'MXN'
                END AS moneda,
                COALESCE(c.nombre || ' ' || COALESCE(c.ape_p,''), 'Publico General') AS cliente_nombre, c.registro AS cliente_registro, COALESCE(reg.nombre || ' ' || COALESCE(reg.ape_p,''), '') AS registrador_nombre FROM venta v LEFT JOIN cliente c ON c.id = v.cliente_id LEFT JOIN cliente reg ON reg.registro::text = v.registro_id::text WHERE v.approved=1 AND COALESCE(v.producto_id,'') != 'calificacion-mes' AND COALESCE(v.comentario,'') NOT ILIKE '%calificacion del mes%' AND (v.requiere_factura = false OR v.requiere_factura IS NULL) AND (v.factura_emitida = false OR v.factura_emitida IS NULL) AND (v.factura_uuid IS NULL OR v.factura_uuid = '') AND v.id::text NOT IN (SELECT jsonb_array_elements_text(ventas_ids::jsonb) FROM facturas_solicitadas WHERE estado IN ('solicitada','en_proceso') AND ventas_ids IS NOT NULL AND ventas_ids <> '[]' AND ventas_ids <> 'null') AND v.id::text NOT IN (SELECT numero_nota::text FROM facturas_solicitadas WHERE estado IN ('solicitada','en_proceso') AND numero_nota IS NOT NULL) AND v.id::text NOT IN (SELECT jsonb_array_elements_text(ventas_ids::jsonb) FROM facturas_solicitadas WHERE estado = 'facturada' AND ventas_ids IS NOT NULL AND ventas_ids <> '[]' AND ventas_ids <> 'null') AND v.id::text NOT IN (SELECT numero_nota::text FROM facturas_solicitadas WHERE estado = 'facturada' AND numero_nota IS NOT NULL) AND v.id::text NOT IN (SELECT numero_nota::text FROM facturas_solicitadas WHERE cfdi_id IS NOT NULL AND cfdi_id <> '' AND fecha_cancelacion IS NULL) AND v.id::text NOT IN (SELECT jsonb_array_elements_text(ventas_ids::jsonb) FROM facturas_solicitadas WHERE cfdi_id IS NOT NULL AND cfdi_id <> '' AND fecha_cancelacion IS NULL AND ventas_ids IS NOT NULL AND ventas_ids <> '[]' AND ventas_ids <> 'null') AND v.fecha_venta BETWEEN '${mesInicio}' AND '${mesFin}' ORDER BY v.fecha_venta DESC`;
            res = await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql: sqlBorrador });
        } catch(_fallback) {
            // Fallback: columna moneda no existe aún — query sin ella, inferir por cedis_id
            console.warn('⚠️ Borrador fallback sin columna moneda:', _fallback.message);
            const sqlFallback = `SELECT v.id, v.fecha_venta, v.total, COALESCE(v.monto_facturable::float, v.total) AS monto_facturable, v.comentario, v.piezas, v.registro_id, v.cliente_id, v.cedis_id, v.centro_apoyo_id, CASE WHEN v.cedis_id::text = '4' THEN 'USD' ELSE 'MXN' END AS moneda, COALESCE(c.nombre || ' ' || COALESCE(c.ape_p,''), 'Publico General') AS cliente_nombre, c.registro AS cliente_registro, COALESCE(reg.nombre || ' ' || COALESCE(reg.ape_p,''), '') AS registrador_nombre FROM venta v LEFT JOIN cliente c ON c.id = v.cliente_id LEFT JOIN cliente reg ON reg.registro::text = v.registro_id::text WHERE v.approved=1 AND COALESCE(v.producto_id,'') != 'calificacion-mes' AND COALESCE(v.comentario,'') NOT ILIKE '%calificacion del mes%' AND (v.requiere_factura = false OR v.requiere_factura IS NULL) AND (v.factura_emitida = false OR v.factura_emitida IS NULL) AND (v.factura_uuid IS NULL OR v.factura_uuid = '') AND v.id::text NOT IN (SELECT jsonb_array_elements_text(ventas_ids::jsonb) FROM facturas_solicitadas WHERE estado IN ('solicitada','en_proceso') AND ventas_ids IS NOT NULL AND ventas_ids <> '[]' AND ventas_ids <> 'null') AND v.id::text NOT IN (SELECT numero_nota::text FROM facturas_solicitadas WHERE estado IN ('solicitada','en_proceso') AND numero_nota IS NOT NULL) AND v.id::text NOT IN (SELECT jsonb_array_elements_text(ventas_ids::jsonb) FROM facturas_solicitadas WHERE estado = 'facturada' AND ventas_ids IS NOT NULL AND ventas_ids <> '[]' AND ventas_ids <> 'null') AND v.id::text NOT IN (SELECT numero_nota::text FROM facturas_solicitadas WHERE estado = 'facturada' AND numero_nota IS NOT NULL) AND v.id::text NOT IN (SELECT numero_nota::text FROM facturas_solicitadas WHERE cfdi_id IS NOT NULL AND cfdi_id <> '' AND fecha_cancelacion IS NULL) AND v.id::text NOT IN (SELECT jsonb_array_elements_text(ventas_ids::jsonb) FROM facturas_solicitadas WHERE cfdi_id IS NOT NULL AND cfdi_id <> '' AND fecha_cancelacion IS NULL AND ventas_ids IS NOT NULL AND ventas_ids <> '[]' AND ventas_ids <> 'null') AND v.fecha_venta BETWEEN '${mesInicio}' AND '${mesFin}' ORDER BY v.fecha_venta DESC`;
            res = await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql: sqlFallback });

        }
        window._borradorRawRows = res.rows || [];
        const _exclSetInit = _getFgBorradorExcludedSet();
        _borradorData = window._borradorRawRows.filter(r => !_exclSetInit.has(String(r.id)));
        window._borradorData = _borradorData;
        _borradorPage = 0;
        if (typeof _actualizarVisibilidadBotonCsvGlobal === 'function') _actualizarVisibilidadBotonCsvGlobal();

        // ── Banner informativo: notas en USD (por campo moneda) ──
        const usdRows = _borradorData.filter(r => (r.moneda || 'MXN') !== 'MXN');
        let usdBanner = document.getElementById('fg-usd-banner');
        if (!usdBanner) {
            usdBanner = document.createElement('div');
            usdBanner.id = 'fg-usd-banner';
            const tblParent = tbody.closest('table')?.parentElement;
            if (tblParent) tblParent.insertBefore(usdBanner, tbody.closest('table'));
        }
        if (usdRows.length > 0) {
            const usdCount = usdRows.length;
            const usdTotal = usdRows.reduce((s,t) => s + Number(t.total||0), 0);
            usdBanner.innerHTML = `<div style="margin-bottom:.8rem;padding:.7rem 1rem;background:rgba(59,130,246,.08);border:1px solid rgba(59,130,246,.25);border-radius:8px;display:flex;align-items:center;gap:.6rem;">
                <span style="font-size:1.3rem;">🇺🇸</span>
                <div style="flex:1;">
                    <div style="font-weight:700;color:#60a5fa;font-size:.85rem;">${usdCount} nota${usdCount > 1 ? 's' : ''} en USD — $${usdTotal.toLocaleString('en-US',{minimumFractionDigits:2})} USD</div>
                    <div style="font-size:.72rem;color:var(--text-dim);">Se agrupan como grupo separado "Notas USD". Se creará solicitud independiente con tipo de cambio al timbrar.</div>
                </div>
                <span class="pill" style="background:rgba(59,130,246,.15);color:#60a5fa;font-size:.68rem;font-weight:600;padding:3px 10px;border-radius:20px;">🇺🇸 USD</span>
            </div>`;
        } else {
            usdBanner.innerHTML = '';
        }

        // 2) Obtener catálogo de productos y componentes para recalcular base gravable real
        let productos = [], componentes = [];
        try {
            const [resProd, resComp] = await Promise.all([
                BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql: "SELECT id, sku, nombre, precio, tasa_iva, categoria FROM productos" }),
                BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql: "SELECT paquete_id, componente_id, cantidad FROM producto_componente" })
            ]);
            productos = resProd.rows || [];
            window.PRODUCTOS_DB_CACHE = productos; // Cache for verNotaDetalle
            componentes = resComp.rows || [];
        } catch(e2) { console.warn('No se cargó catálogo de productos para recalcular gravable:', e2.message); }
        window._fgProductosCache = productos;
        window._fgComponentesCache = componentes;

        // 3) Replicar lógica del Motor de Facturación: consolidar piezas y recalcular KPIs
        _recalcularKpisBorradorGlobal();

        renderBorrador();
        if (typeof _actualizarVisibilidadBotonCsvGlobal === 'function') _actualizarVisibilidadBotonCsvGlobal();
    } catch(e) {
        tbody.innerHTML = `<tr><td colspan="8" style="color:#ef4444;text-align:center;">Error: ${e.message}</td></tr>`;
    }
}

// ── Persistencia de exclusiones manuales en Borrador Global (sobrevive cambio de fechas / retroactivo) ──
function _getFgBorradorExcludedSet() {
    if (window._fgBorradorExcludedIds instanceof Set) return window._fgBorradorExcludedIds;
    let arr = [];
    try {
        arr = JSON.parse(sessionStorage.getItem('dulet_fg_borrador_excl') || '[]');
    } catch (_) { arr = []; }
    window._fgBorradorExcludedIds = new Set(Array.isArray(arr) ? arr.map(String) : []);
    return window._fgBorradorExcludedIds;
}

function _saveFgBorradorExcludedSet(setObj) {
    window._fgBorradorExcludedIds = setObj;
    try {
        sessionStorage.setItem('dulet_fg_borrador_excl', JSON.stringify(Array.from(setObj)));
    } catch (_) {}
}

window.restaurarExcluidasBorradorGlobal = function() {
    _saveFgBorradorExcludedSet(new Set());
    _borradorData = (window._borradorRawRows || []).slice();
    window._borradorData = _borradorData;
    _recalcularKpisBorradorGlobal();
    renderBorrador();
    if (typeof _actualizarVisibilidadBotonCsvGlobal === 'function') _actualizarVisibilidadBotonCsvGlobal();
    BO_AUTH.showAlert('♻️ Notas excluidas restauradas al corte global.', 'success');
};

function _recalcularKpisBorradorGlobal() {
    const productos = window._fgProductosCache || window.PRODUCTOS_DB_CACHE || [];
    const componentes = window._fgComponentesCache || [];
    const totalHist = _borradorData.reduce((s,t) => s + Number(t.total||0), 0);
    let totalGravableReal = totalHist;

    if (productos.length > 0) {
        const consolidated = {};
        const ACTIVOS_PRICE = 0.01;

        for (const v of _borradorData) {
            let piezas = v.piezas || [];
            if (typeof piezas === 'string') { try { piezas = JSON.parse(piezas); } catch(e) { piezas = []; } }
            if (!Array.isArray(piezas)) piezas = [];

            for (const pieza of piezas) {
                const prodId = pieza.producto_id || pieza.sku || '';
                if (!prodId) continue;
                const qty = parseInt(pieza.cantidad) || 1;
                const precioVenta = parseFloat(pieza.precio_unitario) || null;

                const catProd = productos.find(p => String(p.id) === String(prodId) || p.sku === prodId);
                if (catProd && catProd.categoria === 'paquete') {
                    const comps = componentes.filter(c => c.paquete_id === catProd.id);
                    if (comps.length > 0) {
                        const totalPiezas = comps.reduce((s, c) => s + (parseInt(c.cantidad) || 0), 0);
                        const precioXPieza = (precioVenta && totalPiezas > 0) ? precioVenta / totalPiezas : null;
                        for (const comp of comps) {
                            const compKey = String(comp.componente_id);
                            const compQty = (parseInt(comp.cantidad) || 1) * qty;
                            if (!consolidated[compKey]) consolidated[compKey] = { qty: 0, precioVenta: precioXPieza };
                            consolidated[compKey].qty += compQty;
                            if (precioXPieza && !consolidated[compKey].precioVenta) consolidated[compKey].precioVenta = precioXPieza;
                        }
                        continue;
                    }
                }
                const key = String(prodId);
                if (!consolidated[key]) consolidated[key] = { qty: 0, precioVenta: null };
                consolidated[key].qty += qty;
                if (precioVenta && !consolidated[key].precioVenta) consolidated[key].precioVenta = precioVenta;
            }
        }

        const totalGravableDB = _borradorData.reduce((s,t) => {
            if (t.monto_facturable !== undefined && t.monto_facturable !== null
                && Number(t.monto_facturable) !== Number(t.total || 0)
                && Number(t.monto_facturable) >= 0) {
                return s + Number(t.monto_facturable);
            }
            let tt = Number(t.total||0);
            let totalPagadoCheck = 0;
            const pagosCheck = (t.comentario || '').match(/\$[\d,]+(?:\.\d+)?/g) || [];
            pagosCheck.forEach(m => { const val = parseFloat(m.replace(/[\$,]/g, '')); if (!isNaN(val)) totalPagadoCheck += val; });
            const envioMCheck = (t.comentario || '').match(/ENVIO_EXTRA\s*\$([\d,]+(?:\.\d+)?)/i);
            if (envioMCheck) totalPagadoCheck -= parseFloat(envioMCheck[1].replace(/,/g,''));
            if (totalPagadoCheck > tt) tt = totalPagadoCheck;

            const allActivosMatches = [...((t.comentario || '').matchAll(/(?:^|[^A-Z_])(?:ACTIVOS(?:_[A-Z_]+)?(?:\/[^\s$]+)?[^$]*\$([0-9.,]+))/gi))];
            let activosSum = 0;
            if (allActivosMatches.length > 0) activosSum = allActivosMatches.reduce((acc, m) => acc + parseFloat(m[1].replace(/,/g, '')), 0);

            let fac = Math.max(0, tt - activosSum);
            return s + fac;
        }, 0);
        let totalProductValue = 0;
        for (const [prodId, data] of Object.entries(consolidated)) {
            const prod = productos.find(p => String(p.id) === String(prodId) || p.sku === prodId);
            const precio = data.precioVenta || (prod ? parseFloat(prod.precio || 0) : 0);
            totalProductValue += data.qty * precio;
        }
        let totalActivos = totalProductValue - totalGravableDB;
        if (totalActivos < 0) totalActivos = 0;

        let items16 = [], items0 = [];
        for (const [prodId, data] of Object.entries(consolidated)) {
            const prod = productos.find(p => String(p.id) === String(prodId) || p.sku === prodId);
            if (!prod) continue;
            const tasa = parseFloat(prod.tasa_iva || 0);
            const precioUnitario = data.precioVenta || parseFloat(prod.precio || 0);
            const item = { prodId, qty: data.qty, precio: precioUnitario, tasa };
            if (tasa === 16) items16.push(item);
            else items0.push(item);
        }

        totalGravableReal = 0;
        function processItems(bucket) {
            for (const item of bucket) {
                if (item.qty <= 0) continue;
                const subsidizable = item.precio > 0 ? Math.floor(totalActivos / item.precio) : 0;
                const toSubsidize = Math.min(item.qty, subsidizable);
                if (toSubsidize > 0) {
                    totalGravableReal += toSubsidize * ACTIVOS_PRICE;
                    totalActivos -= toSubsidize * item.precio;
                    item.qty -= toSubsidize;
                }
                if (item.qty > 0) {
                    totalGravableReal += item.qty * item.precio;
                }
            }
        }
        processItems(items16);
        processItems(items0);
    }

    const elTickets = document.getElementById('fg-tickets');
    if (elTickets) elTickets.textContent = _borradorData.length;
    const elHist = document.getElementById('fg-total-hist');
    if (elHist) elHist.textContent = '$' + totalHist.toLocaleString('es-MX', {minimumFractionDigits:2});
    const elBase = document.getElementById('fg-base-gravable');
    if (elBase) elBase.textContent = '$' + totalGravableReal.toLocaleString('es-MX', {minimumFractionDigits:2});

    window._fgBaseGravableReal = totalGravableReal;
}

// ── Render con filtro + paginación ────────────────────────────────────────────
function renderBorrador() {
    const tbody    = document.getElementById('bodyFacturaGlobal');
    const pagDiv   = document.getElementById('fg-pagination');
    const countLbl = document.getElementById('fg-count-label');
    const q        = (document.getElementById('fg-search')?.value || '').toLowerCase().trim();

    // Filtrar — accent-insensitive ("e" encuentra "é") y extendido a todos los campos
    const _normAccent = s => (s||'').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    const qNorm = _normAccent(q);
    const filtered = qNorm
        ? _borradorData.filter(t => {
            const idMatch = _normAccent(t.id).includes(qNorm);
            const clienteMatch = _normAccent(t.cliente_nombre).includes(qNorm);
            const fechaMatch = (t.fecha_venta||'').includes(qNorm);
            const totalMatch = String(t.total||'').includes(qNorm);
            const comentMatch = _normAccent(t.comentario).includes(qNorm);
            const regLeaderMatch = String(t.registro_id||'').includes(qNorm);
            const regClientMatch = String(t.cliente_registro||'').includes(qNorm);
            return idMatch || clienteMatch || fechaMatch || totalMatch || comentMatch || regLeaderMatch || regClientMatch;
        })
        : _borradorData;

    // ── Calcular créditos pendientes para cada venta ──
    let creditCount = 0;
    let creditTotal = 0;
    filtered.forEach(t => {
        const credAmt = _calcularCreditoVenta({ comentarioRaw: t.comentario || '', totalNum: Number(t.total || 0) });
        t._creditoPendiente = credAmt;
        if (credAmt > 0) { creditCount++; creditTotal += credAmt; }
    });

    // Mostrar/ocultar banner de exclusiones manuales del borrador
    const _exclSetRender = _getFgBorradorExcludedSet();
    const _rawRows = window._borradorRawRows || [];
    const _exclInPeriod = _rawRows.filter(r => _exclSetRender.has(String(r.id)));
    let exclBanner = document.getElementById('fg-excluded-banner');
    if (!exclBanner) {
        exclBanner = document.createElement('div');
        exclBanner.id = 'fg-excluded-banner';
        const tblParent = tbody.closest('table')?.parentElement;
        if (tblParent) tblParent.insertBefore(exclBanner, tbody.closest('table'));
    }
    if (_exclSetRender.size > 0) {
        const _exclMonto = _exclInPeriod.reduce((s, r) => s + Number(r.total || 0), 0);
        const _labelExcl = _exclInPeriod.length > 0
            ? `${_exclInPeriod.length} nota${_exclInPeriod.length > 1 ? 's' : ''} excluida${_exclInPeriod.length > 1 ? 's' : ''} de este corte ($${_exclMonto.toLocaleString('es-MX', { minimumFractionDigits: 2 })})`
            : `${_exclSetRender.size} nota${_exclSetRender.size > 1 ? 's' : ''} excluida${_exclSetRender.size > 1 ? 's' : ''} en esta sesión`;
        exclBanner.innerHTML = `<div style="margin-bottom:.8rem;padding:.65rem 1rem;background:rgba(245,158,11,.08);border:1px solid rgba(245,158,11,.3);border-radius:8px;display:flex;align-items:center;justify-content:space-between;gap:.6rem;flex-wrap:wrap;">
            <div style="display:flex;align-items:center;gap:.6rem;">
                <span style="font-size:1.2rem;">🙈</span>
                <div>
                    <div style="font-weight:700;color:#fbbf24;font-size:.83rem;">${_labelExcl}</div>
                    <div style="font-size:.71rem;color:var(--text-dim);">No se incluirán al generar solicitudes globales aunque cambies el rango de fechas (retroactivo).</div>
                </div>
            </div>
            <button type="button" class="btn btn-outline btn-sm" style="border-color:#f59e0b;color:#fbbf24;font-size:.72rem;font-weight:700;" onclick="window.restaurarExcluidasBorradorGlobal()">♻️ Restaurar excluidas</button>
        </div>`;
    } else {
        exclBanner.innerHTML = '';
    }

    // Mostrar/ocultar alerta de créditos
    let creditAlert = document.getElementById('fg-credit-alert');
    if (!creditAlert) {
        creditAlert = document.createElement('div');
        creditAlert.id = 'fg-credit-alert';
        const tblParent = tbody.closest('table')?.parentElement;
        if (tblParent) tblParent.insertBefore(creditAlert, tbody.closest('table'));
    }
    if (creditCount > 0) {
        creditAlert.innerHTML = `<div style="margin-bottom:.8rem;padding:.7rem 1rem;background:rgba(239,68,68,.08);border:1px solid rgba(239,68,68,.25);border-radius:8px;display:flex;align-items:center;gap:.6rem;">
            <span style="font-size:1.3rem;">🚫</span>
            <div>
                <div style="font-weight:700;color:#f87171;font-size:.85rem;">${creditCount} nota${creditCount > 1 ? 's' : ''} con crédito pendiente — $${creditTotal.toLocaleString('es-MX',{minimumFractionDigits:2})}</div>
                <div style="font-size:.72rem;color:var(--text-dim);">Estas notas no pueden incluirse en el timbrado global hasta liquidar el saldo completo.</div>
            </div>
        </div>`;
    } else {
        creditAlert.innerHTML = '';
    }

    // ── Actualizar banner USD excluyendo notas con crédito pendiente ──
    const usdBannerPost = document.getElementById('fg-usd-banner');
    if (usdBannerPost) {
        const usdFacturables = _borradorData.filter(r => (r.moneda || 'MXN') !== 'MXN' && !(r._creditoPendiente > 0));
        if (usdFacturables.length > 0) {
            const usdC = usdFacturables.length;
            const usdT = usdFacturables.reduce((s,t) => s + Number(t.total||0), 0);
            usdBannerPost.innerHTML = `<div style="margin-bottom:.8rem;padding:.7rem 1rem;background:rgba(59,130,246,.08);border:1px solid rgba(59,130,246,.25);border-radius:8px;display:flex;align-items:center;gap:.6rem;">
                <span style="font-size:1.3rem;">🇺🇸</span>
                <div style="flex:1;">
                    <div style="font-weight:700;color:#60a5fa;font-size:.85rem;">${usdC} nota${usdC > 1 ? 's' : ''} en USD — $${usdT.toLocaleString('en-US',{minimumFractionDigits:2})} USD</div>
                    <div style="font-size:.72rem;color:var(--text-dim);">Se agrupan como grupo separado "Notas USD". Se creará solicitud independiente con tipo de cambio al timbrar.</div>
                </div>
                <span class="pill" style="background:rgba(59,130,246,.15);color:#60a5fa;font-size:.68rem;font-weight:600;padding:3px 10px;border-radius:20px;">🇺🇸 USD</span>
            </div>`;
        } else {
            usdBannerPost.innerHTML = '';
        }
    }

    const totalPages = Math.ceil(filtered.length / _BORRADOR_PER_PAGE);
    if (_borradorPage >= totalPages) _borradorPage = Math.max(0, totalPages - 1);

    const start  = _borradorPage * _BORRADOR_PER_PAGE;
    const page   = filtered.slice(start, start + _BORRADOR_PER_PAGE);

    if (countLbl) countLbl.textContent = `${filtered.length} nota${filtered.length!==1?'s':''} encontrada${filtered.length!==1?'s':''}${creditCount > 0 ? ` (${creditCount} con crédito)` : ''}`;

    if (!filtered.length) {
        tbody.innerHTML = '<tr><td colspan="8" style="text-align:center;color:var(--success);padding:1.5rem;">✅ Corte limpio — Sin notas pendientes para este mes.</td></tr>';
        pagDiv.innerHTML = '';
        return;
    }

    tbody.innerHTML = page.map((t, i) => {
        const f    = t.fecha_venta ? new Date(t.fecha_venta).toLocaleDateString('es-MX') : '—';
        const sId  = (t.id||'').substring(0,12);
        const cNom = (t.cliente_nombre||'Publico General').replace(/'/g,"\\'");
        const cred = t._creditoPendiente || 0;
        const creditBadge = cred > 0
            ? `<span style="display:inline-flex;align-items:center;gap:.25rem;padding:2px 8px;border-radius:6px;font-size:.68rem;font-weight:700;background:rgba(239,68,68,.12);color:#f87171;border:1px solid rgba(239,68,68,.25);">🔴 $${cred.toLocaleString('es-MX',{minimumFractionDigits:2})}</span>`
            : `<span style="font-size:.72rem;color:var(--success);">🟢</span>`;
        const isUSDRow = (t.moneda || 'MXN') !== 'MXN';
        const usdBadge = isUSDRow
            ? `<span style="display:inline-flex;align-items:center;gap:.2rem;padding:1px 7px;border-radius:6px;font-size:.65rem;font-weight:700;background:rgba(59,130,246,.15);color:#60a5fa;border:1px solid rgba(59,130,246,.3);margin-left:.3rem;">🇺🇸 USD</span>`
            : '';
        return `<tr${cred > 0 ? ' style="background:rgba(239,68,68,.03);"' : (isUSDRow ? ' style="background:rgba(59,130,246,.03);"' : '')}>
            <td style="font-size:.75rem;font-family:monospace;">#${sId}…</td>
            <td style="color:var(--text-dim);">${f}</td>
            <td>${t.cliente_nombre||'Publico General'}</td>
            <td>$${(function(){
                let tt=Number(t.total||0);
                let totalPagadoCheck = 0;
                const pagosCheck = (t.comentario || '').match(/\$[\d,]+(?:\.\d+)?/g) || [];
                pagosCheck.forEach(m => { const val = parseFloat(m.replace(/[\$,]/g, '')); if (!isNaN(val)) totalPagadoCheck += val; });
                const envioMCheck = (t.comentario || '').match(/ENVIO_EXTRA\s*\$([\d,]+(?:\.\d+)?)/i);
                if (envioMCheck) totalPagadoCheck -= parseFloat(envioMCheck[1].replace(/,/g,''));
                if (totalPagadoCheck > tt) tt = totalPagadoCheck;
                return tt;
            })().toLocaleString('es-MX',{minimumFractionDigits:2})}${usdBadge}</td>
            <td style="color:var(--success);font-weight:700;">$${Number(t.monto_facturable||0).toLocaleString('es-MX',{minimumFractionDigits:2})}</td>
            <td style="text-align:center;">${creditBadge}</td>
            <td style="display:flex;gap:.3rem;align-items:center;flex-wrap:wrap;min-height:30px;justify-content:center;">
                <button class="btn btn-outline btn-sm fg-ver" data-i="${i}" style="padding:2px 8px;font-size:.72rem;color:#60a5fa;border-color:#60a5fa;margin-bottom:2px;">👁</button>
                <button class="btn btn-outline btn-sm fg-pdf" data-i="${i}" style="padding:2px 8px;font-size:.72rem;">&#8595; PDF</button>
                <button class="btn btn-outline btn-sm fg-excluir" data-id="${t.id}" title="Excluir esta nota del corte actual (no borra nada)" style="padding:2px 7px;font-size:.72rem;color:#f87171;border-color:#f87171;">✕</button>
            </td>
            <td><button class="btn btn-outline btn-sm" style="font-size:.72rem;white-space:nowrap;" onclick="facturarNotaBorrador('${t.id}','${cNom}',${Number(t.total||0)},'${t.cliente_id||''}')">📄 Solicitar</button></td>
        </tr>`;
    }).join('');

    // Event delegation para botones
    tbody.querySelectorAll('.fg-ver').forEach(btn => {
        btn.addEventListener('click', function() {
            const raw = page[+this.dataset.i];
            // Normalizar objeto crudo BD → formato esperado por verNotaDetalle
            const fechaD = raw.fecha_venta ? new Date(String(raw.fecha_venta).substring(0,10)+'T12:00:00') : null;
            let totalNum = parseFloat(raw.total || 0);
            const v = {
                nota:          raw.id ? String(raw.id).split('-')[0].toUpperCase() : '???',
                notaFull:      raw.id || '',
                cliente:       (raw.cliente_nombre || 'Público General').trim(),
                clienteReg:    raw.cliente_registro ?? raw.registro ?? 'N/A',
                fechaStr:      fechaD ? fechaD.toLocaleDateString('es-MX',{day:'2-digit',month:'2-digit',year:'numeric'}) : '—',
                total:         '$' + totalNum.toLocaleString('es-MX',{minimumFractionDigits:2}),
                totalNum,
                tipoPago:      parseVentasPago(raw.comentario || ''),
                comentarioRaw: raw.comentario || '',
                estado:        parseInt(raw.approved) === 1 ? 'aprobada' : 'pendiente',
                cajas:         parseInt(raw.cantidad) || 1,
                cedis_id:      raw.cedis_id || null,
                moneda:        raw.moneda || 'MXN',
                subioPor:      raw.registro_id || '',
                subioPorNombre:(raw.registrador_nombre || '').trim() || '—',
                piezas:        (typeof raw.piezas === 'string' ? JSON.parse(raw.piezas || '[]') : (raw.piezas || []))
            };

            verNotaDetalle(v);
        });
    });
    tbody.querySelectorAll('.fg-excluir').forEach(btn => {
        btn.addEventListener('click', function() {
            const ventaId = this.dataset.id;
            if (!confirm('¿Excluir esta nota del corte actual?\n\nNo se elimina nada — queda fuera al generar la Factura Global (incluso si cambias fechas para retroactivo). Puedes restaurarla con el botón "♻️ Restaurar excluidas".')) return;
            const exclSet = _getFgBorradorExcludedSet();
            exclSet.add(String(ventaId));
            _saveFgBorradorExcludedSet(exclSet);
            _borradorData = _borradorData.filter(r => String(r.id) !== String(ventaId));
            window._borradorData = _borradorData;
            _recalcularKpisBorradorGlobal();
            renderBorrador();
            if (typeof _actualizarVisibilidadBotonCsvGlobal === 'function') _actualizarVisibilidadBotonCsvGlobal();
            BO_AUTH.showAlert('🙈 Nota excluida del corte global (se conserva excluida aunque cambies fechas).', 'info');
        });
    });
    tbody.querySelectorAll('.fg-pdf').forEach(btn => {
        btn.addEventListener('click', function() {
            const v = page[+this.dataset.i];
            let printItems = [];
            let items = [];
            try { items = typeof v.piezas === 'string' ? JSON.parse(v.piezas) : (v.piezas || []); } catch(_) {}
            if (items && items.length > 0) {
                printItems = items.map(pz => {
                    const pid = pz.producto_id || pz.sku || pz.nombre;
                    const inv = typeof INV_PRODUCTOS !== 'undefined' ? INV_PRODUCTOS.find(p => p.id === pid || p.id === pz.sku) : null;
                    const cat = typeof PRODUCTOS_CAT !== 'undefined' ? PRODUCTOS_CAT.find(p => String(p.id) === String(pz.producto_id) || p.sku === pz.sku) : null;
                    const rawNombre = inv?.nombre || cat?.nombre || pz.nombre || pz.sku || 'Producto';
                    const n = typeof limpiarSufijos === 'function' ? limpiarSufijos(rawNombre) : rawNombre;
                    const pr = pz.precio_unitario ? Number(pz.precio_unitario) : Math.round(Number(v.total||0)/(v.cajas||1));
                    const sub = pz.precio_unitario ? Number(pz.precio_unitario)*Number(pz.cantidad) : Number(v.total||0);
                    return { nombre: n, cantidad: pz.cantidad, precio: pr, subtotal: sub };
                });
            } else {
                printItems = [{nombre: 'Dulet', cantidad: v.cajas || 1, precio: Number(v.total||0), subtotal: Number(v.total||0)}];
            }

            generarNotaVentaPDF({
                numero: v.id, clienteNombre: v.cliente_nombre, clienteId: v.registro_id,
                fecha: v.fecha_venta ? new Date(v.fecha_venta).toLocaleDateString('es-MX') : '—', tipoPago: 'Global', total: Number(v.total||0),
                subtotal: Number(v.monto_facturable||0), iva: 0,
                items: printItems, envio: {monto: 0, es_gratis: false, carrier: null}
            });
        });
    });

    // Paginación
    if (totalPages <= 1) { pagDiv.innerHTML = ''; return; }
    let btns = '';
    const from = Math.max(0, _borradorPage - 2);
    const to   = Math.min(totalPages - 1, _borradorPage + 2);
    if (from > 0) btns += `<button class="btn btn-outline btn-sm" onclick="_borradorPage=0;renderBorrador()">1</button><span style="color:var(--text-dim);">…</span>`;
    for (let i = from; i <= to; i++) {
        const active = i === _borradorPage ? 'style="background:var(--accent-purple);color:#fff;border-color:var(--accent-purple);"' : '';
        btns += `<button class="btn btn-outline btn-sm" ${active} onclick="_borradorPage=${i};renderBorrador()">${i+1}</button>`;
    }
    if (to < totalPages - 1) btns += `<span style="color:var(--text-dim);">…</span><button class="btn btn-outline btn-sm" onclick="_borradorPage=${totalPages-1};renderBorrador()">${totalPages}</button>`;
    pagDiv.innerHTML = btns;

    // Bind PDF buttons
    tbody.querySelectorAll('.fg-pdf').forEach(btn => {
        btn.addEventListener('click', function() {
            const idx = parseInt(this.dataset.i);
            const v = page[idx];
            let printItems = [];
            let pzArr = [];
            try { pzArr = typeof v.piezas === 'string' ? JSON.parse(v.piezas) : (v.piezas||[]); } catch(e){}
            if (pzArr && pzArr.length > 0) {
                printItems = pzArr.map(pz => {
                    const pid = pz.producto_id || pz.sku || pz.nombre;
                    const cat = typeof PRODUCTOS_CAT !== 'undefined' ? PRODUCTOS_CAT.find(p => String(p.id) === String(pz.producto_id) || p.sku === pz.sku) : null;
                    const rawNombre = cat?.nombre || pz.nombre || pz.sku || 'Producto';
                    const n = typeof limpiarSufijos === 'function' ? limpiarSufijos(rawNombre) : rawNombre;
                    const pr = pz.precio_unitario ? Number(pz.precio_unitario) : Math.round(Number(v.total||0)/(pz.cantidad||1));
                    const sub = pz.precio_unitario ? Number(pz.precio_unitario)*Number(pz.cantidad) : Number(v.total||0);
                    return { nombre: n, cantidad: pz.cantidad, precio: pr, subtotal: sub };
                });
            } else {
                printItems = [{nombre: 'Venta de Productos', cantidad: 1, precio: Number(v.total||0), subtotal: Number(v.total||0)}];
            }
            if (typeof generarNotaVentaPDF === 'function') {
                generarNotaVentaPDF({
                    numero: v.id, clienteNombre: v.cliente_nombre, clienteId: v.cliente_id,
                    fecha: new Date(v.fecha_venta).toLocaleDateString('es-MX'), tipoPago: 'Definir', total: Number(v.total||0),
                    items: printItems, comentarios: v.comentario || '', subioPor: v.registro_id, notaFull: v.id
                });
            }
        });
    });
}


// ── Detectar forma de pago por MAYORÍA (≥90%) — ignora activos ──────────────
function _detectFormaPagoMayoria(ventas) {
    const buckets = { efectivo: 0, transferencia: 0, tarjeta: 0, intermediario: 0 };
    for (const v of ventas) {
        const com = (v.comentario || '').toUpperCase();
        // Parsear cada segmento separado por ||
        const partes = com.split('||').map(s => s.trim());
        for (const p of partes) {
            // Ignorar activos — no son forma de pago real
            if (p.includes('ACTIVO')) continue;
            // Extraer monto: buscar $N,NNN o $N.NN
            const montoMatch = p.match(/\$([\d,]+\.?\d*)/); 
            const monto = montoMatch ? parseFloat(montoMatch[1].replace(/,/g, '')) : 0;
            if (monto <= 0) continue;
            // Clasificar
            if (p.includes('TRANSF') || p.includes('BBVA') || p.includes('SPEI') || p.includes('BANORTE') || p.includes('HSBC') || p.includes('BANCOMER') || p.includes('SANTANDER'))
                buckets.transferencia += monto;
            else if (p.includes('CLIP') || p.includes('CARD') || p.includes('TARJETA') || p.includes('TDC') || p.includes('TDD'))
                buckets.tarjeta += monto;
            else if (p.includes('MERCADOPAGO') || /\bMP\b/.test(p) || p.includes('STRIPE') || p.includes('PAYPAL'))
                buckets.intermediario += monto;
            else if (p.includes('EFECTIVO') || p.includes('CASH') || p.includes('DEPOSITO') || p.includes('DEP '))
                buckets.efectivo += monto;
            else
                buckets.efectivo += monto; // fallback
        }
    }
    const totalReal = Object.values(buckets).reduce((s, v) => s + v, 0);
    if (totalReal === 0) return { code: '01', label: '01 — Efectivo', pct: 100, buckets };
    // Buscar ≥90%
    const entries = Object.entries(buckets).sort((a, b) => b[1] - a[1]);
    const [topKey, topVal] = entries[0];
    const pct = Math.round((topVal / totalReal) * 100);
    const map = {
        efectivo:      { code: '01', label: '01 — Efectivo' },
        transferencia: { code: '03', label: '03 — Transferencia electrónica de fondos' },
        tarjeta:       { code: '04', label: '04 — Tarjeta de crédito' },
        intermediario: { code: '03', label: '03 — Transferencia electrónica de fondos' }  // MercadoPago/PayPal/Stripe → código 03
    };
    if (pct >= 50) return { ...map[topKey], pct, buckets };
    return { ...map[topKey], label: map[topKey].label + ' (Mayoría relativa)', pct, buckets };
}

// ── Función helper global: calcula monto facturable real de una nota descontando ACTIVOS ──
function _calcularMontoFacturableNota(v) {
    if (!v) return 0;
    // Si tiene monto_facturable explícito y difiere de total, usarlo directo
    // (centros de apoyo y ventas con activos pre-calculados)
    if (v.monto_facturable !== undefined && v.monto_facturable !== null
        && Number(v.monto_facturable) !== Number(v.total || 0)
        && Number(v.monto_facturable) >= 0) {
        return Number(v.monto_facturable);
    }
    let tt = Number(v.total || 0);
    let totalPagadoCheck = 0;
    const pagosCheck = (v.comentario || '').match(/\$[\d,]+(?:\.\d+)?/g) || [];
    pagosCheck.forEach(m => { const val = parseFloat(m.replace(/[\$,]/g, '')); if (!isNaN(val)) totalPagadoCheck += val; });
    const envioMCheck = (v.comentario || '').match(/ENVIO_EXTRA\s*\$([\d,]+(?:\.\d+)?)/i);
    if (envioMCheck) totalPagadoCheck -= parseFloat(envioMCheck[1].replace(/,/g,''));
    if (totalPagadoCheck > tt) tt = totalPagadoCheck;

    const allActivosMatches = [...((v.comentario || '').matchAll(/(?:^|[^A-Z_])(?:ACTIVOS(?:_[A-Z_]+)?(?:\/[^\s$]+)?[^$]*\$([0-9.,]+))/gi))];
    let activosSum = 0;
    if (allActivosMatches.length > 0) {
        activosSum = allActivosMatches.reduce((acc, m) => acc + parseFloat(m[1].replace(/,/g, '')), 0);
    }

    return Math.max(0, tt - activosSum);
}

async function timbrarFacturaGlobal() {
    if (!_borradorData || !_borradorData.length) {
        BO_AUTH.showAlert('No hay notas pendientes para timbrar en este periodo.', 'warning');
        return;
    }

    // Filtrar crédito pendiente — EXCEPTO notas de centros de apoyo
    // (centros manejan activos/pagos visualmente en su modal Vista Pre-Factura)
    const conCredito = [];
    const sinCredito = [];
    const centroNotas = []; // Notas de centros: pasan sin filtro de crédito
    _borradorData.forEach(t => {
        const cliNombre = String(t.cliente_nombre || '').toLowerCase();
        const comentario = String(t.comentario || '').toLowerCase();
        const notaId = String(t.id || '');
        const isCentroNota = !!(t.centro_apoyo_id && String(t.centro_apoyo_id) !== '0' && String(t.centro_apoyo_id) !== 'null') ||
                             cliNombre.includes('centro de apoyo') ||
                             cliNombre.startsWith('centro ') ||
                             comentario.includes('centro de apoyo') ||
                             comentario.includes('crédito (centros)') ||
                             comentario.includes('credito (centros)') ||
                             notaId.startsWith('CENTRO-');
        if (isCentroNota) {
            centroNotas.push(t);
            return;
        }
        const credAmt = _calcularCreditoVenta({ comentarioRaw: t.comentario || '', totalNum: Number(t.total || 0) });
        if (credAmt > 0) { t._creditoPendiente = credAmt; conCredito.push(t); }
        else { sinCredito.push(t); }
    });

    // Solo bloquear si TODAS las notas no-centro tienen crédito
    if (conCredito.length > 0 && sinCredito.length === 0 && centroNotas.length === 0) {
        BO_AUTH.showAlert('🚫 TODAS las notas tienen crédito pendiente. No se puede generar factura global.', 'error');
        return;
    }
    if (conCredito.length > 0) {
        const totalCred = conCredito.reduce((s, t) => s + (t._creditoPendiente || 0), 0);
        const ok = confirm(`⚠️ ${conCredito.length} nota(s) con crédito pendiente serán EXCLUIDAS (no aplica a centros de apoyo).\n\n¿Continuar con ${sinCredito.length + centroNotas.length} notas?`);
        if (!ok) return;
        _borradorData = [...sinCredito, ...centroNotas];
    } else {
        // Sin créditos en notas regulares, re-ensamblar con centros incluidos
        _borradorData = [...sinCredito, ...centroNotas];
    }

    // ═══ AGRUPAR POR CEDIS ═══
    const cedisMap = { '0': {id:0, nombre:'Matriz Guadalajara', cp:'45050'}, '1': {id:1, nombre:'CEDIS Guadalajara', cp:'45050'}, '2': {id:2, nombre:'CEDIS Cancún', cp:'77509'}, '3': {id:3, nombre:'CEDIS Tapachula', cp:'30700'}, '4': {id:4, nombre:'CEDIS 4 — USD 🇺🇸', cp:'45050'} };
    // Intentar cargar CPs reales de la BD
    try {
        const cRes = await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql: "SELECT id, nombre, cp FROM cedis WHERE activo = true" });
        (cRes.rows||[]).forEach(r => { cedisMap[String(r.id)] = { id: r.id, nombre: r.nombre, cp: r.cp || '45050' }; });
    } catch(_){}

    const groups = {};
    // Cargar info de centros de apoyo para sub-agrupación
    let centrosInfo = {};
    try {
        const caRes = await BO_API.post('/bo/sql-relay', { 
            secret: 'duletia_relay_2026', 
            sql: `SELECT ca.id, ca.nombre, ca.codigo_postal, ca.cedis_origen, ca.lider_id, ca.moneda,
                         COALESCE(c.nombre || ' ' || COALESCE(c.ape_p, ''), '') AS lider_nombre
                  FROM centro_apoyo ca
                  LEFT JOIN cliente c ON c.registro::text = ca.lider_id::text
                  ORDER BY ca.id` 
        });
        (caRes.rows||[]).forEach(r => { 
            centrosInfo[String(r.id)] = { 
                id: r.id, 
                nombre: r.nombre || ('Centro #' + r.id), 
                lider_nombre: (r.lider_nombre || '').trim(),
                cp: r.codigo_postal || '45050', 
                cedis: r.cedis_origen,
                moneda: (r.moneda || 'MXN').toUpperCase()
            }; 
        });
    } catch(_){}

    _borradorData.forEach(t => {
        let key;
        
        // Detección robusta de notas de Centros de Apoyo
        const cliNombre = String(t.cliente_nombre || '').toLowerCase();
        const comentario = String(t.comentario || '').toLowerCase();
        const notaId = String(t.id || '');
        
        const hasCentroId = !!(t.centro_apoyo_id && String(t.centro_apoyo_id) !== '0' && String(t.centro_apoyo_id) !== 'null');
        const isCentro = hasCentroId || 
                         cliNombre.includes('centro de apoyo') || 
                         cliNombre.startsWith('centro ') ||
                         comentario.includes('centro de apoyo') || 
                         comentario.includes('crédito (centros)') ||
                         comentario.includes('credito (centros)') ||
                         notaId.startsWith('CENTRO-');

        if (isCentro && hasCentroId) {
            // Sub-agrupar por centro_apoyo_id real
            key = 'CA_' + String(t.centro_apoyo_id);
            const ci = centrosInfo[String(t.centro_apoyo_id)];
            const centroMoneda = (ci?.moneda || t.moneda || 'MXN').toUpperCase();
            
            let displayName = ci?.nombre || ('Centro #' + t.centro_apoyo_id);
            if (ci?.lider_nombre && !displayName.toLowerCase().includes(ci.lider_nombre.toLowerCase())) {
                displayName = `${displayName} (${ci.lider_nombre})`;
            }

            if (!groups[key]) groups[key] = { 
                info: { 
                    id: String(t.centro_apoyo_id), 
                    nombre: displayName, 
                    rawNombre: ci?.nombre || ('Centro #' + t.centro_apoyo_id),
                    liderNombre: ci?.lider_nombre || '',
                    cp: ci?.cp || '45050',
                    moneda: centroMoneda
                }, 
                notas: [], 
                isCentro: true, 
                isCentroUSD: (centroMoneda === 'USD'),
                isUSD: (centroMoneda === 'USD'),
                centroApoyoId: String(t.centro_apoyo_id) 
            };
        } else {
            // Sin centro_apoyo_id → va a su CEDIS normal
            key = String(t.cedis_id || 0);
            if (!groups[key]) groups[key] = { info: cedisMap[key] || {id:key, nombre:'CEDIS '+key, cp:'45050', moneda:'MXN'}, notas: [] };
        }
        groups[key].notas.push(t);
    });

    // ═══ SEPARAR NOTAS USD DE VENTAS DIRECTAS (No de Centros USD) ═══
    const usdRetailNotas = [];
    for (const key of Object.keys(groups)) {
        const g = groups[key];
        // Si el grupo es un Centro en USD (ej. Pojoy), conserva sus notas USD intactas
        if (g.isCentro && g.isCentroUSD) {
            continue;
        }
        const usd = g.notas.filter(t => (t.moneda || 'MXN') !== 'MXN');
        const mxn = g.notas.filter(t => (t.moneda || 'MXN') === 'MXN');
        if (usd.length > 0) {
            usdRetailNotas.push(...usd);
            g.notas = mxn;
            if (mxn.length === 0) delete groups[key]; // CEDIS vacío tras sacar USD
        }
    }
    if (usdRetailNotas.length > 0) {
        groups['USD_RETAIL'] = {
            info: { id: 'USD_RETAIL', nombre: '🇺🇸 Clientes USA (Directas)', cp: '45050', moneda: 'USD' },
            notas: usdRetailNotas,
            isUSD: true,
            isRetailUSD: true
        };
    }

    const groupKeys = Object.keys(groups);

    // Si solo hay 1 grupo, ir directo al modal de confirmación existente
    if (groupKeys.length === 1) {
        window._timbradoCedisTarget = groups[groupKeys[0]];
        return _mostrarModalConfirmacionCedis(groups[groupKeys[0]]);
    }

    // Múltiples CEDIS: mostrar modal de selección
    window._timbradoGroups = groups;
    const fmt = (n) => '$' + Number(n).toLocaleString('es-MX',{minimumFractionDigits:2});
    // Pre-cargar activos para centros con centro_apoyo_id
    const _fgCentroActivos = {};
    const startD_cards = document.getElementById('fg-date-start')?.value || '';
    const endD_cards = document.getElementById('fg-date-end')?.value || '';
    const mesCards = startD_cards && endD_cards ? startD_cards.substring(0,7) : new Date().toISOString().substring(0,7);
    await Promise.all(groupKeys.map(async (k) => {
        const g = groups[k];
        if (!g.isCentro || !g.centroApoyoId) return;
        const cId = g.centroApoyoId;
        try {
            const [actRes, prevRes] = await Promise.all([
                BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql: `SELECT COALESCE(SUM(monto),0) AS total FROM centro_apoyo_pago WHERE centro_id=${cId} AND (tipo_pago='Cobro Activos' OR LOWER(tipo_pago) LIKE '%activo%') AND TO_CHAR(creado_en,'YYYY-MM')='${mesCards}'` }),
                BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql: `SELECT comentario FROM facturas_solicitadas WHERE (numero_nota LIKE 'CENTRO-${cId}-%' OR numero_nota LIKE 'GLOBAL-%-CA_${cId}') AND estado IN ('solicitada','en_proceso','facturada') AND (numero_nota LIKE '%${mesCards}%' OR comentario LIKE '%${mesCards}%' OR comentario LIKE '%mes=${mesCards}%')` })
            ]);
            const brutos = parseFloat(actRes.rows?.[0]?.total || '0');
            let yaConsumidos = 0;
            (prevRes.rows||[]).forEach(s => { const m = String(s.comentario||'').match(/act=([0-9.]+)/); if(m) yaConsumidos += parseFloat(m[1]) || 0; });
            _fgCentroActivos[cId] = { brutos, yaConsumidos, disponibles: Math.max(0, brutos - yaConsumidos) };
            g._activosData = _fgCentroActivos[cId];
        } catch(e) { console.warn('[FG] Error cargando activos centro '+cId, e); _fgCentroActivos[cId] = { brutos:0, yaConsumidos:0, disponibles:0 }; g._activosData = _fgCentroActivos[cId]; }
    }));

    // Separar grupos: Centros MXN vs Centros USD vs Clientes Directos USA vs Otros CEDIS
    const centroKeysMXN = groupKeys.filter(k => groups[k].isCentro && !groups[k].isCentroUSD);
    const centroKeysUSD = groupKeys.filter(k => groups[k].isCentro && groups[k].isCentroUSD);
    const retailUSDKey = groups['USD_RETAIL'] ? ['USD_RETAIL'] : [];
    const allUSDKeys = [...centroKeysUSD, ...retailUSDKey];
    const otherKeys = groupKeys.filter(k => !groups[k].isCentro && !groups[k].isUSD && !groups[k].isRetailUSD);

    // Builder de tarjetas individuales
    const buildCards = (keys) => keys.map(k => {
        const g = groups[k];
        const isUSD = g.isUSD || g.isCentroUSD || false;
        const isCentroReal = g.isCentro || false;
        const totalFact = g.notas.reduce((s,t) => s + _calcularMontoFacturableNota(t), 0);
        const borderStyle = isUSD
            ? 'border:2px solid #3b82f6;background:rgba(59,130,246,.08);'
            : isCentroReal
            ? 'border:2px solid #f59e0b;background:rgba(245,158,11,.06);'
            : 'border:1px solid var(--border);background:rgba(255,255,255,.04);';
        const emoji = isUSD ? (isCentroReal ? '🏪🇺🇸' : '🇺🇸') : isCentroReal ? '🏪' : '📦';
        const sym = '$';
        const monLabel = isUSD ? ' USD' : ' MXN';
        const fmtCard = (n) => sym + Number(n).toLocaleString(isUSD ? 'en-US' : 'es-MX', {minimumFractionDigits:2}) + monLabel;
        let activosBadge = '';
        if (isCentroReal && g._activosData && g._activosData.disponibles > 0) {
            activosBadge = `<div style="font-size:.7rem;color:${isUSD ? '#60a5fa' : '#f59e0b'};margin-top:.2rem;background:${isUSD ? 'rgba(59,130,246,.12)' : 'rgba(245,158,11,.1)'};border-radius:4px;padding:.15rem .4rem;">💰 Activos: ${fmtCard(g._activosData.disponibles)}</div>`;
        }
        const subtitle = isUSD 
            ? (isCentroReal ? (g.info.liderNombre ? `👤 ${g.info.liderNombre} · Centro USD` : 'Centro de Apoyo USD') : 'Venta Directa USA · Requiere TC DOF')
            : isCentroReal 
            ? (g.info.liderNombre ? `👤 ${g.info.liderNombre} · CP: ${g.info.cp}` : `Centro de Apoyo · CP: ${g.info.cp}`) 
            : 'CP: ' + g.info.cp;
        return `<div style="${borderStyle}border-radius:10px;padding:.8rem;text-align:center;min-width:180px;max-width:220px;flex:1;">
            <div style="font-size:1.1rem;margin-bottom:.2rem;">${emoji}</div>
            <div style="font-size:.85rem;font-weight:700;color:${isUSD ? '#60a5fa' : isCentroReal ? '#f59e0b' : 'var(--text-primary)'};">${g.info.nombre}</div>
            <div style="font-size:.65rem;color:var(--text-dim);margin:.15rem 0;">${subtitle}</div>
            <div style="font-size:1rem;font-weight:800;color:${isUSD ? '#3b82f6' : '#818cf8'};margin:.2rem 0;">${g.notas.length} notas</div>
            <div style="font-size:.8rem;font-weight:600;color:${isUSD ? '#60a5fa' : 'var(--success)'}">${fmtCard(totalFact)}</div>
            ${activosBadge}
            <button class="btn btn-outline" style="margin-top:.5rem;padding:.3rem .7rem;font-size:.7rem;${isUSD ? 'border-color:#3b82f6;color:#60a5fa;' : isCentroReal ? 'border-color:#f59e0b;color:#f59e0b;' : ''}" onclick="_crearSolicitudCedis('${k}')">${isUSD ? '🇺🇸 Crear Solicitud USD' : '📝 Crear Solicitud'}</button>
        </div>`;
    }).join('');

    // ═══ BARRA 1: CONSOLIDADO CENTROS MXN ═══
    let centroConsolidadoHtml = '';
    if (centroKeysMXN.length > 0) {
        const totalNotasCentros = centroKeysMXN.reduce((s,k) => s + groups[k].notas.length, 0);
        const totalFactCentros = centroKeysMXN.reduce((s,k) => s + groups[k].notas.reduce((ss,t) => ss + _calcularMontoFacturableNota(t), 0), 0);
        const totalActivosCentros = centroKeysMXN.reduce((s,k) => {
            const ad = groups[k]._activosData;
            return s + (ad ? ad.disponibles : 0);
        }, 0);
        const fmtC = (n) => '$' + Number(n).toLocaleString('es-MX',{minimumFractionDigits:2});
        centroConsolidadoHtml = `
        <div style="width:100%;background:rgba(245,158,11,.05);border:1px solid rgba(245,158,11,.25);border-radius:10px;padding:.8rem 1rem;margin-bottom:.8rem;">
            <div style="display:flex;align-items:center;justify-content:space-between;flex-wrap:wrap;gap:.5rem;">
                <div style="display:flex;align-items:center;gap:.5rem;">
                    <span style="font-size:1.1rem;">🏪</span>
                    <span style="font-size:.85rem;font-weight:800;color:#f59e0b;">CONSOLIDADO CENTROS (MXN)</span>
                    <span style="font-size:.7rem;color:var(--text-dim);background:rgba(245,158,11,.12);padding:.1rem .4rem;border-radius:4px;">${centroKeysMXN.length} centros · ${totalNotasCentros} notas</span>
                </div>
                <div style="display:flex;gap:1rem;align-items:center;flex-wrap:wrap;">
                    <div style="text-align:center;">
                        <div style="font-size:.6rem;color:var(--text-dim);text-transform:uppercase;">Facturable</div>
                        <div style="font-size:.85rem;font-weight:700;color:var(--success);">${fmtC(totalFactCentros)} MXN</div>
                    </div>
                    ${totalActivosCentros > 0 ? `<div style="text-align:center;">
                        <div style="font-size:.6rem;color:var(--text-dim);text-transform:uppercase;">Activos Disp.</div>
                        <div style="font-size:.85rem;font-weight:700;color:#f59e0b;">${fmtC(totalActivosCentros)} MXN</div>
                    </div>` : ''}
                    <button class="btn btn-outline" style="padding:.4rem .9rem;font-size:.75rem;font-weight:700;border:1px solid #f59e0b;color:#f59e0b;background:rgba(245,158,11,.12);border-radius:6px;cursor:pointer;white-space:nowrap;transition:all .2s;" onmouseover="this.style.background='rgba(245,158,11,.25)'" onmouseout="this.style.background='rgba(245,158,11,.12)'" onclick="_crearSolicitudConsolidadaCentros()">📝 Crear Solicitud Consolidada MXN</button>
                </div>
            </div>
        </div>`;
    }

    // ═══ BARRA 2: CONSOLIDADO DÓLARES (USD) CON TAG INTELIGENTE ═══
    let usdConsolidadoHtml = '';
    if (allUSDKeys.length > 0) {
        const centrosUSDNombres = centroKeysUSD.map(k => groups[k].info.rawNombre || groups[k].info.nombre);
        const totalNotasCentrosUSD = centroKeysUSD.reduce((s,k) => s + groups[k].notas.length, 0);
        const totalNotasRetailUSD = groups['USD_RETAIL'] ? groups['USD_RETAIL'].notas.length : 0;
        const totalNotasUSD = totalNotasCentrosUSD + totalNotasRetailUSD;

        const tagParts = [];
        if (centrosUSDNombres.length > 0) {
            tagParts.push(`Centros USD: ${centrosUSDNombres.join(', ')} (${totalNotasCentrosUSD} nota${totalNotasCentrosUSD > 1 ? 's' : ''})`);
        }
        if (totalNotasRetailUSD > 0) {
            tagParts.push(`Clientes USA: ${totalNotasRetailUSD} nota${totalNotasRetailUSD > 1 ? 's' : ''}`);
        }
        const smartTagUSD = tagParts.join(' · ');

        const totalActivosUSD = centroKeysUSD.reduce((s,k) => {
            const ad = groups[k]._activosData;
            return s + (ad ? ad.disponibles : 0);
        }, 0);

        let factUSD = 0;
        for (const k of centroKeysUSD) {
            const g = groups[k];
            const totNotas = g.notas.reduce((s,t) => s + _calcularMontoFacturableNota(t), 0);
            const actDisp = g._activosData ? g._activosData.disponibles : 0;
            factUSD += Math.max(0, totNotas - actDisp);
        }
        if (groups['USD_RETAIL']) {
            factUSD += groups['USD_RETAIL'].notas.reduce((s,t) => s + _calcularMontoFacturableNota(t), 0);
        }

        const fmtU = (n) => '$' + Number(n).toLocaleString('en-US',{minimumFractionDigits:2});
        usdConsolidadoHtml = `
        <div style="width:100%;background:rgba(59,130,246,.06);border:1px solid rgba(59,130,246,.3);border-radius:10px;padding:.8rem 1rem;margin-bottom:.8rem;">
            <div style="display:flex;align-items:center;justify-content:space-between;flex-wrap:wrap;gap:.5rem;">
                <div style="display:flex;align-items:center;gap:.5rem;flex-wrap:wrap;">
                    <span style="font-size:1.1rem;">🇺🇸</span>
                    <span style="font-size:.85rem;font-weight:800;color:#60a5fa;">CONSOLIDADO DÓLARES (USD)</span>
                    <span style="font-size:.7rem;color:#93c5fd;background:rgba(59,130,246,.15);border:1px solid rgba(59,130,246,.25);padding:.15rem .5rem;border-radius:4px;font-weight:600;">${smartTagUSD} · ${totalNotasUSD} notas</span>
                </div>
                <div style="display:flex;gap:1rem;align-items:center;flex-wrap:wrap;">
                    <div style="text-align:center;">
                        <div style="font-size:.6rem;color:var(--text-dim);text-transform:uppercase;">Facturable</div>
                        <div style="font-size:.85rem;font-weight:700;color:#60a5fa;">${fmtU(factUSD)} USD</div>
                    </div>
                    ${totalActivosUSD > 0 ? `<div style="text-align:center;">
                        <div style="font-size:.6rem;color:var(--text-dim);text-transform:uppercase;">Activos Centros USD</div>
                        <div style="font-size:.85rem;font-weight:700;color:#3b82f6;">${fmtU(totalActivosUSD)} USD</div>
                    </div>` : ''}
                    <button class="btn btn-outline" style="padding:.4rem .9rem;font-size:.75rem;font-weight:700;border:1px solid #3b82f6;color:#60a5fa;background:rgba(59,130,246,.15);border-radius:6px;cursor:pointer;white-space:nowrap;transition:all .2s;" onmouseover="this.style.background='rgba(59,130,246,.3)'" onmouseout="this.style.background='rgba(59,130,246,.15)'" onclick="_crearSolicitudConsolidadaUSD()">🇺🇸 Crear Consolidado Dólares</button>
                </div>
            </div>
        </div>`;
    }

    const centroCardsHtml = centroKeysMXN.length > 0 ? `
        <div style="width:100%;padding:0 .5rem;">
            <div style="font-size:.75rem;font-weight:700;color:#f59e0b;text-transform:uppercase;margin-bottom:.5rem;display:flex;align-items:center;gap:.5rem;">
                🏪 Centros de Apoyo México (${centroKeysMXN.length})
                <div style="flex:1;height:1px;background:rgba(245,158,11,.2);"></div>
            </div>
            ${centroConsolidadoHtml}
            <div style="display:flex;flex-wrap:wrap;gap:.8rem;justify-content:center;">${buildCards(centroKeysMXN)}</div>
        </div>` : '';

    const usdCardsHtml = allUSDKeys.length > 0 ? `
        <div style="width:100%;padding:0 .5rem;margin-top:.8rem;">
            <div style="font-size:.75rem;font-weight:700;color:#60a5fa;text-transform:uppercase;margin-bottom:.5rem;display:flex;align-items:center;gap:.5rem;">
                🇺🇸 Ventas y Centros en Dólares (${allUSDKeys.length})
                <div style="flex:1;height:1px;background:rgba(59,130,246,.25);"></div>
            </div>
            ${usdConsolidadoHtml}
            <div style="display:flex;flex-wrap:wrap;gap:.8rem;justify-content:center;">${buildCards(allUSDKeys)}</div>
        </div>` : '';

    const otherCardsHtml = otherKeys.length > 0 ? `
        <div style="width:100%;padding:0 .5rem;margin-top:.8rem;">
            <div style="font-size:.75rem;font-weight:700;color:#818cf8;text-transform:uppercase;margin-bottom:.5rem;display:flex;align-items:center;gap:.5rem;">
                📦 CEDIS Nacionales (${otherKeys.length})
                <div style="flex:1;height:1px;background:rgba(129,140,248,.2);"></div>
            </div>
            <div style="display:flex;flex-wrap:wrap;gap:.8rem;justify-content:center;">${buildCards(otherKeys)}</div>
        </div>` : '';

    // Botón de centros solo si hay más de 1 en MXN
    const btnCentros = centroKeysMXN.length > 1 ? `<button onclick="_crearTodasSolicitudesCentros()" class="btn btn-outline" style="padding:.5rem 1.2rem;border-color:#f59e0b;color:#f59e0b;font-weight:700;">🏪 Crear Todos los Centros MXN (${centroKeysMXN.length})</button>` : '';

    let modal = document.getElementById('modal-cedis-select');
    if (!modal) { modal = document.createElement('div'); modal.id = 'modal-cedis-select'; document.body.appendChild(modal); }
    modal.innerHTML = `<div style="position:fixed;inset:0;background:rgba(0,0,0,.75);z-index:9999;display:flex;align-items:center;justify-content:center;padding:1rem;" onclick="if(event.target===this)this.parentElement.style.display='none'">
        <div style="background:#1a1a2e;border:1px solid var(--border);border-radius:12px;max-width:920px;width:95%;max-height:90vh;display:flex;flex-direction:column;box-shadow:0 25px 50px rgba(0,0,0,.5);" onclick="event.stopPropagation()">
            <div style="padding:1rem 1.5rem;border-bottom:1px solid var(--border);display:flex;justify-content:space-between;align-items:center;flex-shrink:0;">
                <div><div style="font-size:1rem;font-weight:800;">🏷️ Separación por Lugar de Expedición y Divisa</div>
                <div style="font-size:.75rem;color:var(--text-dim);">Se detectaron notas de ${groupKeys.length} grupos diferentes. El SAT requiere CFDI separado por CP y divisa oficial.</div></div>
                <button onclick="document.getElementById('modal-cedis-select').style.display='none'" style="background:none;border:none;color:var(--text-dim);font-size:1.3rem;cursor:pointer;">✕</button>
            </div>
            <div style="padding:1rem 1.5rem;overflow-y:auto;flex:1;">${centroCardsHtml}${usdCardsHtml}${otherCardsHtml}</div>
            <div style="padding:1rem 1.5rem;border-top:1px solid var(--border);display:flex;justify-content:flex-end;gap:.8rem;flex-shrink:0;flex-wrap:wrap;">
                <button onclick="document.getElementById('modal-cedis-select').style.display='none'" class="btn btn-outline" style="padding:.5rem 1rem;">Cancelar</button>
                ${btnCentros}
                <button onclick="_crearTodasSolicitudesCedis()" class="btn btn-primary" style="padding:.5rem 1.2rem;background:linear-gradient(135deg,#6366f1,#8b5cf6);font-weight:700;">🚀 Crear Todas (${groupKeys.length} solicitudes)</button>
            </div>
        </div>
    </div>`;
    modal.style.display = 'block';
}

// ═══ Mostrar modal de confirmación para un grupo CEDIS ═══
function _mostrarModalConfirmacionCedis(group) {
    const notas = group.notas;
    const info = group.info;
    const isUSD = group.isUSD || false;
    const isCentroReal = group.isCentro || false;
    window._timbradoIsUSD = isUSD;
    window._timbradoIsCentro = isCentroReal;
    window._fgTipoCambioUSD = null;
    const fmtM = (n) => (isUSD ? '$' : '$') + Number(n).toLocaleString(isUSD ? 'en-US' : 'es-MX', {minimumFractionDigits:2}) + (isUSD ? ' USD' : '');
    const fmt = (n) => '$' + Number(n).toLocaleString('es-MX',{minimumFractionDigits:2});
    const totalHist = notas.reduce((s,t) => s + Number(t.total||0), 0);
    // Para centros reales, activos vienen de centro_apoyo_pago, no del comentario
    const activosData = group._activosData || { brutos:0, yaConsumidos:0, disponibles:0 };
    const totalActivosCentro = isCentroReal ? activosData.disponibles : 0;
    // Activos del comentario (para notas sin centro_apoyo_id y centros externos)
    const totalGravableComment = notas.reduce((s,t) => s + _calcularMontoFacturableNota(t), 0);
    const totalActivosComment = Math.max(0, totalHist - totalGravableComment);
    // Facturable = total - activos_del_comentario - activos_del_centro (editables)
    window._fgActivosCentroAplicar = isCentroReal ? Math.min(totalActivosCentro, Math.max(0, totalHist - totalActivosComment)) : 0;
    window._fgActivosCentroDisponibles = totalActivosCentro;
    const totalGravable = Math.max(0, totalGravableComment - window._fgActivosCentroAplicar);
    const totalActivos = totalActivosComment + window._fgActivosCentroAplicar;
    // Precios YA incluyen IVA → desglosar (no sumar encima)
    const subtotalSinIva = +(totalGravable / 1.16).toFixed(2);
    const ivaEstimado = +(totalGravable - subtotalSinIva).toFixed(2);
    const startD = document.getElementById('fg-date-start')?.value || '';
    const endD = document.getElementById('fg-date-end')?.value || '';
    const mesLabel = startD && endD ? `${startD} al ${endD}` : 'Mes actual';
    const fpMayoria = _detectFormaPagoMayoria(notas);
    window._fgFormaPagoCode = fpMayoria.code;
    const fpDesglose = Object.entries(fpMayoria.buckets).filter(([,v])=>v>0).map(([k,v])=>`${k.charAt(0).toUpperCase()+k.slice(1)}: ${fmt(v)}`).join(' · ');

    const maxPrev = 50;
    const ticketsHtml = notas.slice(0,maxPrev).map((t,i) => {
        let totalReal = Number(t.total||0);
        let totalPagadoCheck = 0;
        const pagosCheck = (t.comentario || '').match(/\$[\d,]+(?:\.\d+)?/g) || [];
        pagosCheck.forEach(m => { const val = parseFloat(m.replace(/[\$,]/g, '')); if (!isNaN(val)) totalPagadoCheck += val; });
        const envioMCheck = (t.comentario || '').match(/ENVIO_EXTRA\s*\$([\d,]+(?:\.\d+)?)/i);
        if (envioMCheck) totalPagadoCheck -= parseFloat(envioMCheck[1].replace(/,/g,''));
        if (totalPagadoCheck > totalReal) totalReal = totalPagadoCheck;

        const allActivosMatches = [...((t.comentario || '').matchAll(/(?:^|[^A-Z_])(?:ACTIVOS(?:_[A-Z_]+)?(?:\/[^\s$]+)?[^$]*\$([0-9.,]+))/gi))];
        let activosSum = 0;
        if (allActivosMatches.length > 0) activosSum = allActivosMatches.reduce((acc, m) => acc + parseFloat(m[1].replace(/,/g, '')), 0);
        let facturableReal = Math.max(0, totalReal - activosSum);
        return `<tr style="border-bottom:1px solid rgba(255,255,255,.06);"><td style="padding:.35rem .5rem;font-size:.72rem;color:var(--text-dim);">${i+1}</td><td style="padding:.35rem .5rem;font-size:.72rem;font-family:monospace;">#${(t.id||'').substring(0,10)}…</td><td style="padding:.35rem .5rem;font-size:.78rem;">${t.cliente_nombre||'Público General'}</td><td style="padding:.35rem .5rem;font-size:.78rem;">${t.fecha_venta?new Date(t.fecha_venta).toLocaleDateString('es-MX'):'—'}</td><td style="padding:.35rem .5rem;font-size:.78rem;text-align:right;">${fmt(totalReal)}</td><td style="padding:.35rem .5rem;font-size:.78rem;text-align:right;color:var(--success);font-weight:600;">${fmt(facturableReal)}</td></tr>`;
    }).join('');
    const moreLabel = notas.length > maxPrev ? `<div style="text-align:center;padding:.5rem;color:var(--text-dim);font-size:.75rem;">… y ${notas.length - maxPrev} notas más</div>` : '';

    let modal = document.getElementById('modal-timbrado-preview');
    if (!modal) { modal = document.createElement('div'); modal.id = 'modal-timbrado-preview'; document.body.appendChild(modal); }

    modal.innerHTML = `
    <div style="position:fixed;inset:0;background:rgba(0,0,0,.7);z-index:9999;display:flex;align-items:center;justify-content:center;padding:1rem;" onclick="if(event.target===this)this.parentElement.style.display='none'">
        <div style="background:#1a1a2e;border:1px solid var(--border);border-radius:var(--radius);max-width:820px;width:100%;max-height:90vh;overflow-y:auto;box-shadow:0 25px 50px -12px rgba(0,0,0,.5);" onclick="event.stopPropagation()">
            <div style="padding:1.2rem 1.5rem;border-bottom:1px solid var(--border);display:flex;justify-content:space-between;align-items:center;">
                <div>
                    <div style="font-size:1.1rem;font-weight:800;">${isUSD ? '🇺🇸 Factura Global USD' : '🏷️ Factura Global'} — ${info.nombre}</div>
                    <div style="font-size:.75rem;color:var(--text-dim);margin-top:.2rem;">${mesLabel} · CP: ${info.cp}${isUSD ? ' · Moneda: USD' : ''}</div>
                </div>
                <button onclick="document.getElementById('modal-timbrado-preview').style.display='none'" style="background:none;border:none;color:var(--text-dim);font-size:1.3rem;cursor:pointer;">✕</button>
            </div>
            <div style="padding:1rem 1.5rem;border-bottom:1px solid var(--border);">
                <div style="font-size:.72rem;font-weight:700;color:var(--accent-purple);text-transform:uppercase;margin-bottom:.6rem;">📋 Datos Fiscales del CFDI</div>
                <div style="display:grid;grid-template-columns:1fr 1fr;gap:.6rem;">
                    <div style="background:rgba(255,255,255,.03);border:1px solid rgba(255,255,255,.08);border-radius:8px;padding:.6rem .8rem;">
                        <div style="font-size:.65rem;color:var(--text-dim);">RFC Receptor</div><div style="font-size:.9rem;font-weight:700;font-family:monospace;">XAXX010101000</div></div>
                    <div style="background:rgba(255,255,255,.03);border:1px solid rgba(255,255,255,.08);border-radius:8px;padding:.6rem .8rem;">
                        <div style="font-size:.65rem;color:var(--text-dim);">Nombre</div><div style="font-size:.9rem;font-weight:700;">PÚBLICO EN GENERAL</div></div>
                    <div style="background:rgba(255,255,255,.03);border:1px solid rgba(255,255,255,.08);border-radius:8px;padding:.6rem .8rem;">
                        <div style="font-size:.65rem;color:var(--text-dim);">Uso CFDI</div><div style="font-size:.9rem;font-weight:600;">S01 — Sin efectos fiscales</div></div>
                    <div style="background:rgba(255,255,255,.03);border:1px solid rgba(255,255,255,.08);border-radius:8px;padding:.6rem .8rem;">
                        <div style="font-size:.65rem;color:var(--text-dim);">Régimen / CP Expedición</div><div style="font-size:.9rem;font-weight:600;">616 — Sin obligaciones / ${info.cp}</div></div>
                    <div style="background:rgba(255,255,255,.03);border:1px solid rgba(255,255,255,.08);border-radius:8px;padding:.6rem .8rem;">
                        <div style="font-size:.65rem;color:var(--text-dim);">Forma de pago (${fpMayoria.pct}% mayoría)</div>
                        <div style="font-size:.9rem;font-weight:700;color:${fpMayoria.code==='99'?'#fbbf24':'var(--success)'}">${fpMayoria.label}</div>
                        <div style="font-size:.65rem;color:var(--text-dim);margin-top:.2rem;">${fpDesglose}</div></div>
                    <div style="background:rgba(255,255,255,.03);border:1px solid rgba(255,255,255,.08);border-radius:8px;padding:.6rem .8rem;">
                        <div style="font-size:.65rem;color:var(--text-dim);">Método de pago</div><div style="font-size:.9rem;font-weight:600;">PUE — Pago en una exhibición</div></div>
                    <div style="background:rgba(255,255,255,.03);border:1px solid rgba(255,255,255,.08);border-radius:8px;padding:.6rem .8rem;">
                        <div style="font-size:.65rem;color:var(--text-dim);">Periodicidad SAT</div><div style="font-size:.9rem;font-weight:700;color:#c084fc;">${{'02':'02 — Semanal','03':'03 — Quincenal','04':'04 — Mensual'}[document.getElementById('fg-periodicidad')?.value||'04']||'04 — Mensual'}</div></div>
                </div>
            </div>
${isUSD ? `            <div style="padding:1rem 1.5rem;border-bottom:1px solid var(--border);">
                <div style="font-size:.72rem;font-weight:700;color:#3b82f6;text-transform:uppercase;margin-bottom:.6rem;">🇺🇸 Tipo de Cambio DOF (Requerido por el SAT)</div>
                <div style="display:flex;gap:.8rem;align-items:flex-end;flex-wrap:wrap;">
                    <div style="flex:1;min-width:160px;">
                        <label style="font-size:.68rem;color:var(--text-dim);display:block;margin-bottom:.3rem;">Fecha para consulta TC</label>
                        <input type="date" id="fg-tc-fecha" value="${new Date().toISOString().substring(0,10)}" style="width:100%;padding:.45rem .6rem;background:rgba(255,255,255,.05);border:1px solid rgba(59,130,246,.3);border-radius:6px;color:var(--text-primary);font-size:.85rem;" />
                    </div>
                    <button onclick="_consultarTCdof()" class="btn btn-outline" style="padding:.45rem 1rem;font-size:.78rem;border-color:#3b82f6;color:#60a5fa;">Consultar DOF</button>
                    <div style="flex:1;min-width:120px;">
                        <label style="font-size:.68rem;color:var(--text-dim);display:block;margin-bottom:.3rem;">Tipo de Cambio</label>
                        <input type="number" id="fg-tc-valor" step="0.0001" min="0" placeholder="Ej: 17.5432" style="width:100%;padding:.45rem .6rem;background:rgba(255,255,255,.05);border:1px solid rgba(59,130,246,.3);border-radius:6px;color:#60a5fa;font-size:.95rem;font-weight:700;" />
                    </div>
                </div>
                <div id="fg-tc-status" style="font-size:.7rem;color:var(--text-dim);margin-top:.4rem;"></div>
                <div style="font-size:.65rem;color:rgba(251,191,36,.7);margin-top:.3rem;">⚠️ El SAT requiere el tipo de cambio publicado en el DOF del día anterior a la emisión o del día de la transacción.</div>
            </div>` : ''}
            ${isCentroReal && totalActivosCentro > 0 ? `<div style="padding:1rem 1.5rem;border-bottom:1px solid var(--border);">
                <div style="font-size:.72rem;font-weight:700;color:#f59e0b;text-transform:uppercase;margin-bottom:.6rem;">💰 Activos del Centro (centro_apoyo_pago)</div>
                <div style="display:grid;grid-template-columns:1fr 1fr 1fr;gap:.5rem;margin-bottom:.6rem;">
                    <div style="background:rgba(245,158,11,.06);border:1px solid rgba(245,158,11,.2);border-radius:8px;padding:.6rem;text-align:center;"><div style="font-size:.65rem;color:var(--text-dim);">Cobrados ${mesLabel}</div><div style="font-size:.9rem;font-weight:700;color:#f59e0b;">${fmtM(activosData.brutos)}</div></div>
                    <div style="background:rgba(239,68,68,.06);border:1px solid rgba(239,68,68,.15);border-radius:8px;padding:.6rem;text-align:center;"><div style="font-size:.65rem;color:var(--text-dim);">Ya Consumidos</div><div style="font-size:.9rem;font-weight:700;color:#f87171;">-${fmtM(activosData.yaConsumidos)}</div></div>
                    <div style="background:rgba(16,185,129,.08);border:1px solid rgba(16,185,129,.2);border-radius:8px;padding:.6rem;text-align:center;"><div style="font-size:.65rem;color:var(--text-dim);">Disponibles</div><div style="font-size:.9rem;font-weight:800;color:var(--success);">${fmtM(totalActivosCentro)}</div></div>
                </div>
                <div style="display:flex;align-items:center;gap:.8rem;background:rgba(245,158,11,.05);border:1px solid rgba(245,158,11,.2);border-radius:8px;padding:.6rem .8rem;">
                    <label style="font-size:.75rem;color:#f59e0b;font-weight:600;white-space:nowrap;">Aplicar activos:</label>
                    <input type="number" id="fg-activos-centro-input" step="0.01" min="0" max="${totalActivosCentro}" value="${window._fgActivosCentroAplicar.toFixed(2)}" style="flex:1;padding:.4rem .6rem;background:rgba(255,255,255,.05);border:1px solid rgba(245,158,11,.3);border-radius:6px;color:#f59e0b;font-size:.95rem;font-weight:700;max-width:180px;" oninput="_fgRecalcActivosCentro()" />
                    <button onclick="document.getElementById('fg-activos-centro-input').value=${totalActivosCentro.toFixed(2)};_fgRecalcActivosCentro()" class="btn btn-outline" style="padding:.3rem .6rem;font-size:.7rem;border-color:#f59e0b;color:#f59e0b;">Usar todo</button>
                    <button onclick="document.getElementById('fg-activos-centro-input').value='0';_fgRecalcActivosCentro()" class="btn btn-outline" style="padding:.3rem .6rem;font-size:.7rem;">Sin activos</button>
                </div>
            </div>` : ''}
            <div style="padding:1rem 1.5rem;border-bottom:1px solid var(--border);">
                <div style="font-size:.72rem;font-weight:700;color:#fbbf24;text-transform:uppercase;margin-bottom:.6rem;">💰 Resumen Financiero</div>
                <div style="display:grid;grid-template-columns:1fr 1fr 1fr 1fr;gap:.5rem;" id="fg-resumen-financiero">
                    <div style="background:rgba(99,102,241,.08);border:1px solid rgba(99,102,241,.25);border-radius:8px;padding:.6rem;text-align:center;"><div style="font-size:.65rem;color:var(--text-dim);">Notas</div><div style="font-size:1.2rem;font-weight:800;color:#818cf8;">${notas.length}</div></div>
                    <div style="background:rgba(239,68,68,.06);border:1px solid rgba(239,68,68,.2);border-radius:8px;padding:.6rem;text-align:center;"><div style="font-size:.65rem;color:var(--text-dim);">Total Histórico</div><div style="font-size:.95rem;font-weight:700;color:#f87171;">${fmtM(totalHist)}</div></div>
                    <div style="background:rgba(251,191,36,.06);border:1px solid rgba(251,191,36,.2);border-radius:8px;padding:.6rem;text-align:center;"><div style="font-size:.65rem;color:var(--text-dim);">Activos</div><div id="fg-activos-total-display" style="font-size:.95rem;font-weight:700;color:#fbbf24;">-${fmtM(totalActivos)}</div></div>
                    <div style="background:rgba(16,185,129,.08);border:1px solid rgba(16,185,129,.3);border-radius:8px;padding:.6rem;text-align:center;"><div style="font-size:.65rem;color:var(--text-dim);">Facturable</div><div id="fg-facturable-display" style="font-size:.95rem;font-weight:800;color:var(--success);">${fmtM(totalGravable)}</div></div>
                </div>
                <div style="margin-top:.6rem;display:flex;justify-content:flex-end;gap:1.2rem;font-size:.8rem;" id="fg-iva-desglose">
                    <span style="color:var(--text-dim);">Subtotal s/IVA: <strong style="color:var(--text-primary)">${fmtM(subtotalSinIva)}</strong></span>
                    <span style="color:var(--text-dim);">IVA 16% (incluido): <strong style="color:var(--text-primary)">${fmtM(ivaEstimado)}</strong></span>
                    <span style="color:var(--text-dim);">Total: <strong style="color:var(--success)">${fmtM(totalGravable)}</strong></span>
                </div>
            </div>
            <div style="padding:1rem 1.5rem;border-bottom:1px solid var(--border);">
                <div style="font-size:.72rem;font-weight:700;color:var(--text-dim);text-transform:uppercase;margin-bottom:.5rem;">📑 Notas (${notas.length})</div>
                <div style="max-height:250px;overflow-y:auto;border:1px solid rgba(255,255,255,.06);border-radius:8px;">
                    <table style="width:100%;border-collapse:collapse;">
                        <thead><tr style="background:#1a1a2e;position:sticky;top:0;z-index:2;">
                            <th style="padding:.35rem .5rem;font-size:.65rem;text-align:left;color:var(--text-dim);">#</th>
                            <th style="padding:.35rem .5rem;font-size:.65rem;text-align:left;color:var(--text-dim);">NOTA</th>
                            <th style="padding:.35rem .5rem;font-size:.65rem;text-align:left;color:var(--text-dim);">CLIENTE</th>
                            <th style="padding:.35rem .5rem;font-size:.65rem;text-align:left;color:var(--text-dim);">FECHA</th>
                            <th style="padding:.35rem .5rem;font-size:.65rem;text-align:right;color:var(--text-dim);">TOTAL</th>
                            <th style="padding:.35rem .5rem;font-size:.65rem;text-align:right;color:var(--text-dim);">FACTURABLE</th>
                        </tr></thead>
                        <tbody>${ticketsHtml}</tbody>
                    </table>
                    ${moreLabel}
                </div>
            </div>
            <div style="padding:1.2rem 1.5rem;display:flex;justify-content:flex-end;gap:.8rem;">
                <button onclick="window._descargarCSVPreviewCedis()" class="btn btn-outline" style="padding:.5rem 1.2rem;border-color:var(--accent-purple);color:var(--accent-purple);">⬇️ CSV Desglose</button>
                <button onclick="document.getElementById('modal-timbrado-preview').style.display='none'" class="btn btn-outline" style="padding:.5rem 1.2rem;">Cancelar</button>
                <button id="btn-confirmar-timbrado" onclick="_ejecutarTimbradoCedis()" class="btn btn-primary" style="padding:.5rem 1.5rem;background:linear-gradient(135deg,#6366f1,#8b5cf6);font-weight:700;">⚡ Confirmar Timbrado al SAT</button>
            </div>
        </div>
    </div>`;
    modal.style.display = 'block';
}

// ═══ Recalcular Resumen Financiero cuando se cambia el monto de activos del centro ═══
function _fgRecalcActivosCentro() {
    const input = document.getElementById('fg-activos-centro-input');
    if (!input) return;
    let val = parseFloat(input.value) || 0;
    const maxDisp = window._fgActivosCentroDisponibles || 0;
    if (val > maxDisp) { val = maxDisp; input.value = maxDisp.toFixed(2); }
    if (val < 0) { val = 0; input.value = '0.00'; }
    window._fgActivosCentroAplicar = val;

    const group = window._timbradoCedisTarget;
    if (!group) return;
    const fmt = (n) => '$' + Number(n).toLocaleString('es-MX',{minimumFractionDigits:2});
    const totalHist = group.notas.reduce((s,t) => s + Number(t.total||0), 0);
    const totalGravableComment = group.notas.reduce((s,t) => s + _calcularMontoFacturableNota(t), 0);
    const totalActivosComment = Math.max(0, totalHist - totalGravableComment);
    const totalActivos = totalActivosComment + val;
    const totalGravable = Math.max(0, totalGravableComment - val);
    const subtotalSinIva = +(totalGravable / 1.16).toFixed(2);
    const ivaEstimado = +(totalGravable - subtotalSinIva).toFixed(2);

    const elActivos = document.getElementById('fg-activos-total-display');
    const elFact = document.getElementById('fg-facturable-display');
    const elIva = document.getElementById('fg-iva-desglose');
    if (elActivos) elActivos.textContent = '-' + fmt(totalActivos);
    if (elFact) elFact.textContent = fmt(totalGravable);
    if (elIva) elIva.innerHTML = `
        <span style="color:var(--text-dim);">Subtotal s/IVA: <strong style="color:var(--text-primary)">${fmt(subtotalSinIva)}</strong></span>
        <span style="color:var(--text-dim);">IVA 16% (incluido): <strong style="color:var(--text-primary)">${fmt(ivaEstimado)}</strong></span>
        <span style="color:var(--text-dim);">Total: <strong style="color:var(--success)">${fmt(totalGravable)}</strong></span>`;
}

window._descargarCSVPreviewCedis = function() {
    const group = window._timbradoCedisTarget;
    if (!group || !group.notas) return;
    // Agregamos BOM para UTF-8 y 'sep=,' para que Excel en Mac/Español separe las columnas correctamente
    let csv = "\uFEFFsep=,\nID Nota,Cliente,Fecha,Total Original,Facturable,Cantidad Activos,Tipo de Pago,Banco,Comentario Completo\n";
    
    const quote = (str) => `"${String(str || '').replace(/"/g, '""')}"`;
    
    group.notas.forEach(v => {
        const cliente = v.cliente_nombre || 'Publico General';
        let totalReal = Number(v.total || 0);
        let facturableReal = Number(v.monto_facturable || v.total || 0);
        let activosNum = 0;
        const allActivosMatches = [...((v.comentario || '').matchAll(/(?:^|[^A-Z_])(?:ACTIVOS(?:_[A-Z_]+)?(?:\/[^\s$]+)?[^$]*\$([0-9.,]+))/gi))];
        if (allActivosMatches.length > 0) {
            activosNum = allActivosMatches.reduce((s, m) => s + parseFloat(m[1].replace(/,/g, '')), 0);
        }
        
        let totalPagadoCheck = 0;
        const pagosCheck = (v.comentario || '').match(/\$[\d,]+(?:\.\d+)?/g) || [];
        pagosCheck.forEach(m => {
            const val = parseFloat(m.replace(/[\$,]/g, ''));
            if (!isNaN(val)) totalPagadoCheck += val;
        });
        const envioMCheck = (v.comentario || '').match(/ENVIO_EXTRA\s*\$([\d,]+(?:\.\d+)?)/i);
        if (envioMCheck) totalPagadoCheck -= parseFloat(envioMCheck[1].replace(/,/g,''));

        if (totalPagadoCheck > totalReal) {
            totalReal = totalPagadoCheck;
        }
        
        if (activosNum > 0) {
            facturableReal = Math.max(0, totalReal - activosNum);
        }
        
        const totalStr = totalReal.toFixed(2);
        const facturable = facturableReal.toFixed(2);
        const activosStr = activosNum.toFixed(2);
        
        let tipoPago = '';
        let banco = '';
        const cmtParts = (v.comentario || '').split('||');
        if (cmtParts.length > 1) {
            const pbPart = cmtParts[cmtParts.length - 1].trim();
            const pbParts = pbPart.split('/');
            if (pbParts.length > 1) {
                banco = pbParts[0].trim();
                tipoPago = pbParts[1].trim();
            } else {
                tipoPago = pbPart;
            }
        }
        
        const comentarioLimpio = (v.comentario || '').replace(/[\r\n]+/g, ' ').replace(/\s+/g, ' ').trim();
        const fechaStr = v.fecha_venta ? new Date(v.fecha_venta).toLocaleDateString('es-MX') : '';
        
        csv += `${quote(v.id)},${quote(cliente)},${quote(fechaStr)},${totalStr},${facturable},${activosStr},${quote(tipoPago)},${quote(banco)},${quote(comentarioLimpio)}\n`;
    });
    
    // Eliminamos el BOM explícito por si estaba causando problemas en su Mac/Excel
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `Previo_Factura_Global_${group.info?.nombre?.replace(/\s+/g,'_') || 'CEDIS'}.csv`;
    a.click();
    URL.revokeObjectURL(url);
};

// ═══ Consultar Tipo de Cambio DOF ═══
async function _consultarTCdof() {
    const statusEl = document.getElementById('fg-tc-status');
    const valorEl = document.getElementById('fg-tc-valor');
    const fechaEl = document.getElementById('fg-tc-fecha');
    if (!fechaEl || !valorEl) return;
    const fecha = fechaEl.value;
    if (!fecha) { if(statusEl) statusEl.innerHTML = '<span style="color:#f87171;">⚠ Selecciona una fecha</span>'; return; }
    if(statusEl) statusEl.innerHTML = '<span style="color:#60a5fa;">⏳ Consultando tipo de cambio…</span>';

    try {
        let tc = null;
        let fuente = '';

        // ── Estrategia 1: Cache en BD ──
        try {
            const proxyResp = await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026',
                sql: `SELECT valor FROM sistema_config WHERE clave = 'tc_cache_${fecha}'`
            });
            const cached = proxyResp.rows?.[0]?.valor;
            if (cached) {
                const val = parseFloat(typeof cached === 'string' ? cached : JSON.stringify(cached));
                if (val > 0) { tc = val; fuente = 'cache'; }
            }
        } catch(_) {}

        // ── Estrategia 2: Proxy vía n8n (sin CORS — servidor llama a Banxico) ──
        if (!tc) {
            try {
                const proxyUrl = BO_API.BASE + '/bo/tipo-cambio-dof?fecha=' + encodeURIComponent(fecha);
                const resp = await fetch(proxyUrl, { headers: BO_API._headers ? BO_API._headers() : {} });
                if (resp.ok) {
                    const data = await resp.json();
                    if (data.ok && data.tc > 0) { tc = parseFloat(data.tc); fuente = 'n8n/Banxico'; }
                }
            } catch(_) { /* n8n proxy no disponible */ }
        }

        // ── Estrategia 2.5: Frankfurter.app (histórico por fecha, sin token, sin CORS) ──
        if (!tc) {
            try {
                // Frankfurter soporta fecha exacta y devuelve el último día hábil si es feriado/fin de semana
                const frUrl = `https://api.frankfurter.app/${fecha}?from=USD&to=MXN`;
                const resp = await fetch(frUrl);
                if (resp.ok) {
                    const data = await resp.json();
                    const mxnRate = data?.rates?.MXN;
                    const fechaReal = data?.date || fecha;
                    if (mxnRate && mxnRate > 0) {
                        tc = parseFloat(mxnRate.toFixed(4));
                        fuente = fechaReal !== fecha
                            ? `Frankfurter (fecha hábil: ${fechaReal})`
                            : 'Frankfurter (histórico)';
                    }
                }
            } catch(_) {}
        }

        // ── Estrategia 2.6: ExchangeRate-API (solo si Frankfurter también falla — no respeta fecha) ──
        if (!tc) {
            try {
                const erUrl = `https://api.exchangerate-api.com/v4/latest/USD`;
                const resp = await fetch(erUrl);
                if (resp.ok) {
                    const data = await resp.json();
                    const mxnRate = data?.rates?.MXN;
                    if (mxnRate && mxnRate > 0) { tc = parseFloat(mxnRate.toFixed(4)); fuente = 'ExchangeRate-API (actual — verifica en DOF)'; }
                }
            } catch(_) {}
        }

        // ── Estrategia 3: Fetch directo a Banxico (puede fallar por CORS) ──
        if (!tc) {
            const _bmxToken = '65d630da46143059e9ddbf14febc8a6d33e5e5b89e2be8c00dd34aed22d22da2';
            const _bmxUrl = `https://www.banxico.org.mx/SieAPIRest/service/v1/series/SF43718/datos/${fecha.replace(/-/g,'/')}/${fecha.replace(/-/g,'/')}`;
            try {
                const resp = await fetch(_bmxUrl, { headers: { 'Bmx-Token': _bmxToken } });
                if (resp.ok) {
                    const data = await resp.json();
                    const series = data?.bmx?.series?.[0]?.datos;
                    if (series && series.length > 0) { tc = parseFloat(series[series.length - 1].dato); fuente = 'Banxico directo'; }
                }
            } catch(_) { /* CORS bloqueado — esperado */ }

            if (!tc) {
                try {
                    const altUrl = `https://api.banxico.org.mx/SieAPIRest/service/v1/series/SF43718/datos/${fecha.replace(/-/g,'/')}/${fecha.replace(/-/g,'/')}?token=${_bmxToken}`;
                    const resp2 = await fetch(altUrl);
                    if (resp2.ok) {
                        const data2 = await resp2.json();
                        const series2 = data2?.bmx?.series?.[0]?.datos;
                        if (series2 && series2.length > 0) { tc = parseFloat(series2[series2.length - 1].dato); fuente = 'Banxico alt'; }
                    }
                } catch(_) {}
            }
        }

        if (tc && tc > 0) {
            valorEl.value = tc.toFixed(4);
            window._fgTipoCambioUSD = tc;
            const fuenteLabel = fuente ? ` <span style="color:rgba(255,255,255,.4);font-size:.65rem;">(${fuente})</span>` : '';
            if(statusEl) statusEl.innerHTML = `<span style="color:#10b981;">✅ TC DOF ${fecha}: <strong>${tc.toFixed(4)}</strong> MXN/USD${fuenteLabel}</span>`;
            // Guardar en cache — usar texto plano, no ::jsonb
            try {
                await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026',
                    sql: `INSERT INTO sistema_config (clave, valor) VALUES ('tc_cache_${fecha}', '"${tc.toFixed(4)}"') ON CONFLICT (clave) DO NOTHING`
                });
            } catch(_) {}
        } else {
            if(statusEl) statusEl.innerHTML = '<span style="color:#fbbf24;">⚠ No se pudo obtener el TC automáticamente (feriado/día sin publicación). <strong>Captura el valor manualmente</strong> — consulta en <a href="https://www.banxico.org.mx/tipcamb/main.do?page=tip&idioma=sp" target="_blank" style="color:#60a5fa;text-decoration:underline;">banxico.org.mx</a></span>';
        }
    } catch(e) {
        console.error('[DOF TC Error]', e);
        if(statusEl) statusEl.innerHTML = '<span style="color:#f87171;">⚠ Error al consultar: ' + (e.message || 'Error desconocido') + '. <strong>Captura el valor manualmente</strong> — consulta en <a href="https://www.banxico.org.mx/tipcamb/main.do?page=tip&idioma=sp" target="_blank" style="color:#60a5fa;text-decoration:underline;">banxico.org.mx</a></span>';
    }
}

// ═══ Crear solicitud para un CEDIS individual desde el selector ═══
async function _crearSolicitudCedis(cedisKey) {
    const group = window._timbradoGroups[cedisKey];
    if (!group) return;
    document.getElementById('modal-cedis-select').style.display = 'none';
    window._timbradoCedisTarget = group;
    _mostrarModalConfirmacionCedis(group);
}

// ═══ Crear 1 sola solicitud consolidada para TODOS los CENTROS DE APOYO (MXN) ═══
function _crearSolicitudConsolidadaCentros() {
    const groups = window._timbradoGroups;
    if (!groups) return;
    const centroKeys = Object.keys(groups).filter(k => (groups[k].isCentro || groups[k].isCentroExt) && !groups[k].isCentroUSD);
    if (centroKeys.length === 0) { BO_AUTH.showAlert('No hay centros de apoyo en MXN para consolidar.', 'warning'); return; }

    const todasNotas = [];
    let totalBrutos = 0;
    let totalYaConsumidos = 0;
    let totalDisponibles = 0;
    let cpConsolidado = '45050';

    for (const k of centroKeys) {
        const g = groups[k];
        if (g.notas && g.notas.length > 0) {
            todasNotas.push(...g.notas);
        }
        if (g._activosData) {
            totalBrutos += Number(g._activosData.brutos || 0);
            totalYaConsumidos += Number(g._activosData.yaConsumidos || 0);
            totalDisponibles += Number(g._activosData.disponibles || 0);
        }
        if (g.info && g.info.cp) {
            cpConsolidado = g.info.cp;
        }
    }

    const consolidadoGroup = {
        isCentro: true,
        isConsolidado: true,
        info: {
            id: 'CA_CONSOLIDADO',
            nombre: `Consolidado Centros (${centroKeys.length} centros)`,
            cp: cpConsolidado,
            moneda: 'MXN'
        },
        notas: todasNotas,
        _activosData: {
            brutos: totalBrutos,
            yaConsumidos: totalYaConsumidos,
            disponibles: totalDisponibles
        }
    };

    document.getElementById('modal-cedis-select').style.display = 'none';
    window._timbradoCedisTarget = consolidadoGroup;
    _mostrarModalConfirmacionCedis(consolidadoGroup);
}

// ═══ Crear 1 sola solicitud consolidada para TODO LO QUE SEA USD (Centros USD + Clientes USA) ═══
async function _crearSolicitudConsolidadaUSD() {
    const groups = window._timbradoGroups;
    if (!groups) return;
    const centroKeysUSD = Object.keys(groups).filter(k => groups[k].isCentro && groups[k].isCentroUSD);
    const hasRetailUSD = !!(groups['USD_RETAIL'] && groups['USD_RETAIL'].notas.length > 0);
    if (centroKeysUSD.length === 0 && !hasRetailUSD) {
        BO_AUTH.showAlert('No hay notas en USD para consolidar.', 'warning');
        return;
    }

    const todasNotasUSD = [];
    let totalBrutosUSD = 0;
    let totalYaConsumidosUSD = 0;
    let totalDisponiblesUSD = 0;
    const centrosList = [];

    for (const k of centroKeysUSD) {
        const g = groups[k];
        if (g.notas && g.notas.length > 0) todasNotasUSD.push(...g.notas);
        if (g._activosData) {
            totalBrutosUSD += Number(g._activosData.brutos || 0);
            totalYaConsumidosUSD += Number(g._activosData.yaConsumidos || 0);
            totalDisponiblesUSD += Number(g._activosData.disponibles || 0);
        }
        centrosList.push(g.info.rawNombre || g.info.nombre);
    }
    if (hasRetailUSD) {
        todasNotasUSD.push(...groups['USD_RETAIL'].notas);
    }

    const tagDesc = centrosList.length > 0 
        ? `Consolidado Dólares (${centrosList.join(', ')} + Clientes USA)`
        : 'Consolidado Dólares (Clientes USA)';

    const consolidadoUSDGroup = {
        isCentro: centroKeysUSD.length > 0,
        isConsolidado: true,
        isUSD: true,
        info: {
            id: 'USD_CONSOLIDADO',
            nombre: tagDesc,
            cp: '45050',
            moneda: 'USD'
        },
        notas: todasNotasUSD,
        _activosData: {
            brutos: totalBrutosUSD,
            yaConsumidos: totalYaConsumidosUSD,
            disponibles: totalDisponiblesUSD
        },
        _centrosUSDList: centrosList
    };

    document.getElementById('modal-cedis-select').style.display = 'none';
    window._timbradoCedisTarget = consolidadoUSDGroup;
    _mostrarModalConfirmacionCedis(consolidadoUSDGroup);
}

// ═══ Crear solicitudes solo para CENTROS DE APOYO ═══
async function _crearTodasSolicitudesCentros() {
    const groups = window._timbradoGroups;
    if (!groups) return;
    const centroKeys = Object.keys(groups).filter(k => groups[k].isCentro || groups[k].isCentroExt);
    if (centroKeys.length === 0) { BO_AUTH.showAlert('No hay centros de apoyo para procesar.', 'warning'); return; }
    const ok = confirm(`Se crearán ${centroKeys.length} solicitudes globales separadas para Centros de Apoyo.\n\n¿Continuar?`);
    if (!ok) return;

    document.getElementById('modal-cedis-select').style.display = 'none';
    BO_AUTH.showAlert('⏳ Creando solicitudes de centros...', 'info');

    const startD = document.getElementById('fg-date-start')?.value || '';
    const endD = document.getElementById('fg-date-end')?.value || '';
    const mesLabel = startD && endD ? `${startD}_${endD}` : new Date().toISOString().substring(0,7);
    let creadas = 0;

    for (const k of centroKeys) {
        const g = groups[k];
        const fpM = _detectFormaPagoMayoria(g.notas);
        const globalRef = 'GLOBAL-' + mesLabel + '-CA_' + g.info.id;
        const _periodicidadBatch = document.getElementById('fg-periodicidad')?.value || '04';
        try {
            const noteIds = g.notas.map(t => t.id);
            const idsStr = noteIds.map(id => `'${id}'`).join(',');

            const dupCheck = await BO_API.post('/bo/sql-relay', {
                secret: 'duletia_relay_2026',
                sql: `SELECT COUNT(*) AS cnt FROM venta WHERE id IN (${idsStr}) AND factura_emitida = true`
            });
            const dupCount = parseInt(dupCheck.rows?.[0]?.cnt || '0');
            if (dupCount > 0) {
                console.warn(`[ANTI-DUP] ⚠️ ${dupCount} notas ya facturadas en Centro ${g.info.id}, saltando`);
                BO_AUTH.showAlert(`⚠️ ${g.info.nombre}: ${dupCount} nota(s) ya facturadas — solicitud NO creada.`, 'warning');
                continue;
            }

            const idsJson = JSON.stringify(noteIds);
            const sqlIns = `INSERT INTO facturas_solicitadas (usuario_id, rfc, razon_social, cp, regimen, uso_cfdi, forma_pago, numero_nota, estado, cedis_id, periodicidad, ventas_ids) VALUES ('${CURRENT_USER?.id||0}', 'XAXX010101000', 'PUBLICO EN GENERAL', '${g.info.cp}', '616', 'S01', '${fpM.code}', '${globalRef}', 'solicitada', '${g.info.id}', '${_periodicidadBatch}', '${idsJson}') RETURNING id`;
            const insRes = await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql: sqlIns });
            const sid = insRes.rows?.[0]?.id;
            if (sid) {
                if (g.isCentro && g._activosData && g._activosData.disponibles > 0) {
                    const actAplicar = g._activosData.disponibles;
                    const metaStr = `act=${actAplicar};act_disp=${g._activosData.disponibles};pg=1;mes=${mesLabel};n=${g.notas.length}`;
                    try { await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql: `UPDATE facturas_solicitadas SET comentario='${metaStr.replace(/'/g,"''")}' WHERE id=${sid}` }); } catch(_){}
                }
                await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql: `UPDATE venta SET requiere_factura = true WHERE id IN (${idsStr})` });
                creadas++;
            }
        } catch(e) { console.error('Error Centro ' + k, e); }
    }
    BO_AUTH.showAlert(`✅ ${creadas} solicitudes de centros creadas.`, creadas > 0 ? 'success' : 'warning');
    if (typeof showView === 'function') showView('facturacion');
    setTimeout(() => { if (typeof loadHistorialFacturas === 'function') loadHistorialFacturas(); if (typeof switchHistorialTab === 'function') switchHistorialTab('pendientes'); }, 400);
    loadFacturaGlobal();
}

// ═══ Crear todas las solicitudes de golpe ═══
async function _crearTodasSolicitudesCedis() {
    const groups = window._timbradoGroups;
    if (!groups) return;
    const keys = Object.keys(groups);
    const ok = confirm(`Se crearán ${keys.length} solicitudes globales separadas (una por cada CEDIS/CP).\n\n¿Continuar?`);
    if (!ok) return;

    document.getElementById('modal-cedis-select').style.display = 'none';
    BO_AUTH.showAlert('⏳ Creando solicitudes por CEDIS...', 'info');

    const startD = document.getElementById('fg-date-start')?.value || '';
    const endD = document.getElementById('fg-date-end')?.value || '';
    const mesLabel = startD && endD ? `${startD}_${endD}` : new Date().toISOString().substring(0,7);
    let creadas = 0;

    let skippedUSD = 0;
    for (const k of keys) {
        const g = groups[k];
        if (g.isUSD) { skippedUSD++; continue; }  // USD requiere TC manual → usar modal individual
        const fpM = _detectFormaPagoMayoria(g.notas);
        const globalRef = 'GLOBAL-' + mesLabel + '-C' + g.info.id;
        const _periodicidadBatch = document.getElementById('fg-periodicidad')?.value || '04';
        try {
            const noteIds = g.notas.map(t => t.id);
            const idsStr = noteIds.map(id => `'${id}'`).join(',');

            // ── VALIDACIÓN ANTI-DUPLICADOS: rechazar notas ya facturadas ──
            const dupCheck = await BO_API.post('/bo/sql-relay', {
                secret: 'duletia_relay_2026',
                sql: `SELECT COUNT(*) AS cnt FROM venta WHERE id IN (${idsStr}) AND factura_emitida = true`
            });
            const dupCount = parseInt(dupCheck.rows?.[0]?.cnt || '0');
            if (dupCount > 0) {
                console.warn(`[ANTI-DUP] ⚠️ ${dupCount} notas ya facturadas en CEDIS ${g.info.id}, saltando`);
                BO_AUTH.showAlert(`⚠️ CEDIS ${g.info.nombre}: ${dupCount} nota(s) ya facturadas — solicitud NO creada para evitar duplicado.`, 'warning');
                continue;
            }

            const idsJson = JSON.stringify(noteIds);
            const sqlIns = `INSERT INTO facturas_solicitadas (usuario_id, rfc, razon_social, cp, regimen, uso_cfdi, forma_pago, numero_nota, estado, cedis_id, periodicidad, ventas_ids) VALUES ('${CURRENT_USER?.id||0}', 'XAXX010101000', 'PUBLICO EN GENERAL', '${g.info.cp}', '616', 'S01', '${fpM.code}', '${globalRef}', 'solicitada', '${g.info.id}', '${_periodicidadBatch}', '${idsJson}') RETURNING id`;
            const insRes = await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql: sqlIns });
            const sid = insRes.rows?.[0]?.id;
            if (sid) {
                // Grabar metadata de activos para centros (compatible con centros-apoyo-detail.js)
                if (g.isCentro && g._activosData && g._activosData.disponibles > 0) {
                    const actAplicar = g._activosData.disponibles;
                    const metaStr = `act=${actAplicar};act_disp=${g._activosData.disponibles};pg=1;mes=${mesLabel};n=${g.notas.length}`;
                    try { await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql: `UPDATE facturas_solicitadas SET comentario='${metaStr.replace(/'/g,"''")}' WHERE id=${sid}` }); } catch(_){}
                }
                // Marcar notas inmediatamente para que no aparezcan en otro borrador
                await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql: `UPDATE venta SET requiere_factura = true WHERE id IN (${idsStr})` });
                creadas++;
            }
        } catch(e) { console.error('Error CEDIS ' + k, e); }
    }
    let msg = `✅ ${creadas} solicitudes globales creadas.`;
    if (skippedUSD > 0) msg += ` ⚠️ ${skippedUSD} grupo(s) USD omitidos — usa el botón individual para capturar el tipo de cambio.`;
    BO_AUTH.showAlert(msg, creadas > 0 ? 'success' : 'warning');
    if (typeof showView === 'function') showView('facturacion');
    setTimeout(() => { if (typeof loadHistorialFacturas === 'function') loadHistorialFacturas(); if (typeof switchHistorialTab === 'function') switchHistorialTab('pendientes'); }, 400);
    loadFacturaGlobal();
}

// ═══ Ejecutar timbrado para un solo grupo CEDIS ═══
async function _ejecutarTimbradoCedis() {
    const btn = document.getElementById('btn-confirmar-timbrado');
    if (btn) { btn.disabled = true; btn.textContent = '⏳ Guardando solicitud…'; }
    const group = window._timbradoCedisTarget;
    if (!group) { BO_AUTH.showAlert('Error: sin grupo CEDIS.', 'error'); return; }

    try {
        const isUSD = window._timbradoIsUSD || false;
        // Validar TC para USD
        if (isUSD) {
            const tcVal = parseFloat(document.getElementById('fg-tc-valor')?.value);
            if (!tcVal || tcVal <= 0) {
                BO_AUTH.showAlert('⚠️ Debes capturar el Tipo de Cambio para notas en USD.', 'warning');
                if(btn){btn.disabled=false;btn.textContent='⚡ Confirmar Timbrado al SAT';}
                return;
            }
            window._fgTipoCambioUSD = tcVal;
        }

        const noteIds = group.notas.map(t => t.id);
        const idsStr = noteIds.map(id => `'${id}'`).join(',');
        const dupCheck = await BO_API.post('/bo/sql-relay', {
            secret: 'duletia_relay_2026',
            sql: `SELECT COUNT(*) AS cnt FROM venta WHERE id IN (${idsStr}) AND factura_emitida = true`
        });
        const dupCount = parseInt(dupCheck.rows?.[0]?.cnt || '0');
        if (dupCount > 0) {
            BO_AUTH.showAlert(`⚠️ ${dupCount} nota(s) de este grupo ya están facturadas en el sistema.`, 'warning');
            if(btn){btn.disabled=false;btn.textContent='⚡ Confirmar Timbrado al SAT';}
            return;
        }

        const formaPagoCode = window._fgFormaPagoCode || '01';
        const startD = document.getElementById('fg-date-start')?.value || '';
        const endD = document.getElementById('fg-date-end')?.value || '';
        const mesLabel = startD && endD ? `${startD}_${endD}` : new Date().toISOString().substring(0,7);
        const refPrefix = String(group.info.id).startsWith('C') ? group.info.id : ('C' + group.info.id);
        const globalRef = 'GLOBAL-' + mesLabel + '-' + refPrefix + (isUSD ? '-USD' : '');

        const _periodicidadSingle = document.getElementById('fg-periodicidad')?.value || '04';
        const idsJson = JSON.stringify(group.notas.map(t => t.id));
        const monedaCol = isUSD ? ", moneda, tipo_cambio, ventas_ids" : ", ventas_ids";
        const monedaVal = isUSD ? `, 'USD', '${window._fgTipoCambioUSD}', '${idsJson}'` : `, '${idsJson}'`;

        const sqlInsert = `INSERT INTO facturas_solicitadas (usuario_id, rfc, razon_social, cp, regimen, uso_cfdi, forma_pago, numero_nota, estado, cedis_id, periodicidad${monedaCol}) VALUES ('${CURRENT_USER?.id||0}', 'XAXX010101000', 'PUBLICO EN GENERAL', '${group.info.cp}', '616', 'S01', '${formaPagoCode}', '${globalRef}', 'solicitada', '${group.info.id}', '${_periodicidadSingle}'${monedaVal}) RETURNING id`;
        const insRes = await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql: sqlInsert });
        const solicitudId = insRes.rows?.[0]?.id || insRes?.id;
        if (!solicitudId) {
            const errDetail = insRes?.message || insRes?.error || 'No se pudo generar el folio de solicitud';
            BO_AUTH.showAlert(`Error al crear la solicitud: ${errDetail}`, 'error');
            if (btn) { btn.disabled = false; btn.textContent = '⚡ Confirmar Timbrado al SAT'; }
            return;
        }

        // Grabar metadata de activos para centros (compatible con centros-apoyo-detail.js)
        const isCentroGroup = window._timbradoIsCentro || false;
        const activosAplicar = isCentroGroup ? parseFloat(document.getElementById('fg-activos-centro-input')?.value || '0') : 0;
        if (isCentroGroup || activosAplicar > 0) {
            const activosDisp = window._fgActivosCentroDisponibles || 0;
            const metaStr = `act=${activosAplicar};act_disp=${activosDisp};pg=1;mes=${mesLabel};n=${group.notas.length}${group._centrosUSDList ? ';centros_usd=' + group._centrosUSDList.join(',') : ''}`;
            try { await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql: `UPDATE facturas_solicitadas SET comentario='${metaStr.replace(/'/g,"''")}' WHERE id=${solicitudId}` }); } catch(_){}
        }

        await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql: `UPDATE venta SET requiere_factura = true WHERE id IN (${idsStr})` });

        document.getElementById('modal-timbrado-preview').style.display = 'none';
        BO_AUTH.showAlert(`✅ Solicitud Global #${solicitudId} (${group.info.nombre} — CP ${group.info.cp}) creada.`, 'success');
        if (typeof showView === 'function') showView('facturacion');
        setTimeout(() => { if (typeof loadHistorialFacturas === 'function') loadHistorialFacturas(); if (typeof switchHistorialTab === 'function') switchHistorialTab('pendientes'); }, 400);
        loadFacturaGlobal();
    } catch(e) {
        console.error('[TIMBRADO ERROR]', e);
        BO_AUTH.showAlert('Error: ' + e.message, 'error');
        if (btn) { btn.disabled = false; btn.textContent = '⚡ Confirmar Timbrado al SAT'; }
    }
}


function solicitarFactura() {
    const nota = document.getElementById('fac-nota').value;
    const rfc  = document.getElementById('fac-rfc').value;
    if (!nota || !rfc) { alert('Nota y RFC son requeridos.'); return; }
    const tbody = document.getElementById('facturasBody');
    const fila = `<tr>
        <td>#${nota}</td><td>${rfc}</td>
        <td>${new Date().toLocaleDateString('es-MX',{month:'short',year:'numeric'})}</td>
        <td><span class="pill pill-blanco" style="font-size:.7rem;">⏳ Solicitada</span></td>
        <td><span style="color:var(--text-dim);font-size:.8rem;">En proceso</span></td>
    </tr>`;
    if (tbody.querySelector('td[colspan]')) tbody.innerHTML = fila;
    else tbody.insertAdjacentHTML('afterbegin', fila);
    alert(`✓ Solicitud de factura enviada para nota #${nota}`);
}

async function guardarPrecios() {
    const btn=event?.target; if(btn) btn.disabled=true;
    const payload={
        mxn: Number(document.getElementById('cfg-mxn')?.value||4500),
        envio_mxn: Number(document.getElementById('cfg-env-mxn')?.value||250),
        usd: Number(document.getElementById('cfg-usd')?.value||225),
        niveles:[
            Number(document.querySelector('[id="cfg-niv1"]')?.value||900),
            Number(document.querySelector('[id="cfg-niv2"]')?.value||1350),
            Number(document.querySelector('[id="cfg-niv3"]')?.value||225),
            Number(document.querySelector('[id="cfg-niv4"]')?.value||225),
        ]
    };
    try {
        await BO_API.post('/bo/config/precios', payload);
        BO_AUTH.showAlert('✔ Precios guardados correctamente en el sistema','success');
    } catch(e) {
        BO_AUTH.showAlert('⚠ Sin conexión al servidor — cambios guardados localmente','warning');
        localStorage.setItem('dulet_config_precios', JSON.stringify(payload));
    }
    if(btn) btn.disabled=false;
}

// ── Preview en tiempo real del panel de configuración ─────────
function refreshCommissionPreview() {
    const mxn = Number(document.getElementById('cfg-precio-mxn')?.value || 4500);
    const usd = Number(document.getElementById('cfg-precio-usd')?.value || 300);
    const gtq = Number(document.getElementById('cfg-precio-gtq')?.value || 2250);
    const n1  = Number(document.getElementById('cfg-pct-n1')?.value || 20);
    const n2  = Number(document.getElementById('cfg-pct-n2')?.value || 30);
    const n3  = Number(document.getElementById('cfg-pct-n3')?.value || 5);
    const n4  = Number(document.getElementById('cfg-pct-n4')?.value || 5);

    const tbody = document.getElementById('cfg-preview-tbody');
    const tfoot = document.getElementById('cfg-preview-total');
    if (!tbody) return;

    const niveles = [
        { label: 'N1 — Frontal Directo', pct: n1 },
        { label: 'N2 — Segundo Nivel',   pct: n2 },
        { label: 'N3 — Tercer Nivel',    pct: n3 },
        { label: 'N4 — Cuarto Nivel',    pct: n4 },
    ];

    const fmt = (n, sym) => `${sym}${n.toLocaleString('es-MX',{minimumFractionDigits:2})}`;

    tbody.innerHTML = niveles.map(nv => {
        const vmxn = (mxn * nv.pct / 100).toFixed(2);
        const vusd = (usd * nv.pct / 100).toFixed(2);
        const vgtq = (gtq * nv.pct / 100).toFixed(2);
        return `<tr style="border-bottom:1px solid var(--border);">
            <td style="padding:.45rem .6rem;">${nv.label}</td>
            <td style="padding:.45rem .6rem;text-align:right;color:var(--text-dim);">${nv.pct}%</td>
            <td style="padding:.45rem .6rem;text-align:right;color:var(--success);font-weight:600;">${fmt(vmxn,'$')}</td>
            <td style="padding:.45rem .6rem;text-align:right;color:#3b82f6;font-weight:600;">${fmt(vusd,'$')}</td>
            <td style="padding:.45rem .6rem;text-align:right;color:#8b5cf6;font-weight:600;">${fmt(vgtq,'Q')}</td>
        </tr>`;
    }).join('');

    const totalPct = n1+n2+n3+n4;
    const tmxn = (mxn * totalPct / 100).toFixed(2);
    const tusd = (usd * totalPct / 100).toFixed(2);
    const tgtq = (gtq * totalPct / 100).toFixed(2);
    tfoot.innerHTML = `
        <td style="padding:.5rem .6rem;">TOTAL comisión / caja</td>
        <td style="padding:.5rem .6rem;text-align:right;">${totalPct}%</td>
        <td style="padding:.5rem .6rem;text-align:right;color:var(--success);">${fmt(tmxn,'$')}</td>
        <td style="padding:.5rem .6rem;text-align:right;color:#3b82f6;">${fmt(tusd,'$')}</td>
        <td style="padding:.5rem .6rem;text-align:right;color:#8b5cf6;">${fmt(tgtq,'Q')}</td>`;
}

async function guardarDistribucion(btnEl) {
    const btn = btnEl || document.getElementById('cfg-save-btn');
    if (btn) { btn.disabled = true; btn.textContent = '⏳ Guardando...'; }

    // Leer valores del nuevo panel
    const mxn = Number(document.getElementById('cfg-precio-mxn')?.value || 4500);
    const usd = Number(document.getElementById('cfg-precio-usd')?.value || 300);
    const gtq = Number(document.getElementById('cfg-precio-gtq')?.value || 2250);
    const pct = {
        n1: Number(document.getElementById('cfg-pct-n1')?.value || 20),
        n2: Number(document.getElementById('cfg-pct-n2')?.value || 30),
        n3: Number(document.getElementById('cfg-pct-n3')?.value || 5),
        n4: Number(document.getElementById('cfg-pct-n4')?.value || 5),
    };

    // Leer umbrales Empresario LED
    const umbralLed = {
        MXN: Number(document.getElementById('cfg-umbral-led-mxn')?.value || 10000),
        USD: Number(document.getElementById('cfg-umbral-led-usd')?.value || 500),
        GTQ: Number(document.getElementById('cfg-umbral-led-gtq')?.value || 5000),
        CAD: Number(document.getElementById('cfg-umbral-led-cad')?.value || 700),
        SLV_USD: Number(document.getElementById('cfg-umbral-led-slv')?.value || 500),
    };

    const newCfg = { precio_caja: { MXN: mxn, USD: usd, GTQ: gtq, CAD: Number(document.getElementById('cfg-precio-cad')?.value||415), SLV_USD: 300 }, pct, umbral_empresario_led: umbralLed };

    // Actualizar en memoria + localStorage
    saveCommissionConfig(newCfg);

    // ── Persistir a BD (sistema_config) ──
    let dbOk = false;
    try {
        const user = BO_AUTH.getUser();
        const valorJson = JSON.stringify(newCfg).replace(/'/g, "''");
        await BO_API.post('/bo/sql-relay', {
            secret: 'duletia_relay_2026',
            sql: `INSERT INTO sistema_config (clave, valor, updated_at, updated_by)
                  VALUES ('comisiones', '${valorJson}'::jsonb, NOW(), '${user?.nombre || 'admin'}')
                  ON CONFLICT (clave) DO UPDATE SET
                    valor = EXCLUDED.valor,
                    updated_at = NOW(),
                    updated_by = EXCLUDED.updated_by`
        });
        dbOk = true;
        console.log('✅ Config guardada en BD');
    } catch(e) {
        console.warn('Error guardando config en BD:', e.message);
    }

    // Recalcular activos en tiempo real si la sección está activa
    if (ACTIVOS_USER || CURRENT_USER) {
        await loadActivos(ACTIVOS_USER || CURRENT_USER).catch(()=>{});
    }

    if (btn) { btn.disabled = false; btn.textContent = '💾 Guardar Distribución'; }
    BO_AUTH.showAlert(
        dbOk ? '✔ Configuración guardada en base de datos y aplicada a todos los usuarios'
             : '⚠ Guardado local únicamente — error al guardar en BD',
        dbOk ? 'success' : 'warning'
    );
}

// Inicializar preview al entrar al bloque Configuración
function initConfigPanel() {
    // Cargar desde COMMISSION_CONFIG actual
    const pc = COMMISSION_CONFIG.precio_caja;
    const p  = COMMISSION_CONFIG.pct;
    const ul = COMMISSION_CONFIG.umbral_empresario_led || { MXN: 10000, USD: 500, GTQ: 5000, CAD: 700, SLV_USD: 500 };
    const set = (id, v) => { const el = document.getElementById(id); if (el) el.value = v; };
    set('cfg-precio-mxn', pc.MXN); set('cfg-precio-usd', pc.USD); set('cfg-precio-gtq', pc.GTQ);
    set('cfg-precio-cad', pc.CAD || 415);
    set('cfg-pct-n1', p.n1); set('cfg-pct-n2', p.n2); set('cfg-pct-n3', p.n3); set('cfg-pct-n4', p.n4);
    // Umbral Empresario LED
    set('cfg-umbral-led-mxn', ul.MXN); set('cfg-umbral-led-usd', ul.USD);
    set('cfg-umbral-led-gtq', ul.GTQ); set('cfg-umbral-led-cad', ul.CAD);
    set('cfg-umbral-led-slv', ul.SLV_USD);
    refreshCommissionPreview();
}


// ============================================================
// NUEVAS FUNCIONES: Productos, Premios, Autocomplete & Árbol Lista
// ============================================================

let _sponsorTimer = null;
function buscarSponsorNuevo() {
    clearTimeout(_sponsorTimer);
    const id = document.getElementById('nl-sponsor').value?.trim();
    const nameInput = document.getElementById('nl-sponsorNombre');
    if (!id) { nameInput.value = ''; return; }
    nameInput.value = '⏳ ...';
    _sponsorTimer = setTimeout(() => _doBuscarSponsor(id, nameInput), 400);
}
async function _doBuscarSponsor(id, nameInput) {
    // 1) Buscar en LIDERES_DATA en memoria (match exacto)
    const local = (window.LIDERES_DATA || []).find(u =>
        String(u.id) === id || String(u.registro) === id ||
        String(u.no_registro) === id || String(u.id_registro) === id
    );
    if (local) {
        nameInput.value = `${local.nombre || ''} ${local.ape_p || local.apellido || ''}`.trim();
        return;
    }
    // 2) SQL exacto por registro (campo numérico de 5-6 dígitos) — PRIORIDAD
    try {
        const r = await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026',
            sql: `SELECT id, nombre, ape_p FROM cliente WHERE registro::text = '${id}' LIMIT 1`
        });
        const u = r.rows?.[0];
        if (u) {
            nameInput.value = `${u.nombre || ''} ${u.ape_p || ''}`.trim();
            return;
        }
    } catch(_) {}
    // 3) Fallback: listUsers API (match más amplio)
    try {
        const data = await BO_API.listUsers({ search: id, limit: 5 });
        if (data && data.length > 0) {
            // Buscar match exacto por registro dentro de los resultados
            const exact = data.find(u => String(u.registro) === id || String(u.id) === id || String(u.no_registro) === id);
            const u = exact || data[0];
            nameInput.value = `${u.nombre || ''} ${u.ape_p || u.apellido || ''}`.trim();
            return;
        }
    } catch(_) {}
    nameInput.value = 'No encontrado';
}

// ── Categoría change handler ─────────────────────────────────
function onCategoriaChange() {
    const cat = document.getElementById('np-categoria')?.value;
    const conceptoEl = document.getElementById('np-conceptoFactura');
    const comEl = document.getElementById('np-comisiona');
    const paqSection = document.getElementById('np-paqueteSection');
    // Ensure talla section exists
    if (!document.getElementById('np-tallaSection')) {
        const sec = document.createElement('div');
        sec.id = 'np-tallaSection';
        sec.style.cssText = 'display:none;margin-top:.8rem;padding:.8rem;background:rgba(99,102,241,.06);border:1px solid rgba(99,102,241,.2);border-radius:8px;';
        sec.innerHTML = `
            <label style="display:flex;align-items:center;gap:.5rem;cursor:pointer;font-size:.85rem;color:var(--text-primary);">
                <input type="checkbox" id="np-requiereTalla" onchange="toggleTallaCheckboxes()"> 👕 Este producto tiene tallas
            </label>
            <div id="np-tallasCheckboxes" style="display:none;margin-top:.6rem;flex-wrap:wrap;gap:.5rem;">
                ${['CH','M','L','XL','XXL'].map(t => `
                    <label style="display:flex;align-items:center;gap:.3rem;padding:4px 10px;background:rgba(255,255,255,.06);border:1px solid rgba(255,255,255,.1);border-radius:6px;cursor:pointer;font-size:.8rem;color:var(--text-secondary);">
                        <input type="checkbox" class="np-talla-chk" value="${t}" checked> ${t}
                    </label>
                `).join('')}
            </div>`;
        const paqEl = document.getElementById('np-paqueteSection');
        if (paqEl) paqEl.parentNode.insertBefore(sec, paqEl);
    }
    const tallaSection = document.getElementById('np-tallaSection');
    
    if (cat === 'promo') {
        if (conceptoEl) conceptoEl.value = '📦 Logística';
        if (comEl) { comEl.checked = false; comEl.disabled = true; }
        if (paqSection) paqSection.style.display = 'none';
        if (tallaSection) tallaSection.style.display = 'block';
    } else if (cat === 'envios') {
        if (conceptoEl) conceptoEl.value = '🚚 Logística (Paquetería)';
        if (comEl) { comEl.checked = false; comEl.disabled = true; }
        if (paqSection) paqSection.style.display = 'none';
        if (tallaSection) tallaSection.style.display = 'none';
    } else if (cat === 'esencia') {
        if (conceptoEl) conceptoEl.value = '🍃 Producto (Esencia)';
        if (comEl) comEl.disabled = false;
        if (paqSection) paqSection.style.display = 'none';
        if (tallaSection) tallaSection.style.display = 'none';
    } else if (cat === 'paquete') {
        if (conceptoEl) conceptoEl.value = '📦 Paquete';
        if (comEl) comEl.disabled = false;
        if (paqSection) {
            paqSection.style.display = 'block';
            // Add one default empty row if none exist
            const items = document.getElementById('np-paqueteItems');
            if (items && items.children.length === 0) agregarComponentePaquete();
        }
        if (tallaSection) tallaSection.style.display = 'none';
    } else {
        if (conceptoEl) conceptoEl.value = '🥛 Producto (Suero)';
        if (comEl) comEl.disabled = false;
        if (paqSection) paqSection.style.display = 'none';
        if (tallaSection) tallaSection.style.display = 'none';
    }
}

function toggleTallaCheckboxes() {
    const checked = document.getElementById('np-requiereTalla')?.checked;
    const wrap = document.getElementById('np-tallasCheckboxes');
    if (wrap) wrap.style.display = checked ? 'flex' : 'none';
}

// ── Paquete: agregar fila de componente ──────────────────────
function agregarComponentePaquete(productoId = '', cantidad = 1) {
    const container = document.getElementById('np-paqueteItems');
    if (!container) return;
    const row = document.createElement('div');
    row.style.cssText = 'display:grid;grid-template-columns:1fr 80px 36px;gap:.5rem;align-items:center;';
    const opts = PRODUCTOS_CAT
        .filter(p => p.categoria !== 'paquete') // No paquetes dentro de paquetes
        .map(p => `<option value="${p.id}" ${String(p.id) === String(productoId) ? 'selected' : ''}>${p.nombre} ($${(p.mx||0).toLocaleString()})</option>`)
        .join('');
    row.innerHTML = `
        <select class="form-control paq-comp-select" style="font-size:.82rem;">${opts}</select>
        <input type="number" class="form-control paq-comp-qty" min="1" value="${cantidad}" style="font-size:.82rem;text-align:center;">
        <button type="button" onclick="this.parentElement.remove()" style="background:none;border:none;color:#ef4444;font-size:1.1rem;cursor:pointer;padding:0;">✕</button>
    `;
    container.appendChild(row);
}

function obtenerComponentesPaquete() {
    const rows = document.querySelectorAll('#np-paqueteItems > div');
    return Array.from(rows).map(row => ({
        producto_id: parseInt(row.querySelector('.paq-comp-select')?.value),
        cantidad: parseInt(row.querySelector('.paq-comp-qty')?.value) || 1
    })).filter(c => c.producto_id);
}

async function guardarComponentesPaquete(paqueteId) {
    if (!paqueteId) return;
    try {
        // Ensure table exists
        await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql: `CREATE TABLE IF NOT EXISTS producto_componente (id SERIAL PRIMARY KEY, paquete_id INTEGER NOT NULL REFERENCES productos(id) ON DELETE CASCADE, componente_id INTEGER NOT NULL REFERENCES productos(id), cantidad INTEGER NOT NULL DEFAULT 1, UNIQUE(paquete_id, componente_id))` });
        // Delete old components
        await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql: `DELETE FROM producto_componente WHERE paquete_id = ${paqueteId}` });
        // Insert new components
        const comps = obtenerComponentesPaquete();
        for (const c of comps) {
            await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql: `INSERT INTO producto_componente (paquete_id, componente_id, cantidad) VALUES (${paqueteId}, ${c.producto_id}, ${c.cantidad}) ON CONFLICT (paquete_id, componente_id) DO UPDATE SET cantidad = ${c.cantidad}` });
        }
    } catch(e) { console.warn('Error guardando componentes paquete:', e); }
}

async function cargarComponentesPaquete(productoId) {
    const container = document.getElementById('np-paqueteItems');
    if (!container) return;
    container.innerHTML = '';
    try {
        const res = await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql: `SELECT componente_id, cantidad FROM producto_componente WHERE paquete_id = ${productoId} ORDER BY id` });
        const rows = Array.isArray(res) ? res : (res?.rows || []);
        if (rows.length > 0) {
            rows.forEach(r => agregarComponentePaquete(r.componente_id, r.cantidad));
        } else {
            agregarComponentePaquete();
        }
    } catch(e) {
        console.warn('Error cargando componentes:', e);
        agregarComponentePaquete();
    }
}

// ── Modal Producto (Crear / Editar) ──────────────────────────
function abrirModalProducto(modo) {
    if (typeof _asegurarEstudioImagenProducto === 'function') _asegurarEstudioImagenProducto();
    const m = document.getElementById('modalProducto');
    const t = document.getElementById('modalProductoTitle');
    const b = document.getElementById('btnGuardarProducto');
    if (m) { m.style.display = 'block'; document.body.style.overflow = 'hidden'; }
    if (t) t.textContent = modo === 'editar' ? '✏️ Editar Producto' : '➕ Agregar Nuevo Producto';
    if (b) b.textContent = modo === 'editar' ? 'Guardar Cambios' : 'Guardar Producto';
    // Reset categoria handler
    if (modo !== 'editar') {
        onCategoriaChange();
        if (typeof _resetEstudioImagenProducto === 'function') _resetEstudioImagenProducto();
    }
    if (typeof _refrescarEstudioImagenProducto === 'function') _refrescarEstudioImagenProducto();
}

function cerrarModalProducto() {
    const m = document.getElementById('modalProducto');
    if (m) { m.style.display = 'none'; document.body.style.overflow = ''; }
    const d = document.getElementById('np-desc');
    if (d) { d.value = ''; delete d.dataset.editSku; }
    document.getElementById('np-mx').value = '';
    document.getElementById('np-eu').value = '';
    document.getElementById('np-gua').value = '';
    const cadCl = document.getElementById('np-cad'); if (cadCl) cadCl.value = '';
    document.getElementById('np-comisiona').checked = false;
    document.getElementById('np-comisiona').disabled = false;
    const catEl = document.getElementById('np-categoria'); if (catEl) catEl.value = 'suero';
    const cfEl = document.getElementById('np-conceptoFactura'); if (cfEl) cfEl.value = '🥛 Producto (Suero)';
    const vpEl = document.getElementById('np-visiblePagina'); if (vpEl) vpEl.checked = false;
    const vuEl = document.getElementById('np-ventaUnitaria'); if (vuEl) vuEl.checked = false;
    const descTa = document.getElementById('np-descripcion'); if (descTa) descTa.value = '';
    const imgEl = document.getElementById('np-imagenUrl'); if (imgEl) imgEl.value = '';
    const csEl = document.getElementById('np-claveSat'); if (csEl) csEl.value = '50131705';
    const usEl = document.getElementById('np-unidadSat'); if (usEl) usEl.value = 'H87';
    const nbEnEl = document.getElementById('np-nombre-en'); if (nbEnEl) nbEnEl.value = '';
    const descEnEl = document.getElementById('np-descripcion-en'); if (descEnEl) descEnEl.value = '';
    // Reset paquete section
    const paqSection = document.getElementById('np-paqueteSection'); if (paqSection) paqSection.style.display = 'none';
    const paqItems = document.getElementById('np-paqueteItems'); if (paqItems) paqItems.innerHTML = '';
    if (typeof _resetEstudioImagenProducto === 'function') _resetEstudioImagenProducto();
}

async function guardarNuevoProducto() {
    const descEl = document.getElementById('np-desc');
    const desc   = descEl?.value.trim() || '';
    const descSafe = desc.replace(/'/g, "''"); // escape single quotes
    const mx     = parseFloat(document.getElementById('np-mx').value) || 0;
    const eu     = parseFloat(document.getElementById('np-eu').value) || 0;
    const gua    = parseFloat(document.getElementById('np-gua').value) || 0;
    const cad    = parseFloat(document.getElementById('np-cad')?.value) || 0;
    const com    = document.getElementById('np-comisiona').checked;
    const editSku = descEl?.dataset.editSku || null;

    if (!desc) { BO_AUTH.showAlert('Ingresa la descripción del producto.', 'warning'); return; }

    const cat  = document.getElementById('np-categoria')?.value || 'suero';
    const isPromo = cat === 'promo';
    const concepto = isPromo ? 'logistica' : 'producto';
    const visPag = document.getElementById('np-visiblePagina')?.checked || false;
    const ventaUnit = document.getElementById('np-ventaUnitaria')?.checked || false;
    const descripcion = (document.getElementById('np-descripcion')?.value || '').trim().replace(/'/g, "''");
    const imagenUrlRaw = (document.getElementById('np-imagenUrl')?.value || '').trim();
    const imagenUrl = imagenUrlRaw.replace(/'/g, "''");
    const imagenesExtraObj = (typeof _obtenerImagenesExtraActuales === 'function') ? _obtenerImagenesExtraActuales() : {};
    const imagenesExtraJson = JSON.stringify(imagenesExtraObj || {}).replace(/'/g, "''");
    const aplicarFamilia = !!document.getElementById('np-img-cascade-chk')?.checked;
    const claveSat = document.getElementById('np-claveSat')?.value || '50131705';
    const unidadSat = document.getElementById('np-unidadSat')?.value || 'H87';
    const unidadNombre = unidadSat === 'H87' ? 'Pieza' : 'Servicio';
    const nombreEn = (document.getElementById('np-nombre-en')?.value || '').trim().replace(/'/g, "''");
    const descripcionEn = (document.getElementById('np-descripcion-en')?.value || '').trim().replace(/'/g, "''");

    if (editSku) {
        // Editar existente — buscar por SKU (único, sin colisión)
        const p = PRODUCTOS_CAT.find(x => x.sku === editSku);
        try {
            const sql = `UPDATE productos SET nombre = '${descSafe}', precio = ${mx}, precio_usd = ${eu}, precio_gtq = ${gua}, categoria = '${cat}', comisiona = ${isPromo ? false : com}, es_promo = ${isPromo}, concepto_factura = '${concepto}', visible_pagina = ${visPag}, venta_unitaria = ${ventaUnit}, descripcion = ${descripcion ? `'${descripcion}'` : 'NULL'}, imagen_url = ${imagenUrl ? `'${imagenUrl}'` : 'NULL'}, imagenes_extra = '${imagenesExtraJson}'::jsonb, clave_sat = '${claveSat}', unidad_sat = '${unidadSat}', unidad_nombre = '${unidadNombre}', nombre_en = ${nombreEn ? `'${nombreEn}'` : 'NULL'}, descripcion_en = ${descripcionEn ? `'${descripcionEn}'` : 'NULL'} WHERE sku = '${editSku}'`;
            await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql });
        } catch(e) { console.warn("Error DB (Editar Prod)", e); }

        if (p) {
            p.nombre = desc; p.mx = mx; p.eu = eu; p.gua = gua; p.cad = cad;
            p.comisiona = isPromo ? false : com;
            p.esPromo = isPromo; p.conceptoFactura = concepto; p.visiblePagina = visPag;
            p.ventaUnitaria = ventaUnit;
            p.categoria = cat;
            p.imagen_url = imagenUrlRaw;
            p.imagenes_extra = imagenesExtraObj;
            p.claveSat = claveSat; p.unidadSat = unidadSat; p.unidadNombre = unidadNombre;
        }
        BO_AUTH.showAlert(`"${desc}" actualizado correctamente.`, 'success');
    } else {
        // Crear nuevo — auto-generar SKU único
        const prefix = isPromo ? 'PROMO' : (cat === 'esencia' ? 'ESENCIA' : (cat === 'paquete' ? 'PAQUETE' : 'SUERO'));
        const ts = Date.now().toString(36).toUpperCase();
        const rnd = Math.random().toString(36).substring(2,5).toUpperCase();
        const newSku = `${prefix}-${ts}-${rnd}`;
        let newId = PRODUCTOS_CAT.length ? Math.max(...PRODUCTOS_CAT.map(p => p.id)) + 1 : 1;
        try {
            const sql = `INSERT INTO productos (sku, nombre, precio, precio_usd, precio_gtq, activo, categoria, comisiona, es_promo, concepto_factura, visible_pagina, venta_unitaria, descripcion, imagen_url, imagenes_extra, clave_sat, unidad_sat, unidad_nombre, nombre_en, descripcion_en) VALUES ('${newSku}', '${descSafe}', ${mx}, ${eu}, ${gua}, true, '${cat}', ${isPromo ? false : com}, ${isPromo}, '${concepto}', ${visPag}, ${ventaUnit}, ${descripcion ? `'${descripcion}'` : 'NULL'}, ${imagenUrl ? `'${imagenUrl}'` : 'NULL'}, '${imagenesExtraJson}'::jsonb, '${claveSat}', '${unidadSat}', '${unidadNombre}', ${nombreEn ? `'${nombreEn}'` : 'NULL'}, ${descripcionEn ? `'${descripcionEn}'` : 'NULL'}) RETURNING id`;
            const dbRes = await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql });
            if (dbRes && dbRes.rows && dbRes.rows[0]) newId = dbRes.rows[0].id;
        } catch(e) { console.warn("Error DB (Crear Prod)", e); }

        PRODUCTOS_CAT.push({
            id: newId, sku: newSku, nombre: desc, mx, eu, gua, cad,
            comisiona: isPromo ? false : com,
            esPromo: isPromo, conceptoFactura: concepto, visiblePagina: visPag,
            ventaUnitaria: ventaUnit, categoria: cat,
            imagen_url: imagenUrlRaw, imagenes_extra: imagenesExtraObj,
            claveSat, unidadSat, unidadNombre
        });
        BO_AUTH.showAlert(`"${desc}" añadido (SKU: ${newSku}).`, 'success');

        // Si es paquete, guardar componentes
        if (cat === 'paquete') await guardarComponentesPaquete(newId);
    }

    // Aplicar imagen en cascada a variantes hermanas de la misma familia si se activó el check
    if (aplicarFamilia && imagenUrlRaw && typeof _aplicarImagenAFamilia === 'function') {
        const currentSkuFinal = editSku || (PRODUCTOS_CAT[PRODUCTOS_CAT.length - 1]?.sku);
        await _aplicarImagenAFamilia(desc, currentSkuFinal, imagenUrlRaw, imagenesExtraObj);
    }

    // Si es edición de paquete, guardar componentes también
    if (editSku && cat === 'paquete') {
        const editP = PRODUCTOS_CAT.find(x => x.sku === editSku);
        if (editP) await guardarComponentesPaquete(editP.id);
    }

    // Guardar configuración de Tallas en PRODUCT_EXTRAS (runtime)
    const sku = editSku || (PRODUCTOS_CAT[PRODUCTOS_CAT.length - 1]?.sku);
    if (isPromo && sku) {
        const requiereTalla = document.getElementById('np-requiereTalla')?.checked;
        if (requiereTalla) {
            const tallasSeleccionadas = [];
            document.querySelectorAll('.np-talla-chk:checked').forEach(chk => tallasSeleccionadas.push(chk.value));
            if (!PRODUCT_EXTRAS[sku]) PRODUCT_EXTRAS[sku] = {};
            PRODUCT_EXTRAS[sku].requiereTalla = true;
            PRODUCT_EXTRAS[sku].tallas = tallasSeleccionadas;
        } else if (PRODUCT_EXTRAS[sku]) {
            delete PRODUCT_EXTRAS[sku].requiereTalla;
            delete PRODUCT_EXTRAS[sku].tallas;
        }
    }

    cerrarModalProducto();
    loadProductos();
    if (document.getElementById('nuevaVentaForm')?.style.display !== 'none') renderVentaItems();
}

let _prodFiltroActual = 'todos';

function _getCatInfo(p) {
    if (p.esPromo) return { key: 'promo', emoji: '🎁', label: 'Promo', bg: 'rgba(168,85,247,.15)', color: '#c084fc', border: 'rgba(168,85,247,.3)' };
    if (p.categoria === 'paquete') return { key: 'paquete', emoji: '📦', label: 'Paquete', bg: 'rgba(245,158,11,.12)', color: '#fbbf24', border: 'rgba(245,158,11,.25)' };
    if (p.categoria === 'esencia') return { key: 'esencia', emoji: '🍃', label: 'Esencia', bg: 'rgba(6,182,212,.12)', color: '#22d3ee', border: 'rgba(6,182,212,.25)' };
    if (p.categoria === 'envios' || p.categoria === 'envio' || p.categoria === 'envío' || p.categoria === 'envíos') return { key: 'envios', emoji: '🚚', label: 'Envío', bg: 'rgba(251,146,60,.12)', color: '#fb923c', border: 'rgba(251,146,60,.25)' };
    return { key: 'suero', emoji: '🥛', label: 'Suero', bg: 'rgba(34,197,94,.12)', color: '#4ade80', border: 'rgba(34,197,94,.25)' };
}

function filtrarProductos(tipo) {
    _prodFiltroActual = tipo;
    const colores = { todos: { bg: 'rgba(59,130,246,.2)', c: '#60a5fa' }, suero: { bg: 'rgba(34,197,94,.2)', c: '#4ade80' }, esencia: { bg: 'rgba(6,182,212,.2)', c: '#22d3ee' }, paquete: { bg: 'rgba(245,158,11,.2)', c: '#fbbf24' }, promo: { bg: 'rgba(168,85,247,.2)', c: '#c084fc' }, envios: { bg: 'rgba(251,146,60,.2)', c: '#fb923c' } };
    document.querySelectorAll('.prod-filtro-btn').forEach(b => {
        const isActive = b.dataset.filtro === tipo;
        b.classList.toggle('active', isActive);
        b.style.background = isActive ? (colores[tipo]?.bg || colores.todos.bg) : 'transparent';
        b.style.color = isActive ? (colores[tipo]?.c || colores.todos.c) : '#94a3b8';
    });
    loadProductos();
}

function loadProductos() {
    const tbody = document.getElementById('productosBody');
    if (!tbody) return;
    const isAdmin = BO_AUTH.hasRole('master') || BO_AUTH.hasRole('admin');
    let items = PRODUCTOS_CAT;
    if (_prodFiltroActual === 'suero') items = PRODUCTOS_CAT.filter(p => !p.esPromo && p.categoria !== 'esencia' && p.categoria !== 'paquete' && _getCatInfo(p).key !== 'envios');
    if (_prodFiltroActual === 'esencia') items = PRODUCTOS_CAT.filter(p => p.categoria === 'esencia');
    if (_prodFiltroActual === 'paquete') items = PRODUCTOS_CAT.filter(p => p.categoria === 'paquete');
    if (_prodFiltroActual === 'promo') items = PRODUCTOS_CAT.filter(p => p.esPromo);
    if (_prodFiltroActual === 'envios') items = PRODUCTOS_CAT.filter(p => _getCatInfo(p).key === 'envios');

    const countEl = document.getElementById('productosCount');
    if (countEl) countEl.textContent = `${items.length} de ${PRODUCTOS_CAT.length} productos`;

    tbody.innerHTML = items.map(p => {
        const ci = _getCatInfo(p);
        const catPill = `<span style="display:inline-block;padding:2px 10px;border-radius:12px;font-size:.7rem;font-weight:700;background:${ci.bg};color:${ci.color};border:1px solid ${ci.border};">${ci.emoji} ${ci.label}</span>`;

        const cfVal = p.conceptoFactura || 'producto';
        const conceptoBadge = cfVal === 'logistica'
            ? '<span style="font-size:.72rem;padding:2px 8px;border-radius:8px;background:rgba(251,191,36,.1);color:#fbbf24;border:1px solid rgba(251,191,36,.2);">📦 Logística</span>'
            : '<span style="font-size:.72rem;padding:2px 8px;border-radius:8px;background:rgba(59,130,246,.1);color:#60a5fa;border:1px solid rgba(59,130,246,.2);">🛒 Producto</span>';

        const pubBtn = isAdmin
            ? (p.visiblePagina
                ? `<button class="btn btn-sm" style="padding:3px 10px;border-radius:6px;font-size:.7rem;font-weight:600;background:rgba(34,197,94,.15);color:#4ade80;border:1px solid rgba(34,197,94,.3);cursor:pointer;" onclick="toggleVisiblePagina('${p.sku}')" title="Publicado en página">✅ Publicado</button>`
                : `<button class="btn btn-sm" style="padding:3px 10px;border-radius:6px;font-size:.7rem;font-weight:600;background:rgba(100,116,139,.1);color:#94a3b8;border:1px solid rgba(100,116,139,.2);cursor:pointer;" onclick="toggleVisiblePagina('${p.sku}')" title="No visible en página">⬜ Oculto</button>`)
            : (p.visiblePagina ? '<span style="font-size:.72rem;color:#4ade80;">✅</span>' : '<span style="font-size:.72rem;color:#64748b;">—</span>');

        const hasTalla = _pExtras(p).requiereTalla;
        const thumbUrl = (typeof _resolverPreviewProductoUrl === 'function') ? _resolverPreviewProductoUrl(p.imagen_url || p.imagenUrl || '') : '';
        const thumbHtml = thumbUrl
            ? `<img src="${thumbUrl}" alt="" loading="lazy" width="34" height="34" style="width:34px;height:34px;object-fit:contain;border-radius:8px;background:rgba(255,255,255,.06);border:1px solid rgba(255,255,255,.1);padding:2px;flex-shrink:0;" onerror="this.style.display='none'">`
            : `<span style="width:34px;height:34px;border-radius:8px;background:rgba(255,255,255,.03);border:1px dashed rgba(255,255,255,.12);display:inline-flex;align-items:center;justify-content:center;font-size:.8rem;color:#475569;flex-shrink:0;" title="Sin imagen asignada">🖼️</span>`;
        return `
        <tr style="border-bottom:1px solid rgba(255,255,255,.05);" data-prod-cat="${p.esPromo ? 'promo' : 'suero'}">
            <td style="font-weight:600;color:var(--text-primary);"><div style="display:flex;align-items:center;gap:.65rem;">${thumbHtml}<div>${p.nombre}${hasTalla ? ' <span style="font-size:.65rem;color:#94a3b8;background:rgba(255,255,255,.05);padding:1px 6px;border-radius:4px;">TALLAS</span>' : ''}</div></div></td>
            <td style="text-align:center;">${catPill}</td>
            <td style="text-align:center;font-weight:600;">$${(p.mx||0).toLocaleString()}</td>
            <td style="text-align:center;color:${(p.eu||0) > 0 ? 'var(--text-primary)' : '#475569'};">$${(p.eu||0).toLocaleString()}</td>
            <td style="text-align:center;color:${(p.gua||0) > 0 ? 'var(--text-primary)' : '#475569'};">Q${(p.gua||0).toLocaleString()}</td>
            <td style="text-align:center;color:${(p.cad||0) > 0 ? 'var(--text-primary)' : '#475569'};">C$${(p.cad||0).toLocaleString()}</td>
            <td style="text-align:center;font-weight:600;color:${p.comisiona ? 'var(--success)' : 'var(--text-dim)'};">${p.comisiona ? '✓ Sí' : '—'}</td>
            <td style="text-align:center;font-weight:600;color:${p.ventaUnitaria ? '#3b82f6' : 'var(--text-dim)'};">${p.ventaUnitaria ? '✓' : '—'}</td>
            <td style="text-align:center;">${conceptoBadge}</td>
            <td style="text-align:center;">${pubBtn}</td>
            <td style="text-align:center;">
                <div style="display:flex;gap:4px;justify-content:center;">
                    <button class="btn btn-sm" style="padding:4px 8px;background:#f59e0b;color:#fff;border:none;border-radius:6px;font-size:.72rem;cursor:pointer;" onclick="editarProducto('${p.sku}')">✏️</button>
                    <button class="btn btn-sm" style="padding:4px 8px;background:#ef4444;color:#fff;border:none;border-radius:6px;font-size:.72rem;cursor:pointer;" onclick="eliminarProducto('${p.sku}')">🗑</button>
                </div>
            </td>
        </tr>`;
    }).join('');
}

async function toggleVisiblePagina(sku) {
    const p = PRODUCTOS_CAT.find(x => x.sku === sku);
    if (!p) return;
    
    // Toggle state immediately for UI
    p.visiblePagina = !p.visiblePagina;

    try {
        const res = await BO_API.post('/bo/products/visibility', { 
            id: p.sku,
            visible: p.visiblePagina 
        });
        if(res && res.success) {
            BO_AUTH.showAlert(p.visiblePagina ? `"${p.nombre}" publicado en página` : `"${p.nombre}" ocultado de la página`, p.visiblePagina ? 'success' : 'info');
        } else {
            throw new Error(res?.message || 'Error guardando en BD');
        }
    } catch(err) {
        p.visiblePagina = !p.visiblePagina;
        BO_AUTH.showAlert('Error al actualizar visibilidad en BD', 'error');
        console.error(err);
    }
    loadProductos();
}

// Sincronizar catálogo con la BD al iniciar
async function syncDatabaseCatalog() {
    try {
        const sql = `SELECT * FROM productos ORDER BY id ASC`;
        const res = await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql });
        const data = Array.isArray(res) ? res : (res?.rows || []);

        if (data && Array.isArray(data)) {
            const dbAssignedIds = new Set();

            data.forEach(dbProd => {
                // Match by sku first, then fallback to nombre (but only if not already synced)
                const p = PRODUCTOS_CAT.find(x => (x.sku && dbProd.sku && x.sku === dbProd.sku) || (!x._dbSynced && x.nombre === dbProd.nombre));
                
                if (dbProd.activo === false || dbProd.activo === 0 || dbProd.activo === 'false') {
                    if (p) {
                        const idx = PRODUCTOS_CAT.indexOf(p);
                        if (idx !== -1) PRODUCTOS_CAT.splice(idx, 1);
                    }
                    return;
                }

                if (p) {
                    // Update existing
                    p.id = dbProd.id;
                    p._dbSynced = true;
                    p.visiblePagina = dbProd.visible_pagina === true;
                    p.mx = dbProd.precio ? parseFloat(dbProd.precio) : (p.mx || 0);
                    p.eu = dbProd.precio_usd ? parseFloat(dbProd.precio_usd) : (p.eu || 0);
                    p.gua = dbProd.precio_gtq ? parseFloat(dbProd.precio_gtq) : (p.gua || 0);
                    p.comisiona = dbProd.comisiona === true;
                    p.esPromo = dbProd.es_promo === true;
                    p.ventaUnitaria = dbProd.venta_unitaria === true;
                    p.conceptoFactura = dbProd.concepto_factura;
                    if (dbProd.categoria) p.categoria = dbProd.categoria;
                    p.descripcion = dbProd.descripcion || '';
                    p.imagen_url = dbProd.imagen_url || '';
                    p.imagenes_extra = (dbProd.imagenes_extra && typeof dbProd.imagenes_extra === 'object') ? dbProd.imagenes_extra : {};
                    if (dbProd.clave_sat) p.claveSat = dbProd.clave_sat;
                    if (dbProd.unidad_sat) p.unidadSat = dbProd.unidad_sat;
                    if (dbProd.unidad_nombre) p.unidadNombre = dbProd.unidad_nombre;
                    p.nombreEn = dbProd.nombre_en || '';
                    p.descripcionEn = dbProd.descripcion_en || '';
                } else {
                    // Inject new product missing from local array
                    PRODUCTOS_CAT.push({
                        id: dbProd.id, sku: dbProd.sku, nombre: dbProd.nombre,
                        _dbSynced: true,
                        mx: dbProd.precio ? parseFloat(dbProd.precio) : 0,
                        eu: dbProd.precio_usd ? parseFloat(dbProd.precio_usd) : 0,
                        gua: dbProd.precio_gtq ? parseFloat(dbProd.precio_gtq) : 0,
                        cad: 0,
                        comisiona: dbProd.comisiona === true,
                        esPromo: dbProd.es_promo === true,
                        ventaUnitaria: dbProd.venta_unitaria === true,
                        conceptoFactura: dbProd.concepto_factura,
                        visiblePagina: dbProd.visible_pagina === true,
                        categoria: dbProd.categoria,
                        descripcion: dbProd.descripcion || '',
                        imagen_url: dbProd.imagen_url || '',
                        imagenes_extra: (dbProd.imagenes_extra && typeof dbProd.imagenes_extra === 'object') ? dbProd.imagenes_extra : {},
                        claveSat: dbProd.clave_sat || '50131705',
                        unidadSat: dbProd.unidad_sat || 'H87',
                        unidadNombre: dbProd.unidad_nombre || 'Pieza',
                        nombreEn: dbProd.nombre_en || '',
                        descripcionEn: dbProd.descripcion_en || ''
                    });
                }
                dbAssignedIds.add(dbProd.id);
            });

            // DB-synced products keep their real IDs (needed for SQL UPDATE/DELETE).
            // Any hardcoded products that did not sync with the DB (e.g. they were hard deleted) MUST BE REMOVED to avoid ghost items.
            for (let i = PRODUCTOS_CAT.length - 1; i >= 0; i--) {
                if (!PRODUCTOS_CAT[i]._dbSynced) {
                    PRODUCTOS_CAT.splice(i, 1);
                }
            }

            loadProductos();
        }
    } catch(e) {
        console.error("Error sincronizando catálogo con BD:", e);
    }
}
// Llamar inicialmente
syncDatabaseCatalog();

function editarProducto(sku) {
    const p = PRODUCTOS_CAT.find(x => x.sku === sku);
    if (!p) return;
    document.getElementById('np-desc').value = p.nombre;
    document.getElementById('np-mx').value   = p.mx;
    document.getElementById('np-eu').value   = p.eu;
    document.getElementById('np-gua').value  = p.gua;
    const cadEl = document.getElementById('np-cad'); if (cadEl) cadEl.value = p.cad || 0;
    document.getElementById('np-comisiona').checked = p.comisiona;
    const catEl = document.getElementById('np-categoria');
    if (catEl) catEl.value = p.esPromo ? 'promo' : (p.categoria === 'paquete' ? 'paquete' : (p.categoria === 'esencia' ? 'esencia' : (p.categoria === 'envios' || p.categoria === 'envio' || p.categoria === 'envío' || p.categoria === 'envíos' ? 'envios' : 'suero')));
    const visEl = document.getElementById('np-visiblePagina');
    if (visEl) visEl.checked = p.visiblePagina || false;
    const vuEl = document.getElementById('np-ventaUnitaria');
    if (vuEl) vuEl.checked = p.ventaUnitaria || false;
    const comEl = document.getElementById('np-comisiona');
    if (comEl && p.esPromo) { comEl.checked = false; comEl.disabled = true; }
    // Imagen y descripción ES
    const descTa = document.getElementById('np-descripcion'); if (descTa) descTa.value = p.descripcion || '';
    const imgEl = document.getElementById('np-imagenUrl'); if (imgEl) imgEl.value = p.imagenUrl || p.imagen_url || '';
    if (typeof _cargarImagenesExtraProducto === 'function') _cargarImagenesExtraProducto(p);
    const csEl = document.getElementById('np-claveSat'); if (csEl) csEl.value = p.claveSat || '50131705';
    const usEl = document.getElementById('np-unidadSat'); if (usEl) usEl.value = p.unidadSat || 'H87';
    // Campos en inglés
    const nbEnEl = document.getElementById('np-nombre-en'); if (nbEnEl) nbEnEl.value = p.nombreEn || '';
    const descEnEl = document.getElementById('np-descripcion-en'); if (descEnEl) descEnEl.value = p.descripcionEn || '';
    // Paquete: mostrar sección y cargar componentes
    const paqSection = document.getElementById('np-paqueteSection');
    if (p.categoria === 'paquete') {
        if (paqSection) paqSection.style.display = 'block';
        cargarComponentesPaquete(p.id);
    } else {
        if (paqSection) paqSection.style.display = 'none';
    }
    // Tallas: populate from PRODUCT_EXTRAS
    const extras = _pExtras(p);
    onCategoriaChange(); // ensure talla section is created
    const tallaSection = document.getElementById('np-tallaSection');
    const requiereTallaEl = document.getElementById('np-requiereTalla');
    if (p.esPromo && tallaSection) {
        tallaSection.style.display = 'block';
        if (requiereTallaEl) requiereTallaEl.checked = !!extras.requiereTalla;
        toggleTallaCheckboxes();
        if (extras.tallas && extras.tallas.length > 0) {
            document.querySelectorAll('.np-talla-chk').forEach(chk => {
                chk.checked = extras.tallas.includes(chk.value);
            });
        }
    } else if (tallaSection) {
        tallaSection.style.display = 'none';
    }
    // Store SKU for the save function
    document.getElementById('np-desc').dataset.editSku = sku;
    abrirModalProducto('editar');
}

// ── Modal Eliminar Producto ───────────────────────────────────
let _pendingEliminarSku = null;

function eliminarProducto(sku) {
    const p = PRODUCTOS_CAT.find(x => x.sku === sku);
    if (!p) return;
    _pendingEliminarSku = sku;
    const nomEl = document.getElementById('eliminarProdNombre');
    if (nomEl) nomEl.textContent = `"${p.nombre}" (${sku}) — Precio MXN $${(p.mx||0).toLocaleString()}`;
    const m = document.getElementById('modalEliminarProducto');
    if (m) { m.style.display = 'flex'; document.body.style.overflow = 'hidden'; }
}

function cerrarModalEliminar() {
    const m = document.getElementById('modalEliminarProducto');
    if (m) { m.style.display = 'none'; document.body.style.overflow = ''; }
    _pendingEliminarSku = null;
}

async function confirmarEliminarProducto() {
    if (!_pendingEliminarSku) return;
    const btn = document.getElementById('btnConfirmarEliminar');
    if (btn) { btn.disabled = true; btn.textContent = 'Eliminando…'; }
    try { 
        const p = PRODUCTOS_CAT.find(x => x.sku === _pendingEliminarSku);
        if (!p) throw new Error('No se encontró el producto en memoria');

        const sql = `UPDATE productos SET activo = false WHERE sku = '${_pendingEliminarSku}';`;
        const res = await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql });
        // Verificar que la operación tuvo efecto real en BD
        if (res?.error) throw new Error(res.error || 'DB error');
        console.log('[Eliminar Producto] BD actualizada, eliminado o activo=false para SKU:', _pendingEliminarSku);
    } catch(e) { 
        console.error("Error DB (Eliminar Prod)", e); 
        BO_AUTH.showAlert('Error al eliminar de la BD: ' + e.message, 'danger');
        if (btn) { btn.disabled = false; btn.textContent = 'Sí, eliminar'; }
        return;
    }
    const idx = PRODUCTOS_CAT.findIndex(x => x.sku === _pendingEliminarSku);
    if (idx !== -1) PRODUCTOS_CAT.splice(idx, 1);
    _nvProductos = []; // Limpiar caché del dropdown de Nueva Venta
    cerrarModalEliminar();
    loadProductos();
    BO_AUTH.showAlert('Producto eliminado del catálogo.', 'success');
    if (btn) { btn.disabled = false; btn.textContent = 'Sí, eliminar'; }
}


let _ganItems = [];
let _ganPage = 1;

async function loadPremios() {
    const tbody = document.getElementById('premiosGanadoresBody');
    if (!tbody) return;

    if (!window.LIDERES_DATA || !window.LIDERES_DATA.length) {
        tbody.innerHTML = `<tr><td colspan="3" style="text-align:center;color:var(--text-dim);padding:2rem;">⏳ Cargando datos de líderes...</td></tr>`;
        try { window.LIDERES_DATA = await BO_API.listUsers({}); } catch(e) { window.LIDERES_DATA = BO_API.MOCK.usuarios || []; }
    }
    
    // 1. Obtener desde el backend a los usuarios que ya tienen un galardon oficial asignado (Sugerencia del usuario)
    let ganadoresDB = [];
    try {
        const sql = `SELECT id, registro, nombre, ape_p, ape_m, galardon FROM cliente WHERE galardon IS NOT NULL AND rol_id != '00000000-0000-0000-0000-000000000002' ORDER BY created_at ASC`;
        const res = await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql });
        ganadoresDB = Array.isArray(res) ? res : (res?.rows || []);
    } catch(e) { console.warn("No se pudo cargar galardones de DB", e); }

    const users  = window.LIDERES_DATA || [];
    const ventas = window._ventasData || window._comprasHistoricas || window.ALL_VENTAS || [];

    // Meses a evaluar: M-0 (Actual), M-1, M-2
    const mnts = [];
    const now = new Date();
    for (let i = 0; i < 3; i++) {
        const d = new Date(now.getFullYear(), now.getMonth() - i, 1);
        mnts.push({
            id: `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}`,
            name: d.toLocaleString('es-ES', { month: 'short' }).toUpperCase()
        });
    }

    // 1. Cajas propias por usuario y mes
    const cajas_propias = {};
    ventas.forEach(v => {
        const uid = String(v.cliente_id || v.usuario_id || '');
        if (!uid) return;
        const vMes = v.fecha_venta ? String(v.fecha_venta).substring(0, 7) : v.mes;
        if (!cajas_propias[uid]) cajas_propias[uid] = {};
        cajas_propias[uid][vMes] = (cajas_propias[uid][vMes] || 0) + (v.cajas_calc || v.cajas || v.cantidad || 0);
    });

    // 2. Frontales Activos por usuario y mes
    const frontales_activos = {};
    users.forEach(u => {
        const uid = String(u.id);
        frontales_activos[uid] = {};
        mnts.forEach(m => {
            let count = 0;
            users.forEach(child => {
                if (String(child.patrocinador_id) == uid && (cajas_propias[String(child.id)]?.[m.id] || 0) > 0) count++;
            });
            frontales_activos[uid][m.id] = count;
        });
    });

    // 4. Evaluar Galardones
    const niveles = [
        { nombre: 'Diamante', cajas: 2000, frontales: 25, img: 'LED_DIAMANTE.png' },
        { nombre: 'Perla Negra', cajas: 1000, frontales: 0, img: 'LED_PERLA_NEGRA.png' },
        { nombre: 'Oro', cajas: 750, frontales: 20, img: 'LED_ORO.png' },
        { nombre: 'Platino', cajas: 500, frontales: 0, img: 'LED_PLATINO.png' },
        { nombre: 'Plata', illuminated: false, cajas: 100, frontales: 10, img: 'LED_PLATA.png' },
        { nombre: 'Bronce', cajas: 50, frontales: 0, img: 'LED_BRONCE.png' },
        { nombre: 'Acero', cajas: 30, frontales: 0, img: 'LED_ACERO.png' }
    ];

    _ganItems = [];

    // Llenar tabla estrictamente con los galardonados oficiales
    ganadoresDB.forEach(u => {
        let galMatch = niveles.find(req => req.nombre.toLowerCase() === (u.galardon || '').toLowerCase());
        if (!galMatch) galMatch = niveles[niveles.length-1]; // Fallback
        
        _ganItems.push({
            cliente: `#${u.registro || u.id} - ${u.nombre} ${u.ape_p || ''}`.trim(),
            premio: `LED ${galMatch.nombre}`,
            img: _ledImgUrl(galMatch.img),
            progreso: `Oficial`,
            cajas_red_total: '-', // Ya no requiere de cálculo en vivo porque es manual/oficial
            compl: true,
            c1: '-', c2: '-', c3: '-'
        });
    });

    // Ordenar por nivel de galardón (Diamante primero, Acero último) para mejor visibilidad
    const _galOrden = { 'LED Diamante': 0, 'LED Perla Negra': 1, 'LED Oro': 2, 'LED Platino': 3, 'LED Plata': 4, 'LED Bronce': 5, 'LED Acero': 6 };
    _ganItems.sort((a,b) => (_galOrden[a.premio] ?? 99) - (_galOrden[b.premio] ?? 99));
    _ganPage = 1;
    renderGanPaginated();
}

function ganChangePage(dir) {
    const maxP = Math.ceil(_ganItems.length / 15);
    _ganPage += dir;
    if(_ganPage < 1) _ganPage = 1;
    if(_ganPage > maxP) _ganPage = maxP;
    renderGanPaginated();
}

function renderGanPaginated() {
    const tbody = document.getElementById('premiosGanadoresBody');
    const info = document.getElementById('gan-page-info');
    const prev = document.getElementById('gan-prev');
    const next = document.getElementById('gan-next');
    if(!tbody) return;

    if (!_ganItems.length) {
        tbody.innerHTML = `<tr><td colspan="3" style="text-align:center;color:var(--text-dim);padding:2rem;">Aún no hay ganadores en el ciclo actual. Toda tu cadena necesita sumar volumen.</td></tr>`;
        if(info) info.textContent = `Página 1`;
        if(prev) prev.disabled = true;
        if(next) next.disabled = true;
        return;
    }

    const maxP = Math.ceil(_ganItems.length / 15);
    if(info) info.textContent = `Página ${_ganPage} de ${maxP}`;
    if(prev) prev.disabled = (_ganPage === 1);
    if(next) next.disabled = (_ganPage === maxP);

    const start = (_ganPage - 1) * 15;
    const pageItems = _ganItems.slice(start, start + 15);

    tbody.innerHTML = pageItems.map(g => `
        <tr>
            <td style="font-weight:600;display:flex;align-items:center;gap:.5rem;">
                <img src="${g.img}" style="height:28px;object-fit:contain;" onerror="this.style.display='none'">
                ${g.cliente}
            </td>
            <td><span class="pill pill-blanco" style="font-size:.7rem;">${g.premio}</span></td>
            <td style="text-align:center;">${g.compl 
                ? '<span style="color:var(--success);font-weight:600;">✓ Asignado</span>' 
                : '<span style="color:var(--accent-gold);font-weight:600;">⏳ En Progreso</span>'}
            </td>
        </tr>
    `).join('');
}

let _cadenaItems = [];
let _cadenaPage = 1;

function cadenaChangePage(dir) {
    const maxP = Math.ceil(_cadenaItems.length / 30);
    _cadenaPage += dir;
    if(_cadenaPage < 1) _cadenaPage = 1;
    if(_cadenaPage > maxP) _cadenaPage = maxP;
    renderCadenaPaginated();
}

function renderCadenaPaginated() {
    const tbody = document.getElementById('arbolListBody');
    const info = document.getElementById('cad-page-info');
    const prev = document.getElementById('cad-prev');
    const next = document.getElementById('cad-next');
    if(!tbody) return;

    if (!_cadenaItems.length) {
        tbody.innerHTML = `<tr><td colspan="6" style="text-align:center;color:var(--text-dim);padding:2rem;">Esta cadena aún no tiene líderes registrados.</td></tr>`;
        if(info) info.textContent = `Página 1`;
        if(prev) prev.disabled = true;
        if(next) next.disabled = true;
        return;
    }

    const maxP = Math.ceil(_cadenaItems.length / 30);
    if(info) info.textContent = `Página ${_cadenaPage} de ${maxP}`;
    if(prev) prev.disabled = (_cadenaPage === 1);
    if(next) next.disabled = (_cadenaPage === maxP);

    const start = (_cadenaPage - 1) * 30;
    const pageItems = _cadenaItems.slice(start, start + 30);
    
    // Estatus: mapear a títulos legibles y colores (semáforo completo)
    const sLabels = {
        nuevo:       'Nuevo',
        activo:      'Activo',
        seguimiento: 'Seguimiento',
        en_riesgo:   'En Riesgo',
        baja:        'Baja',
        inactivo:    'Inactivo',
        prospecto:   'Prospecto',
        // legacy
        blanco:'Activo', gris:'Inactivo', '1':'Activo', '0':'Inactivo'
    };
    const sColors = {
        nuevo:       '#60A5FA',   // azul — recién registrado
        activo:      '#22C55E',   // verde — compró este mes
        seguimiento: '#F59E0B',   // amarillo — 1 mes sin comprar
        en_riesgo:   '#F97316',   // naranja — 2 meses sin comprar
        baja:        '#EF4444',   // rojo — 3+ meses sin comprar
        inactivo:    '#6b7280',   // gris — sin historial
        prospecto:   '#A78BFA',   // violeta
        // legacy
        blanco:'#22C55E', gris:'#6b7280', '1':'#22C55E', '0':'#6b7280'
    };

    tbody.innerHTML = pageItems.map(u => {
        const sColor = sColors[u.estatus] || '#71717A';
        const sLabel = sLabels[u.estatus] || u.estatus || 'Desconocido';
        const frontales = u.frontales || 0;
        const nombre = u.nombre ? `${u.nombre} ${u.apellido||''}` : '—';
        const levelLabels = ['','N1','N2','N3','N4'];
        return `<tr>
            <td><span style="font-size:.7rem;font-weight:800;padding:2px 8px;border-radius:6px;background:rgba(59,130,246,.12);color:#60A5FA;">${levelLabels[u.level]||'N'+u.level}</span></td>
            <td style="color:var(--text-dim);font-size:.8rem;">#${u.id}</td>
            <td style="font-weight:600;">${nombre}</td>
            <td style="font-size:.82rem;">${u.sponsorHTML}</td>
            <td><span style="font-size:.7rem;font-weight:700;padding:2px 8px;border-radius:100px;background:${sColor}22;color:${sColor};">${sLabel}</span></td>
            <td style="font-weight:700;color:${frontales>=5?'#22C55E':'#F59E0B'};">${frontales}</td>
        </tr>`;
    }).join('');
}

async function loadArbolView(viewType) {
    const id = document.getElementById('treeRootId').value || CURRENT_USER?.id || 1;
    showView('arbol');
    
    if (viewType === 'lista') {
        document.getElementById('arbolVisualPanel').style.display = 'none';
        document.getElementById('arbolListPanel').style.display = 'block';
        
        const tbody = document.getElementById('arbolListBody');
        tbody.innerHTML = '<tr><td colspan="6" style="text-align:center;color:var(--text-dim);padding:2rem;">Cargando cadena…</td></tr>';
        try {
            let rawData = await BO_API.getTree(id).catch(() => null);
            
            // API devuelve filas planas con campo 'nivel' — no necesita traverse
            let list = [];
            if (Array.isArray(rawData) && rawData.length && rawData[0].registro !== undefined) {
                // Formato real: filas planas [{nivel, registro, nombre, ...}]
                list = rawData.filter(r => +r.nivel > 0).map(r => ({
                    ...r,
                    id: r.registro || r.id,
                    level: +r.nivel,  // nivel 1=N1, 2=N2...
                    frontales: +(r.frontales || 0),
                    sponsorId: r.patrocinador_id || null
                }));
            } else if (rawData && !Array.isArray(rawData) && rawData.nombre) {
                // Formato jerárquico antiguo
                function traverse(node, level, sponsorId) {
                    if(level > 4) return;
                    const kids = node.hijos || node.children || [];
                    if(level > 0) list.push({ ...node, children: kids, level, sponsorId });
                    kids.forEach(child => traverse(child, level + 1, node.id));
                }
                traverse(rawData, 0, null);
            }
            
            if(!list.length) {
                _cadenaItems = [];
                renderCadenaPaginated();
                return;
            }
            
            // Crear mapa UUID→nombre para resolver patrocinador
            const uuidMap = {};
            if (Array.isArray(rawData)) {
                rawData.forEach(r => {
                    uuidMap[r.id] = { nombre: `${r.nombre||''} ${r.apellido||''}`.trim(), registro: r.registro };
                });
            }
            
            list.forEach(u => {
                const sponsorInfo = u.sponsorId ? uuidMap[u.sponsorId] : null;
                u.sponsorHTML = sponsorInfo
                    ? `${sponsorInfo.nombre} <span style="color:var(--text-dim);font-size:.75rem;">#${sponsorInfo.registro}</span>`
                    : (u.sponsorId ? `<span style="color:var(--text-dim);">#${u.sponsorId}</span>` : '—');
            });
            
            _cadenaItems = list;
            _cadenaPage = 1;
            renderCadenaPaginated();
            
        } catch(e) { 
            tbody.innerHTML = `<tr><td colspan="6" style="text-align:center;color:var(--danger);">Error: ${e.message}</td></tr>`; 
        }
    } else {
        document.getElementById('arbolListPanel').style.display = 'none';
        document.getElementById('arbolVisualPanel').style.display = 'block';
        loadTree();
    }
}



// Aplica visibilidad de botones y paneles según el rol del usuario logueado
function aplicarRestriccionesRol() {
    const rol = CURRENT_USER?.rol || '';
    const esMaster = rol === 'master';
    const esAdmin  = ['master','admin'].includes(rol);
    const esCliente = ['cliente','prospecto'].includes(rol);
    const esCedis  = rol === 'cedis';

    // Botones Export: solo master
    const elExcelBtn = document.getElementById('btnExportExcel');
    const elPDFBtn   = document.getElementById('btnExportPDF');
    const elRescXls  = document.getElementById('btnRescateExcel');
    const elRescPDF  = document.getElementById('btnRescatePDF');
    if (elExcelBtn) elExcelBtn.style.display = esMaster ? '' : 'none';
    if (elPDFBtn)   elPDFBtn.style.display   = esMaster ? '' : 'none';
    if (elRescXls)  elRescXls.style.display  = esMaster ? '' : 'none';
    if (elRescPDF)  elRescPDF.style.display  = esMaster ? '' : 'none';

    // Stat "Activos Distribuidos": ocultar para líderes/clientes
    const statDist = document.querySelector('.stat-card:has(#s-activos-dist)');
    if (statDist) statDist.style.display = esAdmin ? '' : 'none';

    // Vista de líderes: si es cliente, mostrar solo su perfil
    if (esCliente) {
        const lidTab = document.getElementById('view-lideres');
        if (lidTab) {
            // Reemplazar contenido con tarjeta de perfil propio
            const panel = lidTab.querySelector('.panel');
            if (panel) {
                panel.innerHTML = `<div class="panel-header"><span class="panel-title">Mi Perfil</span></div>
                    <div class="panel-body" id="miPerfilBody" style="display:grid;grid-template-columns:1fr 1fr;gap:1rem;"></div>`;
            }
            // Ocultar filtros y tabs
            const header = lidTab.querySelector('.page-header > div:last-child');
            if (header) header.style.display = 'none';
            const tabs = lidTab.querySelector('[style*="display:flex;gap:4px"]');
            if (tabs) tabs.style.display = 'none';
        }
    }

    // Control de visibilidad de la barra inferior móvil (exclusiva para clientes/líderes en móvil)
    const bNav = document.getElementById('mobileBottomNav');
    if (bNav) {
        if (esCliente) {
            document.body.classList.add('es-cliente');
            bNav.classList.add('visible-lider');
        } else {
            document.body.classList.remove('es-cliente');
            bNav.classList.remove('visible-lider');
            bNav.style.display = 'none';
        }
    }

    // Dashboard: diferenciado por rol
    ajustarDashboardPorRol(rol);
}

// ══════════════════════════════════════════════════════════════════════════════
// INVENTARIO BASE — Carga inicial corte físico 07-Ago-2026
// ══════════════════════════════════════════════════════════════════════════════
const _LOTE_BASE = 'INICIO-2026-08-07';
const _FECHA_BASE = '2026-08-07';

async function verificarInvBase() {
    const statusEl = document.getElementById('invBase-status');
    if (statusEl) statusEl.textContent = '⏳ Verificando...';
    try {
        const res = await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026',
            sql: `SELECT COUNT(*) AS cnt FROM inventario_mp WHERE lote_peps = '${_LOTE_BASE}'` });
        const cnt = parseInt(res?.rows?.[0]?.cnt || 0);
        if (statusEl) statusEl.textContent = cnt > 0
            ? `✅ ${cnt} registros ya cargados`
            : '⚪ Sin registros — pendiente de cargar';
    } catch(e) {
        if (statusEl) statusEl.textContent = '❌ Error: ' + e.message;
    }
}

async function ejecutarCargaInvBase() {
    const progressEl = document.getElementById('invBase-progress');
    const barEl      = document.getElementById('invBase-progress-bar');
    const txtEl      = document.getElementById('invBase-progress-txt');
    const statusEl   = document.getElementById('invBase-status');

    if (!confirm('¿Cargar inventario base del 07-Ago-2026? Esta operación es idempotente y segura.')) return;

    // 1) Migrar tabla inventario_mp — asegurar columnas PEPS
    const migSQL = [
        `CREATE TABLE IF NOT EXISTS inventario_mp (
            id SERIAL PRIMARY KEY,
            ingrediente TEXT NOT NULL,
            tipo_movimiento TEXT DEFAULT 'ingreso',
            cantidad_kg NUMERIC(14,4) DEFAULT 0,
            costo_unitario_kg NUMERIC(14,4) DEFAULT 0,
            costo_total NUMERIC(14,2) DEFAULT 0,
            lote_peps TEXT,
            referencia_tipo TEXT DEFAULT 'inventario_inicial',
            referencia_id INTEGER,
            proveedor_rfc TEXT DEFAULT '',
            fecha DATE DEFAULT CURRENT_DATE,
            saldo_restante_kg NUMERIC(14,4) DEFAULT 0,
            unidad TEXT DEFAULT 'kg',
            notas TEXT,
            creado_por TEXT DEFAULT 'sistema',
            created_at TIMESTAMPTZ DEFAULT NOW()
        )`,
        `ALTER TABLE inventario_mp ADD COLUMN IF NOT EXISTS saldo_restante_kg NUMERIC(14,4) DEFAULT 0`,
        `ALTER TABLE inventario_mp ADD COLUMN IF NOT EXISTS unidad TEXT DEFAULT 'kg'`,
        `ALTER TABLE inventario_mp ADD COLUMN IF NOT EXISTS lote_peps TEXT`,
        `CREATE TABLE IF NOT EXISTS stock_pt (
            id SERIAL PRIMARY KEY,
            producto_id TEXT NOT NULL,
            cantidad INTEGER DEFAULT 0,
            lote TEXT,
            fecha DATE DEFAULT CURRENT_DATE,
            notas TEXT,
            created_at TIMESTAMPTZ DEFAULT NOW(),
            UNIQUE(producto_id, lote)
        )`
    ];
    if (progressEl) progressEl.style.display = 'block';
    if (txtEl) txtEl.textContent = 'Preparando tablas...';
    await Promise.allSettled(migSQL.map(sql =>
        BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql }).catch(() => {})
    ));

    // 2) Colectar filas MP del panel
    const mpRows = [];
    document.querySelectorAll('#panelInvBase .invBase-row').forEach(row => {
        const ing = row.dataset.ing || '';
        const unidad = row.dataset.unidad || 'pzas';
        const qty = parseFloat(row.querySelector('.invBase-qty')?.value || 0);
        const cost = parseFloat(row.querySelector('.invBase-cost')?.value || 0);
        if (ing && qty > 0) mpRows.push({ ing, unidad, qty, cost });
    });

    // 3) PT desde inputs
    const ptItems = [
        { slug: 'natural',  nombre: 'PT Natural',   qty: parseInt(document.getElementById('invBase-pt-natural')?.value || 0) },
        { slug: 'fresa',    nombre: 'PT Fresa',     qty: parseInt(document.getElementById('invBase-pt-fresa')?.value || 0) },
        { slug: 'vainilla', nombre: 'PT Vainilla',  qty: parseInt(document.getElementById('invBase-pt-vainilla')?.value || 0) },
        { slug: 'choco',    nombre: 'PT Chocolate', qty: parseInt(document.getElementById('invBase-pt-choco')?.value || 0) },
        { slug: 'eucament', nombre: 'PT Eucament',  qty: parseInt(document.getElementById('invBase-pt-eucament')?.value || 0) },
    ].filter(p => p.qty > 0);

    const totalOps = mpRows.length + ptItems.length;
    let done = 0;
    let errores = 0;

    const setProgress = (label) => {
        const pct = totalOps > 0 ? Math.round((done / totalOps) * 100) : 0;
        if (barEl) barEl.style.width = pct + '%';
        if (txtEl) txtEl.textContent = label;
    };

    setProgress('Iniciando...');

    // 4) INSERT MP items
    for (const row of mpRows) {
        const esc = row.ing.replace(/'/g, "''");
        const costoTotal = row.qty * row.cost;
        const sql = `
            INSERT INTO inventario_mp
                (ingrediente, tipo_movimiento, cantidad_kg, costo_unitario_kg, costo_total,
                 lote_peps, referencia_tipo, fecha, saldo_restante_kg, unidad, notas, creado_por)
            VALUES
                ('${esc}', 'ingreso', ${row.qty}, ${row.cost}, ${costoTotal},
                 '${_LOTE_BASE}', 'inventario_inicial', '${_FECHA_BASE}', ${row.qty}, '${row.unidad}',
                 'Carga inicial - Corte físico 07-Ago-2026', 'sistema')
            ON CONFLICT DO NOTHING`;
        try {
            await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql });
        } catch(e) { errores++; console.warn('invBase MP error:', row.ing, e); }
        done++;
        setProgress(`MP: ${row.ing} (${done}/${totalOps})`);
    }

    // 5) INSERT PT items → stock_pt
    for (const pt of ptItems) {
        const sql = `
            INSERT INTO stock_pt (producto_id, cantidad, lote, fecha, notas)
            VALUES ('${pt.slug}', ${pt.qty}, '${_LOTE_BASE}', '${_FECHA_BASE}',
                    'Inventario inicial - Corte físico 07-Ago-2026')
            ON CONFLICT (producto_id, lote) DO NOTHING`;
        try {
            await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql });
        } catch(e) { errores++; console.warn('invBase PT error:', pt.slug, e); }
        done++;
        setProgress(`PT: ${pt.nombre} (${done}/${totalOps})`);
    }

    if (barEl) barEl.style.width = '100%';
    const msg = errores > 0
        ? `⚠️ ${done - errores}/${totalOps} cargados | ${errores} errores`
        : `✅ ${done} registros cargados exitosamente`;
    if (txtEl) txtEl.textContent = msg;
    if (statusEl) statusEl.textContent = `✅ Carga completa — ${done - errores} items`;
    BO_AUTH.showAlert(msg, errores > 0 ? 'warning' : 'success', 5000);
}

// ══════════════════════════════════════════════════════════════════
// MOTOR MRP: Triangulación Formulación (BOM) ↔ Inventario MP (PEPS)
// ══════════════════════════════════════════════════════════════════

function _coincideComponenteConMP(compNombre, mpIngrediente, aliasProveedores = '') {
    const c = (compNombre || '').toString().toLowerCase().trim();
    const m = (mpIngrediente || '').toString().toLowerCase().trim();
    if (!c || !m) return false;
    if (c === m) return true;

    // 1. Cajas
    if (c.includes('caja') || m.includes('caja') || c.includes('corrugado') || m.includes('corrugado')) {
        if (!((c.includes('caja') || c.includes('corrugado')) && (m.includes('caja') || m.includes('corrugado')))) return false;
        if (c.includes('eucament')) return m.includes('eucament');
        return !m.includes('eucament');
    }

    // 2. Etiquetas
    if (c.includes('etiqueta') || m.includes('etiqueta')) {
        if (!(c.includes('etiqueta') && m.includes('etiqueta'))) return false;
        if (c.includes('eucament')) return m.includes('eucament');
        if (c.includes('fresa')) return m.includes('fresa');
        if (c.includes('vainilla')) return m.includes('vainilla');
        if (c.includes('choco') || c.includes('chocolate')) return m.includes('choco') || m.includes('chocolate');
        if (c.includes('natural')) {
            if (c.includes('usa')) return m.includes('usa');
            if (c.includes('guatemala') || c.includes('gtq')) return m.includes('guatemala') || m.includes('gtq');
            return !m.includes('usa') && !m.includes('guatemala') && !m.includes('gtq');
        }
        return false;
    }

    // 3. Sachets / Bolsas
    if (c.includes('sachet') || m.includes('sachet') || c.includes('bolsa') || m.includes('bolsa')) {
        if (!((c.includes('sachet') || c.includes('bolsa')) && (m.includes('sachet') || m.includes('bolsa')))) return false;
        if (c.includes('fresa')) return m.includes('fresa');
        if (c.includes('vainilla')) return m.includes('vainilla');
        if (c.includes('choco') || c.includes('chocolate')) return m.includes('choco') || m.includes('chocolate');
        if (c.includes('natural')) return m.includes('natural');
        return true;
    }

    // 4. Envases (Tarro/Bote vs Botella)
    if (c.includes('botella') || m.includes('botella')) {
        return c.includes('botella') && m.includes('botella');
    }
    if (c.includes('tarro') || m.includes('tarro') || c.includes('bote') || m.includes('bote')) {
        return (c.includes('tarro') || c.includes('bote')) && (m.includes('tarro') || m.includes('bote')) && !m.includes('botella');
    }

    // 5. Tapas y Liners
    if (c.includes('tapa') || m.includes('tapa')) return c.includes('tapa') && m.includes('tapa');
    if (c.includes('liner') || m.includes('liner')) return c.includes('liner') && m.includes('liner');

    // 6. Atomizador
    if (c.includes('atomizador') || m.includes('atomizador')) return c.includes('atomizador') && m.includes('atomizador');

    // 7. Suero / Base láctea
    if (c.includes('suero') || m.includes('suero') || c.includes('lacteo') || m.includes('lacteo')) {
        return (c.includes('suero') || c.includes('lacteo')) && (m.includes('suero') || m.includes('lacteo'));
    }

    // 8. Saborizantes e Insumos Químicos
    const insumos = ['cacao','cocoa','vainilla','fresa','menthol','menta','alcohol','alcanfor','eucalipto','salicilato','glicol','aloe'];
    for (const k of insumos) {
        if (c.includes(k) || m.includes(k)) {
            return c.includes(k) && m.includes(k);
        }
    }

    return false;
}

function _resolverFormulacionSlug(productoId, presentacion, pais) {
    const p = String(productoId || '').toLowerCase().trim();
    const pres = String(presentacion || '').toLowerCase().trim();
    const cPais = String(pais || 'MEX').toUpperCase().trim();

    // 1. Eucament
    if (p.includes('eucament')) {
        return cPais === 'USA' ? 'eucament_usa' : 'eucament_mex';
    }

    const esSachet = pres === 'sachet' || pres === 'bolsa' || p.includes('sachet') || p.includes('bolsa');

    // 2. Guatemala
    if (cPais === 'GTQ' || cPais === 'GTM') {
        if (p.includes('fresa')) return 'fresa_bote_mex';
        if (p.includes('vainilla')) return 'vainilla_bote_mex';
        return esSachet ? 'natural_sachet_gtq' : 'natural_bote_gtq';
    }

    // 3. USA
    if (cPais === 'USA') {
        if (!esSachet) return 'natural_bote_usa';
        if (p.includes('fresa')) return 'fresa_sachet_usa';
        if (p.includes('vainilla')) return 'vainilla_sachet_usa';
        return 'natural_sachet_usa';
    }

    // 4. México / Default
    if (esSachet) {
        if (p.includes('fresa')) return 'fresa_sachet_mex';
        if (p.includes('vainilla')) return 'vainilla_sachet_mex';
        if (p.includes('choco') || p.includes('cacao') || p.includes('chocolate')) return 'choco_sachet_mex';
        return 'natural_sachet_mex';
    } else {
        if (p.includes('fresa')) return 'fresa_bote_mex';
        if (p.includes('vainilla')) return 'vainilla_bote_mex';
        if (p.includes('choco') || p.includes('cacao') || p.includes('chocolate')) return 'choco_bote_mex';
        return 'natural_bote_mex';
    }
}
window._resolverFormulacionSlug = _resolverFormulacionSlug;

// ── Descontar Materiales PEPS de un lote individual ──
async function descontarMaterialesLotePEPS(loteId, productoId, cantidad, loteClave, creadoPor, loteFecha, presentacion, etiquetadoPais, forzar = false) {
    if (!loteId || !cantidad || cantidad <= 0) return { ok: false, message: 'Datos insuficientes' };

    let fechaConsumo = loteFecha;
    let pres = presentacion;
    let pais = etiquetadoPais;

    if (!fechaConsumo || !pres || !pais) {
        try {
            const lRes = await BO_API.post('/bo/sql-relay', {
                secret: 'duletia_relay_2026',
                sql: `SELECT TO_CHAR(fecha, 'YYYY-MM-DD') as f, COALESCE(presentacion, 'bote') as pres, COALESCE(etiquetado_pais, 'MEX') as pais FROM produccion_diaria WHERE id = ${loteId}`
            });
            if (lRes?.rows?.[0]) {
                fechaConsumo = fechaConsumo || lRes.rows[0].f;
                pres = pres || lRes.rows[0].pres;
                pais = pais || lRes.rows[0].pais;
            }
        } catch (_) {}
    }
    fechaConsumo = fechaConsumo || (new Date()).toISOString().slice(0, 10);
    pres = pres || (String(productoId||'').includes('sachet') ? 'sachet' : 'bote');
    pais = pais || 'MEX';

    const prodSlug = _resolverFormulacionSlug(productoId, pres, pais);

    try {
        // 1. Evitar consumos duplicados a menos que se fuerce reconciliación
        if (forzar) {
            await BO_API.post('/bo/sql-relay', {
                secret: 'duletia_relay_2026',
                sql: `DELETE FROM inventario_mp WHERE referencia_tipo = 'produccion' AND referencia_id = ${loteId} AND tipo_movimiento = 'consumo'`
            });
        } else {
            const chk = await BO_API.post('/bo/sql-relay', {
                secret: 'duletia_relay_2026',
                sql: `SELECT COUNT(*) as n FROM inventario_mp WHERE referencia_tipo = 'produccion' AND referencia_id = ${loteId} AND tipo_movimiento = 'consumo'`
            });
            if (+(chk?.rows?.[0]?.n || 0) > 0) {
                return { ok: true, alreadyProcessed: true, message: 'Lote ya tenía consumos registrados' };
            }
        }

        // 2. Componentes de formulación para este producto específico
        const formRes = await BO_API.post('/bo/sql-relay', {
            secret: 'duletia_relay_2026',
            sql: `SELECT id, componente, gramos_unidad, COALESCE(unidad,'g') as unidad, costo_por_kg, alias_proveedores
                  FROM formulacion_componentes 
                  WHERE producto_slug = '${prodSlug}'`
        });
        let componentes = formRes?.rows || [];
        if (!componentes.length) {
            // Intentar fallback sin sufijo de país si no encuentra variante específica
            const fallbackSlug = prodSlug.replace(/_(mex|usa|gtq)$/, '');
            const fbRes = await BO_API.post('/bo/sql-relay', {
                secret: 'duletia_relay_2026',
                sql: `SELECT id, componente, gramos_unidad, COALESCE(unidad,'g') as unidad, costo_por_kg, alias_proveedores
                      FROM formulacion_componentes WHERE producto_slug = '${fallbackSlug}'`
            });
            componentes = fbRes?.rows || [];
        }

        if (!componentes.length) {
            return { ok: false, message: `Sin componentes en formulación para ${prodSlug}` };
        }

        // 3. Stock disponible en inventario_mp
        const mpStockRes = await BO_API.post('/bo/sql-relay', {
            secret: 'duletia_relay_2026',
            sql: `SELECT id, ingrediente, saldo_restante_kg, costo_unitario_kg, lote_peps, COALESCE(unidad,'kg') as unidad, planta, fecha
                  FROM inventario_mp 
                  WHERE tipo_movimiento = 'ingreso' AND saldo_restante_kg > 0 
                  ORDER BY fecha ASC, id ASC`
        });
        const lotesDisponibles = mpStockRes?.rows || [];

        let costoRealLote = 0;
        let totalMovimientos = 0;

        for (const comp of componentes) {
            const esPiezas = ['piezas', 'pz', 'pzas'].includes((comp.unidad || '').toLowerCase());
            const cantidadPorUnidad = parseFloat(comp.gramos_unidad || 0);
            if (cantidadPorUnidad <= 0) continue;

            const totalRequerido = esPiezas ? (cantidadPorUnidad * cantidad) : ((cantidadPorUnidad * cantidad) / 1000);
            let pendientePorDescontar = totalRequerido;

            const lotesCompatibles = lotesDisponibles.filter(st => {
                const disponible = parseFloat(st.saldo_restante_kg || 0);
                if (disponible <= 0) return false;
                return _coincideComponenteConMP(comp.componente, st.ingrediente, comp.alias_proveedores);
            });

            for (const st of lotesCompatibles) {
                if (pendientePorDescontar <= 0) break;
                const disponible = parseFloat(st.saldo_restante_kg || 0);

                // Conversión de unidades si el stock está en Millares (MI) y el BOM en piezas
                const esStockMI = (st.unidad || '').toLowerCase() === 'mi';
                const factor = (esStockMI && esPiezas) ? 0.001 : 1.0;

                const pendienteEnUnidadSt = pendientePorDescontar * factor;
                const aConsumir = Math.min(disponible, pendienteEnUnidadSt);

                if (aConsumir > 0) {
                    const cpk = parseFloat(st.costo_unitario_kg || 0) > 0
                        ? parseFloat(st.costo_unitario_kg)
                        : (esStockMI && esPiezas ? (parseFloat(comp.costo_por_kg || 0) * 1000) : parseFloat(comp.costo_por_kg || 0));
                    const costoConsumo = +(aConsumir * cpk).toFixed(2);
                    costoRealLote += costoConsumo;

                    const sqlConsumo = `
                        UPDATE inventario_mp 
                        SET saldo_restante_kg = GREATEST(0, saldo_restante_kg - ${aConsumir})
                        WHERE id = ${st.id};

                        INSERT INTO inventario_mp (
                            ingrediente, tipo_movimiento, cantidad_kg, costo_unitario_kg, costo_total,
                            lote_peps, referencia_tipo, referencia_id, fecha, saldo_restante_kg, creado_por, notas, unidad, planta
                        ) VALUES (
                            '${st.ingrediente.replace(/'/g,"''")}', 'consumo', ${aConsumir}, ${cpk}, ${costoConsumo},
                            '${st.lote_peps}', 'produccion', ${loteId}, '${fechaConsumo}', 0, '${(creadoPor||'sistema').replace(/'/g,"''")}',
                            'Consumo Lote ${String(loteClave||loteId).replace(/'/g,"''")}', '${st.unidad}', '${st.planta || 'planta_1'}'
                        );
                    `;
                    await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql: sqlConsumo });

                    st.saldo_restante_kg = disponible - aConsumir;
                    pendientePorDescontar -= (aConsumir / factor);
                    totalMovimientos++;
                }
            }

            // Si el stock registrado en inventario_mp se agotó pero hubo producción real:
            // Registrar el consumo con costo estándar del BOM (permitiendo saldo negativo como alerta operativa de compras no cargadas)
            if (pendientePorDescontar > 0) {
                const cpkBom = parseFloat(comp.costo_por_kg || 38.0);
                const matchedSt = lotesDisponibles.slice().reverse().find(st => _coincideComponenteConMP(comp.componente, st.ingrediente, comp.alias_proveedores));
                const ingNombre = matchedSt ? matchedSt.ingrediente : comp.componente;
                const uNombre   = matchedSt ? (matchedSt.unidad || 'kg') : (esPiezas ? 'piezas' : 'kg');
                const esStockMI = uNombre.toLowerCase() === 'mi';
                const factor    = (esStockMI && esPiezas) ? 0.001 : 1.0;

                const aConsumir = pendientePorDescontar * factor;
                const cpkReal = matchedSt && parseFloat(matchedSt.costo_unitario_kg || 0) > 0
                    ? parseFloat(matchedSt.costo_unitario_kg)
                    : (esStockMI && esPiezas ? (cpkBom * 1000) : cpkBom);
                const costoConsumo = +(aConsumir * cpkReal).toFixed(2);
                costoRealLote += costoConsumo;

                const sqlConsumoOverflow = `
                    ${matchedSt ? `UPDATE inventario_mp SET saldo_restante_kg = saldo_restante_kg - ${aConsumir} WHERE id = ${matchedSt.id};` : ''}
                    INSERT INTO inventario_mp (
                        ingrediente, tipo_movimiento, cantidad_kg, costo_unitario_kg, costo_total,
                        lote_peps, referencia_tipo, referencia_id, fecha, saldo_restante_kg, creado_por, notas, unidad, planta
                    ) VALUES (
                        '${ingNombre.replace(/'/g,"''")}', 'consumo', ${aConsumir}, ${cpkReal}, ${costoConsumo},
                        '${(matchedSt?.lote_peps || 'PENDIENTE_FACTURA').replace(/'/g,"''")}', 'produccion', ${loteId}, '${fechaConsumo}', 0, '${(creadoPor||'sistema').replace(/'/g,"''")}',
                        'Consumo Lote ${String(loteClave||loteId).replace(/'/g,"''")} (Alerta: stock en negativo / factura pendiente)', '${uNombre}', '${matchedSt?.planta || 'planta_1'}'
                    );
                `;
                await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql: sqlConsumoOverflow });
                if (matchedSt) matchedSt.saldo_restante_kg = parseFloat(matchedSt.saldo_restante_kg || 0) - aConsumir;
                totalMovimientos++;
            }
        }

        if (costoRealLote > 0) {
            await BO_API.post('/bo/sql-relay', {
                secret: 'duletia_relay_2026',
                sql: `UPDATE produccion_diaria SET costo_materia_prima = ${costoRealLote.toFixed(2)} WHERE id = ${loteId}`
            });
        }

        return { ok: true, movimientos: totalMovimientos, costoReal: costoRealLote };
    } catch(e) {
        console.error('[MRP Error]', e);
        return { ok: false, error: e.message };
    }
}

// ── Reconciliación de Consumos PEPS para el periodo activo ──
async function reconciliarConsumosProduccionMP(desde, hasta) {
    const _desde = desde || document.getElementById('invMpDesde')?.value || document.getElementById('prodDesde')?.value || document.getElementById('mpDesde')?.value || '';
    const _hasta = hasta || document.getElementById('invMpHasta')?.value || document.getElementById('prodHasta')?.value || document.getElementById('mpHasta')?.value || '';

    const dateWhere = (_desde && _hasta) ? `WHERE (fecha::date BETWEEN '${_desde}' AND '${_hasta}')` : '';

    if (!confirm(`¿Deseas reconciliar los consumos PEPS de Materia Prima para los lotes de producción?${_desde && _hasta ? ' (Periodo: ' + _desde + ' a ' + _hasta + ')' : ''}`)) return;

    const forzar = confirm(`¿Deseas recalcular y actualizar consumos incluso para lotes que ya tenían registros previos en el periodo?`);

    BO_AUTH.showAlert('⏳ Ejecutando explosión de materiales (BOM) y deducción PEPS...', 'info', 0);

    try {
        const sqlLotes = `
            SELECT id, TO_CHAR(fecha, 'YYYY-MM-DD') as fecha, producto_id, lote, cantidad, creado_por, costo_materia_prima,
                   COALESCE(presentacion, 'bote') as presentacion, COALESCE(etiquetado_pais, 'MEX') as etiquetado_pais
            FROM produccion_diaria
            ${dateWhere}
            ORDER BY fecha ASC, id ASC
        `;
        const res = await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql: sqlLotes });
        const lotes = res?.rows || [];

        if (!lotes.length) {
            BO_AUTH.showAlert('No se encontraron lotes de producción en el rango indicado.', 'warning', 3000);
            return;
        }

        let lotesProcesados = 0;
        let totalMovimientos = 0;
        let costoTotalCalculado = 0;

        for (const l of lotes) {
            const r = await descontarMaterialesLotePEPS(l.id, l.producto_id, +l.cantidad, l.lote, l.creado_por, l.fecha, l.presentacion, l.etiquetado_pais, forzar);
            if (r.ok && (!r.alreadyProcessed || forzar) && r.movimientos > 0) {
                lotesProcesados++;
                totalMovimientos += r.movimientos;
                costoTotalCalculado += (r.costoReal || 0);
            }
        }

        const msgRes = lotesProcesados > 0
            ? `✅ Reconciliación PEPS completada: ${lotesProcesados} lote(s) procesados con ${totalMovimientos} consumos descontados ($${costoTotalCalculado.toLocaleString('es-MX', {minimumFractionDigits:2})}).`
            : `ℹ️ Todos los lotes del periodo ya cuentan con sus consumos PEPS registrados en el inventario.`;

        BO_AUTH.showAlert(msgRes, 'success', 5000);

        if (typeof loadInventarioMP === 'function') loadInventarioMP();
        if (typeof loadTrazabilidadPEPS === 'function') loadTrazabilidadPEPS();
        if (typeof loadLotesSinVincular === 'function') loadLotesSinVincular();
        if (typeof loadProduccion === 'function') loadProduccion();
    } catch(e) {
        console.error('reconciliarConsumosProduccionMP', e);
        BO_AUTH.showAlert('Error en reconciliación: ' + e.message, 'danger');
    }
}

// ══════════════════════════════════════════════════════════════════
// MODAL DE MERMAS, DEVOLUCIONES Y REEMPAQUE (DI ↔ DG)
// ══════════════════════════════════════════════════════════════════

function abrirModalNuevaMermaODevolucion() {
    let m = document.getElementById('modalNuevaMermaDevolucion');
    if (!m) {
        m = document.createElement('div');
        m.id = 'modalNuevaMermaDevolucion';
        m.style.cssText = 'display:none;position:fixed;inset:0;background:rgba(0,0,0,.75);z-index:10099;overflow-y:auto;padding:2rem 0;backdrop-filter:blur(5px);';
        document.body.appendChild(m);
    }

    m.innerHTML = `
    <div style="background:var(--bg-card);border:1px solid rgba(239,68,68,.3);border-radius:var(--radius);max-width:680px;margin:auto;box-shadow:0 24px 80px rgba(0,0,0,.85);">
        <!-- Encabezado -->
        <div style="display:flex;justify-content:space-between;align-items:center;padding:1.25rem 1.5rem;border-bottom:1px solid rgba(255,255,255,.1);background:linear-gradient(135deg,rgba(239,68,68,.12),transparent);border-radius:var(--radius) var(--radius) 0 0;">
            <div>
                <div style="font-size:1.1rem;font-weight:700;color:#fca5a5;">🗑️ Registrar Merma o Devolución por CEDIS y Presentación</div>
                <div style="font-size:.73rem;color:var(--text-dim);margin-top:2px;">Control operativo de pérdidas de planta, producto defectuoso y devoluciones intercompañía</div>
            </div>
            <button onclick="document.getElementById('modalNuevaMermaDevolucion').style.display='none'" style="background:none;border:none;color:#94a3b8;font-size:1.3rem;cursor:pointer;">✕</button>
        </div>

        <!-- Formulario -->
        <div style="padding:1.25rem 1.5rem;display:grid;grid-template-columns:1fr 1fr;gap:1rem;">
            <div class="form-group" style="margin:0;">
                <label class="form-label">🏢 Empresa Responsable *</label>
                <select id="md-empresa" class="form-control" onchange="_actualizarCedisPorEmpresa(this.value)">
                    <option value="DI">🏭 DI — Dulet Internacional (Planta)</option>
                    <option value="DG" selected>🏢 DG — Dulet Grupo (Distribuidora)</option>
                    <option value="LLC">🇺🇸 LLC — Dulet Group LLC (USA)</option>
                </select>
            </div>
            <div class="form-group" style="margin:0;">
                <label class="form-label">📋 Tipo de Evento *</label>
                <select id="md-subtipo" class="form-control" onchange="_actualizarAyudaMerma(this.value)">
                    <option value="merma_produccion">🔴 Merma en Planta DI (Pérdida MP en producción)</option>
                    <option value="devolucion_cliente" selected>🔵 Devolución de DG hacia DI (Defecto de Lote / Empaque)</option>
                    <option value="merma_transporte">🟡 Daño en Transporte / Chofer</option>
                    <option value="merma_caducidad">🟠 Caducidad en CEDIS / Bodega</option>
                    <option value="reposicion_cliente">🟣 Reempaque / Reposición (Consumo insumos extra)</option>
                </select>
            </div>

            <!-- CEDIS Origen y Destino -->
            <div class="form-group" style="margin:0;">
                <label class="form-label">📍 CEDIS / Almacén Origen *</label>
                <select id="md-cedis-origen" class="form-control">
                    <option value="master">🏭 Planta DI — Matriz / Producción</option>
                    <option value="1" selected>🏢 CEDIS Guadalajara (DG)</option>
                    <option value="2">🏖️ CEDIS Cancún (DG)</option>
                    <option value="3">🌴 CEDIS Tapachula (DG)</option>
                    <option value="4">🇺🇸 CEDIS USA (LLC)</option>
                </select>
            </div>
            <div class="form-group" id="grp-md-cedis-destino" style="margin:0;">
                <label class="form-label">🎯 CEDIS / Almacén Destino (Devolución) *</label>
                <select id="md-cedis-destino" class="form-control">
                    <option value="master" selected>🏭 Planta DI — Matriz (Peritaje / Cuarentena)</option>
                    <option value="1">🏢 CEDIS Guadalajara (DG)</option>
                    <option value="2">🏖️ CEDIS Cancún (DG)</option>
                    <option value="3">🌴 CEDIS Tapachula (DG)</option>
                    <option value="4">🇺🇸 CEDIS USA (LLC)</option>
                </select>
            </div>

            <!-- Producto y Presentación -->
            <div class="form-group" style="margin:0;">
                <label class="form-label">📦 Producto / Sabor *</label>
                <select id="md-producto" class="form-control" onchange="_actualizarPesoMermaModal()">
                    <option value="natural" selected>Dulet Natural</option>
                    <option value="fresa">Dulet Fresa</option>
                    <option value="vainilla">Dulet Vainilla</option>
                    <option value="choco">Dulet Chocolate</option>
                    <option value="eucament">Eucament</option>
                    <option value="materia_prima">Materia Prima / Insumo General</option>
                </select>
            </div>
            <div class="form-group" style="margin:0;">
                <label class="form-label">🍶 Presentación *</label>
                <select id="md-presentacion" class="form-control" onchange="_actualizarPesoMermaModal()">
                    <option value="bote" selected>🍶 Bote</option>
                    <option value="sachet">🎒 Sachet / Bolsa</option>
                    <option value="frasco">🌿 Frasco (60ml)</option>
                    <option value="insumo">📦 Insumo Suelto</option>
                </select>
            </div>

            <!-- Banner Informativo de Peso y Costo Nominal -->
            <div id="md-banner-peso" style="grid-column:1/-1;background:rgba(59,130,246,.08);border:1px solid rgba(59,130,246,.25);border-radius:6px;padding:.5rem .75rem;font-size:.78rem;color:#93c5fd;display:flex;justify-content:space-between;align-items:center;">
                <span id="md-peso-desc">⚖️ <strong>Dulet Natural Bote</strong>: Peso nominal <strong>500g</strong></span>
                <span id="md-costo-ref-lbl" style="color:#fcd34d;font-weight:600;">Precio Intercia Ref: $32.08 MXN</span>
            </div>

            <div class="form-group" style="margin:0;">
                <label class="form-label">🏷️ Lote Involucrado (Opcional)</label>
                <input type="text" id="md-lote" class="form-control" placeholder="Ej. LOT-J202616N">
            </div>
            <div class="form-group" style="margin:0;">
                <label class="form-label">🔢 Cantidad (Pzas o Kg) *</label>
                <input type="number" id="md-cantidad" step="any" min="0.1" class="form-control" placeholder="Ej. 50" oninput="_calcularCostoMermaAuto()">
            </div>

            <div class="form-group" style="margin:0;grid-column:1/-1;">
                <label class="form-label">💰 Costo Estimado ($ MXN) <small style="color:var(--text-dim);">(Se autocalcula según precio intercompañía si se deja vacío)</small></label>
                <input type="number" id="md-costo" step="0.01" min="0" class="form-control" placeholder="0.00">
            </div>

            <div class="form-group" style="margin:0;grid-column:1/-1;">
                <label class="form-label">⚖️ Tratamiento Financiero *</label>
                <select id="md-tratamiento" class="form-control">
                    <option value="cobro_intercompania">🔴 Cobro / Deducción Intercompañía (Nota de Crédito a DG)</option>
                    <option value="absorcion_interna">⚪ Absorción Interna (Gasto de la empresa responsable)</option>
                    <option value="reempaque_gastos">📦 Reempaque Recuperado (Aumenta gastos de tapas/cajas/fletes)</option>
                </select>
                <small id="md-ayuda-tratamiento" style="display:block;margin-top:4px;font-size:.72rem;color:#f59e0b;">
                    Devolución de CEDIS hacia DI: se genera una Nota de Crédito Intercompañía para que el CEDIS/DG no absorba el costo.
                </small>
            </div>

            <div class="form-group" style="margin:0;grid-column:1/-1;">
                <label class="form-label">📝 Motivo y Hallazgo *</label>
                <textarea id="md-motivo" class="form-control" rows="2" placeholder="Describe la causa: bote roto en flete, sello vencido, merma de tolva, reclamo distribuidor..."></textarea>
            </div>
        </div>

        <!-- Footer -->
        <div style="display:flex;justify-content:flex-end;gap:.75rem;padding:1rem 1.5rem;border-top:1px solid rgba(255,255,255,.1);">
            <button class="btn btn-outline" onclick="document.getElementById('modalNuevaMermaDevolucion').style.display='none'">Cancelar</button>
            <button class="btn btn-primary" onclick="guardarNuevaMermaODevolucion()" style="background:linear-gradient(135deg,#ef4444,#dc2626);border:none;font-weight:600;padding:.5rem 1.25rem;">
                💾 Guardar Registro
            </button>
        </div>
    </div>`;

    m.style.display = 'block';
    document.body.style.overflow = 'hidden';
    m.onclick = function(e) { if (e.target === m) { m.style.display='none'; document.body.style.overflow=''; } };

    _actualizarAyudaMerma('devolucion_cliente');
    _actualizarPesoMermaModal();
}

function _actualizarCedisPorEmpresa(empresa) {
    const selOrigen = document.getElementById('md-cedis-origen');
    if (!selOrigen) return;
    if (empresa === 'DI') {
        selOrigen.value = 'master';
    } else if (empresa === 'LLC') {
        selOrigen.value = '4';
    } else {
        if (selOrigen.value === 'master' || selOrigen.value === '4') selOrigen.value = '1';
    }
}

function _actualizarAyudaMerma(subtipo) {
    const lbl = document.getElementById('md-ayuda-tratamiento');
    const trat = document.getElementById('md-tratamiento');
    const grpDest = document.getElementById('grp-md-cedis-destino');
    if (!lbl || !trat) return;

    if (grpDest) {
        grpDest.style.display = (subtipo === 'devolucion_cliente') ? 'block' : 'none';
    }

    if (subtipo === 'merma_produccion') {
        lbl.textContent = 'Pérdida en planta DI: se absorbe internamente o se añade al costo de merma de fabricación en DI.';
        trat.value = 'absorcion_interna';
    } else if (subtipo === 'devolucion_cliente') {
        lbl.textContent = 'Devolución de CEDIS hacia DI: se genera una Nota de Crédito Intercompañía para que el CEDIS/DG no absorba el costo.';
        trat.value = 'cobro_intercompania';
    } else if (subtipo === 'reposicion_cliente') {
        lbl.textContent = 'Reempaque: Se recupera el producto a granel consumiendo nuevas tapas/etiquetas, registrando el gasto extra.';
        trat.value = 'reempaque_gastos';
    } else {
        lbl.textContent = 'Merma en transporte o almacén: se asigna responsabilidad según póliza de flete o absorción del CEDIS.';
        trat.value = 'absorcion_interna';
    }
}

function _actualizarPesoMermaModal() {
    const prod = document.getElementById('md-producto')?.value || 'natural';
    const presEl = document.getElementById('md-presentacion');
    const descSpan = document.getElementById('md-peso-desc');
    const refLbl = document.getElementById('md-costo-ref-lbl');
    if (!descSpan || !presEl) return;

    if (prod === 'eucament') {
        presEl.value = 'frasco';
        descSpan.innerHTML = `🌿 <strong>Eucament</strong>: Frasco dosificador <strong>60ml</strong>`;
        if (refLbl) refLbl.textContent = 'Precio Intercia Ref: $22.92 MXN';
    } else if (prod === 'materia_prima') {
        presEl.value = 'insumo';
        descSpan.innerHTML = `📦 <strong>Materia Prima / Insumo General</strong> (Unidades o Kg sueltos)`;
        if (refLbl) refLbl.textContent = 'Costo s/gasto real';
    } else {
        if (presEl.value === 'frasco' || presEl.value === 'insumo') presEl.value = 'bote';
        const pres = presEl.value || 'bote';
        const esNat = prod === 'natural';
        const peso = esNat ? '500g' : '450g';
        const tipoPres = pres === 'sachet' ? '🎒 Sachet / Bolsa' : '🍶 Bote';
        const nombreProd = prod.charAt(0).toUpperCase() + prod.slice(1);
        descSpan.innerHTML = `🥛 <strong>Dulet ${nombreProd} ${tipoPres}</strong>: Peso nominal <strong>${peso}</strong>`;
        if (refLbl) refLbl.textContent = 'Precio Intercia Ref: $32.08 MXN';
    }
    _calcularCostoMermaAuto();
}

function _calcularCostoMermaAuto() {
    const cant = parseFloat(document.getElementById('md-cantidad')?.value) || 0;
    const costoInput = document.getElementById('md-costo');
    if (!costoInput || costoInput.value !== '') return;
    const prod = document.getElementById('md-producto')?.value || 'natural';
    const unitario = prod === 'eucament' ? 22.92 : 32.08;
    if (cant > 0) {
        costoInput.placeholder = (cant * unitario).toFixed(2);
    }
}

async function guardarNuevaMermaODevolucion() {
    const empresa = document.getElementById('md-empresa')?.value || 'DG';
    const subtipo = document.getElementById('md-subtipo')?.value || 'devolucion_cliente';
    const producto = document.getElementById('md-producto')?.value || 'natural';
    const presentacion = document.getElementById('md-presentacion')?.value || 'bote';
    const cedisOrigen = document.getElementById('md-cedis-origen')?.value || (empresa === 'DI' ? 'master' : (empresa === 'LLC' ? '4' : '1'));
    const cedisDestino = (subtipo === 'devolucion_cliente') ? (document.getElementById('md-cedis-destino')?.value || 'master') : null;
    const lote = (document.getElementById('md-lote')?.value || '').trim();
    const cantidad = parseFloat(document.getElementById('md-cantidad')?.value) || 0;
    let costo = parseFloat(document.getElementById('md-costo')?.value);
    const tratamiento = document.getElementById('md-tratamiento')?.value || 'cobro_intercompania';
    const motivo = (document.getElementById('md-motivo')?.value || '').trim();

    if (cantidad <= 0) { BO_AUTH.showAlert('Ingresa una cantidad mayor a 0.', 'warning'); return; }
    if (!motivo) { BO_AUTH.showAlert('Describe el motivo o hallazgo.', 'warning'); return; }

    const precioRef = producto === 'eucament' ? 22.92 : 32.08;
    if (isNaN(costo) || costo <= 0) {
        costo = +(cantidad * precioRef).toFixed(2);
    }

    const creador = (CURRENT_USER?.nombre || CURRENT_USER?.registro || 'sistema').replace(/'/g, "''");
    const tipoMov = (subtipo === 'devolucion_cliente') ? 'devolucion' : 'merma';
    const destSqlVal = cedisDestino ? `'${cedisDestino}'` : 'NULL';

    try {
        // 1. Insertar en inventario_transacciones
        // NOTA: El trigger procesar_transaccion_inventario() resta NEW.cantidad de origen_id
        // y (si existe) suma NEW.cantidad en destino_id. Por tanto, cantidad debe ser POSITIVA.
        const sqlTrans = `
            INSERT INTO inventario_transacciones
                (cedis_id, producto_id, presentacion, cantidad, tipo_movimiento, subtipo_merma, tratamiento_financiero, notas, autor_id, created_at, origen_id, destino_id)
            VALUES
                ('${cedisOrigen}', '${producto}', '${presentacion}', ${cantidad}, '${tipoMov}', '${subtipo}', '${tratamiento}', '${motivo.replace(/'/g,"''")}', '${creador}', NOW(), '${cedisOrigen}', ${destSqlVal});
        `;
        await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql: sqlTrans });

        // 2. Si es Devolución con Cobro Intercompañía, generar Nota de Crédito en ventas_intercompania
        if (tratamiento === 'cobro_intercompania') {
            const fechaStr = new Date().toISOString().slice(0, 10).replace(/-/g, '');
            const folioNC = `NC-IC-${fechaStr}-${Math.floor(Math.random()*9000+1000)}`;
            const nomProdCompleto = `${producto.toUpperCase()} ${presentacion.toUpperCase()}`;
            const sqlNC = `
                INSERT INTO ventas_intercompania
                    (folio, lote_clave, producto_id, producto_nombre, cantidad, costo_unitario, total, liberado_por, empresa_origen, empresa_destino, notas, total_facturable, costo_fabricacion_total, moneda)
                VALUES
                    ('${folioNC}', '${lote.replace(/'/g,"''")}', '${producto}', '${nomProdCompleto}', -${cantidad}, ${precioRef}, -${costo}, '${creador}', '${empresa}', 'DI', 'Nota de Crédito Intercompañía (Devolución ${cedisOrigen} ➔ ${cedisDestino||'DI'}) — ${motivo.replace(/'/g,"''")}', -${costo}, -${costo}, 'MXN');
            `;
            await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql: sqlNC }).catch(e => console.warn('NC IC error:', e));
        }

        // 3. Si genera gastos adicionales por Reempaque o Absorción
        if (costo > 0 && (tratamiento === 'reempaque_gastos' || tratamiento === 'absorcion_interna')) {
            const mesActual = new Date().toISOString().slice(0, 7);
            const subcatGasto = tratamiento === 'reempaque_gastos' ? 'reempaque_garantias' : 'merma_produccion';
            const sqlGasto = `
                INSERT INTO gastos_mensuales
                    (mes, concepto, categoria, subcategoria, producto_id, monto, notas, creado_por, empresa, origen)
                VALUES
                    ('${mesActual}', 'Merma/Devolución — ${producto.toUpperCase()} (${presentacion})', 'produccion', '${subcatGasto}', '${producto}', ${costo}, '${motivo.replace(/'/g,"''")} | Lote: ${lote.replace(/'/g,"''")} | CEDIS: ${cedisOrigen}', '${creador}', '${empresa}', 'auto_merma');
            `;
            await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql: sqlGasto }).catch(e => console.warn('Gasto merma error:', e));
        }

        BO_AUTH.showAlert(`✅ Registro guardado exitosamente (${subtipo.replace(/_/g, ' ')} — ${presentacion.toUpperCase()}).`, 'success');
        document.getElementById('modalNuevaMermaDevolucion').style.display = 'none';
        document.body.style.overflow = '';

        if (typeof _cargarTablaMermas === 'function') _refrescarReportes();
    } catch(e) {
        console.error('guardarNuevaMermaODevolucion', e);
        BO_AUTH.showAlert('Error al registrar: ' + e.message, 'danger');
    }
}



/* ============================================================================
 * ESTUDIO VISUAL DE IMÁGENES DE PRODUCTO + PANEL DE AVISOS Y PROMOS WEB
 * - Drag & Drop + Pegado Cmd+V / Ctrl+V directo desde portapapeles
 * - Auto-optimizador en navegador (<canvas> -> WebP ligero + recorte alfa + 1:1)
 * - Cascada por familia de SKUs + Mini-galería CDN reutilizable + 4 ranuras
 * - Motor de Pop-ups Inteligentes, Cintillos y Avisos Web (<dialog closedby="any">)
 * ============================================================================ */

const _STUDIO_API_BASE = (typeof window !== 'undefined' && (
    window.location.hostname === 'backoffice.duletias3rver.com' ||
    window.location.hostname.endsWith('.dulet-backoffice.pages.dev')
)) ? '' : 'https://backoffice.duletias3rver.com';

const _SHOPIFY_LEGACY_PROD_CDN = 'https://cdn.shopify.com/s/files/1/0947/4172/5498/t/9/assets/prod-';

const _IMG_STUDIO_STATE = {
    activeSlot: 'principal', // 'principal' | 'hover' | 'tabla_mx' | 'tabla_usa'
    slots: {
        principal: '',
        hover: '',
        tabla_mx: '',
        tabla_usa: ''
    },
    lightBg: false,
    uploading: false,
    galleryLoaded: false,
    galleryItems: [],
    lastStatText: ''
};

function _getAuthHeadersStudio() {
    const token = sessionStorage.getItem('bo_token') || localStorage.getItem('bo_token') || '';
    return {
        'Content-Type': 'application/json',
        ...(token ? { 'Authorization': `Bearer ${token}` } : {})
    };
}

function _resolverPreviewProductoUrl(rawVal) {
    const v = String(rawVal || '').trim();
    if (!v) return '';
    if (v.startsWith('http://') || v.startsWith('https://') || v.startsWith('data:')) return v;
    if (v.startsWith('/api/media')) return `${_STUDIO_API_BASE}${v}`;
    return `${_SHOPIFY_LEGACY_PROD_CDN}${v}`;
}

function _extraerRaizFamiliaProducto(nombre) {
    const clean = String(nombre || '')
        .trim()
        .replace(/\s+\b(pub|publico|público|dist|distribuidor|mc|mayorista|usa|mx|eu|estados\s+unidos)\b\.?$/i, '')
        .replace(/\s+/g, ' ')
        .trim();
    return clean.length >= 4 ? clean : '';
}

function _buscarHermanosFamiliaProducto(nombreActual, skuActual) {
    const raiz = _extraerRaizFamiliaProducto(nombreActual);
    if (!raiz || !Array.isArray(PRODUCTOS_CAT)) return [];
    const raizLow = raiz.toLowerCase();
    return PRODUCTOS_CAT.filter(p => {
        if (!p || !p.sku || p.sku === skuActual) return false;
        const r = _extraerRaizFamiliaProducto(p.nombre || '').toLowerCase();
        return r === raizLow;
    });
}

function _obtenerImagenesExtraActuales() {
    const out = {};
    if (_IMG_STUDIO_STATE.slots.hover) out.hover_url = _IMG_STUDIO_STATE.slots.hover;
    if (_IMG_STUDIO_STATE.slots.tabla_mx) out.tabla_mx_url = _IMG_STUDIO_STATE.slots.tabla_mx;
    if (_IMG_STUDIO_STATE.slots.tabla_usa) out.tabla_usa_url = _IMG_STUDIO_STATE.slots.tabla_usa;
    return out;
}

function _cargarImagenesExtraProducto(p) {
    const extra = (p && p.imagenes_extra && typeof p.imagenes_extra === 'object') ? p.imagenes_extra : {};
    _IMG_STUDIO_STATE.activeSlot = 'principal';
    _IMG_STUDIO_STATE.slots.principal = String(p?.imagen_url || p?.imagenUrl || '').trim();
    _IMG_STUDIO_STATE.slots.hover = String(extra.hover_url || '').trim();
    _IMG_STUDIO_STATE.slots.tabla_mx = String(extra.tabla_mx_url || '').trim();
    _IMG_STUDIO_STATE.slots.tabla_usa = String(extra.tabla_usa_url || '').trim();
    _IMG_STUDIO_STATE.lastStatText = '';
    _refrescarEstudioImagenProducto();
}

function _resetEstudioImagenProducto() {
    _IMG_STUDIO_STATE.activeSlot = 'principal';
    _IMG_STUDIO_STATE.slots = { principal: '', hover: '', tabla_mx: '', tabla_usa: '' };
    _IMG_STUDIO_STATE.lastStatText = '';
    const chk = document.getElementById('np-img-cascade-chk');
    if (chk) chk.checked = false;
    _refrescarEstudioImagenProducto();
}

async function _aplicarImagenAFamilia(nombreBase, skuActual, imagenUrlRaw, imagenesExtraObj) {
    const hermanos = _buscarHermanosFamiliaProducto(nombreBase, skuActual);
    if (!hermanos.length) return;
    const skusSafe = hermanos.map(h => `'${String(h.sku).replace(/'/g, "''")}'`).join(',');
    const imgSafe = String(imagenUrlRaw || '').replace(/'/g, "''");
    const extraSafe = JSON.stringify(imagenesExtraObj || {}).replace(/'/g, "''");
    try {
        const sql = `UPDATE productos SET imagen_url = '${imgSafe}', imagenes_extra = '${extraSafe}'::jsonb WHERE sku IN (${skusSafe})`;
        await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql });
        hermanos.forEach(h => {
            h.imagen_url = imagenUrlRaw;
            h.imagenes_extra = { ...(imagenesExtraObj || {}) };
        });
        BO_AUTH.showAlert(`✨ Imagen aplicada también a ${hermanos.length} variante(s) de la familia.`, 'info');
    } catch (e) {
        console.warn('Error aplicando cascada de imagen a familia:', e);
    }
}

// Optimización en cliente (<canvas>): recorta bordes alfa vacíos opcionales y comprime a WebP nítido
async function _optimizarArchivoImagenEnNavegador(file, mode = 'square') {
    const origBytes = file.size || 0;
    const bitmapUrl = URL.createObjectURL(file);
    try {
        const img = await new Promise((resolve, reject) => {
            const el = new Image();
            el.onload = () => resolve(el);
            el.onerror = () => reject(new Error('No se pudo leer el archivo de imagen'));
            el.src = bitmapUrl;
        });

        const srcW = img.naturalWidth || img.width;
        const srcH = img.naturalHeight || img.height;

        // 1. Detectar caja delimitadora no transparente para centrar envases PNG con márgenes disparejos
        let cropX = 0, cropY = 0, cropW = srcW, cropH = srcH;
        if (mode === 'square' && srcW * srcH <= 16000000) {
            const tmp = document.createElement('canvas');
            const scanScale = Math.min(1, 500 / Math.max(srcW, srcH));
            const sW = Math.max(1, Math.round(srcW * scanScale));
            const sH = Math.max(1, Math.round(srcH * scanScale));
            tmp.width = sW;
            tmp.height = sH;
            const tCtx = tmp.getContext('2d', { willReadFrequently: true });
            tCtx.drawImage(img, 0, 0, sW, sH);
            const data = tCtx.getImageData(0, 0, sW, sH).data;
            let minX = sW, minY = sH, maxX = -1, maxY = -1;
            for (let y = 0; y < sH; y++) {
                for (let x = 0; x < sW; x++) {
                    const a = data[(y * sW + x) * 4 + 3];
                    if (a > 12) {
                        if (x < minX) minX = x;
                        if (x > maxX) maxX = x;
                        if (y < minY) minY = y;
                        if (y > maxY) maxY = y;
                    }
                }
            }
            if (maxX >= minX && maxY >= minY && (maxX - minX + 1 < sW * 0.96 || maxY - minY + 1 < sH * 0.96)) {
                cropX = Math.max(0, Math.floor(minX / scanScale) - 4);
                cropY = Math.max(0, Math.floor(minY / scanScale) - 4);
                cropW = Math.min(srcW - cropX, Math.ceil((maxX - minX + 1) / scanScale) + 8);
                cropH = Math.min(srcH - cropY, Math.ceil((maxY - minY + 1) / scanScale) + 8);
            }
        }

        const outCanvas = document.createElement('canvas');
        let outW, outH;

        if (mode === 'square') {
            const targetSide = Math.min(1080, Math.max(640, Math.max(cropW, cropH)));
            outW = targetSide;
            outH = targetSide;
            outCanvas.width = outW;
            outCanvas.height = outH;
            const ctx = outCanvas.getContext('2d');
            ctx.imageSmoothingEnabled = true;
            ctx.imageSmoothingQuality = 'high';
            const pad = Math.round(targetSide * 0.06);
            const avail = targetSide - pad * 2;
            const scale = Math.min(avail / cropW, avail / cropH);
            const drawW = Math.round(cropW * scale);
            const drawH = Math.round(cropH * scale);
            const dx = Math.round((targetSide - drawW) / 2);
            const dy = Math.round((targetSide - drawH) / 2);
            ctx.drawImage(img, cropX, cropY, cropW, cropH, dx, dy, drawW, drawH);
        } else {
            const maxDim = mode === 'banner' ? 1440 : 1400;
            const scale = Math.min(1, maxDim / Math.max(srcW, srcH));
            outW = Math.max(1, Math.round(srcW * scale));
            outH = Math.max(1, Math.round(srcH * scale));
            outCanvas.width = outW;
            outCanvas.height = outH;
            const ctx = outCanvas.getContext('2d');
            ctx.imageSmoothingEnabled = true;
            ctx.imageSmoothingQuality = 'high';
            ctx.drawImage(img, 0, 0, outW, outH);
        }

        let dataUrl = outCanvas.toDataURL('image/webp', 0.88);
        let mimeType = 'image/webp';
        if (!dataUrl.startsWith('data:image/webp')) {
            dataUrl = outCanvas.toDataURL('image/png');
            mimeType = 'image/png';
        }
        const base64Data = dataUrl.split(',')[1] || '';
        const optBytes = Math.round((base64Data.length * 3) / 4);
        const baseName = String(file.name || 'imagen').replace(/\.[a-zA-Z0-9]+$/, '') || 'dulet-imagen';
        const ext = mimeType === 'image/webp' ? 'webp' : 'png';

        return {
            fileName: `${baseName}.${ext}`,
            mimeType,
            base64Data,
            width: outW,
            height: outH,
            origKb: Math.max(1, Math.round(origBytes / 1024)),
            optKb: Math.max(1, Math.round(optBytes / 1024))
        };
    } finally {
        URL.revokeObjectURL(bitmapUrl);
    }
}

async function _subirArchivoAlCdnEstudio(file, mode = 'square') {
    const optimized = await _optimizarArchivoImagenEnNavegador(file, mode);
    const res = await fetch(`${_STUDIO_API_BASE}/api/upload-media`, {
        method: 'POST',
        headers: _getAuthHeadersStudio(),
        body: JSON.stringify({
            fileName: optimized.fileName,
            mimeType: optimized.mimeType,
            base64Data: optimized.base64Data,
            width: optimized.width,
            height: optimized.height
        })
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok || !data.ok || !data.url) {
        throw new Error(data.message || `Error subiendo imagen (${res.status})`);
    }
    return {
        url: data.url,
        deduplicated: !!data.deduplicated,
        origKb: optimized.origKb,
        optKb: data.sizeKb || optimized.optKb,
        width: optimized.width,
        height: optimized.height
    };
}

function _asegurarEstudioImagenProducto() {
    const inputOriginal = document.getElementById('np-imagenUrl');
    if (!inputOriginal || document.getElementById('np-img-studio-box')) return;

    const formGroup = inputOriginal.closest('.form-group');
    if (!formGroup) return;

    formGroup.innerHTML = `
        <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:.45rem;flex-wrap:wrap;gap:.4rem;">
            <label class="form-label" style="margin:0;">🖼️ Estudio de Imagen del Producto <span style="font-size:.68rem;color:#38bdf8;font-weight:700;">CDN Directo · Auto-WebP</span></label>
            <div style="display:flex;gap:.35rem;align-items:center;">
                <select id="np-img-mode-select" class="form-control" style="padding:2px 8px;font-size:.7rem;height:26px;width:auto;background:rgba(15,23,42,.8);">
                    <option value="square">📐 Encuadre 1:1 Centrado</option>
                    <option value="original">📄 Proporción Original</option>
                </select>
                <button type="button" id="np-img-bg-toggle" onclick="_toggleFondoPreviewProducto()" style="padding:2px 8px;font-size:.7rem;height:26px;border-radius:6px;border:1px solid rgba(255,255,255,.14);background:rgba(255,255,255,.05);color:#cbd5e1;cursor:pointer;" title="Alternar fondo claro/oscuro en la vista previa">☀️/🌙 Fondo</button>
            </div>
        </div>

        <!-- Pestañas de las 4 ranuras -->
        <div id="np-img-slot-tabs" style="display:grid;grid-template-columns:repeat(4,1fr);gap:4px;margin-bottom:.55rem;">
            <button type="button" data-slot="principal" onclick="_seleccionarRanuraImagenProd('principal')" style="padding:5px 6px;font-size:.7rem;font-weight:700;border-radius:7px;cursor:pointer;border:1px solid rgba(56,189,248,.4);background:rgba(56,189,248,.16);color:#38bdf8;">📦 Principal</button>
            <button type="button" data-slot="hover" onclick="_seleccionarRanuraImagenProd('hover')" style="padding:5px 6px;font-size:.7rem;font-weight:600;border-radius:7px;cursor:pointer;border:1px solid rgba(255,255,255,.1);background:rgba(255,255,255,.03);color:#94a3b8;">✨ Hover 2ª</button>
            <button type="button" data-slot="tabla_mx" onclick="_seleccionarRanuraImagenProd('tabla_mx')" style="padding:5px 6px;font-size:.7rem;font-weight:600;border-radius:7px;cursor:pointer;border:1px solid rgba(255,255,255,.1);background:rgba(255,255,255,.03);color:#94a3b8;">🇲🇽 Tabla MX</button>
            <button type="button" data-slot="tabla_usa" onclick="_seleccionarRanuraImagenProd('tabla_usa')" style="padding:5px 6px;font-size:.7rem;font-weight:600;border-radius:7px;cursor:pointer;border:1px solid rgba(255,255,255,.1);background:rgba(255,255,255,.03);color:#94a3b8;">🇺🇸 Tabla USA</button>
        </div>

        <!-- Zona Drag & Drop + Vista Previa -->
        <div id="np-img-studio-box" style="display:grid;grid-template-columns:126px 1fr;gap:.85rem;padding:.85rem;border-radius:10px;border:1.5px dashed rgba(56,189,248,.35);background:rgba(15,23,42,.55);transition:all .18s ease;">
            <div id="np-img-preview-wrap" style="width:126px;height:126px;border-radius:10px;background:rgba(255,255,255,.04);border:1px solid rgba(255,255,255,.1);display:flex;align-items:center;justify-content:center;position:relative;overflow:hidden;">
                <img id="np-img-preview-el" src="" alt="Vista previa" style="display:none;max-width:92%;max-height:92%;object-fit:contain;">
                <div id="np-img-preview-empty" style="text-align:center;color:#64748b;font-size:.7rem;padding:.4rem;">Sin foto<br>en ranura</div>
                <button type="button" id="np-img-clear-btn" onclick="_limpiarRanuraImagenProd()" style="display:none;position:absolute;top:4px;right:4px;width:22px;height:22px;border-radius:50%;border:none;background:rgba(239,68,68,.88);color:#fff;font-size:.7rem;cursor:pointer;line-height:1;" title="Quitar imagen de esta ranura">✕</button>
            </div>
            <div style="display:flex;flex-direction:column;justify-content:center;gap:.45rem;min-width:0;">
                <div id="np-img-drop-title" style="font-size:.8rem;font-weight:700;color:#e2e8f0;">Arrastra tu imagen aquí o pega con <kbd style="background:rgba(255,255,255,.12);padding:1px 5px;border-radius:4px;font-size:.7rem;">Cmd+V</kbd> / <kbd style="background:rgba(255,255,255,.12);padding:1px 5px;border-radius:4px;font-size:.7rem;">Ctrl+V</kbd></div>
                <div style="font-size:.7rem;color:#94a3b8;line-height:1.35;">Convierte PNG/JPG pesados a WebP ligero conservando transparencia y publica directo en el CDN sin tocar <code>assets/</code>.</div>
                <div style="display:flex;gap:.45rem;flex-wrap:wrap;align-items:center;">
                    <input type="file" id="np-img-file-input" accept="image/png,image/jpeg,image/webp" style="display:none;" onchange="if(this.files&&this.files[0])_procesarSubidaImagenProducto(this.files[0])">
                    <button type="button" class="btn btn-sm" onclick="document.getElementById('np-img-file-input').click()" style="padding:5px 12px;font-size:.74rem;font-weight:700;background:linear-gradient(135deg,#0284c7,#2563eb);color:#fff;border:none;border-radius:7px;cursor:pointer;">📤 Subir archivo...</button>
                    <button type="button" class="btn btn-sm" onclick="_toggleGaleriaRapidaProd()" style="padding:5px 10px;font-size:.73rem;font-weight:600;background:rgba(255,255,255,.06);color:#cbd5e1;border:1px solid rgba(255,255,255,.14);border-radius:7px;cursor:pointer;">📚 Galería CDN</button>
                </div>
                <div id="np-img-stat-lbl" style="font-size:.7rem;color:#4ade80;min-height:14px;"></div>
            </div>
        </div>

        <!-- Cascada por familia -->
        <div id="np-img-family-box" style="display:none;margin-top:.5rem;padding:.55rem .75rem;border-radius:8px;background:rgba(56,189,248,.08);border:1px solid rgba(56,189,248,.24);align-items:center;gap:.55rem;">
            <input type="checkbox" id="np-img-cascade-chk" style="width:16px;height:16px;accent-color:#38bdf8;cursor:pointer;">
            <label for="np-img-cascade-chk" id="np-img-cascade-lbl" style="font-size:.74rem;color:#e2e8f0;cursor:pointer;line-height:1.3;"></label>
        </div>

        <!-- Mini-galería reutilizable -->
        <div id="np-img-gallery-drawer" style="display:none;margin-top:.55rem;padding:.65rem;border-radius:8px;background:rgba(2,6,23,.65);border:1px solid rgba(255,255,255,.1);">
            <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:.45rem;">
                <span style="font-size:.72rem;font-weight:700;color:#cbd5e1;">📚 Fotos disponibles en CDN (1 clic para usar en la ranura activa)</span>
                <button type="button" onclick="_cargarGaleriaCdnEstudio(true)" style="background:none;border:none;color:#38bdf8;font-size:.7rem;cursor:pointer;">↻ Actualizar</button>
            </div>
            <div id="np-img-gallery-grid" style="display:flex;gap:.45rem;overflow-x:auto;padding-bottom:.25rem;"></div>
        </div>

        <!-- Input compatible de URL / archivo legado -->
        <div style="margin-top:.45rem;display:flex;align-items:center;gap:.4rem;">
            <span style="font-size:.68rem;color:#64748b;white-space:nowrap;">URL / Archivo:</span>
            <input type="text" id="np-imagenUrl" class="form-control" placeholder="Se llena automático al subir (o escribe URL / archivo legado)" style="font-size:.74rem;padding:.32rem .55rem;height:30px;" oninput="_onManualInputImagenProd(this.value)">
        </div>
    `;

    // Eventos Drag & Drop sobre la caja
    const box = document.getElementById('np-img-studio-box');
    if (box) {
        ['dragenter', 'dragover'].forEach(ev => {
            box.addEventListener(ev, e => {
                e.preventDefault();
                e.stopPropagation();
                box.style.borderColor = '#38bdf8';
                box.style.background = 'rgba(56,189,248,.1)';
            });
        });
        ['dragleave', 'drop'].forEach(ev => {
            box.addEventListener(ev, e => {
                e.preventDefault();
                e.stopPropagation();
                box.style.borderColor = 'rgba(56,189,248,.35)';
                box.style.background = 'rgba(15,23,42,.55)';
            });
        });
        box.addEventListener('drop', e => {
            const f = e.dataTransfer?.files?.[0];
            if (f && f.type.startsWith('image/')) {
                _procesarSubidaImagenProducto(f);
            }
        });
    }

    // Actualizar sugerencia de familia cuando cambia el nombre del producto
    const descInput = document.getElementById('np-desc');
    if (descInput && !descInput.dataset.studioBound) {
        descInput.dataset.studioBound = '1';
        descInput.addEventListener('input', () => _actualizarBannerFamiliaProducto());
    }
}

function _seleccionarRanuraImagenProd(slot) {
    _IMG_STUDIO_STATE.activeSlot = slot;
    const modeSel = document.getElementById('np-img-mode-select');
    if (modeSel) {
        modeSel.value = (slot === 'tabla_mx' || slot === 'tabla_usa') ? 'original' : 'square';
    }
    _refrescarEstudioImagenProducto();
}

function _toggleFondoPreviewProducto() {
    _IMG_STUDIO_STATE.lightBg = !_IMG_STUDIO_STATE.lightBg;
    _refrescarEstudioImagenProducto();
}

function _limpiarRanuraImagenProd() {
    const slot = _IMG_STUDIO_STATE.activeSlot;
    _IMG_STUDIO_STATE.slots[slot] = '';
    if (slot === 'principal') {
        const inp = document.getElementById('np-imagenUrl');
        if (inp) inp.value = '';
    }
    _IMG_STUDIO_STATE.lastStatText = 'Ranura limpiada.';
    _refrescarEstudioImagenProducto();
}

function _onManualInputImagenProd(val) {
    const v = String(val || '').trim();
    if (_IMG_STUDIO_STATE.activeSlot === 'principal') {
        _IMG_STUDIO_STATE.slots.principal = v;
    } else {
        _IMG_STUDIO_STATE.slots[_IMG_STUDIO_STATE.activeSlot] = v;
        // Mantener #np-imagenUrl sincronizado siempre con la foto principal para guardarNuevoProducto()
        const inp = document.getElementById('np-imagenUrl');
        if (inp) inp.value = _IMG_STUDIO_STATE.slots.principal || '';
    }
    _refrescarVistaPreviaEstudio();
}

function _actualizarBannerFamiliaProducto() {
    const box = document.getElementById('np-img-family-box');
    const lbl = document.getElementById('np-img-cascade-lbl');
    const descEl = document.getElementById('np-desc');
    if (!box || !lbl || !descEl) return;
    const hermanos = _buscarHermanosFamiliaProducto(descEl.value, descEl.dataset.editSku || '');
    if (hermanos.length > 0 && (_IMG_STUDIO_STATE.slots.principal || _IMG_STUDIO_STATE.slots.hover)) {
        box.style.display = 'flex';
        const nombres = hermanos.map(h => h.nombre).slice(0, 3).join(', ');
        lbl.innerHTML = `<strong>Aplicar en cascada a toda la familia (${hermanos.length}):</strong> ${nombres}${hermanos.length > 3 ? '…' : ''}`;
    } else {
        box.style.display = 'none';
    }
}

function _refrescarVistaPreviaEstudio() {
    const slot = _IMG_STUDIO_STATE.activeSlot;
    const rawVal = _IMG_STUDIO_STATE.slots[slot] || '';
    const previewUrl = _resolverPreviewProductoUrl(rawVal);
    const wrap = document.getElementById('np-img-preview-wrap');
    const imgEl = document.getElementById('np-img-preview-el');
    const emptyEl = document.getElementById('np-img-preview-empty');
    const clearBtn = document.getElementById('np-img-clear-btn');
    const statLbl = document.getElementById('np-img-stat-lbl');

    if (wrap) {
        wrap.style.background = _IMG_STUDIO_STATE.lightBg ? '#f5f2eb' : 'rgba(255,255,255,.04)';
    }
    if (imgEl && emptyEl) {
        if (previewUrl) {
            imgEl.src = previewUrl;
            imgEl.style.display = 'block';
            emptyEl.style.display = 'none';
            if (clearBtn) clearBtn.style.display = 'block';
        } else {
            imgEl.removeAttribute('src');
            imgEl.style.display = 'none';
            emptyEl.style.display = 'block';
            if (clearBtn) clearBtn.style.display = 'none';
        }
    }
    if (statLbl) {
        statLbl.textContent = _IMG_STUDIO_STATE.lastStatText || '';
    }
    _actualizarBannerFamiliaProducto();
}

function _refrescarEstudioImagenProducto() {
    _asegurarEstudioImagenProducto();
    const inp = document.getElementById('np-imagenUrl');
    if (inp && !_IMG_STUDIO_STATE.slots.principal && inp.value) {
        _IMG_STUDIO_STATE.slots.principal = inp.value.trim();
    }
    if (inp) {
        inp.value = _IMG_STUDIO_STATE.slots.principal || '';
    }

    const tabs = document.querySelectorAll('#np-img-slot-tabs button[data-slot]');
    tabs.forEach(btn => {
        const s = btn.dataset.slot;
        const active = s === _IMG_STUDIO_STATE.activeSlot;
        const hasVal = !!_IMG_STUDIO_STATE.slots[s];
        btn.style.borderColor = active ? 'rgba(56,189,248,.6)' : (hasVal ? 'rgba(74,222,128,.35)' : 'rgba(255,255,255,.1)');
        btn.style.background = active ? 'rgba(56,189,248,.18)' : (hasVal ? 'rgba(74,222,128,.08)' : 'rgba(255,255,255,.03)');
        btn.style.color = active ? '#38bdf8' : (hasVal ? '#86efac' : '#94a3b8');
    });

    _refrescarVistaPreviaEstudio();
}

async function _procesarSubidaImagenProducto(file) {
    if (!file || _IMG_STUDIO_STATE.uploading) return;
    _IMG_STUDIO_STATE.uploading = true;
    const statLbl = document.getElementById('np-img-stat-lbl');
    if (statLbl) {
        statLbl.style.color = '#38bdf8';
        statLbl.textContent = '⏳ Optimizando a WebP y subiendo al CDN...';
    }

    try {
        const mode = document.getElementById('np-img-mode-select')?.value || 'square';
        const res = await _subirArchivoAlCdnEstudio(file, mode === 'square' ? 'square' : 'original');
        const slot = _IMG_STUDIO_STATE.activeSlot;
        _IMG_STUDIO_STATE.slots[slot] = res.url;

        const inp = document.getElementById('np-imagenUrl');
        if (inp) inp.value = _IMG_STUDIO_STATE.slots.principal || '';

        _IMG_STUDIO_STATE.lastStatText = `✅ Lista en CDN (${res.origKb} KB → ${res.optKb} KB WebP · ${res.width}×${res.height})`;
        if (statLbl) statLbl.style.color = '#4ade80';
        _IMG_STUDIO_STATE.galleryLoaded = false;
        _refrescarEstudioImagenProducto();
    } catch (err) {
        if (statLbl) {
            statLbl.style.color = '#f87171';
            statLbl.textContent = '✕ ' + (err.message || 'Error al subir imagen');
        }
        BO_AUTH.showAlert('Error al subir imagen: ' + (err.message || err), 'danger');
    } finally {
        _IMG_STUDIO_STATE.uploading = false;
        const fi = document.getElementById('np-img-file-input');
        if (fi) fi.value = '';
    }
}

async function _toggleGaleriaRapidaProd() {
    const drawer = document.getElementById('np-img-gallery-drawer');
    if (!drawer) return;
    const open = drawer.style.display === 'none';
    drawer.style.display = open ? 'block' : 'none';
    if (open) await _cargarGaleriaCdnEstudio(false);
}

async function _cargarGaleriaCdnEstudio(force = false) {
    const grid = document.getElementById('np-img-gallery-grid');
    if (!grid) return;
    if (!force && _IMG_STUDIO_STATE.galleryLoaded && _IMG_STUDIO_STATE.galleryItems.length > 0) {
        _renderGaleriaCdnGrid();
        return;
    }
    grid.innerHTML = '<span style="font-size:.72rem;color:#94a3b8;">Cargando fotos...</span>';
    try {
        const res = await fetch(`${_STUDIO_API_BASE}/api/upload-media`, {
            method: 'GET',
            headers: _getAuthHeadersStudio()
        });
        const data = await res.json().catch(() => ({}));
        const uploaded = Array.isArray(data.items) ? data.items : [];

        // Combinar con fotos existentes del catálogo para reutilización rápida en 1 clic
        const seen = new Set(uploaded.map(i => i.url));
        const legacyItems = [];
        if (Array.isArray(PRODUCTOS_CAT)) {
            PRODUCTOS_CAT.forEach(p => {
                const raw = String(p.imagen_url || p.imagenUrl || '').trim();
                if (!raw) return;
                const resolved = _resolverPreviewProductoUrl(raw);
                if (seen.has(raw) || seen.has(resolved)) return;
                seen.add(raw);
                seen.add(resolved);
                legacyItems.push({
                    nombre: p.nombre,
                    rawValue: raw,
                    url: resolved,
                    sizeKb: null
                });
            });
        }

        _IMG_STUDIO_STATE.galleryItems = [
            ...uploaded.map(u => ({ nombre: u.nombre, rawValue: u.url, url: u.url, sizeKb: u.sizeKb })),
            ...legacyItems
        ];
        _IMG_STUDIO_STATE.galleryLoaded = true;
        _renderGaleriaCdnGrid();
    } catch (e) {
        grid.innerHTML = `<span style="font-size:.72rem;color:#f87171;">No se pudo cargar la galería: ${e.message}</span>`;
    }
}

function _renderGaleriaCdnGrid() {
    const grid = document.getElementById('np-img-gallery-grid');
    if (!grid) return;
    if (!_IMG_STUDIO_STATE.galleryItems.length) {
        grid.innerHTML = '<span style="font-size:.72rem;color:#64748b;">Aún no hay imágenes subidas al CDN.</span>';
        return;
    }
    grid.innerHTML = _IMG_STUDIO_STATE.galleryItems.map((it, idx) => `
        <button type="button" onclick="_asignarDesdeGaleriaCdn(${idx})" title="${String(it.nombre || '').replace(/"/g, '&quot;')}${it.sizeKb ? ` (${it.sizeKb} KB)` : ''}" style="flex:0 0 auto;width:62px;height:62px;border-radius:8px;border:1px solid rgba(255,255,255,.14);background:rgba(255,255,255,.04);padding:4px;cursor:pointer;display:flex;align-items:center;justify-content:center;transition:transform .12s;" onmouseover="this.style.borderColor='#38bdf8'" onmouseout="this.style.borderColor='rgba(255,255,255,.14)'">
            <img src="${it.url}" alt="" loading="lazy" fetchpriority="low" width="52" height="52" style="max-width:100%;max-height:100%;object-fit:contain;">
        </button>
    `).join('');
}

function _asignarDesdeGaleriaCdn(idx) {
    const item = _IMG_STUDIO_STATE.galleryItems[idx];
    if (!item) return;
    const slot = _IMG_STUDIO_STATE.activeSlot;
    _IMG_STUDIO_STATE.slots[slot] = item.rawValue;
    const inp = document.getElementById('np-imagenUrl');
    if (inp) inp.value = _IMG_STUDIO_STATE.slots.principal || '';
    _IMG_STUDIO_STATE.lastStatText = `✅ Imagen asignada desde galería (${item.nombre || 'Catálogo'})`;
    _refrescarEstudioImagenProducto();
}

// ============================================================================
// MÓDULO: AVISOS Y PROMOS WEB (POP-UP INTELIGENTE / CINTILLO / TOAST)
// ============================================================================

const _AVISOS_WEB_STATE = {
    notices: [],
    editingId: 0,
    uploadingImg: false
};

function _inyectarEstilosYControlesWebStudio() {
    if (!document.getElementById('dulet-web-studio-css')) {
        const st = document.createElement('style');
        st.id = 'dulet-web-studio-css';
        st.textContent = `
            dialog.dulet-web-dialog {
                position: fixed;
                inset: 0;
                margin: auto !important;
                border: 1px solid rgba(56, 189, 248, 0.35);
                border-radius: 16px;
                background: #0b1329;
                color: #e2e8f0;
                padding: 0;
                max-width: 1060px;
                width: calc(100vw - 2rem);
                max-height: 90vh;
                overflow: hidden;
                box-shadow: 0 28px 80px rgba(0, 0, 0, 0.85);
            }
            dialog.dulet-web-dialog button:focus:not(:focus-visible) {
                outline: none;
                box-shadow: none;
            }
            dialog.dulet-web-dialog[open] {
                display: flex;
                flex-direction: column;
            }
            dialog.dulet-web-dialog:modal {
                overscroll-behavior: contain;
            }
            dialog.dulet-web-dialog::backdrop {
                background: rgba(2, 6, 23, 0.78);
                backdrop-filter: blur(4px);
                overflow: hidden;
                overscroll-behavior: contain;
            }
            @media (max-width: 860px) {
                .dulet-aviso-studio-grid {
                    grid-template-columns: 1fr !important;
                }
            }
        `;
        document.head.appendChild(st);
    }

    // 1. Botón directo en la cabecera de Catálogo de Productos (#view-productos .page-header)
    const prodView = document.getElementById('view-productos');
    const prodHeader = prodView?.querySelector('.page-header');
    if (prodHeader && !document.getElementById('btnAbrirAvisosWebProd')) {
        const addBtn = prodHeader.querySelector('button');
        if (addBtn) {
            const wrap = document.createElement('div');
            wrap.style.cssText = 'display:flex;gap:.6rem;flex-wrap:wrap;align-items:center;';
            addBtn.parentNode.insertBefore(wrap, addBtn);
            const promoBtn = document.createElement('button');
            promoBtn.id = 'btnAbrirAvisosWebProd';
            promoBtn.type = 'button';
            promoBtn.className = 'btn btn-sm';
            promoBtn.style.cssText = 'background:linear-gradient(135deg,#0284c7,#6366f1);color:#fff;border:none;font-weight:700;padding:.5rem .95rem;border-radius:8px;cursor:pointer;display:inline-flex;align-items:center;gap:.4rem;';
            promoBtn.innerHTML = '📣 Avisos y Pop-up Web';
            promoBtn.onclick = () => abrirModalAvisosWeb();
            wrap.appendChild(promoBtn);
            wrap.appendChild(addBtn);
        }
    }

    // 2. Tarjeta de acceso rápido en Configuración (#view-config)
    const cfgView = document.getElementById('view-config');
    const cfgGrid = cfgView?.querySelector('div[style*="grid-template-columns"]');
    if (cfgGrid && !document.getElementById('panelAccesoAvisosWebCfg')) {
        const card = document.createElement('div');
        card.id = 'panelAccesoAvisosWebCfg';
        card.className = 'panel';
        card.innerHTML = `
            <div class="panel-header" style="display:flex;justify-content:space-between;align-items:center;flex-wrap:wrap;gap:.5rem;">
                <div>
                    <span class="panel-title">📣 Pop-up Inteligente y Cintillo de Avisos en Tienda Web</span>
                    <div style="font-size:.73rem;color:var(--text-dim);margin-top:2px;">Programa promociones del momento, cupones o avisos logísticos con vista previa en vivo</div>
                </div>
                <button type="button" class="btn btn-primary btn-sm" onclick="abrirModalAvisosWeb()">Abrir Estudio de Avisos Web →</button>
            </div>
        `;
        cfgGrid.insertBefore(card, cfgGrid.firstChild);
    }

    // 3. Listener global de pegado Cmd+V / Ctrl+V para imágenes en Producto o Aviso Web
    if (!window._duletPasteStudioBound) {
        window._duletPasteStudioBound = true;
        document.addEventListener('paste', e => {
            const items = e.clipboardData?.items;
            if (!items) return;
            let imgFile = null;
            for (let i = 0; i < items.length; i++) {
                if (items[i].type && items[i].type.startsWith('image/')) {
                    imgFile = items[i].getAsFile();
                    break;
                }
            }
            if (!imgFile) return;

            const dlgAviso = document.getElementById('dialogAvisosWeb');
            if (dlgAviso && dlgAviso.open) {
                e.preventDefault();
                _subirImagenAvisoWeb(imgFile);
                return;
            }
            const modalProd = document.getElementById('modalProducto');
            if (modalProd && modalProd.style.display !== 'none') {
                e.preventDefault();
                _procesarSubidaImagenProducto(imgFile);
            }
        });
    }
}

function _asegurarDialogAvisosWeb() {
    _inyectarEstilosYControlesWebStudio();
    let dlg = document.getElementById('dialogAvisosWeb');
    if (dlg) return dlg;

    dlg = document.createElement('dialog');
    dlg.id = 'dialogAvisosWeb';
    dlg.className = 'dulet-web-dialog';
    dlg.setAttribute('closedby', 'any');
    dlg.setAttribute('aria-labelledby', 'dialogAvisosWebTitle');

    dlg.innerHTML = `
        <div style="flex-shrink:0;padding:1.1rem 1.4rem;border-bottom:1px solid rgba(255,255,255,.1);display:flex;justify-content:space-between;align-items:center;background:linear-gradient(135deg,rgba(2,132,199,.18),rgba(15,23,42,.98));">
            <div>
                <h2 id="dialogAvisosWebTitle" style="margin:0;font-size:1.1rem;font-weight:800;color:#f8fafc;display:flex;align-items:center;gap:.5rem;">📣 Estudio de Pop-up Inteligente y Avisos Web</h2>
                <div style="font-size:.74rem;color:#94a3b8;margin-top:2px;">Controla promociones del momento, cupones y cintillos superiores sin tocar código</div>
            </div>
            <form method="dialog" style="margin:0;">
                <button type="submit" autofocus aria-label="Cerrar estudio de avisos" style="background:rgba(255,255,255,.07);border:1px solid rgba(255,255,255,.14);color:#cbd5e1;width:32px;height:32px;border-radius:8px;font-size:1rem;cursor:pointer;">✕</button>
            </form>
        </div>

        <div id="aw-dialog-scroll-body" style="flex:1;min-height:0;padding:1.15rem 1.4rem;overflow-y:auto;display:flex;flex-direction:column;gap:1.1rem;">
            <div id="aw-inline-msg" style="display:none;padding:.55rem .85rem;border-radius:8px;font-size:.78rem;font-weight:600;"></div>
            <!-- Lista de campañas guardadas -->
            <div style="background:rgba(2,6,23,.68);border:1px solid rgba(56,189,248,.28);border-radius:12px;padding:.9rem 1rem;box-shadow:0 8px 24px rgba(0,0,0,.28);">
                <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:.65rem;flex-wrap:wrap;gap:.5rem;">
                    <div>
                        <span style="font-size:.8rem;font-weight:800;color:#38bdf8;text-transform:uppercase;letter-spacing:.04em;">📋 Mis Anuncios Creados (Administrar: Pausar · Activar · Editar · Borrar)</span>
                        <div style="font-size:.7rem;color:#94a3b8;margin-top:2px;">Desde aquí puedes pausar o reactivar cualquier promoción al instante, cambiar su frecuencia o eliminarla</div>
                    </div>
                    <div style="display:flex;gap:.4rem;flex-wrap:wrap;">
                        <button type="button" onclick="_aplicarPlantillaAvisoWeb('promo')" style="padding:4px 10px;font-size:.72rem;font-weight:600;border-radius:6px;border:1px solid rgba(56,189,248,.35);background:rgba(56,189,248,.12);color:#38bdf8;cursor:pointer;">+ 🎁 Plantilla Promo</button>
                        <button type="button" onclick="_aplicarPlantillaAvisoWeb('cintillo')" style="padding:4px 10px;font-size:.72rem;font-weight:600;border-radius:6px;border:1px solid rgba(251,191,36,.35);background:rgba(251,191,36,.12);color:#fbbf24;cursor:pointer;">+ 🚚 Plantilla Cintillo</button>
                        <button type="button" onclick="_aplicarPlantillaAvisoWeb('cupon')" style="padding:4px 10px;font-size:.72rem;font-weight:600;border-radius:6px;border:1px solid rgba(168,85,247,.35);background:rgba(168,85,247,.12);color:#c084fc;cursor:pointer;">+ 🏷️ Plantilla Cupón</button>
                    </div>
                </div>
                <div id="aw-lista-campanas" style="display:flex;flex-direction:column;gap:.45rem;max-height:175px;overflow-y:auto;">
                    <div style="font-size:.76rem;color:#64748b;padding:.4rem 0;">Cargando avisos...</div>
                </div>
            </div>

            <!-- Editor + Simulador en Vivo -->
            <div class="dulet-aviso-studio-grid" style="display:grid;grid-template-columns:1.25fr 1fr;gap:1.15rem;align-items:start;">
                <!-- Formulario Editor -->
                <div style="background:rgba(255,255,255,.025);border:1px solid rgba(255,255,255,.09);border-radius:12px;padding:1rem;display:flex;flex-direction:column;gap:.75rem;">
                    <div style="display:flex;justify-content:space-between;align-items:center;gap:.5rem;flex-wrap:wrap;">
                        <span id="aw-editor-badge" style="font-size:.75rem;font-weight:700;color:#cbd5e1;padding:3px 9px;border-radius:999px;background:rgba(255,255,255,.06);border:1px solid rgba(255,255,255,.12);">✨ Nuevo Aviso / Promoción</span>
                        <button type="button" onclick="_limpiarFormularioAvisoWeb()" style="background:rgba(148,163,184,.12);border:1px solid rgba(148,163,184,.28);border-radius:6px;padding:3px 9px;color:#e2e8f0;font-size:.72rem;font-weight:600;cursor:pointer;">➕ Nuevo Aviso en Blanco</button>
                    </div>

                    <div style="display:grid;grid-template-columns:1fr 1fr;gap:.65rem;">
                        <div>
                            <label class="form-label" style="font-size:.72rem;">Formato Visual</label>
                            <select id="aw-formato" class="form-control" style="font-size:.8rem;" onchange="_renderSimuladorAvisoWeb()">
                                <option value="modal_promo">🪟 Pop-up Central Editorial</option>
                                <option value="cintillo_superior">📌 Cintillo Superior Fijo</option>
                                <option value="toast_esquina">💬 Aviso Flotante Esquina</option>
                            </select>
                        </div>
                        <div>
                            <label class="form-label" style="font-size:.72rem;">Etiqueta Superior (Eyebrow)</label>
                            <input type="text" id="aw-subtitulo" class="form-control" placeholder="Ej: PROMOCIÓN DEL MES · EDICIÓN LIMITADA" style="font-size:.8rem;" oninput="_renderSimuladorAvisoWeb()">
                        </div>
                    </div>

                    <div>
                        <label class="form-label" style="font-size:.72rem;">Título Principal *</label>
                        <input type="text" id="aw-titulo" class="form-control" placeholder="Ej: Envío Gratis en tu Pack Bienestar Suizo" style="font-size:.84rem;font-weight:600;" oninput="_renderSimuladorAvisoWeb()">
                    </div>

                    <div>
                        <label class="form-label" style="font-size:.72rem;">Mensaje / Detalle</label>
                        <textarea id="aw-cuerpo" class="form-control" rows="2" placeholder="Ej: Aprovecha esta semana precio especial en Dulet Clásico + Eucament..." style="font-size:.8rem;resize:vertical;" oninput="_renderSimuladorAvisoWeb()"></textarea>
                    </div>

                    <!-- Imagen opcional con Drag & Drop / Cmd+V -->
                    <div id="aw-img-drop" style="padding:.6rem .75rem;border-radius:8px;border:1px dashed rgba(56,189,248,.35);background:rgba(15,23,42,.5);display:flex;align-items:center;justify-content:space-between;gap:.6rem;flex-wrap:wrap;">
                        <div style="font-size:.73rem;color:#cbd5e1;flex:1;min-width:180px;">
                            🖼️ <strong>Imagen Promo (opcional):</strong> pega con <kbd style="background:rgba(255,255,255,.1);padding:1px 4px;border-radius:3px;">Cmd+V</kbd> o sube archivo
                            <input type="text" id="aw-imagen-url" class="form-control" placeholder="https://... (opcional)" style="margin-top:4px;font-size:.72rem;height:28px;padding:2px 8px;" oninput="_renderSimuladorAvisoWeb()">
                        </div>
                        <div style="display:flex;gap:.35rem;align-items:center;">
                            <input type="file" id="aw-img-file" accept="image/png,image/jpeg,image/webp" style="display:none;" onchange="if(this.files&&this.files[0])_subirImagenAvisoWeb(this.files[0])">
                            <button type="button" class="btn btn-sm" onclick="document.getElementById('aw-img-file').click()" style="font-size:.72rem;padding:4px 10px;background:#0284c7;color:#fff;border:none;border-radius:6px;cursor:pointer;">📤 Subir Foto</button>
                        </div>
                    </div>

                    <!-- Botón CTA y Cupón -->
                    <div style="display:grid;grid-template-columns:1fr 1fr;gap:.65rem;">
                        <div>
                            <label class="form-label" style="font-size:.72rem;">Acción del Botón</label>
                            <select id="aw-cta-tipo" class="form-control" style="font-size:.78rem;" onchange="_onCambioCtaTipoAviso()">
                                <option value="ir_url">🔗 Ir a sección o enlace</option>
                                <option value="agregar_sku_carrito">🛒 Agregar Producto (SKU) al carrito</option>
                                <option value="copiar_cupon">🏷️ Copiar código de cupón</option>
                                <option value="abrir_whatsapp">💬 Abrir WhatsApp con mensaje</option>
                                <option value="ninguno">Sin botón (solo informativo)</option>
                            </select>
                        </div>
                        <div>
                            <label class="form-label" style="font-size:.72rem;">Texto del Botón</label>
                            <input type="text" id="aw-cta-texto" class="form-control" placeholder="Ej: Ver Promoción →" style="font-size:.78rem;" oninput="_renderSimuladorAvisoWeb()">
                        </div>
                    </div>

                    <div id="aw-cta-valor-row" style="display:grid;grid-template-columns:1fr 1fr;gap:.65rem;">
                        <div>
                            <label class="form-label" style="font-size:.72rem;" id="aw-cta-valor-lbl">Destino (URL, #catalogo, SKU o mensaje)</label>
                            <input type="text" id="aw-cta-valor" class="form-control" placeholder="#catalogo" style="font-size:.78rem;" oninput="_renderSimuladorAvisoWeb()">
                        </div>
                        <div>
                            <label class="form-label" style="font-size:.72rem;">Código Cupón (opcional)</label>
                            <input type="text" id="aw-cupon" class="form-control" placeholder="Ej: SUIZA10" style="font-size:.78rem;text-transform:uppercase;" oninput="_renderSimuladorAvisoWeb()">
                        </div>
                    </div>

                    <!-- Reglas Inteligentes de Disparo y Segmentación -->
                    <div style="display:grid;grid-template-columns:repeat(3,1fr);gap:.55rem;">
                        <div>
                            <label class="form-label" style="font-size:.7rem;">🌎 País / Región</label>
                            <select id="aw-pais" class="form-control" style="font-size:.76rem;">
                                <option value="TODOS">Todos (MX + USA)</option>
                                <option value="MX">🇲🇽 Solo México</option>
                                <option value="USA">🇺🇸 Solo USA</option>
                            </select>
                        </div>
                        <div>
                            <label class="form-label" style="font-size:.7rem;">⚡ Disparador</label>
                            <select id="aw-disparador" class="form-control" style="font-size:.76rem;">
                                <option value="delay_3s">A los 3 segundos</option>
                                <option value="inmediato">Al abrir página</option>
                                <option value="scroll_40">Al bajar 40% scroll</option>
                                <option value="exit_intent">Intención de salida</option>
                            </select>
                        </div>
                        <div>
                            <label class="form-label" style="font-size:.7rem;">🔁 Frecuencia</label>
                            <select id="aw-frecuencia" class="form-control" style="font-size:.76rem;">
                                <option value="cada_24h">Máx. 1 vez cada 24h</option>
                                <option value="una_vez_sesion">1 vez por sesión</option>
                                <option value="una_vez_por_campana">1 sola vez total</option>
                                <option value="siempre">Siempre (Pruebas)</option>
                            </select>
                        </div>
                    </div>

                    <div style="display:grid;grid-template-columns:1fr 1fr;gap:.65rem;">
                        <div>
                            <label class="form-label" style="font-size:.7rem;">📅 Inicio automático (opcional)</label>
                            <input type="datetime-local" id="aw-fecha-inicio" class="form-control" style="font-size:.75rem;">
                        </div>
                        <div>
                            <label class="form-label" style="font-size:.7rem;">⏳ Fin automático (opcional)</label>
                            <input type="datetime-local" id="aw-fecha-fin" class="form-control" style="font-size:.75rem;">
                        </div>
                    </div>

                    <div style="display:flex;justify-content:space-between;align-items:center;padding-top:.55rem;border-top:1px solid rgba(255,255,255,.08);flex-wrap:wrap;gap:.5rem;">
                        <label style="display:flex;align-items:center;gap:.45rem;font-size:.8rem;font-weight:700;color:#4ade80;cursor:pointer;">
                            <input type="checkbox" id="aw-activo" checked style="width:17px;height:17px;accent-color:#22c55e;">
                            Activar en vivo al guardar
                        </label>
                        <div style="display:flex;gap:.5rem;flex-wrap:wrap;">
                            <button type="button" id="aw-btn-guardar-probar" onclick="_guardarAvisoWeb(true)" class="btn btn-sm" style="padding:.52rem .95rem;font-weight:700;background:rgba(56,189,248,.14);color:#38bdf8;border:1px solid rgba(56,189,248,.38);border-radius:8px;cursor:pointer;">👁 Guardar y Probar</button>
                            <button type="button" id="aw-btn-guardar" onclick="_guardarAvisoWeb(false)" class="btn btn-primary btn-sm" style="padding:.55rem 1.2rem;font-weight:700;background:linear-gradient(135deg,#0284c7,#2563eb);border:none;border-radius:8px;cursor:pointer;">💾 Guardar y Cerrar</button>
                        </div>
                    </div>
                </div>

                <!-- Simulador en Vivo -->
                <div style="background:#f5f2eb;border-radius:12px;border:1px solid rgba(255,255,255,.15);overflow:hidden;color:#141413;min-height:410px;display:flex;flex-direction:column;">
                    <div style="background:#141413;color:#f5f2eb;padding:.55rem .9rem;font-size:.7rem;font-weight:700;letter-spacing:.08em;text-transform:uppercase;display:flex;justify-content:space-between;align-items:center;">
                        <span>👁 Vista Previa en Vivo (Estética Editorial Suiza)</span>
                        <span style="color:#94a3b8;font-weight:500;">Tiempo real</span>
                    </div>
                    <div id="aw-simulador-canvas" style="flex:1;position:relative;padding:1.2rem;display:flex;align-items:center;justify-content:center;background:radial-gradient(circle at top right,#ebe5d8,#f5f2eb);"></div>
                </div>
            </div>
        </div>
    `;

    document.body.appendChild(dlg);

    // Fallback obligatorio de light-dismiss por coordenadas para navegadores sin HTMLDialogElement.prototype.closedBy (ej. Safari)
    if (!('closedBy' in HTMLDialogElement.prototype)) {
        const outside = (e, d) => {
            const r = d.getBoundingClientRect();
            return e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom;
        };
        let pressedOutside = false;
        dlg.addEventListener('pointerdown', e => { pressedOutside = outside(e, dlg); });
        dlg.addEventListener('pointerup', e => { if (pressedOutside && outside(e, dlg)) dlg.close(); });
    }

    dlg.addEventListener('close', () => { dlg.returnValue = ''; });
    return dlg;
}

function _mostrarMsgAvisoWeb(msg, tipo = 'warning') {
    const el = document.getElementById('aw-inline-msg');
    if (!el) return;
    if (!msg) {
        el.style.display = 'none';
        el.textContent = '';
        return;
    }
    const palette = {
        success: { bg: 'rgba(34,197,94,.16)', border: 'rgba(34,197,94,.42)', color: '#86efac' },
        danger:  { bg: 'rgba(239,68,68,.16)', border: 'rgba(239,68,68,.42)', color: '#fca5a5' },
        warning: { bg: 'rgba(245,158,11,.16)', border: 'rgba(245,158,11,.45)', color: '#fde68a' },
        info:    { bg: 'rgba(56,189,248,.15)', border: 'rgba(56,189,248,.4)', color: '#7dd3fc' }
    }[tipo] || { bg: 'rgba(56,189,248,.15)', border: 'rgba(56,189,248,.4)', color: '#7dd3fc' };
    el.style.display = 'block';
    el.style.background = palette.bg;
    el.style.border = `1px solid ${palette.border}`;
    el.style.color = palette.color;
    el.textContent = msg;
}

async function abrirModalAvisosWeb() {
    const dlg = _asegurarDialogAvisosWeb();
    if (!dlg.open) dlg.showModal();
    _mostrarMsgAvisoWeb('');
    const scrollBody = document.getElementById('aw-dialog-scroll-body');
    if (scrollBody) scrollBody.scrollTop = 0;
    requestAnimationFrame(() => { if (scrollBody) scrollBody.scrollTop = 0; });
    _renderSimuladorAvisoWeb();
    await _cargarListaAvisosWeb({ autoSelect: true });
    if (scrollBody) scrollBody.scrollTop = 0;
}

function _limpiarFormularioAvisoWeb() {
    _AVISOS_WEB_STATE.editingId = 0;
    _mostrarMsgAvisoWeb('');
    const setV = (id, v) => { const el = document.getElementById(id); if (el) el.value = v; };
    setV('aw-formato', 'modal_promo');
    setV('aw-subtitulo', 'EDICIÓN ESPECIAL · DULET');
    setV('aw-titulo', '');
    setV('aw-cuerpo', '');
    setV('aw-imagen-url', '');
    setV('aw-cta-tipo', 'ir_url');
    setV('aw-cta-texto', 'Explorar Catálogo →');
    setV('aw-cta-valor', '#catalogo');
    setV('aw-cupon', '');
    setV('aw-pais', 'TODOS');
    setV('aw-disparador', 'delay_3s');
    setV('aw-frecuencia', 'cada_24h');
    setV('aw-fecha-inicio', '');
    setV('aw-fecha-fin', '');
    const chk = document.getElementById('aw-activo'); if (chk) chk.checked = true;
    const badge = document.getElementById('aw-editor-badge');
    if (badge) {
        badge.textContent = '✨ Nuevo Aviso / Promoción';
        badge.style.color = '#cbd5e1';
        badge.style.background = 'rgba(255,255,255,.06)';
        badge.style.borderColor = 'rgba(255,255,255,.12)';
    }
    _renderListaAvisosWeb();
    _onCambioCtaTipoAviso();
    _renderSimuladorAvisoWeb();
}

function _aplicarPlantillaAvisoWeb(tipo) {
    _limpiarFormularioAvisoWeb();
    const setV = (id, v) => { const el = document.getElementById(id); if (el) el.value = v; };
    if (tipo === 'promo') {
        setV('aw-formato', 'modal_promo');
        setV('aw-subtitulo', 'PROMOCIÓN DEL MOMENTO');
        setV('aw-titulo', 'Pack Bienestar Suizo con Precio Especial');
        setV('aw-cuerpo', 'Combina la nutrición celular de Dulet Clásico con la frescura botánica de Eucament. Disponible por tiempo limitado.');
        setV('aw-cta-tipo', 'ir_url');
        setV('aw-cta-texto', 'Ver Productos en Tienda →');
        setV('aw-cta-valor', '#catalogo');
    } else if (tipo === 'cintillo') {
        setV('aw-formato', 'cintillo_superior');
        setV('aw-subtitulo', 'AVISO OFICIAL');
        setV('aw-titulo', 'Envíos asegurados a todo México y EE. UU. · Atención directa por WhatsApp');
        setV('aw-cuerpo', '');
        setV('aw-cta-tipo', 'ir_url');
        setV('aw-cta-texto', 'Ir al Catálogo');
        setV('aw-cta-valor', '#catalogo');
        setV('aw-disparador', 'inmediato');
    } else if (tipo === 'cupon') {
        setV('aw-formato', 'modal_promo');
        setV('aw-subtitulo', 'BENEFICIO EXCLUSIVO WEB');
        setV('aw-titulo', 'Obtén un beneficio especial en tu pedido de hoy');
        setV('aw-cuerpo', 'Haz clic en el botón para copiar tu código promocional y úsalo al finalizar tu compra.');
        setV('aw-cta-tipo', 'copiar_cupon');
        setV('aw-cta-texto', 'Copiar Código y Comprar');
        setV('aw-cupon', 'DULET2026');
    }
    _onCambioCtaTipoAviso();
    _renderSimuladorAvisoWeb();
}

function _onCambioCtaTipoAviso() {
    const tipo = document.getElementById('aw-cta-tipo')?.value || 'ir_url';
    const lbl = document.getElementById('aw-cta-valor-lbl');
    const inp = document.getElementById('aw-cta-valor');
    if (lbl && inp) {
        if (tipo === 'agregar_sku_carrito') {
            lbl.textContent = 'SKU del Producto (ej: SUERO-SACHET)';
            inp.placeholder = 'SUERO-SACHET';
        } else if (tipo === 'abrir_whatsapp') {
            lbl.textContent = 'Mensaje prellenado de WhatsApp';
            inp.placeholder = 'Hola, me interesa la promoción vigente en la web';
        } else if (tipo === 'copiar_cupon') {
            lbl.textContent = 'Sección destino tras copiar (opcional)';
            inp.placeholder = '#catalogo';
        } else {
            lbl.textContent = 'URL o ancla destino (ej: #catalogo)';
            inp.placeholder = '#catalogo';
        }
    }
    _renderSimuladorAvisoWeb();
}

async function _subirImagenAvisoWeb(file) {
    if (!file || _AVISOS_WEB_STATE.uploadingImg) return;
    _AVISOS_WEB_STATE.uploadingImg = true;
    const inp = document.getElementById('aw-imagen-url');
    const prev = inp ? inp.value : '';
    if (inp) inp.value = 'Subiendo y optimizando a WebP...';
    try {
        const res = await _subirArchivoAlCdnEstudio(file, 'banner');
        if (inp) inp.value = res.url;
        BO_AUTH.showAlert(`✅ Imagen del aviso lista (${res.optKb} KB WebP).`, 'success');
        _renderSimuladorAvisoWeb();
    } catch (err) {
        if (inp) inp.value = prev;
        BO_AUTH.showAlert('Error subiendo imagen del aviso: ' + err.message, 'danger');
    } finally {
        _AVISOS_WEB_STATE.uploadingImg = false;
    }
}

function _renderSimuladorAvisoWeb() {
    const canvas = document.getElementById('aw-simulador-canvas');
    if (!canvas) return;

    const formato = document.getElementById('aw-formato')?.value || 'modal_promo';
    const sub = (document.getElementById('aw-subtitulo')?.value || 'AVISO ESPECIAL').trim();
    const tit = (document.getElementById('aw-titulo')?.value || 'Título de tu promoción o aviso').trim();
    const cuerpo = (document.getElementById('aw-cuerpo')?.value || '').trim();
    const imgRaw = (document.getElementById('aw-imagen-url')?.value || '').trim();
    const imgUrl = imgRaw.startsWith('http') ? imgRaw : '';
    const ctaTipo = document.getElementById('aw-cta-tipo')?.value || 'ir_url';
    const ctaTxt = (document.getElementById('aw-cta-texto')?.value || 'Ver más →').trim();
    const cupon = (document.getElementById('aw-cupon')?.value || '').trim().toUpperCase();

    const esc = s => String(s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');

    if (formato === 'cintillo_superior') {
        canvas.innerHTML = `
            <div style="width:100%;align-self:flex-start;background:#141413;color:#f5f2eb;padding:.75rem 1rem;border-radius:8px;display:flex;align-items:center;justify-content:space-between;gap:.75rem;flex-wrap:wrap;box-shadow:0 10px 24px rgba(0,0,0,.18);">
                <div style="font-size:.78rem;line-height:1.35;">
                    ${sub ? `<span style="color:#c8a96e;font-weight:700;letter-spacing:.08em;text-transform:uppercase;font-size:.66rem;margin-right:.5rem;">${esc(sub)}</span>` : ''}
                    <strong>${esc(tit)}</strong>
                    ${cuerpo ? `<span style="opacity:.82;margin-left:.35rem;">${esc(cuerpo)}</span>` : ''}
                </div>
                ${ctaTipo !== 'ninguno' && ctaTxt ? `<span style="background:#f5f2eb;color:#141413;padding:4px 12px;border-radius:999px;font-size:.7rem;font-weight:700;white-space:nowrap;">${esc(ctaTxt)}</span>` : ''}
            </div>
        `;
        return;
    }

    if (formato === 'toast_esquina') {
        canvas.innerHTML = `
            <div style="width:100%;max-width:320px;align-self:flex-end;margin-left:auto;background:#ffffff;border:1px solid rgba(20,20,19,.14);border-radius:12px;padding:1rem;box-shadow:0 18px 40px rgba(20,20,19,.16);">
                ${sub ? `<div style="font-size:.64rem;font-weight:700;letter-spacing:.1em;text-transform:uppercase;color:#8c6d3f;margin-bottom:.25rem;">${esc(sub)}</div>` : ''}
                <div style="font-size:.92rem;font-weight:700;color:#141413;line-height:1.25;">${esc(tit)}</div>
                ${cuerpo ? `<div style="font-size:.76rem;color:#57534e;margin-top:.35rem;line-height:1.4;">${esc(cuerpo)}</div>` : ''}
                ${cupon ? `<div style="margin-top:.5rem;padding:4px 8px;background:#f5f2eb;border:1px dashed #8c6d3f;font-family:monospace;font-size:.75rem;font-weight:700;text-align:center;">CÓDIGO: ${esc(cupon)}</div>` : ''}
                ${ctaTipo !== 'ninguno' && ctaTxt ? `<div style="margin-top:.65rem;background:#141413;color:#f5f2eb;text-align:center;padding:7px 12px;border-radius:6px;font-size:.74rem;font-weight:700;">${esc(ctaTxt)}</div>` : ''}
            </div>
        `;
        return;
    }

    // Modal central editorial
    canvas.innerHTML = `
        <div style="width:100%;max-width:${imgUrl ? '440px' : '360px'};background:#ffffff;border:1px solid rgba(20,20,19,.12);border-radius:14px;overflow:hidden;box-shadow:0 24px 60px rgba(20,20,19,.22);display:grid;grid-template-columns:${imgUrl ? '0.92fr 1.08fr' : '1fr'};">
            ${imgUrl ? `<div style="background:#0b1120;display:flex;align-items:center;justify-content:center;overflow:hidden;min-height:220px;"><img src="${imgUrl}" alt="" style="width:100%;height:100%;max-height:310px;object-fit:contain;display:block;"></div>` : ''}
            <div style="padding:1.1rem 1.15rem;display:flex;flex-direction:column;justify-content:center;">
                ${sub ? `<div style="font-size:.62rem;font-weight:700;letter-spacing:.12em;text-transform:uppercase;color:#d91e2a;margin-bottom:.35rem;">${esc(sub)}</div>` : ''}
                <div style="font-size:1.02rem;font-weight:800;color:#0f172a;line-height:1.2;">${esc(tit)}</div>
                ${cuerpo ? `<p style="font-size:.74rem;color:#334155;line-height:1.5;margin:.55rem 0 0;white-space:pre-line;max-height:165px;overflow-y:auto;">${esc(cuerpo)}</p>` : ''}
                ${cupon ? `<div style="margin-top:.65rem;padding:.4rem;background:#fef2f2;border:1px dashed #d91e2a;border-radius:6px;text-align:center;font-family:monospace;font-size:.78rem;font-weight:800;letter-spacing:.08em;color:#0f172a;">${esc(cupon)}</div>` : ''}
                ${ctaTipo !== 'ninguno' && ctaTxt
                    ? `<div style="margin-top:.8rem;background:#d91e2a;color:#ffffff;padding:.55rem .9rem;border-radius:999px;text-align:center;font-size:.74rem;font-weight:700;">${esc(ctaTxt)}</div>`
                    : `<div style="margin-top:.8rem;background:#0f172a;color:#ffffff;padding:.5rem .9rem;border-radius:999px;text-align:center;font-size:.72rem;font-weight:700;">Entendido · Continuar explorando</div>`
                }
            </div>
        </div>
    `;
}

async function _cargarListaAvisosWeb(opts = {}) {
    const box = document.getElementById('aw-lista-campanas');
    if (!box) return;
    try {
        const res = await fetch(`${_STUDIO_API_BASE}/api/site-notice?all=1`, {
            method: 'GET',
            cache: 'no-store',
            headers: _getAuthHeadersStudio()
        });
        const data = await res.json().catch(() => ({}));
        _AVISOS_WEB_STATE.notices = Array.isArray(data.notices) ? data.notices : [];
        if (opts.autoSelect && _AVISOS_WEB_STATE.notices.length > 0) {
            const preferido = _AVISOS_WEB_STATE.notices.find(x => x.activo) || _AVISOS_WEB_STATE.notices[0];
            if (preferido) {
                _editarAvisoWeb(preferido.id);
                return;
            }
        }
        _renderListaAvisosWeb();
    } catch (e) {
        box.innerHTML = `<div style="font-size:.75rem;color:#f87171;">Error cargando avisos: ${e.message}</div>`;
    }
}

function _estadoVigenciaAviso(n) {
    if (!n.activo) return { label: '⏸ Pausado', color: '#94a3b8', bg: 'rgba(148,163,184,.12)' };
    const now = Date.now();
    if (n.fecha_inicio && new Date(n.fecha_inicio).getTime() > now) {
        return { label: '⏳ Programado', color: '#fbbf24', bg: 'rgba(251,191,36,.15)' };
    }
    if (n.fecha_fin && new Date(n.fecha_fin).getTime() < now) {
        return { label: '⏹ Finalizado', color: '#f87171', bg: 'rgba(248,113,113,.15)' };
    }
    return { label: '🟢 Activo en Vivo', color: '#4ade80', bg: 'rgba(34,197,94,.16)' };
}

function _renderListaAvisosWeb() {
    const box = document.getElementById('aw-lista-campanas');
    if (!box) return;
    const list = _AVISOS_WEB_STATE.notices;
    if (!list.length) {
        box.innerHTML = '<div style="font-size:.76rem;color:#94a3b8;padding:.35rem 0;">Aún no tienes avisos creados. Usa una plantilla rápida arriba o llena el editor debajo.</div>';
        return;
    }
    const fmtLabel = { modal_promo: '🪟 Pop-up', cintillo_superior: '📌 Cintillo', toast_esquina: '💬 Toast' };
    const trigLabel = {
        delay_3s: '⚡ 3s',
        inmediato: '⚡ Al abrir',
        scroll_40: '⚡ Scroll 40%',
        exit_intent: '⚡ Salida'
    };
    box.innerHTML = list.map(n => {
        const st = _estadoVigenciaAviso(n);
        const isEditing = Number(n.id) === Number(_AVISOS_WEB_STATE.editingId);
        const freq = n.frecuencia || 'cada_24h';
        const thumb = (n.imagen_url && String(n.imagen_url).startsWith('http'))
            ? `<img src="${n.imagen_url}" alt="" style="width:36px;height:46px;object-fit:contain;border-radius:6px;background:#0b1120;border:1px solid rgba(255,255,255,.12);flex-shrink:0;">`
            : '';
        const previewHref = `https://gkmb77-aw.myshopify.com/?preview_theme_id=192975634746&dulet_preview_notice=${n.id}`;
        return `
            <div style="display:flex;align-items:center;justify-content:space-between;gap:.65rem;padding:.58rem .8rem;border-radius:10px;background:${isEditing ? 'rgba(56,189,248,.11)' : 'rgba(255,255,255,.04)'};border:1px solid ${isEditing ? 'rgba(56,189,248,.5)' : 'rgba(255,255,255,.09)'};flex-wrap:wrap;">
                <div style="display:flex;align-items:center;gap:.6rem;min-width:220px;flex:1;">
                    ${thumb}
                    <div style="display:flex;flex-direction:column;gap:3px;min-width:0;">
                        <div style="display:flex;align-items:center;gap:.45rem;flex-wrap:wrap;">
                            <span style="padding:2px 8px;border-radius:999px;font-size:.68rem;font-weight:700;color:${st.color};background:${st.bg};white-space:nowrap;">${st.label}</span>
                            <span style="font-size:.7rem;color:#38bdf8;font-weight:700;">${fmtLabel[n.formato] || '🪟 Pop-up'}</span>
                            <strong style="font-size:.82rem;color:#f8fafc;">${String(n.titulo || '').replace(/</g, '&lt;')}</strong>
                        </div>
                        <div style="font-size:.69rem;color:#94a3b8;display:flex;gap:.5rem;flex-wrap:wrap;align-items:center;">
                            <span>${trigLabel[n.disparador] || '⚡ 3s'}</span>
                            <span>· 🌍 ${n.pais_objetivo || 'TODOS'}</span>
                            <span>· 👁 ${n.vistas || 0} vistas</span>
                            <span>· 🖱 ${n.clics || 0} clics</span>
                        </div>
                    </div>
                </div>
                <div style="display:flex;gap:.4rem;align-items:center;flex-wrap:wrap;">
                    <select aria-label="Frecuencia del anuncio" onchange="_cambiarFrecuenciaRapidaAvisoWeb(${n.id}, this.value)" style="padding:3px 7px;font-size:.7rem;font-weight:600;border-radius:6px;background:#0f172a;color:#e2e8f0;border:1px solid rgba(255,255,255,.18);cursor:pointer;">
                        <option value="cada_24h" ${freq === 'cada_24h' ? 'selected' : ''}>🔁 Máx. 1 cada 24h</option>
                        <option value="una_vez_sesion" ${freq === 'una_vez_sesion' ? 'selected' : ''}>🔁 1x por sesión</option>
                        <option value="una_vez_por_campana" ${freq === 'una_vez_por_campana' ? 'selected' : ''}>🔁 1 sola vez total</option>
                        <option value="siempre" ${freq === 'siempre' ? 'selected' : ''}>🧪 Siempre (Pruebas)</option>
                    </select>
                    <button type="button" onclick="_toggleActivoAvisoWeb(${n.id}, ${!n.activo})" style="padding:4px 10px;font-size:.72rem;font-weight:700;border-radius:6px;border:1px solid ${n.activo ? 'rgba(248,113,113,.38)' : 'rgba(34,197,94,.42)'};background:${n.activo ? 'rgba(248,113,113,.16)' : 'rgba(34,197,94,.2)'};color:${n.activo ? '#fca5a5' : '#86efac'};cursor:pointer;">${n.activo ? '⏸ Pausar' : '▶️ Activar'}</button>
                    <button type="button" onclick="_editarAvisoWeb(${n.id})" style="padding:4px 10px;font-size:.72rem;font-weight:700;border-radius:6px;border:none;background:${isEditing ? '#0284c7' : '#f59e0b'};color:#fff;cursor:pointer;">${isEditing ? '✓ Editando' : '✏️ Editar'}</button>
                    <a href="${previewHref}" target="_blank" rel="noopener" style="padding:4px 9px;font-size:.72rem;font-weight:600;border-radius:6px;border:1px solid rgba(56,189,248,.35);background:rgba(56,189,248,.12);color:#38bdf8;text-decoration:none;" title="Abrir prueba en vivo en tema-suizo-2026">👁 Probar</a>
                    <button type="button" onclick="_eliminarAvisoWeb(${n.id})" style="padding:4px 8px;font-size:.72rem;border-radius:6px;border:none;background:rgba(239,68,68,.22);color:#fca5a5;cursor:pointer;" title="Eliminar anuncio">🗑</button>
                </div>
            </div>
        `;
    }).join('');
}

function _toLocalInputDate(iso) {
    if (!iso) return '';
    const d = new Date(iso);
    if (isNaN(d.getTime())) return '';
    const pad = x => String(x).padStart(2, '0');
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

function _editarAvisoWeb(id) {
    const n = _AVISOS_WEB_STATE.notices.find(x => Number(x.id) === Number(id));
    if (!n) return;
    _AVISOS_WEB_STATE.editingId = Number(n.id);
    _mostrarMsgAvisoWeb('');
    const setV = (elId, v) => { const el = document.getElementById(elId); if (el) el.value = v ?? ''; };
    setV('aw-formato', n.formato || 'modal_promo');
    setV('aw-subtitulo', n.subtitulo || '');
    setV('aw-titulo', n.titulo || '');
    setV('aw-cuerpo', n.cuerpo || '');
    setV('aw-imagen-url', n.imagen_url || '');
    setV('aw-cta-tipo', n.cta_tipo || 'ir_url');
    setV('aw-cta-texto', n.cta_texto || '');
    setV('aw-cta-valor', n.cta_valor || '');
    setV('aw-cupon', n.cupon_codigo || '');
    setV('aw-pais', n.pais_objetivo || 'TODOS');
    setV('aw-disparador', n.disparador || 'delay_3s');
    setV('aw-frecuencia', n.frecuencia || 'cada_24h');
    setV('aw-fecha-inicio', _toLocalInputDate(n.fecha_inicio));
    setV('aw-fecha-fin', _toLocalInputDate(n.fecha_fin));
    const chk = document.getElementById('aw-activo'); if (chk) chk.checked = !!n.activo;
    const badge = document.getElementById('aw-editor-badge');
    if (badge) {
        badge.textContent = `✏️ Editando Aviso #${n.id}`;
        badge.style.color = '#7dd3fc';
        badge.style.background = 'rgba(56,189,248,.14)';
        badge.style.borderColor = 'rgba(56,189,248,.4)';
    }
    _renderListaAvisosWeb();
    _onCambioCtaTipoAviso();
    _renderSimuladorAvisoWeb();
}

async function _guardarAvisoWeb(abrirDemo = false) {
    const titulo = (document.getElementById('aw-titulo')?.value || '').trim();
    if (!titulo) {
        _mostrarMsgAvisoWeb('⚠️ Ingresa el título principal del aviso antes de guardar (o pulsa "✏️ Editar" sobre tu campaña actual arriba).', 'warning');
        document.getElementById('aw-titulo')?.focus();
        return;
    }
    const fiVal = document.getElementById('aw-fecha-inicio')?.value || '';
    const ffVal = document.getElementById('aw-fecha-fin')?.value || '';

    const payload = {
        accion: 'guardar',
        id: _AVISOS_WEB_STATE.editingId || 0,
        formato: document.getElementById('aw-formato')?.value || 'modal_promo',
        subtitulo: (document.getElementById('aw-subtitulo')?.value || '').trim(),
        titulo,
        cuerpo: (document.getElementById('aw-cuerpo')?.value || '').trim(),
        imagen_url: (document.getElementById('aw-imagen-url')?.value || '').trim(),
        cta_tipo: document.getElementById('aw-cta-tipo')?.value || 'ir_url',
        cta_texto: (document.getElementById('aw-cta-texto')?.value || '').trim(),
        cta_valor: (document.getElementById('aw-cta-valor')?.value || '').trim(),
        cupon_codigo: (document.getElementById('aw-cupon')?.value || '').trim().toUpperCase(),
        pais_objetivo: document.getElementById('aw-pais')?.value || 'TODOS',
        paginas_objetivo: 'todas',
        disparador: document.getElementById('aw-disparador')?.value || 'delay_3s',
        frecuencia: document.getElementById('aw-frecuencia')?.value || 'cada_24h',
        fecha_inicio: fiVal ? new Date(fiVal).toISOString() : null,
        fecha_fin: ffVal ? new Date(ffVal).toISOString() : null,
        activo: !!document.getElementById('aw-activo')?.checked
    };

    const btn = document.getElementById('aw-btn-guardar');
    const btnProbar = document.getElementById('aw-btn-guardar-probar');
    if (btn) { btn.disabled = true; btn.textContent = 'Guardando...'; }
    if (btnProbar) btnProbar.disabled = true;
    try {
        const res = await fetch(`${_STUDIO_API_BASE}/api/site-notice`, {
            method: 'POST',
            headers: _getAuthHeadersStudio(),
            body: JSON.stringify(payload)
        });
        const data = await res.json().catch(() => ({}));
        if (!res.ok || !data.ok) throw new Error(data.message || 'No se pudo guardar el aviso');

        const savedId = data.notice?.id || payload.id || 0;
        _limpiarFormularioAvisoWeb();
        await _cargarListaAvisosWeb();

        const dlg = document.getElementById('dialogAvisosWeb');
        if (dlg && dlg.open) dlg.close();

        BO_AUTH.showAlert('✅ Aviso web guardado correctamente.', 'success');

        if (abrirDemo && savedId) {
            window.open(`https://gkmb77-aw.myshopify.com/?preview_theme_id=192975634746&dulet_preview_notice=${savedId}`, '_blank', 'noopener');
        }
    } catch (e) {
        _mostrarMsgAvisoWeb('❌ Error guardando aviso: ' + e.message, 'danger');
        BO_AUTH.showAlert('Error guardando aviso: ' + e.message, 'danger');
    } finally {
        if (btn) { btn.disabled = false; btn.textContent = '💾 Guardar y Cerrar'; }
        if (btnProbar) btnProbar.disabled = false;
    }
}

async function _toggleActivoAvisoWeb(id, nuevoEstado) {
    try {
        const res = await fetch(`${_STUDIO_API_BASE}/api/site-notice`, {
            method: 'POST',
            headers: _getAuthHeadersStudio(),
            body: JSON.stringify({ accion: 'toggle', id, activo: nuevoEstado })
        });
        const data = await res.json().catch(() => ({}));
        if (!res.ok || !data.ok) throw new Error(data.message || 'Error actualizando estado');
        if (Number(_AVISOS_WEB_STATE.editingId) === Number(id)) {
            const chk = document.getElementById('aw-activo');
            if (chk) chk.checked = !!nuevoEstado;
        }
        _mostrarMsgAvisoWeb(nuevoEstado ? '🟢 Anuncio activado en vivo inmediatamente.' : '⏸ Anuncio pausado (ya no aparecerá en la tienda hasta que lo reactives).', nuevoEstado ? 'success' : 'info');
        await _cargarListaAvisosWeb();
    } catch (e) {
        _mostrarMsgAvisoWeb('❌ Error: ' + e.message, 'danger');
    }
}

async function _cambiarFrecuenciaRapidaAvisoWeb(id, nuevaFrecuencia) {
    try {
        const res = await fetch(`${_STUDIO_API_BASE}/api/site-notice`, {
            method: 'POST',
            headers: _getAuthHeadersStudio(),
            body: JSON.stringify({ accion: 'cambiar_frecuencia', id, frecuencia: nuevaFrecuencia })
        });
        const data = await res.json().catch(() => ({}));
        if (!res.ok || !data.ok) throw new Error(data.message || 'Error actualizando frecuencia');
        if (Number(_AVISOS_WEB_STATE.editingId) === Number(id)) {
            const sel = document.getElementById('aw-frecuencia');
            if (sel) sel.value = nuevaFrecuencia;
        }
        _mostrarMsgAvisoWeb('✅ Frecuencia actualizada al instante.', 'success');
        await _cargarListaAvisosWeb();
    } catch (e) {
        _mostrarMsgAvisoWeb('❌ Error actualizando frecuencia: ' + e.message, 'danger');
    }
}

async function _eliminarAvisoWeb(id) {
    if (!confirm('¿Eliminar este aviso web permanentemente?')) return;
    try {
        const res = await fetch(`${_STUDIO_API_BASE}/api/site-notice`, {
            method: 'POST',
            headers: _getAuthHeadersStudio(),
            body: JSON.stringify({ accion: 'eliminar', id })
        });
        const data = await res.json().catch(() => ({}));
        if (!res.ok || !data.ok) throw new Error(data.message || 'Error eliminando');
        if (_AVISOS_WEB_STATE.editingId === Number(id)) _limpiarFormularioAvisoWeb();
        await _cargarListaAvisosWeb();
    } catch (e) {
        BO_AUTH.showAlert('Error eliminando aviso: ' + e.message, 'danger');
    }
}

// Inicialización automática segura al cargar DOM
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
        _inyectarEstilosYControlesWebStudio();
        _asegurarEstudioImagenProducto();
    });
} else {
    setTimeout(() => {
        _inyectarEstilosYControlesWebStudio();
        _asegurarEstudioImagenProducto();
    }, 50);
}

window.abrirModalAvisosWeb = abrirModalAvisosWeb;
window._seleccionarRanuraImagenProd = _seleccionarRanuraImagenProd;
window._toggleFondoPreviewProducto = _toggleFondoPreviewProducto;
window._limpiarRanuraImagenProd = _limpiarRanuraImagenProd;
window._onManualInputImagenProd = _onManualInputImagenProd;
window._procesarSubidaImagenProducto = _procesarSubidaImagenProducto;
window._toggleGaleriaRapidaProd = _toggleGaleriaRapidaProd;
window._cargarGaleriaCdnEstudio = _cargarGaleriaCdnEstudio;
window._asignarDesdeGaleriaCdn = _asignarDesdeGaleriaCdn;
window._aplicarPlantillaAvisoWeb = _aplicarPlantillaAvisoWeb;
window._limpiarFormularioAvisoWeb = _limpiarFormularioAvisoWeb;
window._onCambioCtaTipoAviso = _onCambioCtaTipoAviso;
window._subirImagenAvisoWeb = _subirImagenAvisoWeb;
window._renderSimuladorAvisoWeb = _renderSimuladorAvisoWeb;
window._guardarAvisoWeb = _guardarAvisoWeb;
window._editarAvisoWeb = _editarAvisoWeb;
window._toggleActivoAvisoWeb = _toggleActivoAvisoWeb;
window._cambiarFrecuenciaRapidaAvisoWeb = _cambiarFrecuenciaRapidaAvisoWeb;
window._eliminarAvisoWeb = _eliminarAvisoWeb;
